export const hospitals = [
  "Northside Behavioral Health Center - Tampa - FL",
  "Adventist Health Simi Valley - Simi Valley - CA",
  "Avera Dakota Plains Surgery Center - Aberdeen - SD",
  "Baylor Scott & White Medical Center Grapevine - Grapevine - TX",
  "California Department of State Hospitals - Napa - Napa - CA",
  "California Department of State Hospitals Salinas Valley Hospital - Soledad - CA",
  "Carle Richland Memorial Hospital - Olney - IL",
  "Chester County Hospital - West Chester - PA",
  "CHI Memorial Hospital Chattanooga - Chattanooga - TN",
  "CHI Saint Anthony Hospital - Pendleton - OR",
  "CHI Saint Joseph Health Continuing Care Hospital - Lexington - KY",
  "Cuero Regional Hospital - Cuero - TX",
  "Daniel Drake Center - Cincinnati - OH",
  "Downey Medical Center - Downey - CA",
  "Encompass Health Rehabilitation Hospital of Miami - Miami - FL",
  "Encompass Health Rehabilitation Hospital of Ocala - Ocala - FL",
  "Encompass Health Rehabilitation Hospital of Round Rock - Round Rock - TX",
  "Encompass Health Rehabilitation Hospital of Sarasota - Sarasota - FL",
  "Erlanger Western Carolina Hospital - Murphy - NC",
  "Long Island Community Hospital - Patchogue - NY",
  "MarinHealth Medical Center - Greenbrae - CA",
  "Mercy Health - Anderson Hospital - Cincinnati - OH",
  "Mercyhealth Hospital and Medical Center-Harvard - Harvard - IL",
  "Munson Healthcare Manistee Hospital - Manistee - MI",
  "MUSC Institute of Psychiatry - Charleston - SC",
  "Northwestern Medicine Kishwaukee Hospital - DeKalb - IL",
  "Palisades Medical Center - North Bergen - NJ",
  "Pappas Rehabilitation Hospital for Children - Canton - MA",
  "Providence Holy Family Hospital - Spokane - WA",
  "Providence Saint John's Health Center - Santa Monica - CA",
  "Providence Saint Joseph Medical Center - Polson - MT",
  "Reading Hospital - West Reading - PA",
  "Rehabilitation Hospital of Bristol - Bristol - VA",
  "Rocky Mountain Regional VA Medical Center - Aurora - CO",
  "Santa Fe Indian Hospital - Santa Fe - NM",
  "St. Joseph's Healthcare and Rehab Center - Cedar Grove - NJ",
  "University of Kansas Health System Saint Francis Campus - Topeka - KS",
  "UPMC Cole - Coudersport - PA",
  "UPMC Hamot - Erie - PA",
  "UPMC Magee-Womens Hospital - Pittsburgh - PA",
  "UT Health East Texas Rehabilitation Hospital - Tyler - TX",
  "West Tennessee Healthcare Rehabilitation Hospital Jackson - Jackson - TN",
  "Woodland Hills Medical Center - Woodland Hills - CA",
  "Zucker Hillside Hospital - Glen Oaks - NY",
  "316th Medical Group - Joint Base Andrews (Malcolm Grow Medical Clinics and Surgery Center) - Joint Base Andrews, NAF Washington - MD",
  "375th Medical Group - Scott Air Force Base Medical Center - Scott Air Force Base - IL",
  "4C Health - Logansport - IN",
  "60th Medical Group - Travis Air Force Base - Travis Air Force Base - CA",
  "633d Medical Group - Joint Base Langley-Eustis - Hampton - VA",
  "673d Medical Group - Joint Base Elmendorf-Richardson - Joint Base Elmendorf-Richardson - AK",
  "81st Medical Group - Keesler Medical Center - Keesler Air Force Base - MS",
  "88th Medical Group - Wright-Patterson Air Force Base Medical Center - Wright-Patterson AirForce Base - OH",
  "96th Medical Group - Eglin Air Force Base - Eglin Air Force Base - FL",
  "99th Medical Group - Nellis Air Force Base - Nellis Air Force Base - NV",
  "A.O. Fox Hospital - Oneonta - NY",
  "Abbeville Area Medical Center - Abbeville - SC",
  "Abbeville General Hospital - Abbeville - LA",
  "Abbott Northwestern Hospital - Minneapolis - MN",
  "Abrazo Arizona Heart Hospital - Phoenix - AZ",
  "Abrazo Arrowhead Campus - Glendale - AZ",
  "Abrazo Cave Creek Hospital - Cave Creek - AZ",
  "Abrazo Central Campus - Phoenix - AZ",
  "Abrazo Scottsdale Campus - Phoenix - AZ",
  "Abrazo Surprise Hospital - Surprise - AZ",
  "Abrazo West Campus - Goodyear - AZ",
  "Acadia Extended Care Hospital - Crowley - LA",
  "Acadia-Saint Landry Hospital - Church Point - LA",
  "Acadian Medical Center - Eunice - LA",
  "Accel Rehabilitation Hospital of Plano - Plano - TX",
  "Access Hospital Dayton - Dayton - OH",
  "Accord Rehabilitation Hospital - Plaquemine - LA",
  "Adair County Memorial Hospital - Greenfield - IA",
  "Adams County Regional Medical Center - Seaman - OH",
  "Adams Memorial Hospital - Decatur - IN",
  "AdCare Hospital - Worcester - MA",
  "AdCare Rhode Island - North Kingstown - RI",
  "Addison Gilbert Hospital - Gloucester - MA",
  "Adena Fayette Medical Center - Washington Court House - OH",
  "Adena Greenfield Medical Center - Greenfield - OH",
  "Adena Pike Medical Center - Waverly - OH",
  "Adena Regional Medical Center - Chillicothe - OH",
  "Adirondack Medical Center - Sarnac Lake - Saranac Lake - NY",
  "Advanced Care Hospital of Montana - Billings - MT",
  "Advanced Care Hospital of Southern New Mexico - Las Cruces - NM",
  "Advanced Care Hospital of White County - Searcy - AR",
  "Advanced Dallas Hospital and Clinics - Dallas - TX",
  "Advanced Specialty Hospital of Toledo - Toledo - OH",
  "Advanced Surgical Hospital - Washington - PA",
  "AdventHealth Altamonte Springs - Altamonte Springs - FL",
  "AdventHealth Apopka - Apopka - FL",
  "AdventHealth Avista - Louisville - CO",
  "AdventHealth Carrollwood - Tampa - FL",
  "AdventHealth Castle Rock - Castle Rock - CO",
  "AdventHealth Celebration - Celebration - FL",
  "AdventHealth Central Texas - Killeen - TX",
  "AdventHealth Connerton - Land O Lakes - FL",
  "AdventHealth Dade City - Dade City - FL",
  "AdventHealth Daytona Beach - Daytona Beach - FL",
  "AdventHealth DeLand - DeLand - FL",
  "AdventHealth Durand - Durand - WI",
  "AdventHealth East Orlando - Orlando - FL",
  "AdventHealth Fish Memorial - Orange City - FL",
  "AdventHealth Gordon - Calhoun - GA",
  "AdventHealth Heart of Florida - Davenport - FL",
  "AdventHealth Hendersonville - Hendersonville - NC",
  "AdventHealth Kissimmee - Kissimmee - FL",
  "AdventHealth Lake Placid - Lake Placid - FL",
  "AdventHealth Lake Wales - Lake Wales - FL",
  "AdventHealth Littleton - Littleton - CO",
  "AdventHealth Manchester - Manchester - KY",
  "AdventHealth Murray - Chatsworth - GA",
  "AdventHealth New Smyrna Beach - New Smyrna Beach - FL",
  "AdventHealth North Pinellas - Tarpon Springs - FL",
  "AdventHealth Ocala - Ocala - FL",
  "AdventHealth Orlando - Orlando - FL",
  "AdventHealth Ottawa - Ottawa - KS",
  "AdventHealth Palm Coast - Palm Coast - FL",
  "AdventHealth Parker - Parker - CO",
  "AdventHealth Pepin Heart Institute - Tampa - FL",
  "AdventHealth Porter - Denver - CO",
  "AdventHealth Redmond - Rome - GA",
  "AdventHealth Rollins Brook - Lampasas - TX",
  "AdventHealth Sebring - Sebring - FL",
  "AdventHealth Shawnee Mission - Shawnee Mission - KS",
  "AdventHealth South Overland Park - Overland Park - KS",
  "AdventHealth Tampa - Tampa - FL",
  "AdventHealth Waterman - Tavares - FL",
  "AdventHealth Wauchula - Wauchula - FL",
  "AdventHealth Wesley Chapel - Wesley Chapel - FL",
  "AdventHealth Winter Garden - Winter Garden - FL",
  "AdventHealth Winter Park - Winter Park - FL",
  "AdventHealth Zephyrhills - Zephyrhills - FL",
  "Adventist Health and Rideout - Marysville - CA",
  "Adventist Health Bakersfield - Bakersfield - CA",
  "Adventist Health Castle - Kailua - HI",
  "Adventist Health Clear Lake - Clearlake - CA",
  "Adventist Health Columbia Gorge - The Dalles - OR",
  "Adventist Health Delano - Delano - CA",
  "Adventist Health Glendale - Glendale - CA",
  "Adventist Health Hanford - Hanford - CA",
  "Adventist Health Howard Memorial - Willits - CA",
  "Adventist Health Lodi Memorial - Lodi - CA",
  "Adventist Health Mendocino Coast - Fort Bragg - CA",
  "Adventist Health Portland - Portland - OR",
  "Adventist Health Reedley - Reedley - CA",
  "Adventist Health Saint Helena - Saint Helena - CA",
  "Adventist Health Selma - Selma - CA",
  "Adventist Health Sonora - Sonora - CA",
  "Adventist Health Tehachapi Valley - Tehachapi - CA",
  "Adventist Health Tillamook - Tillamook - OR",
  "Adventist Health Tulare - Tulare - CA",
  "Adventist Health Ukiah Valley - Ukiah - CA",
  "Adventist Health Vallejo - Vallejo - CA",
  "Adventist Health White Memorial - Los Angeles - CA",
  "Adventist Health White Memorial Montebello - Montebello - CA",
  "Adventist HealthCare Fort Washington Medical Center - Fort Washington - MD",
  "Adventist HealthCare Rehabilitation - Rockville - MD",
  "Adventist HealthCare Shady Grove Medical Center - Rockville - MD",
  "Adventist HealthCare Shady Grove Medical Center - Mental Health - Rockville - MD",
  "Adventist HealthCare White Oak Medical Center - Silver Springs - MD",
  "Advocate Christ Medical Center - Oak Lawn - IL",
  "Advocate Condell Medical Center - Libertyville - IL",
  "Advocate Good Samaritan Hospital - Downers Grove - IL",
  "Advocate Good Shepherd Hospital - Barrington - IL",
  "Advocate Illinois Masonic Medical Center - Chicago - IL",
  "Advocate Lutheran General Hospital - Park Ridge - IL",
  "Advocate Sherman Hospital - Elgin - IL",
  "Advocate South Suburban Hospital - Hazel Crest - IL",
  "Advocate Trinity Hospital - Chicago - IL",
  "AHMC Seton Medical Center - Daly City - CA",
  "AHMC Seton Medical Center Coastside - Moss Beach - CA",
  "AHN Brentwood Neighborhood Hospital - Brentwood - PA",
  "AHN Grove City - Grove City - PA",
  "AHN Harmar Neighborhood Hospital - Pittsburgh - PA",
  "AHN Hempfield Neighborhood Hospital - Greensburg - PA",
  "AHN McCandless Neighborhood Hospital - Pittsburgh - PA",
  "AHN Wexford Hospital - Wexford - PA",
  "Aiken Regional Medical Centers - Aiken - SC",
  "Akron Children's Hospital - Akron - OH",
  "Akron General Lodi Hospital - Lodi - OH",
  "Alameda Hospital - Alameda - CA",
  "Alaska Native Medical Center - Anchorage - AK",
  "Alaska Psychiatric Institute - Anchorage - AK",
  "Alaska Regional Hospital - Anchorage - AK",
  "Albany Medical Center - Albany - NY",
  "Albany Stratton VA Medical Center - Albany - NY",
  "Albert J. Solnit Psychiatric Center - South Campus - Middletown - CT",
  "Albuquerque ER & Hospital - Albuquerque - NM",
  "Aleda E. Lutz VA Medical Center - Saginaw - MI",
  "Alexandria Emergency Hospital - Alexandria - LA",
  "Alexandria VA Health Care System - Pineville - LA",
  "Alhambra Hospital Medical Center - Alhambra - CA",
  "Alice Hyde Medical Center - Malone - NY",
  "Alice Peck Day Memorial Hospital - Lebanon - NH",
  "Aliso Ridge Behavioral Health - Aliso Viejo - CA",
  "Alleghany Health - Sparta - NC",
  "Allegheny General Hospital - Pittsburgh - PA",
  "Allegheny Valley Hospital - Natrona Heights - PA",
  "Allegiance Behavioral Health Center Of Plainview - Plainview - TX",
  "Allegiance Specialty Hospital of Greenville - Greenville - MS",
  "Allen County Regional Hospital - Iola - KS",
  "Allen Parish Community Healthcare - Kinder - LA",
  "Allendale County Hospital - Fairfax - SC",
  "Alliance Community Hospital - Alliance - OH",
  "Alliance Health Center - Meridian - MS",
  "Alliance Healthcare Hospital - Holly Springs - MS",
  "AllianceHealth Durant - Durant - OK",
  "AllianceHealth Madill - Madill - OK",
  "Allied Services Scranton Rehab Hospital - Scranton - PA",
  "Allied Services Wilkes-Barre Rehab Hospital - Wilkes-Barre - PA",
  "Allina Health Faribault Medical Center - Faribault - MN",
  "Allina Health United Hospital - Hastings Regina Campus - Hastings - MN",
  "Alomere Health - Alexandria - MN",
  "Alta Bates Summit Medical Center - Oakland - CA",
  "Alta Bates Summit Medical Center Herrick Campus - Berkeley - CA",
  "Alta Bates Summit Medical Center Alta Bates Campus - Berkeley - CA",
  "Alta View Hospital - Sandy - UT",
  "Alta Vista Regional Hospital - Las Vegas - NM",
  "Alton Memorial Hospital - Alton - IL",
  "Alton Mental Health Center - Alton - IL",
  "Altru Hospital - Grand Forks - ND",
  "Altru Specialty Center - Grand Forks - ND",
  "Altus Baytown Hospital - Baytown - TX",
  "Altus Houston Hospital - Houston - TX",
  "Altus Lumberton Hospital - Lumberton - TX",
  "Alvarado Parkway Institute - La Mesa - CA",
  "Amberwell Atchison - Atchison - KS",
  "Amberwell Hiawatha - Hiawatha - KS",
  "American Family Children's Hospital - Madison - WI",
  "American Fork Hospital - American Fork - UT",
  "Amery Hospital & Clinic - Amery - WI",
  "AMG Physical Rehabilitation Hospital-Covington - Covington - LA",
  "AMG Specialty Hospital - Central Indiana (Muncie Campus) - Muncie - IN",
  "AMG Specialty Hospital - Houma - Houma - LA",
  "AMG Specialty Hospital - Lafayette - Lafayette - LA",
  "AMG Specialty Hospital - Las Vegas - Las Vegas - NV",
  "AMG Specialty Hospital - Oklahoma City - Oklahoma City - OK",
  "AMG Specialty Hospital Albuquerque - Albuquerque - NM",
  "AMG Specialty Hospital Central Indiana - Hancock - Greenfield - IN",
  "AMG Specialty Hospital North Mississippi - Batesville - MS",
  "AMG Specialty Hospital Zachary - Zachary - LA",
  "Anaheim Community Hospital - Anaheim - CA",
  "Anaheim Global Medical Center - Anaheim - CA",
  "Anaheim Medical Center - Anaheim - CA",
  "Anaheim Regional Medical Center - Anaheim - CA",
  "Anchor Hospital - Atlanta - GA",
  "Ancora Psychiatric Hospital - Ancora - NJ",
  "Andalusia Health - Andalusia - AL",
  "Anderson County Hospital - Garnett - KS",
  "Anderson Hospital - Maryville - IL",
  "Anderson Regional Medical Center - Meridian - MS",
  "Anderson Regional Medical Center South - Meridian - MS",
  "Anderson Rehabilitation Institute - Edwardsville - IL",
  "Androscoggin Valley Hospital - Berlin - NH",
  "Anew Health - Shawnee, KS - Shawnee - KS",
  "Angel Medical Center - Franklin - NC",
  "Angleton Danbury Hospital - Angleton - TX",
  "Animas Surgical Hospital - Durango - CO",
  "AnMed Health Cannon - Pickens - SC",
  "AnMed Health Medical Center - Anderson - SC",
  "AnMed Health North Campus - Anderson - SC",
  "AnMed Health Rehabilitation Hospital - Anderson - SC",
  "Ann & Robert H. Lurie Children's Hospital of Chicago - Chicago - IL",
  "Ann Klein Forensic Center - West Trenton - NJ",
  "Anna Jaques Hospital - Newburyport - MA",
  "Annie Jeffrey Memorial County Health Center - Osceola - NE",
  "Anoka-Metro Regional Treatment Center - Anoka - MN",
  "Anschutz Medical Campus, Aurora - Aurora - CO",
  "Anson General Hospital - Anson - TX",
  "Antelope Memorial Hospital - Neligh - NE",
  "Antelope Valley Hospital - Lancaster - CA",
  "Antioch Medical Center - Antioch - CA",
  "Apalachee Center - Tallahassee - FL",
  "Apollo Behavioral Health Hospital - Baton Rouge - LA",
  "Appalachian Behavioral Healthcare - Athens - OH",
  "Appalachian Regional Behavioral Healthcare - Linville - NC",
  "Appleton Area Health Services - Appleton - MN",
  "Appling Hospital - Baxley - GA",
  "Arbor Health - Morton Hospital - Morton - WA",
  "Arbour Hospital - Jamaica Plain - MA",
  "Arbuckle Memorial Hospital - Sulphur - OK",
  "Archbold Grady General Hospital - Cairo - GA",
  "Archbold Medical Center - Thomasville - GA",
  "ArchCare at Terence Cardinal Cooke Health Care Center - New York - NY",
  "Arden Wood - San Francisco - CA",
  "ARH Our Lady of the Way - Martin - KY",
  "Arise Austin Medical Center - Austin - TX",
  "Arizona Specialty Hospital - Chandler - AZ",
  "Arizona Spine and Joint Hospital - Mesa - AZ",
  "Arizona State Hospital - Phoenix - AZ",
  "Arkansas Children's Hospital - Little Rock - AR",
  "Arkansas Children's Northwest - Springdale - AR",
  "Arkansas Continued Care Hospital of Jonesboro - Jonesboro - AR",
  "Arkansas Extended Care Hospital - Fort Smith - Fort Smith - AR",
  "Arkansas Extended Care Hospital - Hot Springs - Hot Springs - AR",
  "Arkansas Heart Hospital - Little Rock - AR",
  "Arkansas Heart Hospital Encore Medical Center - Bryant - AR",
  "Arkansas Methodist Medical Center - Paragould - AR",
  "Arkansas State Hospital - Little Rock - AR",
  "Arkansas Surgical Hospital - North Little Rock - AR",
  "Arkansas Valley Regional Medical Center - La Junta - CO",
  "Arms Acres - Carmel - NY",
  "Armstrong County Memorial Hospital - Kittanning - PA",
  "Army Community Hospital Weed - Irwin - Fort Irwin - CA",
  "Arnot Ogden Medical Center - Elmira - NY",
  "Arrowhead Behavioral Health - Maumee - OH",
  "Arrowhead Regional Medical Center - Colton - CA",
  "Arroyo Grande Community Hospital - Arroyo Grande - CA",
  "Artesia General Hospital - Artesia - NM",
  "Asante Ashland Community Hospital - Ashland - OR",
  "Asante Rogue Regional Medical Center - Medford - OR",
  "Asante Three Rivers Medical Center - Grants Pass - OR",
  "Ascension Alexian Brothers - Elk Grove Village - IL",
  "Ascension Alexian Brothers - Behavioral Health Hospital - Hoffman Estates - IL",
  "Ascension Alexian Brothers Rehabilitation Hospital - Elk Grove Village - IL",
  "Ascension All Saints Hospital - Surgical Services - Spring Street Campus - Racine - WI",
  "Ascension All Saints Hospital - Wisconsin Avenue Campus - Racine - WI",
  "Ascension Borgess Allegan Hospital - Allegan - MI",
  "Ascension Borgess Hospital - Kalamazoo - MI",
  "Ascension Borgess-Lee Hospital - Dowagiac - MI",
  "Ascension Borgess-Pipp Hospital - Plainwell - MI",
  "Ascension Brighton Center for Recovery - Brighton - MI",
  "Ascension Calumet Hospital - Chilton - WI",
  "Ascension Columbia Saint Mary's - Women's Hospital - Milwaukee - WI",
  "Ascension Columbia Saint Mary's Hospital - Milwaukee Campus - Milwaukee - WI",
  "Ascension Columbia St. Mary's Hospital - Milwaukee Campus - Milwaukee - WI",
  "Ascension Columbia St. Mary's Hospital - Ozaukee Campus - Mequon - WI",
  "Ascension Genesys Hospital - Grand Blanc - MI",
  "Ascension Holy Family - Des Plaines - IL",
  "Ascension Illinois - Behavioral Health Children's Center Chicago - Chicago - IL",
  "Ascension Macomb - Oakland Hospital, Warren Campus - Warren - MI",
  "Ascension Macomb-Oakland Hospital, Madison Heights Campus - Madison Heights - MI",
  "Ascension Medical Group St. Vincent - Heart Care - Carmel - IN",
  "Ascension Mercy in Aurora - Aurora - IL",
  "Ascension NE Wisconsin - Mercy Campus - Oshkosh - WI",
  "Ascension NE Wisconsin - St. Elizabeth Campus - Appleton - WI",
  "Ascension Providence - Waco - TX",
  "Ascension Providence DePaul Center - Waco - TX",
  "Ascension Providence Hospital - Novi Campus - Novi - MI",
  "Ascension Providence Hospital - Southfield Campus - Southfield - MI",
  "Ascension Providence Rochester Hospital - Rochester - MI",
  "Ascension Resurrection - Chicago - IL",
  "Ascension River District Hospital - East China Township - MI",
  "Ascension Sacred Heart Bay - Panama City - FL",
  "Ascension Sacred Heart Emerald Coast - Miramar Beach - FL",
  "Ascension Sacred Heart Hospital Gulf - Port Saint Joe - FL",
  "Ascension Sacred Heart Pensacola Hospital - Pensacola - FL",
  "Ascension Saint Agnes Hospital - Baltimore - MD",
  "Ascension Saint Alexius in Hoffman Estates - Hoffman Estates - IL",
  "Ascension Saint Alexius Women and Children's Hospital - Hoffman Estates - IL",
  "Ascension Saint Elizabeth - Chicago - IL",
  "Ascension Saint Francis - Evanston - IL",
  "Ascension Saint John Broken Arrow - Broken Arrow - OK",
  "Ascension Saint John Hospital - Detroit - MI",
  "Ascension Saint John Sapulpa - Sapulpa - OK",
  "Ascension Saint Joseph - Elgin - Elgin - IL",
  "Ascension Saint Joseph -Chicago - Chicago - IL",
  "Ascension Saint Joseph-Joliet - Joliet - IL",
  "Ascension Saint Mary -Chicago - Chicago - IL",
  "Ascension Saint Mary- Kankakee - Kankakee - IL",
  "Ascension Saint Thomas Behavioral Health Hospital - Nashville - TN",
  "Ascension Saint Thomas DeKalb - Smithville - TN",
  "Ascension Saint Thomas Hickman - Centerville - TN",
  "Ascension Saint Thomas Highlands Hospital - Sparta - TN",
  "Ascension Saint Thomas Hospital West - Nashville - TN",
  "Ascension Saint Thomas Midtown Hospital - Nashville - TN",
  "Ascension Saint Thomas Rehabilitation Hospital - Nashville - TN",
  "Ascension Saint Thomas River Park - McMinnville - TN",
  "Ascension Saint Thomas Rutherford Hospital - Murfreesboro - TN",
  "Ascension Saint Thomas Stones River - Woodbury - TN",
  "Ascension Saint Thomas Three Rivers - Waverly - TN",
  "Ascension Saint Vincent Carmel - Carmel - IN",
  "Ascension Saint Vincent Evansville - Evansville - IN",
  "Ascension Saint Vincent Fishers - Fishers - IN",
  "Ascension Saint Vincent Hospital - Indianapolis - Indianapolis - IN",
  "Ascension Saint Vincent Stress Center - Indianapolis - IN",
  "Ascension Saint Vincent Women's Hospital - Indianapolis - IN",
  "Ascension Saint Vincent's Birmingham - Birmingham - AL",
  "Ascension Saint Vincent's Chilton - Clanton - AL",
  "Ascension Saint Vincent's St. Clair - Pell City - AL",
  "Ascension SE Wisconsin Hospital - Franklin Campus - Franklin - WI",
  "Ascension SE Wisconsin Hospital-Elmbrook Campus - Brookfield - WI",
  "Ascension SE Wisconsin Hospital-St. Joseph Campus - Milwaukee - WI",
  "Ascension Seton Bastrop - Bastrop - TX",
  "Ascension Seton Edgar B. Davis - Luling - TX",
  "Ascension Seton Hays - Kyle - TX",
  "Ascension Seton Highland Lakes - Burnet - TX",
  "Ascension Seton Medical Center Austin - Austin - TX",
  "Ascension Seton Northwest Hospital - Austin - TX",
  "Ascension Seton Shoal Creek - Austin - TX",
  "Ascension Seton Smithville - Smithville - TX",
  "Ascension Seton Southwest Hospital - Austin - TX",
  "Ascension Seton Williamson - Round Rock - TX",
  "Ascension St. Francis Hospital - Milwaukee - WI",
  "Ascension St. John Jane Phillips - Bartlesville - OK",
  "Ascension St. John Nowata - Nowata - OK",
  "Ascension St. John Owasso - Owasso - OK",
  "Ascension St. John Rehabilitation Hospital of Owasso - Owasso - OK",
  "Ascension St. Joseph Hospital - Tawas City - MI",
  "Ascension St. Mary's Hospital - Saginaw - MI",
  "Ascension St. Vincent Anderson - Anderson - IN",
  "Ascension St. Vincent Clay - Brazil - IN",
  "Ascension St. Vincent Jennings - North Vernon - IN",
  "Ascension St. Vincent Kokomo - Kokomo - IN",
  "Ascension St. Vincent Mercy - Elwood - IN",
  "Ascension St. Vincent Plainfield - Plainfield - IN",
  "Ascension St. Vincent Randolph - Winchester - IN",
  "Ascension St. Vincent Salem - Salem - IN",
  "Ascension St. Vincent Seton - Indianapolis - IN",
  "Ascension St. Vincent Warrick - Boonville - IN",
  "Ascension St. Vincent Williamsport - Williamsport - IN",
  "Ascension St. Vincent's Blount - Oneonta - AL",
  "Ascension St. Vincent's Clay County Hospital - Middleburg - FL",
  "Ascension St. Vincent's East - Birmingham - AL",
  "Ascension St. Vincent's Health Center - St. Johns - St. Augustine - FL",
  "Ascension St. Vincent's Riverside Hospital - Jacksonville - FL",
  "Ascension St. Vincent's Southside Hospital - Jacksonville - FL",
  "Ascension St. Vincent's St. Johns County Hospital - St. Johns - FL",
  "Ascension Standish Hospital - Standish - MI",
  "Ascension Via Christi Behavioral Health Center - Wichita - KS",
  "Ascension Via Christi Hospital in Manhattan - Manhattan - KS",
  "Ascension Via Christi Hospital in Pittsburg - Pittsburg - KS",
  "Ascension Via Christi Rehabilitation Hospital - Wichita - KS",
  "Ascension Via Christi St. Francis - Wichita - KS",
  "Ascension Via Christi St. Joseph - Wichita - KS",
  "Ascension Via Christi St. Teresa - Wichita - KS",
  "Ascension Wisconsin Hospital - Greenfield - Greenfield - WI",
  "Ascension Wisconsin Hospital - Menomonee Falls - Menomonee Falls - WI",
  "Ascension Wisconsin Hospital - Waukesha - Waukesha - WI",
  "Ascentist Hospital - Leawood - KS",
  "Ashe Memorial Hospital - Jefferson - NC",
  "Asheville Specialty Hospital - Asheville - NC",
  "Ashford Hospital - San Juan - PR",
  "Ashland Health Center - Ashland - KS",
  "Ashley County Medical Center - Crossett - AR",
  "Ashley Medical Center - Ashley - ND",
  "Ashley Regional Medical Center - Vernal - UT",
  "Ashtabula County Medical Center - Ashtabula - OH",
  "Aspen Mountain Medical Center - Rock Springs - WY",
  "Aspen Valley Hospital - Aspen - CO",
  "Aspire Behavioral Health Hospital - Conroe - TX",
  "Aspire Health Partners -Princeton Plaza - Orlando - FL",
  "Aspirus Divine Savior Hospital - Portage - WI",
  "Aspirus Eagle River Hospital - Eagle River - WI",
  "Aspirus Iron River Hospital - Iron River - MI",
  "Aspirus Ironwood Hospital - Ironwood - MI",
  "Aspirus Keweenaw Hospital - Laurium - MI",
  "Aspirus Langlade Hospital - Antigo - WI",
  "Aspirus Medford Hospital - Medford - WI",
  "Aspirus Merrill Hospital - Merrill - WI",
  "Aspirus Ontonagon Hospital - Ontonagon - MI",
  "Aspirus Plover Hospital - Stevens Point - WI",
  "Aspirus Rhinelander Hospital - Rhinelander - WI",
  "Aspirus Riverview Hospital - Wisconsin Rapids - WI",
  "Aspirus Stanley Hospital - Stanley - WI",
  "Aspirus Stevens Point Hospital - Stevens Point - WI",
  "Aspirus Tomahawk Hospital - Tomahawk - WI",
  "Aspirus Wausau Hospital - Wausau - WI",
  "Assumption Community Hospital - Napoleonville - LA",
  "Assurance Health Cincinnati - Cincinnati - OH",
  "Assurance Health Hudson - Hudson - OH",
  "Assurance Health Indianapolis - Indianapolis - IN",
  "Assurance Health Toledo - Sylvania - OH",
  "Astera Health - Wadena - MN",
  "Astria Sunnyside Hospital - Sunnyside - WA",
  "Astria Toppenish Hospital - Toppenish - WA",
  "Athens-Limestone Hospital - Athens - AL",
  "Athol Memorial Hospital - Athol - MA",
  "Atlantic General Hospital - Berlin - MD",
  "Atlantic Rehabilitation Institute - Madison - NJ",
  "AtlantiCare Regional Medical Center, Atlantic City Campus - Atlantic City - NJ",
  "AtlantiCare Regional Medical Center, Mainland Campus - Pomona - NJ",
  "Atmore Community Hospital - Atmore - AL",
  "Atoka County Medical Center - Atoka - OK",
  "Atrium Health Anson - Wadesboro - NC",
  "Atrium Health Behavioral Health Charlotte, a facility of Carolinas Medical Center - Charlotte - NC",
  "Atrium Health Behavioral Health Psychiatry and Counseling - Davidson - NC",
  "Atrium Health Cabarrus - Concord - NC",
  "Atrium Health Carolinas Medical Center - Charlotte - NC",
  "Atrium Health Cleveland - Shelby - NC",
  "Atrium Health Floyd - Rome - GA",
  "Atrium Health Floyd Cherokee Medical Center - Centre - AL",
  "Atrium Health Floyd Polk Medical Center - Cedartown - GA",
  "Atrium Health Kings Mountain - Kings Mountain - NC",
  "Atrium Health Levine Children's Hospital - Charlotte - NC",
  "Atrium Health Lincoln - Lincolnton - NC",
  "Atrium Health Mercy - Charlotte - NC",
  "Atrium Health Navicent - Macon - GA",
  "Atrium Health Navicent Baldwin - Milledgeville - GA",
  "Atrium Health Navicent Beverly Knight Olson Children's Hospital - Macon - GA",
  "Atrium Health Navicent Peach - Byron - GA",
  "Atrium Health Navicent Rehabilitation Hospital - Macon - GA",
  "Atrium Health Pineville - Charlotte - NC",
  "Atrium Health Stanly - Albemarle - NC",
  "Atrium Health Union - Monroe - NC",
  "Atrium Health Union West - Matthews - NC",
  "Atrium Health University City - Charlotte - NC",
  "Atrium Health Wake Forest Baptist Medical Center - Winston-Salem - NC",
  "Atrium Health Wake Forest Baptist Wilkes Medical Center - North Wilkesboro - NC",
  "Atrium Medical Center - Middletown - OH",
  "Atrium Medical Center - Stafford - TX",
  "Auburn Community Hospital - Auburn - NY",
  "Audie L. Murphy Memorial VA Hospital - San Antonio - TX",
  "Audubon County Memorial Hospital - Audubon - IA",
  "Augusta Health - Fishersville - VA",
  "Augusta University Medical Center - Augusta - GA",
  "Aultman Hospital - Canton - OH",
  "Aultman Orrville Hospital - Orrville - OH",
  "Aultman Specialty Hospital - Canton - OH",
  "Aurora BayCare Medical Center - Green Bay - WI",
  "Aurora Behavioral Health Care San Diego - San Diego - CA",
  "Aurora Charter Oak Hospital - Covina - CA",
  "Aurora East Hospital - Tempe - AZ",
  "Aurora Lakeland Medical Center - Elkhorn - WI",
  "Aurora Medical Center - Burlington - Burlington - WI",
  "Aurora Medical Center - Grafton - Grafton - WI",
  "Aurora Medical Center - Kenosha - Kenosha - WI",
  "Aurora Medical Center - Manitowoc County - Two Rivers - WI",
  "Aurora Medical Center - Mount Pleasant - Mount Pleasant - WI",
  "Aurora Medical Center - Oshkosh - Oshkosh - WI",
  "Aurora Medical Center - Sheboygan County - Sheboygan - WI",
  "Aurora Medical Center - Summit - Summit - WI",
  "Aurora Medical Center - Washington County - Hartford - WI",
  "Aurora Medical Center-Bay Area - Marinette - WI",
  "Aurora Psychiatric Hospital - Wauwatosa - WI",
  "Aurora Saint Luke's South Shore - Cudahy - WI",
  "Aurora Sinai Medical Center - Milwaukee - WI",
  "Aurora St. Luke's Medical Center - Milwaukee - WI",
  "Aurora West Allis Medical Center - West Allis - WI",
  "Aurora West Hospital - Glendale - AZ",
  "Austen Riggs Center - Stockbridge - MA",
  "Austin Oaks Hospital - Austin - TX",
  "Austin State Hospital - Austin - TX",
  "Auxilio Mutuo Hospital of Puerto Rico - Hato Rey - PR",
  "Avail Hospital Lake Charles - Lake Charles - LA",
  "Avala Hospital - Covington - LA",
  "Avenir Behavioral Health Center at Surprise - Surprise - AZ",
  "Avera Creighton Hospital - Creighton - NE",
  "Avera De Smet Memorial Hospital - De Smet - SD",
  "Avera Dells Area Hospital - Dell Rapids - SD",
  "Avera Flandreau Hospital - Flandreau - SD",
  "Avera Fox Run Health Campus - Yankton - SD",
  "Avera Granite Falls Health Center - Granite Falls - MN",
  "Avera Gregory Hospital - Gregory - SD",
  "Avera Hand County Memorial Hospital - Miller - SD",
  "Avera Heart Hospital - Sioux Falls - SD",
  "Avera Holy Family Hospital - Estherville - IA",
  "Avera Marshall Regional Medical Center - Marshall - MN",
  "Avera McKennan Hospital & University Health Center - Sioux Falls - SD",
  "Avera Merrill Pioneer Hospital - Rock Rapids - IA",
  "Avera Missouri River Health Center - Gettysburg - SD",
  "Avera Queen of Peace Hospital - Mitchell - SD",
  "Avera Sacred Heart Hospital - Yankton - SD",
  "Avera Saint Anthony's Hospital - O'Neill - NE",
  "Avera Saint Luke's Hospital - Aberdeen - SD",
  "Avera Saint Mary's Hospital - Pierre - SD",
  "Avera St. Benedict Hospital - Parkston - SD",
  "Avera Tyler Hospital - Tyler - MN",
  "Avera Weskota Memorial Medical Center - Wessington Springs - SD",
  "Avita Ontario Hospital - Ontario - OH",
  "Avon Hospital at Richard E. Jacobs Campus - Avon - OH",
  "Avoyelles Hospital - Marksville - LA",
  "Backus Hospital - Norwich - CT",
  "Bacon County Hospital - Alma - GA",
  "Bailey Medical Center - Owasso - OK",
  "Bakersfield Behavioral Healthcare Hospital - Bakersfield - CA",
  "Bakersfield Heart Hospital - Bakersfield - CA",
  "Bakersfield Memorial Hospital - Bakersfield - CA",
  "Bakersfield Rehabilitation Hospital - Bakersfield - CA",
  "Baldpate Hospital - Georgetown - MA",
  "Baldwin Park Medical Center - Baldwin Park - CA",
  "Ballard Rehabilitation Hospital - San Bernardino - CA",
  "Ballinger Memorial Hospital - Ballinger - TX",
  "Baltimore VA Medical Center - Baltimore - MD",
  "Banner - University Medical Center Tucson - Tucson - AZ",
  "Banner - University Medical Center Phoenix - Phoenix - AZ",
  "Banner - University Medical Center South - Tucson - AZ",
  "Banner Baywood Medical Center - Mesa - AZ",
  "Banner Behavioral Health Hospital - Scottsdale - AZ",
  "Banner Boswell Medical Center - Sun City - AZ",
  "Banner Casa Grande Medical Center - Casa Grande - AZ",
  "Banner Children's at Desert - Mesa - AZ",
  "Banner Churchill Community Hospital - Fallon - NV",
  "Banner Del E. Webb Medical Center - Sun City West - AZ",
  "Banner Desert Medical Center - Mesa - AZ",
  "Banner Estrella Medical Center - Phoenix - AZ",
  "Banner Fort Collins Medical Center - Fort Collins - CO",
  "Banner Gateway Medical Center - Gilbert - AZ",
  "Banner Goldfield Medical Center - Apache Junction - AZ",
  "Banner Heart Hospital - Mesa - AZ",
  "Banner Ironwood Medical Center - Queen Creek - AZ",
  "Banner Lassen Medical Center - Susanville - CA",
  "Banner North Colorado Medical Center - Greeley - CO",
  "Banner Ocotillo Medical Center - Chandler - AZ",
  "Banner Payson Medical Center - Payson - AZ",
  "Banner Rehabilitation Hospital West - Peoria - AZ",
  "Banner Thunderbird Medical Center - Glendale - AZ",
  "Baptist Children's Hospital - Miami - FL",
  "Baptist Collierville - Collierville - TN",
  "Baptist Health Corbin - Corbin - KY",
  "Baptist Health Deaconess Madisonville - Madisonville - KY",
  "Baptist Health Extended Care Hospital - Little Rock - AR",
  "Baptist Health Floyd - New Albany - IN",
  "Baptist Health Hardin - Elizabethtown - KY",
  "Baptist Health LaGrange - La Grange - KY",
  "Baptist Health Lexington - Lexington - KY",
  "Baptist Health Louisville - Louisville - KY",
  "Baptist Health Medical Center - Arkadelphia - Arkadelphia - AR",
  "Baptist Health Medical Center - Conway - Conway - AR",
  "Baptist Health Medical Center - Heber Springs - Heber Springs - AR",
  "Baptist Health Medical Center - Hot Spring County - Malvern - AR",
  "Baptist Health Medical Center - North Little Rock - North Little Rock - AR",
  "Baptist Health Medical Center - Stuttgart - Stuttgart - AR",
  "Baptist Health Medical Center- Little Rock - Little Rock - AR",
  "Baptist Health Paducah - Paducah - KY",
  "Baptist Health Rehabilitation Institute-Little Rock - Little Rock - AR",
  "Baptist Health Richmond - Richmond - KY",
  "Baptist Health-Fort Smith - Fort Smith - AR",
  "Baptist Health-Van Buren - Van Buren - AR",
  "Baptist Heart Hospital - Jacksonville - FL",
  "Baptist Hospital - Miami - FL",
  "Baptist Hospital - Pensacola - FL",
  "Baptist Hospitals of Southeast Texas - Beaumont - TX",
  "Baptist Medical Center - San Antonio - TX",
  "Baptist Medical Center Beaches - Jacksonville Beach - FL",
  "Baptist Medical Center Clay - Fleming Island - FL",
  "Baptist Medical Center East - Montgomery - AL",
  "Baptist Medical Center Jacksonville - Jacksonville - FL",
  "Baptist Medical Center Nassau - Fernandina Beach - FL",
  "Baptist Medical Center South - Jacksonville - FL",
  "Baptist Medical Center South - Montgomery - AL",
  "Baptist Memorial Hospital - Attala - Kosciusko - MS",
  "Baptist Memorial Hospital - Booneville - Booneville - MS",
  "Baptist Memorial Hospital - Calhoun - Calhoun City - MS",
  "Baptist Memorial Hospital - Caroll County - Huntingdon - TN",
  "Baptist Memorial Hospital - Crittenden - West Memphis - AR",
  "Baptist Memorial Hospital - DeSoto - Southaven - MS",
  "Baptist Memorial Hospital - Golden Triangle - Columbus - MS",
  "Baptist Memorial Hospital - Memphis - Memphis - TN",
  "Baptist Memorial Hospital - North Mississippi - Oxford - MS",
  "Baptist Memorial Hospital - Tipton - Covington - TN",
  "Baptist Memorial Hospital - Union City - Union City - TN",
  "Baptist Memorial Hospital - Union County - New Albany - MS",
  "Baptist Memorial Hospital for Women - Memphis - TN",
  "Baptist Memorial Hospital-Leake - Carthage - MS",
  "Baptist Memorial Hospital-Yazoo - Yazoo City - MS",
  "Baptist Memorial Rehabilitation Hospital - Germantown - TN",
  "Baptist Memorial Restorative Care Hospital - Memphis - TN",
  "Baptist Neighborhood Hospital - Hausman - San Antonio - TX",
  "Baptist Neighborhood Hospital - Kelly - San Antonio - TX",
  "Baptist Neighborhood Hospital - Overlook - San Antonio - TX",
  "Baptist Neighborhood Hospital - Schertz - Schertz - TX",
  "Baptist Neighborhood Hospital - Westover Hills - San Antonio - TX",
  "Baptist Neighborhood Hospital - Zarazmora - San Antonio - TX",
  "Baptist Neighborhood Hospital- Thousand Oaks - San Antonio - TX",
  "Baraga County Memorial Hospital - L'Anse - MI",
  "Barbourville ARH Hospital - Barbourville - KY",
  "Barlow Respiratory Hospital at PIH Health Hospital Whittier - Whittier - CA",
  "Barlow Respiratory Hospital at Valley Presbyterian - Van Nuys - CA",
  "Barlow Respiratory Hospital Main in Los Angeles - Los Angeles - CA",
  "Barnes-Jewish Hospital - Saint Louis - MO",
  "Barnes-Jewish Hospital Psychiatric Support Center - Saint Louis - MO",
  "Barnes-Jewish St.Peters Hospital - Saint Peters - MO",
  "Barnes-Jewish West County Hospital - Creve Coeur - MO",
  "Barnes-Kasson Hospital - Susquehanna - PA",
  "Barrett Hospital & Healthcare - Dillon - MT",
  "Barstow Community Hospital - Barstow - CA",
  "Bartlett Regional Hospital - Juneau - AK",
  "Barton Memorial Hospital - South Lake Tahoe - CA",
  "Bartow Regional Medical Center - Bartow - FL",
  "Bascom Palmer Eye Institute - Miami - FL",
  "BASS Surgery Center - Walnut Creek - CA",
  "Bassett Army Community Hospital - Fort Wainwright - AK",
  "Bassett Medical Center - Cooperstown - NY",
  "Batavia VA Medical Center - Batavia - NY",
  "Bates County Memorial Hospital - Butler - MO",
  "Bath Community Hospital - Hot Springs - VA",
  "Bath VA Medical Center - Bath - NY",
  "Baton Rouge Behavioral Hospital - Baton Rouge - LA",
  "Baton Rouge General - Bluebonnet - Baton Rouge - LA",
  "Baton Rouge General - Mid City - Baton Rouge - LA",
  "Baton Rouge Rehabilitation Hospital - Baton Rouge - LA",
  "Battle Creek VA Medical Center - Battle Creek - MI",
  "Battle Mountain General Hospital - Battle Mountain - NV",
  "Baxter Health - Mountain Home - AR",
  "Bay Area Hospital - Coos Bay - OR",
  "Bay Pines VA Healthcare System - Bay Pines - FL",
  "Bayamon Medical Center - Bayamon - PR",
  "Bayamon Regional Hospital - Bayamon - PR",
  "BayCare Alliant Hospital - Dunedin - FL",
  "BayCare Hospital Wesley Chapel - Wesley Chapel - FL",
  "Bayfront Health St. Petersburg - Saint Petersburg - FL",
  "Bayhealth Hospital, Kent Campus - Dover - DE",
  "Bayhealth Hospital, Sussex Campus - Milford - DE",
  "Baylor Scott & White All Saints Medical Center - Fort Worth - Fort Worth - TX",
  "Baylor Scott & White Continuing Care Hospital - Temple - Temple - TX",
  "Baylor Scott & White Emergency Hospital - Colleyville - Colleyville - TX",
  "Baylor Scott & White Emergency Hospital - Grand Prairie - Grand Prairie - TX",
  "Baylor Scott & White Emergency Hospital - Mansfield - Mansfield - TX",
  "Baylor Scott & White Emergency Hospital - Murphy - Murphy - TX",
  "Baylor Scott & White Emergency Hospital - Rockwall - Rockwall - TX",
  "Baylor Scott & White Emergency Hospital Aubrey - Aubrey - TX",
  "Baylor Scott & White Emergency Hospital-Burleson - Burleson - TX",
  "Baylor Scott & White Emergency Hospitals - Keller - Keller - TX",
  "Baylor Scott & White Heart and Vascular Hospital-Dallas - Dallas - TX",
  "Baylor Scott & White Institute for Rehabilitation - Fort Worth - Fort Worth - TX",
  "Baylor Scott & White Institute for Rehabilitation - Frisco - Frisco - TX",
  "Baylor Scott & White Institute for Rehabilitation - Lakeway - Lakeway - TX",
  "Baylor Scott & White McLane Children's Medical Center - Temple - Temple - TX",
  "Baylor Scott & White Medical Center - Austin - Austin - TX",
  "Baylor Scott & White Medical Center - Buda - Buda - TX",
  "Baylor Scott & White Medical Center - Centennial - Frisco - TX",
  "Baylor Scott & White Medical Center - Hillcrest - Waco - TX",
  "Baylor Scott & White Medical Center - Lake Pointe - Rowlett - TX",
  "Baylor Scott & White Medical Center - Lakeway - Lakeway - TX",
  "Baylor Scott & White Medical Center - McKinney - McKinney - TX",
  "Baylor Scott & White Medical Center - Pflugerville - Pflugerville - TX",
  "Baylor Scott & White Medical Center - Plano - Plano - TX",
  "Baylor Scott & White Medical Center - Round Rock - Round Rock - TX",
  "Baylor Scott & White Medical Center - Sunnyvale - Sunnyvale - TX",
  "Baylor Scott & White Medical Center - Taylor - Taylor - TX",
  "Baylor Scott & White Medical Center - Temple - Temple - TX",
  "Baylor Scott & White Medical Center - Waxahachie - Waxahachie - TX",
  "Baylor Scott & White Medical Center College Station - College Station - TX",
  "Baylor Scott & White Medical Center Irving - Irving - TX",
  "Baylor Scott & White Medical Center Marble Falls - Marble Falls - TX",
  "Baylor Scott & White Medical Center Trophy Club - Trophy Club - TX",
  "Baylor Scott & White Medical Center Uptown - Dallas - TX",
  "Baylor Scott & White Medical Center-Brenham - Brenham - TX",
  "Baylor Scott & White Orthopedic and Spine Hospital Arlington - Arlington - TX",
  "Baylor Scott & White Rehabilitation - Dallas - Dallas - TX",
  "Baylor Scott & White Surgical Hospital at Sherman - Sherman - TX",
  "Baylor Scott & White Surgical Hospital Fort Worth - Fort Worth - TX",
  "Baylor Scott & White Texas Spine & Joint Hospital - Tyler - TX",
  "Baylor Scott and White Medical Center Frisco - Frisco - TX",
  "Baylor Scott and White The Heart Hospital - Denton - Denton - TX",
  "Baylor Scott and White The Heart Hospital - Plano - Plano - TX",
  "Baylor Surgical Hospital at Las Colinas - Irving - TX",
  "Baylor University Medical Center - Dallas - TX",
  "Bayne-Jones Army Community Hospital - Fort Polk - LA",
  "Bayonne Medical Center - Bayonne - NJ",
  "Bayou Bend Health System - Franklin - LA",
  "Baypointe Children's Hospital - Mobile - AL",
  "BayRidge Hospital - Lynn - MA",
  "Bayshore Medical Center - Holmdel - NJ",
  "Bayside Community Hospital - Anahuac - TX",
  "Baystate Franklin Medical Center - Greenfield - MA",
  "Baystate Medical Center - Springfield - MA",
  "Baystate Noble Hospital - Westfield - MA",
  "Baystate Wing Hospital - Palmer - MA",
  "Beacham Memorial Hospital - Magnolia - MS",
  "Beacon Behavioral Hospital - Luverne - AL",
  "Beacon Behavioral Hospital - Lutcher - LA",
  "Beacon Behavioral Hospital - Bunkie - Bunkie - LA",
  "Beacon Behavioral Hospital Northshore - Lacombe - LA",
  "Beacon Behavioral Hospital-New Orleans - New Orleans - LA",
  "Beacon Haven - New Brighton - MN",
  "Bear Lake Memorial Hospital - Montpelier - ID",
  "Bear River Valley Hospital - Tremonton - UT",
  "Bear Valley Community Hospital - Big Bear Lake - CA",
  "Beartooth Billings Clinic - Red Lodge - MT",
  "Beatrice Community Hospital - Beatrice - NE",
  "Beaufort Memorial Hospital - Beaufort - SC",
  "Beaumont Behavioral Health - Dearborn - MI",
  "Beaumont Hospital, Dearborn - Dearborn - MI",
  "Beaumont Hospital, Farmington Hills - Farmington Hills - MI",
  "Beaumont Hospital, Grosse Pointe - Grosse Pointe - MI",
  "Beaumont Hospital, Royal Oak - Royal Oak - MI",
  "Beaumont Hospital, Taylor - Taylor - MI",
  "Beaumont Hospital, Trenton - Trenton - MI",
  "Beaumont Hospital, Troy - Troy - MI",
  "Beaumont Hospital, Wayne - Wayne - MI",
  "Beauregard Health System - DeRidder - LA",
  "Beaver County Memorial Hospital - Beaver - OK",
  "Beaver Valley Hospital - Beaver - UT",
  "Beckett Springs - West Chester - OH",
  "Beckley ARH Hospital - Beckley - WV",
  "Beckley VA Medical Center - Beckley - WV",
  "Beebe Healthcare - Lewes - DE",
  "Behavioral Center of Michigan - Warren - MI",
  "Behavioral Health Center - Concord - CA",
  "Behavioral Health of Rocky Top - Rocky Top - TN",
  "Behavioral Hospital of Bellaire - Houston - TX",
  "Bella Vista Hospital - Mayaguez - PR",
  "Bellevue Medical Center - Bellevue - NE",
  "Bellevue Woman's Center - Niskayuna - NY",
  "Bellin Health Oconto Hospital - Oconto - WI",
  "Bellin Health Psychiatric Hospital- Green Bay - Green Bay - WI",
  "Bellin Hospital - Green Bay - WI",
  "Belmont Behavioral Hospital - Philadelphia - PA",
  "Belmont Pines Hospital - Youngstown - OH",
  "Beloit Memorial Hospital - Beloit - WI",
  "Belton Regional Medical Center - Belton - MO",
  "Ben Taub Hospital - Houston - TX",
  "Benchmark Behavioral Health System - Woods Cross - UT",
  "Benefis East Campus - Great Falls - MT",
  "Benefis Missouri River Medical Center - Fort Benton - MT",
  "Benefis Teton Medical Center - Choteau - MT",
  "Benefis West Campus - Great Falls - MT",
  "Benewah Community Hospital - Saint Maries - ID",
  "Bennett County Hospital - Martin - SD",
  "Benson Hospital - Benson - AZ",
  "Bergen New Bridge Medical Center - Paramus - NJ",
  "Berkeley Medical Center - Martinsburg - WV",
  "Berkshire Medical Center - Pittsfield - MA",
  "Bertrand Chaffee Hospital - Springville - NY",
  "Berwick Psychiatric Hospital - Berwick - PA",
  "Beth Israel Deaconess Hospital Milton - Milton - MA",
  "Beth Israel Deaconess Hospital-Plymouth - Plymouth - MA",
  "Beth Israel Deaconess Medical Center - Boston - MA",
  "Beth Israel Deaconess Needham - Needham - MA",
  "Bethany Children's Health Center - Bethany - OK",
  "Bethesda Butler Hospital - Hamilton - OH",
  "Bethesda Hospital East - Boynton Beach - FL",
  "Bethesda Hospital West - Boynton Beach - FL",
  "Bethesda North Hospital - Cincinnati - OH",
  "Bethesda Rehabilitation Hospital - Baton Rouge - LA",
  "Betsy Johnson Regional Hospital - Dunn - NC",
  "Beverly Hospital - Beverly - MA",
  "BHC Alhambra Hospital - Rosemead - CA",
  "Bibb Medical Center - Centreville - AL",
  "Bienville Medical Center - Arcadia - LA",
  "Big Bend Regional Medical Center - Alpine - TX",
  "Big Horn Hospital - Hardin - MT",
  "Big Sandy Medical Center - Big Sandy - MT",
  "Big South Fork Medical Center - Oneida - TN",
  "Big Spring State Hospital - Big Spring - TX",
  "Bigfork Valley Hospital - Bigfork - MN",
  "Billings Clinic Broadwater - Townsend - MT",
  "Billings Clinic Hospital - Billings - MT",
  "Bingham Memorial Hospital - Blackfoot - ID",
  "Birmingham VA Medical Center - Birmingham - AL",
  "Bitterroot Health - Daly Hospital - Hamilton - MT",
  "Black Hills Surgical Hospital - Rapid City - SD",
  "Black River Memorial Hospital - Black River Falls - WI",
  "Blackfeet Community Hospital - Browning - MT",
  "Bladen County Hospital - Elizabethtown - NC",
  "Blanchard Valley Hospital - Findlay - OH",
  "Blanchfield Army Community Hospital - Fort Campbell - KY",
  "Blank Children's Hospital - Des Moines - IA",
  "Bleckley Memorial Hospital - Cochran - GA",
  "Blessing Hospital - Quincy - IL",
  "Bliant Specialty Hospital - New Orleans - LA",
  "Bloomington Meadows Hospital - Bloomington - IN",
  "Bloomington Regional Rehabilitation Hospital - Bloomington - IN",
  "Blount Memorial Hospital - Maryville - TN",
  "Blue Mountain Hospital - Blanding - UT",
  "Blue Mountain Hospital - John Day - OR",
  "Blue Ridge Regional Hospital - Spruce Pine - NC",
  "Bluegrass Community Hospital - Versailles - KY",
  "Blueridge Vista Behavioral Health - Cincinnati - OH",
  "Bluestone Child & Adolescent Psychiatric Hospital - University Heights - OH",
  "Bluffton Hospital - Bluffton - OH",
  "Bluffton Regional Medical Center - Bluffton - IN",
  "Blythedale Children's Hospital - Valhalla - NY",
  "Boca Raton Regional Hospital - Boca Raton - FL",
  "Bogalusa Rehabilitation Hospital - Bogalusa - LA",
  "Boise VA Medical Center - Boise - ID",
  "Bolivar Medical Center - Cleveland - MS",
  "Bon Secours - Southampton Memorial Center - Franklin - VA",
  "Bon Secours - Southern Virginia Medical Center - Emporia - VA",
  "Bon Secours - Southside Medical Center - Petersburg - VA",
  "Bon Secours Community Hospital - Port Jervis - NY",
  "Bon Secours Health Center at Harbour View Campus - Suffolk - VA",
  "Bon Secours Mary Immaculate Hospital - Newport News - VA",
  "Bon Secours Maryview Medical Center - Portsmouth - VA",
  "Bon Secours Saint Francis Hospital - Charleston - SC",
  "Bonner General Hospital - Sandpoint - ID",
  "Boone County Health Center - Albion - NE",
  "Boone County Hospital - Boone - IA",
  "Boone Hospital Center - Columbia - MO",
  "Boone Memorial Health - Madison - WV",
  "Boston Children's Hospital - Boston - MA",
  "Boston Medical Center - Boston - MA",
  "Bothwell Regional Health Center - Sedalia - MO",
  "Boulder City Hospital - Boulder City - NV",
  "Boundary Community Hospital - Bonners Ferry - ID",
  "Bourbon Community Hospital - Paris - KY",
  "Bournewood Hospital - Brookline - MA",
  "Bowdle Healthcare Center - Bowdle - SD",
  "Bowen Health Clinic - Warsaw - Warsaw - IN",
  "Box Butte General Hospital - Alliance - NE",
  "Boys Town National Research Hospital - Boys Town - NE",
  "Bozeman Health Big Sky Medical Center - Big Sky - MT",
  "Bozeman Health Deaconess Regional Medical Center - Bozeman - MT",
  "Bradford Regional Medical Center - Bradford - PA",
  "Bradley County Medical Center - Warren - AR",
  "Bradley Hospital - East Providence - RI",
  "Bradley Memorial Campus - Southington - CT",
  "Brattleboro Memorial Hospital - Brattleboro - VT",
  "Brattleboro Retreat - Brattleboro - VT",
  "Braxton County Memorial Hospital - Gassaway - WV",
  "Breckinridge Health - Hardinsburg - KY",
  "Brenner Children's Wake Forest Baptist Health - Winston-Salem - NC",
  "Brentwood Behavioral Healthcare of Mississippi - Jackson - MS",
  "Brentwood Hospital - Shreveport - LA",
  "Brentwood Springs - Newburgh - IN",
  "BridgePoint Continuing Care Hospital - Marrero - LA",
  "BridgePoint Continuing Care Hospital - EJGH Campus - Metairie - LA",
  "BridgePoint Hospital Capitol Hill - Washington - DC",
  "BridgePoint Hospital National Harbor - Washington - DC",
  "Bridgeport Hospital - Bridgeport - CT",
  "Bridgeport Hospital Milford Campus - Milford - Milford - CT",
  "Bridgewater State Hospital - Bridgewater - MA",
  "Bridgton Hospital - Bridgton - ME",
  "Brigham and Women's Faulkner Hospital - Boston - MA",
  "Brigham and Women's Hospital - Boston - MA",
  "Brigham City Community Hospital - Brigham City - UT",
  "Brightwell Behavioral Health - Clarksville - Clarksville - IN",
  "Brightwell Behavioral Health - East Lansing - East Lansing - MI",
  "Bristol Hospital - Bristol - CT",
  "Bristol Regional Medical Center - Bristol - TN",
  "Bristow Medical Center - Bristow - OK",
  "Broaddus Hospital - South Philippi - WV",
  "Broadlawns Medical Center - Des Moines - IA",
  "Broadview - Los Angeles - CA",
  "Brockton VA Medical Center - Brockton - MA",
  "Brodstone Memorial Hospital - Superior - NE",
  "Bronson Battle Creek Hospital - Battle Creek - MI",
  "Bronson LakeView Hospital - Paw Paw - MI",
  "Bronson Methodist Hospital - Kalamazoo - MI",
  "Bronson South Haven Hospital - South Haven - MI",
  "Bronx Psychiatric Center - Bronx - NY",
  "BronxCare Dr. Martin Luther King, Jr. Health Center - Bronx - NY",
  "BronxCare Special Care Center - Bronx - NY",
  "Brook Lane - Hagerstown - MD",
  "Brookdale University Hospital and Medical Center - Brooklyn - NY",
  "Brooke Army Medical Center - Fort Sam Houston - TX",
  "Brooke Glen Behavioral Hospital - Fort Washington - PA",
  "Brookings Hospital - Brookings - SD",
  "Brooklyn VA Medical Center - Brooklyn - NY",
  "Brooks County Hospital - Quitman - GA",
  "Brooks Rehabilitation Hospital - University Campus - Jacksonville - FL",
  "Brooks- TLC Hospital System - Dunkirk - NY",
  "Brookwood Baptist Medical Center - Birmingham - AL",
  "Broughton Hospital - Morganton - NC",
  "Broward Health Coral Springs - Coral Springs - FL",
  "Broward Health Imperial Point - Fort Lauderdale - FL",
  "Broward Health Medical Center - Fort Lauderdale - FL",
  "Broward Health North - Deerfield Beach - FL",
  "Brown County Hospital - Ainsworth - NE",
  "Brownfield Regional Medical Center - Brownfield - TX",
  "Bruce W. Carter Department of Veterans Affairs Medical Center - Miami - FL",
  "Brunswick Hospital Center - Amityville - NY",
  "Bryan East Campus - Lincoln - NE",
  "Bryan Health Kearney Regional Medical Center - Kearney - NE",
  "Bryan West Campus - Lincoln - NE",
  "Bryant T. Aldridge Rehabilitation Center - Rocky Mount - NC",
  "Bryce Hospital - Tuscaloosa - AL",
  "BryLin Hospitals - Buffalo - NY",
  "Bryn Mawr Hospital - Bryn Mawr - PA",
  "Bryn Mawr Rehab Hospital - Malvern - PA",
  "Brynn Marr Hospital - Jacksonville - NC",
  "BSA Hospital - Amarillo - TX",
  "Buchanan County Health Center - Independence - IA",
  "Buchanan General Hospital - Grundy - VA",
  "Bucktail Medical Center - Renovo - PA",
  "Bucyrus Community Hospital - Bucyrus - OH",
  "Buena Vista Regional Medical Center - Storm Lake - IA",
  "Buffalo General Medical Center - Buffalo - NY",
  "Buffalo Hospital - Buffalo - MN",
  "Buffalo Psychiatric Center - Buffalo - NY",
  "Buffalo VA Medical Center - Buffalo - NY",
  "Bullock County Hospital - Union Springs - AL",
  "Bunkie General Hospital - Bunkie - LA",
  "Burdett Birth Center at Samaritan Hospital - Troy - NY",
  "Burgess Health Center - Onawa - IA",
  "Burke Medical Center - Waynesboro - GA",
  "Burke Rehabilitation Hospital - White Plains - NY",
  "Burnett Medical Center - Grantsburg - WI",
  "Butler County Health - David City - NE",
  "Butler Hospital - Providence - RI",
  "Butler Memorial Hospital - Butler - PA",
  "Buttonwood Behavioral Health Hospital - Pemberton - NJ",
  "Byrd Regional Hospital - Leesville - LA",
  "C.S. Mott Children's Hospital - Ann Arbor - MI",
  "Cabell Huntington Hospital - Huntington - WV",
  "Cabinet Peaks Medical Center - Libby - MT",
  "Cabot Emergency Hospital - Cabot - AR",
  "Cache Valley Hospital - North Logan - UT",
  "Calais Community Hospital - Calais - ME",
  "Calcasieu Oaks Behavioral Health Center - Lake Charles - LA",
  "Caldwell Medical Center - Princeton - KY",
  "Caldwell Memorial Hospital - Lenoir - NC",
  "Caldwell Memorial Hospital - Columbia - LA",
  "Caldwell Regional Medical Center - Caldwell - KS",
  "Calhoun Liberty Hospital - Blountstown - FL",
  "California Health Care Facility, Stockton - Stockton - CA",
  "California Hospital Medical Center - Los Angeles - CA",
  "California Medical Facility - Psychiatric Inpatient Program - Vacaville - CA",
  "California Men's Colony Hospital - San Luis Obispo - CA",
  "California Rehabilitation Institute - Los Angeles - CA",
  "Callaway District Hospital - Callaway - NE",
  "Calvary Hospital Bronx Campus - Bronx - NY",
  "Calvary Hospital Brooklyn Campus - Brooklyn - NY",
  "CalvertHealth Medical Center - Prince Frederick - MD",
  "Cambridge Medical Center - Cambridge - MN",
  "CAMC Greenbrier Valley Medical Center - Ronceverte - WV",
  "CAMC Plateau Medical Center - Oak Hill - WV",
  "CAMC Teays Valley Hospital - Hurricane - WV",
  "CAMC Women and Children's Hospital - Charleston - WV",
  "Camden Clark Medical Center - Parkersburg - WV",
  "Cameron Memorial Community Hospital - Angola - IN",
  "Cameron Regional Medical Center - Cameron - MO",
  "Campbell County Memorial Hospital - Gillette - WY",
  "Canandaigua VA Medical Center - Canandaigua - NY",
  "Candler County Hospital - Metter - GA",
  "Candler Hospital - Savannah - GA",
  "Canonsburg Hospital - Canonsburg - PA",
  "Canton-Potsdam Hospital - Potsdam - NY",
  "Canyon Creek Behavioral Health - Temple - TX",
  "Canyon Ridge Hospital - Chino - CA",
  "Canyon Vista Medical Center - Sierra Vista - AZ",
  "Cape Canaveral Hospital - Cocoa Beach - FL",
  "Cape Cod Hospital - Hyannis - MA",
  "Cape Coral Hospital - Cape Coral - FL",
  "Cape Fear Valley Behavioral Health Care - Fayetteville - NC",
  "Cape Fear Valley Medical Center - Fayetteville - NC",
  "Cape Fear Valley Rehabilitation Center - Fayetteville - NC",
  "Cape Regional Medical Center - Cape May Court House - NJ",
  "Capital District Psychiatric Center - Albany - NY",
  "Capital Health Medical Center - Hopewell - Pennington - NJ",
  "Capital Health Regional Medical Center - Trenton - NJ",
  "Capital Region Medical Center - Jefferson City - MO",
  "Capital Region Southwest Campus - Jefferson City - MO",
  "Capitol Region Mental Health Center - Hartford - CT",
  "CapRock Hospital - Bryan - TX",
  "Captain James A. Lovell Federal Health Care Center - North Chicago - IL",
  "Cardinal Hill Rehabilitation Hospital - Lexington - KY",
  "Cardiovascular Center of Puerto Rico and the Caribbean - Rio Piedras - PR",
  "CarePartners Rehabilitation Hospital - Asheville - NC",
  "CareWell Health Medical Center - East Orange - NJ",
  "Caribou Memorial Hospital - Soda Springs - ID",
  "Carilion Children's Hospital - Roanoke - VA",
  "Carilion Clinic Saint Albans Hospital - Christiansburg - VA",
  "Carilion Franklin Memorial Hospital - Rocky Mount - VA",
  "Carilion Giles Community Hospital - Pearisburg - VA",
  "Carilion New River Valley Medical Center - Christiansburg - VA",
  "Carilion Roanoke Community Hospital - Roanoke - VA",
  "Carilion Roanoke Memorial Hospital - Roanoke - VA",
  "Carilion Rockbridge Community Hospital - Lexington - VA",
  "Carilion Tazewell Community Hospital - Tazewell - VA",
  "Carl Albert Community Mental Health Center - McAlester - OK",
  "Carl R. Darnall Army Medical Center - Fort Hood - TX",
  "Carl T. Hayden Veterans' Administration Medical Center - Phoenix - AZ",
  "Carle BroMenn Medical Center - Normal - IL",
  "Carle Eureka Hospital - Eureka - IL",
  "Carle Foundation Hospital - Urbana - IL",
  "Carle Health Methodist Hospital - Peoria - IL",
  "Carle Health Pekin Hospital - Pekin - IL",
  "Carle Health Proctor Hospital - Peoria - IL",
  "Carle Hoopeston Regional Health Center - Hoopeston - IL",
  "Carlinville Area Hospital - Carlinville - IL",
  "Carlsbad Medical Center - Carlsbad - NM",
  "Carnegie Tri-County Municipal Hospital - Carnegie - OK",
  "Carney Hospital - Dorchester - MA",
  "Caro Center - Caro - MI",
  "Carolina Center For Specialty Surgery - Charlotte - NC",
  "Carolina Dunes Behavioral Health - Leland - NC",
  "Carolina Pines Regional Medical Center - Hartsville - SC",
  "CarolinaEast Medical Center - New Bern - NC",
  "Carolinas ContinueCARE Hospital at Pineville - Charlotte - NC",
  "Carolinas Rehabilitation Charlotte - Charlotte - NC",
  "Carolinas Rehabilitation Mount Holly - Belmont - NC",
  "Carolinas Rehabilitation NorthEast - Concord - NC",
  "CaroMont Regional Medical Center - Gastonia - Gastonia - NC",
  "Carondelet Heart & Vascular Institute - Tucson - AZ",
  "Carroll County Memorial Hospital - Carrollton - MO",
  "Carroll County Memorial Hospital - Carrollton - KY",
  "Carroll Hospital - Westminster - MD",
  "Carrollton Regional Medical Center - Carrollton - TX",
  "Carrollton Springs - Carrollton - TX",
  "Carrus Behavioral Hospital - Sherman - TX",
  "Carrus Rehabilitation Hospital - Sherman - TX",
  "Carrus Specialty Hospital - Sherman - TX",
  "Carson Tahoe Regional Medical Center - Carson City - NV",
  "Carson Tahoe Sierra Surgery - Carson City - NV",
  "Carson Valley Health Hospital - Gardnerville - NV",
  "Carteret Health Care - Morehead City - NC",
  "Carthage Area Hospital - Carthage - NY",
  "Cary Medical Center - Caribou - ME",
  "Casa Colina Hospital and Centers for Healthcare - Pomona - CA",
  "Cascade Medical - Leavenworth - WA",
  "Cascade Medical Center - Cascade - ID",
  "Cascade Valley Hospital - Arlington - WA",
  "Casey County Hospital - Liberty - KY",
  "Cass County Memorial Hospital - Atlantic - IA",
  "Cass Lake Hospital - Cass Lake - MN",
  "Cass Regional Medical Center - Harrisonville - MO",
  "Castleview Hospital - Price - UT",
  "Caswell Developmental Center - Kinston - NC",
  "Catalina Island Medical Center - Avalon - CA",
  "Catawba Hospital - Catawba - VA",
  "Catawba Valley Medical Center - Hickory - NC",
  "Catholic Health Mercy Hospital - Rockville Centre - NY",
  "Catholic Health Saint Catherine of Siena Hospital - Smithtown - NY",
  "Catholic Health Saint Charles Hospital - Port Jefferson - NY",
  "Catholic Health Saint Francis Hospital & Heart Center - Roslyn - NY",
  "Catholic Health St. Joseph Hospital - Bethpage - NY",
  "Catholic Medical Center - Manchester - NH",
  "Cayuga Medical Center - Ithaca - NY",
  "Cedar City Hospital - Cedar City - UT",
  "Cedar County Memorial Hospital - El Dorado Springs - MO",
  "Cedar Creek Hospital of Michigan - St. Johns - MI",
  "Cedar Crest Hospital and Residential Treatment Center - Belton - TX",
  "Cedar Hills Hospital - Portland - OR",
  "Cedar Park Regional Medical Center - Cedar Park - TX",
  "Cedar Ridge Behavioral Hospital at Bethany - Bethany - OK",
  "Cedar Ridge Hospital - Oklahoma City - OK",
  "Cedar Springs Hospital - Colorado Springs - CO",
  "Cedars Sinai Marina Del Rey Hospital - Marina Del Rey - CA",
  "Cedars-Sinai Medical Center - Los Angeles - CA",
  "Centennial Hills Hospital Medical Center - Las Vegas - NV",
  "Centennial Hospital - Centennial - CO",
  "Centennial Peaks Hospital - Louisville - CO",
  "Center for Behavioral Health Osage Beach - Osage Beach - MO",
  "Center For Behavioral Medicine - Kansas City - MO",
  "Center for Forensic Psychiatry - Saline - MI",
  "Centerpoint Medical Center - Independence - MO",
  "CenterPointe Hospital - Saint Charles - MO",
  "CenterPointe Hospital of Columbia - Columbia - MO",
  "Centerstone Bradenton-Hospital and Addiction Center - Bradenton - FL",
  "Centinela Hospital Medical Center - Inglewood - CA",
  "Centra Bedford Memorial Hospital - Bedford - VA",
  "Centra Lynchburg General Hospital - Lynchburg - VA",
  "Centra Southside Community Hospital - Farmville - VA",
  "Centra Specialty Hospital - Lynchburg - VA",
  "Centra Virginia Baptist Hospital - Lynchburg - VA",
  "CentraCare - Melrose - Melrose - MN",
  "CentraCare - Paynesville Hospital - Paynesville - MN",
  "CentraCare - Redwood Hospital - Redwood Falls - MN",
  "CentraCare - Rice Memorial Hospital - Willmar - MN",
  "CentraCare - Sauk Centre - Sauk Centre - MN",
  "CentraCare Health - Long Prairie - Long Prairie - MN",
  "CentraCare Monticello Hospital - Monticello - MN",
  "CentraCare-Benson - Benson - MN",
  "Central Alabama Veterans Health Care System - East Campus - Tuskegee - AL",
  "Central Alabama Veterans Health Care System - West Campus - Montgomery - AL",
  "Central Carolina Hospital - Sanford - NC",
  "Central Desert Behavioral Health Hospital - Albuquerque - NM",
  "Central Florida Behavioral Hospital - Orlando - FL",
  "Central Harnett Hospital - Lillington - NC",
  "Central Louisiana State Hospital - Pineville - LA",
  "Central Louisiana Surgical Hospital - Alexandria - LA",
  "Central Maine Medical Center - Lewiston - ME",
  "Central Mississippi Residential Center (CMRC) - Newton - MS",
  "Central Montana Medical Center - Lewistown - MT",
  "Central New York Psychiatric Center - Marcy - NY",
  "Central Oklahoma Community Mental Health Center - Norman - OK",
  "Central Peninsula Hospital - Soldotna - AK",
  "Central Prison Hospital - Raleigh - NC",
  "Central Regional Hospital - Butner - NC",
  "Central State Hospital - Louisville - KY",
  "Central State Hospital - Petersburg - VA",
  "Central Texas Rehabilitation Hospital - Austin - TX",
  "Central Texas Veterans Health Care System - Olin E. Teague Veterans' Center - Temple - TX",
  "Central Valley Medical Center - Nephi - UT",
  "Central Valley Specialty Hospital - Modesto - CA",
  "Central Vermont Medical Center - Berlin - VT",
  "CentraState Medical Center - Freehold - NJ",
  "Centro Medico Episcopal San Lucas - Ponce - PR",
  "Centro Medico Menonita Cayey - Cayey - PR",
  "Centura - Bob Wilson Memorial Hospital - Ulysses - KS",
  "Centura - Longmont United Hospital - Longmont - CO",
  "Centura - Mercy Hospital - Durango - CO",
  "Centura - Penrose Hospital - Colorado Springs - CO",
  "Centura - St. Anthony Hospital - Lakewood - CO",
  "Centura - St. Anthony North Hospital - Westminster - CO",
  "Centura - St. Anthony Summit Hospital - Frisco - CO",
  "Centura - St. Catherine Hospital - Dodge City - Dodge City - KS",
  "Centura - St. Catherine Hospital - Garden City - Garden City - KS",
  "Centura - St. Elizabeth Hospital - Fort Morgan - CO",
  "Centura - St. Francis Hospital - Colorado Springs - CO",
  "Centura - St. Mary-Corwin Medical Center - Pueblo - CO",
  "Centura - St. Thomas More Hospital - Canon City - CO",
  "Centura St. Francis Hospital - Interquest - Colorado Springs - CO",
  "CGH Medical Center - Sterling - IL",
  "CHA Cambridge Hospital - Cambridge - MA",
  "CHA Everett Hospital - Everett - MA",
  "CHA Hollywood Presbyterian Medical Center - Los Angeles - CA",
  "CHA Somerville Campus - Somerville - MA",
  "Chadron Community Hospital - Chadron - NE",
  "Chambers Memorial Hospital - Danville - AR",
  "Chan Soon-Shiong Medical Center at Windber - Windber - PA",
  "Chandler Regional Medical Center - Chandler - AZ",
  "ChangePoint Psychiatric Hospital Lakeside - Lakeside - AZ",
  "Chapman Global Medical Center - Orange - CA",
  "Charles A. Cannon, Jr. Memorial Hospital - Linville - NC",
  "Charles George Department of Veterans Affairs Medical Center - Asheville - NC",
  "Charleston Area Medical Center General Hospital - Charleston - WV",
  "Charleston Area Medical Center Memorial Hospital - Charleston - WV",
  "Charleston Surgical Hospital - Charleston - WV",
  "Charlie Norwood Department of Veterans Affairs Medical Center - Augusta - GA",
  "Charlotte Hungerford Hospital - Torrington - CT",
  "Charlton Memorial Hospital - Fall River - MA",
  "Chase County Community Hospital - Imperial - NE",
  "Chatham Hospital - Siler City - NC",
  "Chatuge Regional Hospital - Hiawassee - GA",
  "Chelsea Hospital - Chelsea - MI",
  "Cherokee Indian Hospital Authority - Cherokee - NC",
  "Cherokee Medical Center - Gaffney - SC",
  "Cherokee Mental Health Institute - Cherokee - IA",
  "Cherokee Regional Medical Center - Cherokee - IA",
  "Cherry County Hospital - Valentine - NE",
  "Cherry Hospital - Goldsboro - NC",
  "Chesapeake Regional Medical Center - Chesapeake - VA",
  "Cheshire Medical Center - Keene - NH",
  "Chester Medical Center - Chester - SC",
  "Chestnut Hill Benevolent Association - Chestnut Hill - MA",
  "Cheyenne County Hospital - Saint Francis - KS",
  "Cheyenne Regional Medical Center - Cheyenne - WY",
  "Cheyenne VA Medical Center - Cheyenne - WY",
  "CHI Health Creighton University Medical Center - Bergan Mercy - Omaha - NE",
  "CHI Health Good Samaritan - Kearney - NE",
  "CHI Health Immanuel - Omaha - NE",
  "CHI Health Lakeside - Omaha - NE",
  "CHI Health Mercy Corning - Corning - IA",
  "CHI Health Mercy Council Bluffs - Council Bluffs - IA",
  "CHI Health Midlands - Papillion - NE",
  "CHI Health Missouri Valley - Missouri Valley - IA",
  "CHI Health Nebraska Heart - Lincoln - NE",
  "CHI Health Plainview - Plainview - NE",
  "CHI Health Richard Young Behavioral Health - Kearney - NE",
  "CHI Health Saint Elizabeth - Lincoln - NE",
  "CHI Health Saint Mary's - Nebraska City - NE",
  "CHI Health Schuyler - Schuyler - NE",
  "CHI Health St. Francis - Grand Island - NE",
  "CHI LakeWood Health - Baudette - MN",
  "CHI Lisbon Health - Lisbon - ND",
  "CHI Memorial Hospital Georgia - Fort Oglethorpe - GA",
  "CHI Memorial Hospital Hixson - Hixson - TN",
  "CHI Mercy Hospital - Valley City - ND",
  "CHI Oakes Hospital - Oakes - ND",
  "CHI Saint Alexius Health Bismarck - Bismarck - ND",
  "CHI Saint Joseph East - Lexington - KY",
  "CHI Saint Joseph Health Hospital - Lexington - KY",
  "CHI Saint Joseph Health Rehabilitation Hospital - Bryan - TX",
  "CHI Saint Joseph's Health - Park Rapids - MN",
  "CHI St. Alexius Health Carrington - Carrington - ND",
  "CHI St. Alexius Health Dickinson - Dickinson - ND",
  "CHI St. Alexius Health Garrison - Garrison - ND",
  "CHI St. Alexius Health Turtle Lake - Turtle Lake - ND",
  "CHI St. Alexius Health Williston Medical Center - Williston - ND",
  "CHI St. Francis Health - Breckenridge - MN",
  "CHI St. Gabriels Hospital - Little Falls - MN",
  "CHI St. Joseph Health College Station Hospital - College Station, TX - College Station - TX",
  "CHI St. Joseph Health Grimes Hospital - Navasota - TX",
  "CHI St. Joseph Health Regional Hospital - Bryan, TX - Bryan - TX",
  "CHI St. Luke's Health - Lakeside Hospital - The Woodlands - TX",
  "CHI St. Luke's Health - Patients Medical Center - South Pasadena - TX",
  "CHI St. Luke's Health - Sugar Land Hospital - Sugar Land - TX",
  "CHI St. Luke's Health - The Vintage Hospital - Houston - TX",
  "CHI St. Vincent Hot Springs - Hot Springs - AR",
  "CHI St. Vincent Hot Springs Rehabilitation Hospital - Hot Springs - AR",
  "CHI St. Vincent Infirmary - Little Rock - AR",
  "CHI St. Vincent Morrilton - Morrilton - AR",
  "CHI St. Vincent North - Sherwood - AR",
  "CHI St. Vincent Sherwood Rehabilitation Hospital - Sherwood - AR",
  "CHI St.Alexius Health Devils Lake Hospital - Devils Lake - ND",
  "Chicago Behavioral Hospital - Des Plaines - IL",
  "Chicago-Read Mental Health Center - Chicago - IL",
  "Chickasaw Nation Medical Center - Ada - OK",
  "Chicot Memorial Medical Center - Lake Village - AR",
  "Child and Adolescent Behavioral Health Hospital - Willmar - MN",
  "Children's Egleston Hospital - Atlanta - GA",
  "Children's Healthcare of Atlanta at Scottish Rite - Atlanta - GA",
  "Children's Hospital at Erlanger - Chattanooga - TN",
  "Children's Hospital Colorado - Colorado Springs - Colorado Springs - CO",
  "Children's Hospital Colorado North Campus, Broomfield - Broomfield - CO",
  "Children's Hospital Colorado South Campus, Highlands Ranch - Highlands Ranch - CO",
  "Children's Hospital Los Angeles - Los Angeles - CA",
  "Children's Hospital New Orleans - New Orleans - LA",
  "Children's Hospital of Alabama - Birmingham - AL",
  "Children's Hospital of Michigan - Detroit - MI",
  "Children's Hospital of New Jersey at Newark Beth Israel Medical Center - Newark - NJ",
  "Children's Hospital of Orange County - Orange - CA",
  "Children's Hospital of Orange County at Mission - Mission Viejo - CA",
  "Children's Hospital of Philadelphia - Philadelphia - PA",
  "Children's Hospital of Philadelphia - Middleman Family Pavilion - King of Prussia - PA",
  "Children's Hospital of Richmond at VCU - Richmond - VA",
  "Children's Hospital of The King's Daughters - Norfolk - VA",
  "Children's Medical Center Dallas - Dallas - TX",
  "Children's Medical Center Plano - Plano - TX",
  "Children's Memorial Hermann Hospital - Houston - TX",
  "Children's Mercy Hospital Kansas - Overland Park - KS",
  "Children's Mercy Kansas City Adele Hall Campus - Kansas City - MO",
  "Children's Minnesota - Minneapolis - Minneapolis - MN",
  "Children's Minnesota Hospital-St. Paul - Saint Paul - MN",
  "Children's National Medical Center - Washington - DC",
  "Children's Nebraska - Omaha - NE",
  "Children's of Mississippi - Jackson - MS",
  "Children's Specialized Hospital - Mountainside - NJ",
  "Children's Specialized Hospital New Brunswick - New Brunswick - NJ",
  "Children's Wisconsin - Milwaukee - WI",
  "Childress Regional Medical Center - Childress - TX",
  "Chillicothe VA Medical Center - Chillicothe - OH",
  "Chilton Medical Center - Pompton Plains - NJ",
  "Chinese Hospital - San Francisco - CA",
  "Chinle Comprehensive Health Care Facility - Chinle - AZ",
  "Chino Valley Medical Center - Chino - CA",
  "Chippenham Hospital - Richmond - VA",
  "Choate Mental Health & Development Center - Anna - IL",
  "Choctaw Hospital - Choctaw - MS",
  "Choctaw Memorial Hospital - Hugo - OK",
  "Choctaw Regional Medical Center - Ackerman - MS",
  "Chris Kyle Patriots Hospital - Anchorage - AK",
  "Christ Hospital - Jersey City - NJ",
  "Christian Health Care Center - Wyckoff - NJ",
  "Christian Hospital - Saint Louis - MO",
  "Christiana Hospital - Newark - DE",
  "ChristianaCare Union Hospital - Elkton - MD",
  "Christine E. Lynn Rehabilitation Center - Miami - FL",
  "Christus Children's - San Antonio - TX",
  "CHRISTUS Coushatta Health Care Center - Coushatta - LA",
  "CHRISTUS DUBUIS Hospital of Alexandria - Alexandria - LA",
  "CHRISTUS Dubuis Hospital of Beaumont - Beaumont - TX",
  "CHRISTUS Good Shepherd Medical Center - Longview - Longview - TX",
  "CHRISTUS Good Shepherd Medical Center - Marshall - Marshall - TX",
  "CHRISTUS Mother Frances Hospital - Tyler - Tyler - TX",
  "CHRISTUS Mother Frances Hospital - Winnsboro - Winnsboro - TX",
  "CHRISTUS Mother Frances Hospital-Sulphur Springs - Sulphur Springs - TX",
  "CHRISTUS Ochsner Lake Area Hospital - Lake Charles - LA",
  "CHRISTUS Ochsner St. Patrick Hospital - Lake Charles - LA",
  "CHRISTUS Saint Frances Cabrini Hospital - Alexandria - LA",
  "CHRISTUS Saint Michael Hospital - Texarkana - TX",
  "CHRISTUS Saint Michael Hospital - Atlanta - Atlanta - TX",
  "CHRISTUS Saint Michael Rehabilitation Hospital - Texarkana - TX",
  "CHRISTUS Saint Vincent Regional Medical Center - Santa Fe - NM",
  "CHRISTUS Santa Rosa Hospital - Alamo Heights - San Antonio - TX",
  "CHRISTUS Santa Rosa Hospital - Medical Center - San Antonio - TX",
  "CHRISTUS Santa Rosa Hospital - New Braunfels - New Braunfels - TX",
  "CHRISTUS Santa Rosa Hospital - Westover Hills - San Antonio - TX",
  "Christus Santa Rosa Hospital-San Marcos - San Marcos - TX",
  "CHRISTUS Shreveport Bossier - Highland Medical Center - Shreveport - LA",
  "CHRISTUS Southeast Texas - Jasper Memorial - Jasper - TX",
  "CHRISTUS Southeast Texas - Saint Elizabeth - Beaumont - TX",
  "CHRISTUS Spohn Hospital - Alice - Alice - TX",
  "CHRISTUS Spohn Hospital - Beeville - Beeville - TX",
  "CHRISTUS Spohn Hospital - Kleberg - Kingsville - TX",
  "CHRISTUS Spohn Hospital Corpus Christi - South - Corpus Christi - TX",
  "CHRISTUS Spohn Hospital Corpus Christi -Shoreline - Corpus Christi - TX",
  "CHRISTUS St. Vincent Orthopaedic Specialty Clinic - Santa Fe - NM",
  "CHRISTUS Surgical Hospital - Corpus Christi - TX",
  "CHRISTUS Trinity Clinic - Jacksonville - TX",
  "CHRISTUS Trinity Mother Frances Hospital - South Tyler - Tyler - TX",
  "CHRISTUS Trinity Mother Frances Louis and Peaches Owen Heart Hospital - Tyler - TX",
  "CHRISTUS Trinity Mother Frances Rehabilitation Hospital - Tyler - TX",
  "Cibola General Hospital - Grants - NM",
  "Cimarron Memorial Hospital - Boise City - OK",
  "Cincinnati Children's - Cincinnati - OH",
  "Cincinnati VA Medical Center - Cincinnati - OH",
  "Citizens Baptist Medical Center - Talladega - AL",
  "Citizens Medical Center - Columbia - LA",
  "Citizens Medical Center - Victoria - TX",
  "Citizens Medical Center - Colby - KS",
  "Citizens Memorial Hospital - Bolivar - MO",
  "City of Hope Atlanta Comprehensive Care and Research Center - Newnan - GA",
  "City of Hope Chicago - Zion - IL",
  "City of Hope Comprehensive Cancer Center - Duarte - CA",
  "City of Hope Phoenix - Goodyear - AZ",
  "Claiborne County Medical Center - Port Gibson - MS",
  "Claiborne Medical Center - Tazewell - TN",
  "Claiborne Memorial Medical Center - Homer - LA",
  "Clara Barton Hospital - Hoisington - KS",
  "Clara Maass Medical Center - Belleville - NJ",
  "Claremore Indian Hospital - Claremore - OK",
  "Clarinda Regional Health Center - Clarinda - IA",
  "Clarion Hospital - Clarion - PA",
  "Clarion Psychiatric Center - Clarion - PA",
  "Clarity Child Guidance Center - San Antonio - TX",
  "Clark Fork Valley Hospital - Plains - MT",
  "Clark Regional Medical Center - Winchester - KY",
  "Clarke County Hospital - Osceola - IA",
  "Clarks Summit State Hospital - Clarks Summit - PA",
  "Claxton-Hepburn Medical Center - Ogdensburg - NY",
  "Clay County Hospital - Flora - IL",
  "Clay County Hospital - Ashland - AL",
  "Clay County Medical Center - Clay Center - KS",
  "Clay County Memorial Hospital - Henrietta - TX",
  "Clearbrook Treatment Centers Pennsylvania - Laurel Run - PA",
  "ClearSky Rehabilitation Hospital of Avondale - Avondale - AZ",
  "ClearSky Rehabilitation Hospital of Elwood-St. Joseph - Elwood - KS",
  "ClearSky Rehabilitation Hospital of Flower Mound - Flower Mound - TX",
  "ClearSky Rehabilitation Hospital of Leesville - Leesville - LA",
  "ClearSky Rehabilitation Hospital of Mansfield - Mansfield - TX",
  "ClearSky Rehabilitation Hospital of Rio Rancho - Rio Rancho - NM",
  "ClearSky Rehabilitation Hospital of Rosepine - Leesville - LA",
  "ClearSky Rehabilitation Hospital of Weatherford - Weatherford - TX",
  "ClearVista Behavioral Health - Lorain - OH",
  "Clearwater Valley Hospital - Orofino - ID",
  "Cleveland Area Hospital - Cleveland - OK",
  "Cleveland Clinic Akron General - Akron - OH",
  "Cleveland Clinic Children's Hospital for Rehabilitation - Cleveland - OH",
  "Cleveland Clinic Florida / Weston Hospital - Weston - FL",
  "Cleveland Clinic Indian River Hospital - Vero Beach - FL",
  "Cleveland Clinic Lutheran Hospital - Cleveland - OH",
  "Cleveland Clinic Martin North Hospital - Stuart - FL",
  "Cleveland Clinic Martin South Hospital - Stuart - FL",
  "Cleveland Clinic Marymount Hospital - Garfield Heights - OH",
  "Cleveland Clinic Medina Hospital - Medina - OH",
  "Cleveland Clinic Mercy Hospital - Canton - OH",
  "Cleveland Clinic Rehabilitation Hospital, Avon - Avon - OH",
  "Cleveland Clinic Rehabilitation Hospital, Edwin Shaw - Copley - OH",
  "Cleveland Clinic Tradition Hospital - Port St. Lucie - FL",
  "Cleveland Clinic Union Hospital - Dover - OH",
  "Clifton Springs Hospital and Clinic - Clifton Springs - NY",
  "Clifton T. Perkins Hospital Center - Jessup - MD",
  "Clifton-Fine Hospital - Star Lake - NY",
  "Clinch Memorial Hospital - Homerville - GA",
  "Clinch Valley Medical Center - Richlands - VA",
  "Clinton Memorial Hospital - Wilmington - OH",
  "Clinton Regional Hospital - Clinton - OK",
  "Clive Behavioral Health - Clive - IA",
  "Clovis Community Medical Center - Clovis - CA",
  "Coal County General Hospital - Coalgate - OK",
  "Coalinga Regional Medical Center - Coalinga - CA",
  "Coast Plaza Hospital - Norwalk - CA",
  "Coastal Behavioral Health - Savannah - GA",
  "Coastal Carolina Hospital - Hardeeville - SC",
  "Coastal Harbor Treatment Center - Savannah - GA",
  "Coastal Plain Hospital - Rocky Mount - NC",
  "Coatesville VA Medical Center - Coatesville - PA",
  "Cobleskill Regional Hospital - Cobleskill - NY",
  "Cobre Valley Regional Medical Center - Globe - AZ",
  "Cochran Memorial Hospital - Morton - TX",
  "Cody Regional Health - Cody - WY",
  "Coffee Regional Medical Center - Douglas - GA",
  "Coffey County Hospital - Burlington - KS",
  "Coffeyville Regional Medical Center - Coffeyville - KS",
  "Cogdell Memorial Hospital - Snyder - TX",
  "Cohen Children's Medical Center - New Hyde Park - NY",
  "Coleman County Medical Center - Coleman - TX",
  "Coliseum Center for Behavioral Health - Macon - GA",
  "College Hospital Cerritos - Cerritos - CA",
  "College Hospital Costa Mesa - Costa Mesa - CA",
  "College Medical Center - Long Beach - CA",
  "Colleton Medical Center - Walterboro - SC",
  "Collingsworth General Hospital - Wellington - TX",
  "Colmery-O'Neil Veterans' Administration Medical Center - Topeka - KS",
  "Colorado Mental Health Hospital in Pueblo - Pueblo - CO",
  "Colorado Mental Health Institute at Fort Logan - Denver - CO",
  "Colorado River Medical Center - Needles - CA",
  "Colquitt Regional Medical Center - Moultrie - GA",
  "Columbia Basin Hospital - Ephrata - WA",
  "Columbia Memorial Hospital - Astoria - OR",
  "Columbia Memorial Hospital - Hudson - NY",
  "Columbia VA Health Care System - Columbia - SC",
  "Columbus Behavioral Center for Children and Adolescents - Columbus - IN",
  "Columbus Community Hospital - Columbus - TX",
  "Columbus Community Hospital - Columbus - NE",
  "Columbus Regional Healthcare System - Whiteville - NC",
  "Columbus Regional Hospital - Columbus - IN",
  "Columbus Specialty Hospital - Columbus - GA",
  "Columbus Springs Dublin - Dublin - OH",
  "Columbus Springs East - Columbus - OH",
  "Colusa Medical Center - Colusa - CA",
  "Comanche County Hospital - Coldwater - KS",
  "Comanche County Medical Center - Comanche - TX",
  "Comanche County Memorial Hospital - Lawton - OK",
  "Commonwealth Center for Children and Adolescents - Staunton - VA",
  "Commonwealth Health Center - Saipan - MP",
  "Commonwealth Regional Specialty Hospital - Bowling Green - KY",
  "Community Behavioral Health Hospital - Alexandria - Alexandria - MN",
  "Community Behavioral Health Hospital - Annandale - Annandale - MN",
  "Community Behavioral Health Hospital - Baxter - Baxter - MN",
  "Community Behavioral Health Hospital - Bemidji - Bemidji - MN",
  "Community Behavioral Health Hospital - Fergus Falls - Fergus Falls - MN",
  "Community Behavioral Health Hospital - Rochester - Rochester - MN",
  "Community Care Hospital - New Orleans - LA",
  "Community Fairbanks Recovery Center - Indianapolis - IN",
  "Community First Medical Center - Chicago - IL",
  "Community Heart And Vascular Hospital - Indianapolis - IN",
  "Community Hospital - Tallassee - AL",
  "Community Hospital - Torrington - WY",
  "Community Hospital - Grand Junction - CO",
  "Community Hospital - Oklahoma City - OK",
  "Community Hospital - Munster - IN",
  "Community Hospital - McCook - NE",
  "Community Hospital Anderson - Anderson - IN",
  "Community Hospital East - Indianapolis - IN",
  "Community Hospital Fairfax - Fairfax - MO",
  "Community Hospital North - Indianapolis - IN",
  "Community Hospital of Anaconda - Anaconda - MT",
  "Community Hospital of Bremen - Bremen - IN",
  "Community Hospital of Huntington Park - Huntington Park - CA",
  "Community Hospital of San Bernardino - San Bernardino - CA",
  "Community Hospital of Staunton - Staunton - IL",
  "Community Hospital of the Monterey Peninsula - Monterey - CA",
  "Community Hospital Onaga - Onaga - KS",
  "Community Hospital South - Indianapolis - IN",
  "Community Howard Regional Health - Kokomo - IN",
  "Community Medical Center - Falls City - NE",
  "Community Medical Center - Toms River - NJ",
  "Community Medical Center - Missoula - MT",
  "Community Memorial Healthcare - Marysville - KS",
  "Community Memorial Hospital - Hamilton - NY",
  "Community Memorial Hospital - Burke - SD",
  "Community Memorial Hospital - Cloquet - MN",
  "Community Memorial Hospital - Ojai - CA",
  "Community Memorial Hospital - Hicksville - OH",
  "Community Memorial Hospital - Sumner - IA",
  "Community Memorial Hospital - Ventura - CA",
  "Community Memorial Hospital Avera - Redfield - SD",
  "Community Mental Health Center, Inc. - Lawrenceburg - IN",
  "Community Regional Medical Center - Fresno - CA",
  "Community Rehabilitation Hospital North - Indianapolis - IN",
  "Community Rehabilitation Hospital South - Greenwood - IN",
  "Community Rehabilitation Hospital West - Brownsburg - IN",
  "Community Stroke & Rehabilitation Center - Crown Point - IN",
  "Compass Behavioral Center of Alexandria - Alexandria - LA",
  "Compass Behavioral Center of Houma - Houma - LA",
  "Compass Behavioral Center of Kaplan - Kaplan - LA",
  "Compass Behavioral Center of Marksville - Marksville - LA",
  "Compass Memorial Healthcare - Marengo - IA",
  "Concho County Hospital - Eden - TX",
  "Concord Hospital - Concord - NH",
  "Concord Hospital-Franklin - Franklin - NH",
  "Concord Hospital-Laconia - Laconia - NH",
  "Concord Medical Center - Concord - CA",
  "Cone Health Alamance Regional - Burlington - NC",
  "Cone Health Annie Penn Hospital - Reidsville - NC",
  "Cone Health Behavioral Health Hospital - Greensboro - NC",
  "Cone Health Moses Cone Hospital - Greensboro - NC",
  "Cone Health Wesley Long Hospital - Greensboro - NC",
  "Cone Health Women's and Children's Center at Moses Cone Hospital - Greensboro - NC",
  "Conejos County Hospital - La Jara - CO",
  "Conemaugh Memorial Medical Center - Johnstown - PA",
  "Conemaugh Memorial Medical Center - Lee Campus - Johnstown - PA",
  "Conemaugh Meyersdale Medical Center - Meyersdale - PA",
  "Conemaugh Miners Medical Center - Hastings - PA",
  "Conemaugh Nason Medical Center - Roaring Spring - PA",
  "Conerly Critical Care Hospital - UMMC - Jackson - MS",
  "Confluence Health Hospital Central Campus - Wenatchee - WA",
  "Confluence Health Hospital Mares Campus - Wenatchee - WA",
  "Conifer Park - Glenville - NY",
  "Connally Memorial Medical Center - Floresville - TX",
  "Connecticut Behavioral Health Hospital - West Hartford - CT",
  "Connecticut Children's - Hartford - Hartford - CT",
  "Connecticut Valley Hospital - Middletown - CT",
  "ContinueCARE Hospital at Baptist Health Corbin - Corbin - KY",
  "ContinueCARE Hospital at Baptist Health Deaconess Madisonville - Madisonville - KY",
  "ContinueCARE Hospital at Baptist Health Paducah - Paducah - KY",
  "ContinueCARE Hospital at Hendrick Medical Center - Abilene - TX",
  "ContinueCARE Hospital at Medical Center (Odessa) - Odessa - TX",
  "ContinueCARE Hospital at Palmetto Health Baptist - Columbia - SC",
  "Contra Costa Regional Medical Center - Martinez - CA",
  "Convalescent Hospital for Children - Cincinnati - OH",
  "Conway Behavioral Health Hospital - Conway - AR",
  "Conway Medical Center - Conway - SC",
  "Conway Regional Medical Center - Conway - AR",
  "Conway Regional Rehabilitation Hospital - Conway - AR",
  "Cook Children's Medical Center - Fort Worth - TX",
  "Cook Children's Medical Center Prosper - Prosper - TX",
  "Cook Hospital - Cook - MN",
  "Cookeville Regional Medical Center - Cookeville - TN",
  "Cooley Dickinson Hospital - Northampton - MA",
  "Coon Memorial Hospital - Dalhart - TX",
  "Cooper University Hospital - Camden - NJ",
  "Cooperman Barnabas Medical Center - Livingston - NJ",
  "Coosa Valley Medical Center - Sylacauga - AL",
  "Copiah County Medical Center - Hazlehurst - MS",
  "Copley Hospital - Morrisville - VT",
  "Coppell ER - Coppell - TX",
  "Copper Hills Youth Center - West Jordan - UT",
  "Copper Queen Community Hospital - Bisbee - AZ",
  "Copper Springs - Avondale - AZ",
  "Copper Springs East - Gilbert - AZ",
  "Coquille Valley Hospital - Coquille - OR",
  "Coral Gables Hospital - Coral Gables - FL",
  "Coral Shores Behavioral Health - Stuart - FL",
  "Cordell Memorial Hospital - Cordell - OK",
  "Cordova Community Medical Center - Cordova - AK",
  "Corewell Health Greenville Hospital - Greenville - MI",
  "Corewell Health Watervliet Hospital - Watervliet - MI",
  "Cornerstone Behavioral Health - El Dorado - Tucson - AZ",
  "Cornerstone of Fresh Meadows - Fresh Meadows - NY",
  "Cornerstone of Rhinebeck - Rhinebeck - NY",
  "Cornerstone Regional Hospital - Edinburg - TX",
  "Cornerstone Specialty Hospitals Austin - Austin - TX",
  "Cornerstone Specialty Hospitals Bossier City - Bossier City - LA",
  "Cornerstone Specialty Hospitals Conroe - Conroe - TX",
  "Cornerstone Specialty Hospitals Huntington - Huntington - WV",
  "Cornerstone Specialty Hospitals Little Rock - Little Rock - AR",
  "Cornerstone Specialty Hospitals Muskogee - Muskogee - OK",
  "Cornerstone Specialty Hospitals Round Rock - Round Rock - TX",
  "Cornerstone Specialty Hospitals Shawnee - Shawnee - OK",
  "Cornerstone Specialty Hospitals Southeast Arizona - Tucson - AZ",
  "Cornerstone Specialty Hospitals Southwest Louisiana - Lake Charles - LA",
  "Cornerstone Specialty Hospitals West Monroe - West Monroe - LA",
  "Corona Regional Medical Center - Corona - CA",
  "Corporal Michael J. Crescenz Department of Veterans Affairs Medical Center - Philadelphia - PA",
  "Corpus Christi Bay Medical Center Heart and Vascular Care - Corpus Christi - TX",
  "Corpus Christi Medical Center Bay Area - Corpus Christi - TX",
  "Corpus Christi Medical Center Bayview - Corpus Christi - TX",
  "Corpus Christi Medical Center Doctors Regional - Corpus Christi - TX",
  "Corpus Christi Medical Center ER 24/7 Northwest - Corpus Christi - TX",
  "Corpus Christi Rehabilitation Hospital - Corpus Christi - TX",
  "Corrigan Mental Health Center - Fall River - MA",
  "Corry Memorial Hospital - Corry - PA",
  "Coryell Memorial Hospital - Gatesville - TX",
  "Coshocton Regional Medical Center - Coshocton - OH",
  "Coteau Health Care System Hospital - Sisseton - SD",
  "Cottage Hospital - Woodsville - NH",
  "Cottage Rehabilitation Hospital - Santa Barbara - CA",
  "Cottonwood Creek Behavioral Hospital - Meridian - ID",
  "Cottonwood Residential Treatment Center - Cape Girardeau - MO",
  "Cottonwood Springs - Olathe - KS",
  "Coulee Medical Center - Grand Coulee - WA",
  "County Of Humboldt Mental Health Branch - Eureka - CA",
  "Cove Forge Behavioral Health - Williamsburg - PA",
  "Covenant Children's Hospital - Lubbock - TX",
  "Covenant Health Hobbs Hospital - Hobbs - NM",
  "Covenant Health Levelland - Levelland - TX",
  "Covenant Health Plainview - Plainview - TX",
  "Covenant Medical Center - Lubbock - TX",
  "Covenant Medical Center Cooper - Saginaw - MI",
  "Covenant Medical Center Harrison - Saginaw - MI",
  "Covenant Specialty Hospital - Lubbock - TX",
  "Covington Behavioral Health Hospital - Covington - LA",
  "Covington County Hospital - Collins - MS",
  "Covington Trace ER & Hospital - Mandeville - LA",
  "Cox Barton County Hospital - Lamar - MO",
  "Cox Medical Center Branson - Branson - MO",
  "Cox Medical Center South - Springfield - MO",
  "Cox Monett Hospital - Monett - MO",
  "Cox North Hospital - Springfield - MO",
  "Cozad Community Hospital - Cozad - NE",
  "CPMC Davies Campus - San Francisco - CA",
  "CPMC Mission Bernal Campus & Orthopedic Institute - San Francisco - CA",
  "CPMC Van Ness Campus - San Francisco - CA",
  "Craig Hospital - Englewood - CO",
  "Crane Memorial Hospital - Crane - TX",
  "Crawford County Memorial Hospital - Denison - IA",
  "Crawford Memorial Hospital - Robinson - IL",
  "Creedmoor Psychiatric Center - Queens Village - NY",
  "Creekside Behavioral Health - Kingsport - TN",
  "Crenshaw Community Hospital - Luverne - AL",
  "Crescent Regional Hospital - Lancaster - TX",
  "Crestwood Medical Center - Huntsville - AL",
  "Crestwyn Behavioral Health - Memphis - TN",
  "Crete Area Medical Center - Crete - NE",
  "Crisp Regional Hospital - Cordele - GA",
  "Crittenden Community Hospital - Marion - KY",
  "CRMC - Crosby - Crosby - MN",
  "Crockett Medical Center - Crockett - TX",
  "Crook County Medical Services District - Sundance - WY",
  "Crosbyton Clinic Hospital - Crosbyton - TX",
  "Cross Creek Hospital - Austin - TX",
  "Crossbridge Behavioral Health - Montgomery - AL",
  "Crossing Rivers Health - Prairie du Chien - WI",
  "Crossroads Community Hospital - Mount Vernon - IL",
  "Crouse Hospital - Syracuse - NY",
  "Crow/Northern Cheyenne Hospital - Crow Agency - MT",
  "Crownpoint Health Care Facility - Crownpoint - NM",
  "Crozer-Chester Medical Center - Upland - PA",
  "Crystal Clinic Orthopaedic Center - Akron - OH",
  "Cuba Memorial Hospital - Cuba - NY",
  "Culberson Hospital - Van Horn - TX",
  "Cullman Regional Medical Center - Cullman - AL",
  "Culpeper Medical Center - Culpeper - VA",
  "Cumberland County Hospital - Burkesville - KY",
  "Cumberland Hall Hospital - Hopkinsville - KY",
  "Cumberland Hospital for Children and Adolescents - New Kent - VA",
  "Cumberland Medical Center - Crossville - TN",
  "Cumberland Memorial Hospital - Cumberland - WI",
  "Curry General Hospital - Gold Beach - OR",
  "Cypress Creek Hospital - Houston - TX",
  "Cypress Grove Behavioral Health Hospital - Bastrop - LA",
  "Cypress Pointe Surgical Hospital - Hammond - LA",
  "D.W. McMillan Memorial Hospital - Brewton - AL",
  "Dahl Memorial Healthcare - Ekalaka - MT",
  "Dakota Regional Medical Center - Cooperstown - ND",
  "Dale Medical Center - Ozark - AL",
  "Dallas Behavioral Healthcare Hospital - DeSoto - TX",
  "Dallas County Hospital - Perry - IA",
  "Dallas County Medical Center - Fordyce - AR",
  "Dallas Medical Center - Dallas - TX",
  "Dallas Regional Medical Center - Mesquite - TX",
  "Dallas VA Medical Center - Dallas - TX",
  "Dameron Hospital - Stockton - CA",
  "Dana-Farber Cancer Institute - Boston - MA",
  "Danbury Hospital - Danbury - CT",
  "Daniel Drake Center at The Christ Hospital - Mt. Auburn - Cincinnati - OH",
  "Daniels Memorial Healthcare Center - Scobey - MT",
  "Danville Hospital (Main Campus) - Danville - IN",
  "Danville State Hospital - Danville - PA",
  "Dardanelle Regional Medical Center - Dardanelle - AR",
  "Dartmouth Hitchcock Medical Center - Lebanon - NH",
  "Daviess Community Hospital - Washington - IN",
  "Davis County Hospital & Clinics - Bloomfield - IA",
  "Davis Medical Center - Elkins - WV",
  "Davis Regional Medical Center - Statesville - NC",
  "Day Kimball Hospital - Putnam - CT",
  "Dayton Children's Hospital - Dayton - OH",
  "Dayton General Hospital - Dayton - WA",
  "Dayton VA Medical Center - Dayton - OH",
  "DCH Regional Medical Center - Tuscaloosa - AL",
  "Deaconess Cross Pointe - Evansville - IN",
  "Deaconess Gateway Hospital - Newburgh - IN",
  "Deaconess Gibson Hospital - Princeton - IN",
  "Deaconess Henderson Hospital - Henderson - KY",
  "Deaconess Midtown Hospital - Evansville - IN",
  "Deaconess Union County Hospital - Morganfield - KY",
  "Deborah Heart and Lung Center - Browns Mills - NJ",
  "Decatur County Hospital - Leon - IA",
  "Decatur County Memorial Hospital - Greensburg - IN",
  "Decatur Health - Oberlin - KS",
  "Decatur Memorial Hospital - Decatur - IL",
  "Decatur Morgan Hospital - Decatur - AL",
  "Decatur Morgan Hospital Parkway Campus - Decatur - AL",
  "Deckerville Community Hospital - Deckerville - MI",
  "Deer Lodge Medical Center - Deer Lodge - MT",
  "Deer's Head Hospital Center - Salisbury - MD",
  "DeKalb Regional Medical Center - Fort Payne - AL",
  "Del Amo Hospital - Torrance - CA",
  "Del Sol Medical Center - El Paso - TX",
  "Delaware Psychiatric Center - New Castle - DE",
  "Delhi Hospital - Delhi - LA",
  "Dell Children's Medical Center of Central Texas - Austin - TX",
  "Dell Seton Medical Center at The University of Texas - Austin - TX",
  "Delray Medical Center - Delray Beach - FL",
  "Delta Community Hospital - Delta - UT",
  "Delta Health - Delta - CO",
  "Delta Health System West Campus - Greenville - MS",
  "Delta Memorial Hospital - Dumas - AR",
  "Delta Regional Medical Center - Greenville - MS",
  "Delta Specialty Hospital - Memphis - TN",
  "Denver Health Main Campus - Denver - CO",
  "Denver Springs - Englewood - CO",
  "Department of State Hospitals - Atascadero - Atascadero - CA",
  "Department of State Hospitals-Coalinga - Coalinga - CA",
  "Department of State Hospitals-Patton - Patton - CA",
  "DeQuincy Memorial Hospital - DeQuincy - LA",
  "Desert Parkway Behavioral Healthcare Hospital - Las Vegas - NV",
  "Desert Regional Medical Center - Palm Springs - CA",
  "Desert Valley Hospital - Victorville - CA",
  "Desert View Hospital - Pahrump - NV",
  "Desert Winds Hospital - Las Vegas - NV",
  "DeSoto Memorial Hospital - Arcadia - FL",
  "Desoto Regional Health System - Mansfield - LA",
  "Destiny Springs Healthcare - Surprise - AZ",
  "DeTar Hospital Navarro - Victoria - TX",
  "DeTar Hospital North - Victoria - TX",
  "Dewitt Hospital & Nursing Home - De Witt - AR",
  "DHR Health - Edinburg - TX",
  "Diamond Grove Center - Louisville - MS",
  "Dickenson Community Hospital - Clintwood - VA",
  "Dignity Health - Arizona General Hospital Laveen - Laveen - AZ",
  "Dignity Health - Arizona General Hospital Mesa - Mesa - AZ",
  "Dignity Health - St. Rose Dominican Hospital, Rose de Lima Campus - Henderson, NV - Henderson - NV",
  "Dignity Health - St. Rose Dominican Siena Campus - Henderson - NV",
  "Dignity Health East Valley Rehabilitation Hospital - Chandler - AZ",
  "Dignity Health East Valley Rehabilitation Hospital - Gilbert - Gilbert - AZ",
  "Dignity Health Rehabilitation Hospital - Henderson - NV",
  "Dignity Health Saint Rose Dominican North Las Vegas Campus - North Las Vegas - NV",
  "Dignity Health Saint Rose Dominican Sahara Campus - Las Vegas - NV",
  "Dignity Health St. Rose Dominican Blue Diamond Campus - Las Vegas - NV",
  "Dignity Health-Saint Rose Dominican, West Flamingo Campus - Las Vegas - NV",
  "Dignity Health-St. Rose Dominican San Martin Campus - Las Vegas - NV",
  "Diley Ridge Medical Center - Canal Winchester - OH",
  "Dimmit Regional Hospital - Carrizo Springs - TX",
  "DMC Detroit Receiving Hospital - Detroit - MI",
  "DMC Harper University Hospital - Detroit - MI",
  "DMC Heart Hospital - Detroit - MI",
  "DMC Huron Valley-Sinai Hospital - Commerce - MI",
  "DMC Hutzel Women's Hospital - Detroit - MI",
  "DMC Rehabilitation Institute of Michigan - Detroit - MI",
  "DMC Sinai-Grace Hospital - Detroit - MI",
  "Docs Surgical Hospital - Los Angeles - CA",
  "Doctor Dan C. Trigg Memorial Hospital - Tucumcari - NM",
  "Doctor's Center Hospital Bayamon - Bayamon - PR",
  "Doctors Center Hospital Manati - Manati - PR",
  "Doctors Center Hospital Orlando Health - Dorado - Dorado - PR",
  "Doctors Community Hospital - San Juan - PR",
  "Doctors Hospital - Coral Gables - FL",
  "Doctors Hospital of Augusta - Augusta - GA",
  "Doctors Hospital of Laredo - Laredo - TX",
  "Doctors Hospital of Manteca - Manteca - CA",
  "Doctors Medical Center of Modesto - Modesto - CA",
  "Doctors Memorial Hospital - Bonifay - FL",
  "Doctors NeuroPsychiatric Hospital - Bremen - IN",
  "Doctors' Center Hospital San Fernando de la Carolina - Carolina - PR",
  "Doctors' Memorial Hospital - Perry - FL",
  "Dodge County Hospital - Eastman - GA",
  "Dominican Hospital - Santa Cruz - CA",
  "Dominion Hospital - Falls Church - VA",
  "Donalsonville Hospital - Donalsonville - GA",
  "Door County Medical Center - Sturgeon Bay - WI",
  "Doris Miller Department of Veterans Affairs Medical Center - Waco - TX",
  "Dorminy Medical Center - Fitzgerald - GA",
  "Dorothea Dix Psychiatric Center - Bangor - ME",
  "Dosher Memorial Hospital - Southport - NC",
  "Douglas County Health Center - Omaha - NE",
  "Douglas County Memorial Hospital - Armour - SD",
  "Dover Behavioral Health System - Dover - DE",
  "Down East Community Hospital - Machias - ME",
  "Doylestown Hospital - Doylestown - PA",
  "Drew Memorial Hospital - Monticello - AR",
  "DRH Health - Duncan - OK",
  "Driscoll Children's Hospital - Corpus Christi - TX",
  "Drumright Regional Hospital - Drumright - OK",
  "DSH - Metropolitan - Norwalk - CA",
  "Dublin VA Medical Center - Dublin - GA",
  "Duke Raleigh Hospital - Raleigh - NC",
  "Duke Regional Hospital - Durham - NC",
  "Duke University Hospital - Durham - NC",
  "Dukes Memorial Hospital - Peru - IN",
  "Dundy County Hospital - Benkelman - NE",
  "Dunes Surgery Hospital - Dakota Dunes - SD",
  "Dupont Hospital - Fort Wayne - IN",
  "Durham VA Medical Center - Durham - NC",
  "Dwight D. Eisenhower VA Medical Center - Leavenworth - KS",
  "Eagle Butte Hospital - Eagle Butte - SD",
  "Eagle View Behavioral Health - Bettendorf - IA",
  "Eagleville Hospital - Eagleville - PA",
  "EAMC - Lanier - Valley - AL",
  "East Adams Rural Hospital - Ritzville - WA",
  "East Alabama Medical Center - Opelika - AL",
  "East Carroll Parish Hospital - Lake Providence - LA",
  "East Central Regional Hospital - Gracewood Campus - Gracewood - GA",
  "East Central Regional Hospital Augusta Campus - Augusta - GA",
  "East Cooper Medical Center - Mount Pleasant - SC",
  "East End Behavioral Health Hospital - Pittsburgh - PA",
  "East Georgia Regional Medical Center - Statesboro - GA",
  "East Houston Hospital and Clinics - Houston - TX",
  "East Houston Medical Center - Houston - TX",
  "East Jefferson General Hospital - Metairie - LA",
  "East Liverpool City Hospital - East Liverpool - OH",
  "East Los Angeles Doctors Hospital - Los Angeles - CA",
  "East Mississippi State Hospital - Meridian - MS",
  "East Morgan County Hospital - Brush - CO",
  "East Ohio Regional Hospital - Martins Ferry - OH",
  "East Orange VA Medical Center - East Orange - NJ",
  "East Tennessee Behavioral Health - Knoxville - TN",
  "East Tennessee Children's Hospital - Knoxville - TN",
  "East Valley ER & Hospital - Gilbert - AZ",
  "Eastern Idaho Regional Medical Center - Idaho Falls - ID",
  "Eastern Louisiana Health System - Feliciana Forensic Facility - Jackson - LA",
  "Eastern New Mexico Medical Center - Roswell - NM",
  "Eastern Oklahoma Medical Center - Poteau - OK",
  "Eastern Plumas Health Care - Portola - CA",
  "Eastern Shore Hospital Center - Cambridge - MD",
  "Eastern State Hospital - Medical Lake - WA",
  "Eastern State Hospital - Lexington - KY",
  "Eastland Memorial Hospital - Eastland - TX",
  "EastPointe Hospital - Daphne - AL",
  "Eaton Rapids Medical Center - Eaton Rapids - MI",
  "ECMC Hospital - Buffalo - NY",
  "ECU Health Beaufort Hospital - Washington - NC",
  "ECU Health Bertie Hospital - Windsor - NC",
  "ECU Health Chowan Hospital - Edenton - NC",
  "ECU Health Duplin Hospital - Kenansville - NC",
  "ECU Health Edgecombe Hospital - Tarboro - NC",
  "ECU Health Maynard Children's Hospital - Greenville - NC",
  "ECU Health Medical Center - Greenville - NC",
  "ECU Health North Hospital - Roanoke Rapids - NC",
  "ECU Health Roanoke-Chowan Hospital - Ahoskie - NC",
  "Ed Fraser Memorial Hospital - MacClenny - FL",
  "Eden Medical Center - Castro Valley - CA",
  "Edgefield County Hospital - Edgefield - SC",
  "Edgerton Hospital - Edgerton - WI",
  "Edgewood Surgical Hospital - Transfer - PA",
  "Edith Nourse Rogers Memorial Veterans Hospital - Bedford - MA",
  "Edward Hines Junior Hospital - Hines - IL",
  "Edward Hospital - Main Campus - Naperville - IL",
  "Edward P. Boland Department of Veterans Affairs Medical Center - Leeds - MA",
  "Edwards County Medical Center - Kinsley - KS",
  "Effingham Hospital - Springfield - GA",
  "Einstein Medical Center Elkins Park - Elkins Park - PA",
  "Eisenhower Army Medical Center - Fort Gordon - GA",
  "Eisenhower Medical Center - Rancho Mirage - CA",
  "El Camino Health - Los Gatos Hospital - Los Gatos - CA",
  "El Camino Health - Mountain View Hospital - Mountain View - CA",
  "El Campo Memorial Hospital - El Campo - TX",
  "El Centro Regional Medical Center - El Centro - CA",
  "El Paso Behavioral Health System - El Paso - TX",
  "El Paso Children's Hospital - El Paso - TX",
  "El Paso LTAC Hospital - El Paso - TX",
  "El Paso Psychiatric Center - El Paso - TX",
  "Elbert Memorial Hospital - Elberton - GA",
  "Elbow Lake Medical Center - Elbow Lake - MN",
  "Eleanor Slater Hospital - Cranston - RI",
  "Eleanor Slater Hospital Zambarano Unit - Pascoag - RI",
  "Electra Hospital District - Electra - TX",
  "Elgin Mental Health Center - Elgin - IL",
  "Elite Hospital Kingwood - Kingwood - TX",
  "Elite Medical Center - Las Vegas - NV",
  "Elkhart General Hospital - Elkhart - IN",
  "Elkhorn Valley Rehabilitation Hospital - Casper - WY",
  "Elkview General Hospital - Hobart - OK",
  "Ellenville Regional Hospital - Ellenville - NY",
  "Ellett Memorial Hospital - Appleton City - MO",
  "Ellinwood Hospital and Clinic - Ellinwood - KS",
  "Elliot Hospital - Manchester - NH",
  "Ellis Hospital - Schenectady - NY",
  "Ellsworth County Medical Center - Ellsworth - KS",
  "Elmhurst Hospital - Elmhurst - IL",
  "Elmira Psychiatric Center - Elmira - NY",
  "Elmore Community Hospital - Wetumpka - AL",
  "Ely Bloomenson Community Hospital - Ely - MN",
  "Emanate Health Foothill Presbyterian Hospital - Glendora - CA",
  "Emanate Health Inter-Community Hospital - Covina - CA",
  "Emanate Health Queen of the Valley Hospital - West Covina - CA",
  "Emanuel Medical Center - Turlock - CA",
  "Emanuel Medical Center - Swainsboro - GA",
  "Emerald Coast Behavioral Hospital - Panama City - FL",
  "Emerson Hospital - Concord - MA",
  "Emory Decatur Hospital - Decatur - GA",
  "Emory Hillandale Hospital - Lithonia - GA",
  "Emory Johns Creek Hospital - Johns Creek - GA",
  "Emory Long Term Acute Hospital - Decatur - GA",
  "Emory Rehabilitation Hospital - Atlanta - GA",
  "Emory Saint Joseph's Hospital - Atlanta - GA",
  "Emory University Hospital - Atlanta - GA",
  "Emory University Hospital at Wesley Woods - Atlanta - GA",
  "Emory University Hospital Midtown - Atlanta - GA",
  "Emory University Orthopaedics & Spine Hospital - Tucker - GA",
  "Encino Hospital Medical Center - Encino - CA",
  "Encompass Health Rehabilitation Hospital of Tinton Falls - Tinton Falls - NJ",
  "Encompass Health Deaconess Rehabilitation Hospital - Newburgh - IN",
  "Encompass Health Lakeshore Rehabilitation Hospital - Birmingham - AL",
  "Encompass Health MountainView at Bridgeport - Bridgeport - WV",
  "Encompass Health Rehabilitation Hospital of Harmarville - Pittsburgh - PA",
  "Encompass Health Rehabilitation Hospital of Richmond - Richmond - VA",
  "Encompass Health Rehabilitation Hospital of Abilene - Abilene - TX",
  "Encompass Health Rehabilitation Hospital of Albuquerque - Albuquerque - NM",
  "Encompass Health Rehabilitation Hospital of Alexandria - Alexandria - LA",
  "Encompass Health Rehabilitation Hospital of Altamonte Springs - Altamonte Springs - FL",
  "Encompass Health Rehabilitation Hospital of Altoona - Altoona - PA",
  "Encompass Health Rehabilitation Hospital of Arlington - Arlington - TX",
  "Encompass Health Rehabilitation Hospital of Austin - Austin - TX",
  "Encompass Health Rehabilitation Hospital of Bakersfield - Bakersfield - CA",
  "Encompass Health Rehabilitation Hospital of Bluffton - Bluffton - SC",
  "Encompass Health Rehabilitation Hospital of Braintree - Braintree - MA",
  "Encompass Health Rehabilitation Hospital of Braintree at Framingham - Framingham - MA",
  "Encompass Health Rehabilitation Hospital of Cape Coral - Cape Coral - FL",
  "Encompass Health Rehabilitation Hospital of Chattanooga - Chattanooga - TN",
  "Encompass Health Rehabilitation Hospital of Cincinnati - Cincinnati - OH",
  "Encompass Health Rehabilitation Hospital of Cincinnati at Norwood - Norwood - OH",
  "Encompass Health Rehabilitation Hospital of City View - Fort Worth - TX",
  "Encompass Health Rehabilitation Hospital of Clermont - Clermont - FL",
  "Encompass Health Rehabilitation Hospital of Colorado Springs - Colorado Springs - CO",
  "Encompass Health Rehabilitation Hospital of Columbia - Columbia - SC",
  "Encompass Health Rehabilitation Hospital of Concord - Concord - NH",
  "Encompass Health Rehabilitation Hospital of Cumming - Cumming - GA",
  "Encompass Health Rehabilitation Hospital of Cypress - Houston - TX",
  "Encompass Health Rehabilitation Hospital of Dallas - Dallas - TX",
  "Encompass Health Rehabilitation Hospital of Dayton - Dayton - OH",
  "Encompass Health Rehabilitation Hospital of Dothan - Dothan - AL",
  "Encompass Health Rehabilitation Hospital of East Valley - Mesa - AZ",
  "Encompass Health Rehabilitation Hospital of Erie - Erie - PA",
  "Encompass Health Rehabilitation Hospital of Florence - Florence - SC",
  "Encompass Health Rehabilitation Hospital of Fort Smith - Fort Smith - AR",
  "Encompass Health Rehabilitation Hospital of Franklin - Franklin - TN",
  "Encompass Health Rehabilitation Hospital of Gadsden - Gadsden - AL",
  "Encompass Health Rehabilitation Hospital of Greenville - Greenville - SC",
  "Encompass Health Rehabilitation Hospital of Henderson - Henderson - NV",
  "Encompass Health Rehabilitation Hospital of Henry - McDonough - GA",
  "Encompass Health Rehabilitation Hospital of Humble - Humble - TX",
  "Encompass Health Rehabilitation Hospital of Huntington - Huntington - WV",
  "Encompass Health Rehabilitation Hospital of Jacksonville - Jacksonville - FL",
  "Encompass Health Rehabilitation Hospital of Jonesboro - Jonesboro - AR",
  "Encompass Health Rehabilitation Hospital of Katy - Katy - TX",
  "Encompass Health Rehabilitation Hospital of Lakeland - Lakeland - FL",
  "Encompass Health Rehabilitation Hospital of Lakeview - Elizabethtown - KY",
  "Encompass Health Rehabilitation Hospital of Largo - Largo - FL",
  "Encompass Health Rehabilitation Hospital of Las Vegas - Las Vegas - NV",
  "Encompass Health Rehabilitation Hospital of Littleton - Littleton - CO",
  "Encompass Health Rehabilitation Hospital of Manati - Manati - PR",
  "Encompass Health Rehabilitation Hospital of Mechanicsburg - Mechanicsburg - PA",
  "Encompass Health Rehabilitation Hospital of Memphis - Memphis - TN",
  "Encompass Health Rehabilitation Hospital of Middletown - Middletown - DE",
  "Encompass Health Rehabilitation Hospital of Midland Odessa - Midland - TX",
  "Encompass Health Rehabilitation Hospital of Modesto - Modesto - CA",
  "Encompass Health Rehabilitation Hospital of Montgomery - Montgomery - AL",
  "Encompass Health Rehabilitation Hospital of Morgantown - Morgantown - WV",
  "Encompass Health Rehabilitation Hospital of Murrieta - Murrietta - CA",
  "Encompass Health Rehabilitation Hospital of Naples - Naples - FL",
  "Encompass Health Rehabilitation Hospital of New England - Woburn - MA",
  "Encompass Health Rehabilitation Hospital of New England at Beverly - Beverly - MA",
  "Encompass Health Rehabilitation Hospital of New England at Lowell - Lowell - MA",
  "Encompass Health Rehabilitation Hospital of Newnan - Newnan - GA",
  "Encompass Health Rehabilitation Hospital of Nittany Valley - Pleasant Gap - PA",
  "Encompass Health Rehabilitation Hospital of North Alabama - Huntsville - AL",
  "Encompass Health Rehabilitation Hospital of North Memphis - Memphis - TN",
  "Encompass Health Rehabilitation Hospital of North Tampa - Lutz - FL",
  "Encompass Health Rehabilitation Hospital of Northern Kentucky - Edgewood - KY",
  "Encompass Health Rehabilitation Hospital of Northern Virginia - Aldie - VA",
  "Encompass Health Rehabilitation Hospital of Northwest Tucson - Tucson - AZ",
  "Encompass Health Rehabilitation Hospital of Panama City - Panama City - FL",
  "Encompass Health Rehabilitation Hospital of Parkersburg - Parkersburg - WV",
  "Encompass Health Rehabilitation Hospital of Pearland - Pearland - TX",
  "Encompass Health Rehabilitation Hospital of Pensacola - Pensacola - FL",
  "Encompass Health Rehabilitation Hospital of Petersburg - Petersburg - VA",
  "Encompass Health Rehabilitation Hospital of Plano - Plano - TX",
  "Encompass Health Rehabilitation Hospital of Princeton - Princeton - WV",
  "Encompass Health Rehabilitation Hospital of Reading - Reading - PA",
  "Encompass Health Rehabilitation Hospital of Richardson - Richardson - TX",
  "Encompass Health Rehabilitation Hospital of Rock Hill - Rock Hill - SC",
  "Encompass Health Rehabilitation Hospital of Salisbury - Salisbury - MD",
  "Encompass Health Rehabilitation Hospital of San Antonio - San Antonio - TX",
  "Encompass Health Rehabilitation Hospital of San Juan - Rio Piedras - PR",
  "Encompass Health Rehabilitation Hospital of Savannah - Savannah - GA",
  "Encompass Health Rehabilitation Hospital of Scottsdale - Scottsdale - AZ",
  "Encompass Health Rehabilitation Hospital of Sewickley - Sewickley - PA",
  "Encompass Health Rehabilitation Hospital of Shelby County - Pelham - AL",
  "Encompass Health Rehabilitation Hospital of Shreveport - Shreveport - LA",
  "Encompass Health Rehabilitation Hospital of Sioux Falls - Sioux Falls - SD",
  "Encompass Health Rehabilitation Hospital of Spring Hill - Brooksville - FL",
  "Encompass Health Rehabilitation Hospital of St. Augustine - Saint Augustine - FL",
  "Encompass Health Rehabilitation Hospital of Sugar Land - Sugar Land - TX",
  "Encompass Health Rehabilitation Hospital of Sunrise - Sunrise - FL",
  "Encompass Health Rehabilitation Hospital of Tallahassee - Tallahassee - FL",
  "Encompass Health Rehabilitation Hospital of Texarkana - Texarkana - TX",
  "Encompass Health Rehabilitation Hospital of the Mid Cities - Bedford - TX",
  "Encompass Health Rehabilitation Hospital of Toledo - Toledo - OH",
  "Encompass Health Rehabilitation Hospital of Treasure Coast - Vero Beach - FL",
  "Encompass Health Rehabilitation Hospital of Tustin - Tustin - CA",
  "Encompass Health Rehabilitation Hospital of Utah - Sandy - UT",
  "Encompass Health Rehabilitation Hospital of Vineland - Vineland - NJ",
  "Encompass Health Rehabilitation Hospital of Waco - Robinson - TX",
  "Encompass Health Rehabilitation Hospital of Western Massachusetts - Ludlow - MA",
  "Encompass Health Rehabilitation Hospital of Wichita Falls - Wichita Falls - TX",
  "Encompass Health Rehabilitation Hospital of York - York - PA",
  "Encompass Health Rehabilitation Hospital The Vintage - Houston - TX",
  "Encompass Health Rehabilitation Hospital The Woodlands - Conroe - TX",
  "Encompass Health Rehabilitation Hospital Toms River - Toms River - NJ",
  "Encompass Health Rehabilitation Hospital Vision Park - Shenandoah - TX",
  "Encompass Health Rehabilitation Hospital, a partner of Memorial Hospital at Gulfport - Gulfport - MS",
  "Encompass Health Rehabilitation Hospital, a partner of Washington Regional - Fayetteville - AR",
  "Encompass Health Rehabilitation Hospital, an affiliate of Martin Health - Stuart - FL",
  "Encompass Health Rehabilitation Institute of Libertyville - Libertyville - IL",
  "Encompass Health Rehabilitation Institute of Tucson - Tucson - AZ",
  "Encompass Health Rehabilitation of Desert Canyon - Las Vegas - NV",
  "Encompass Health Rehabilitation of Fredericksburg - Fredericksburg - VA",
  "Encompass Health Valley of the Sun Rehabilitation Hospital - Glendale - AZ",
  "Endless Mountains Health Systems - Montrose - PA",
  "Englewood Health - Englewood - NJ",
  "Enloe Medical Center - Chico - CA",
  "Ennis Regional Medical Center - Ennis - TX",
  "Ephraim McDowell Fort Logan Hospital - Stanford - KY",
  "Ephraim McDowell James B. Haggin Hospital - Harrodsburg - KY",
  "Ephraim McDowell Regional Medical Center - Danville - KY",
  "ER of Texas-Medical Center - Mansfield - TX",
  "Erie VA Medical Center - Erie - PA",
  "Erlanger Baroness Hospital - Chattanooga - TN",
  "Erlanger Behavioral Health Hospital - Chattanooga - TN",
  "Erlanger Bledsoe Hospital - Pikeville - TN",
  "Erlanger East Hospital - Chattanooga - TN",
  "Erlanger North Hospital - Chattanooga - TN",
  "Essentia Health - Ada - Ada - MN",
  "Essentia Health - Deer River - Deer River - MN",
  "Essentia Health - Duluth (Miller-Dwan Building) - Duluth - MN",
  "Essentia Health - Fargo - Fargo - ND",
  "Essentia Health - Fosston - Fosston - MN",
  "Essentia Health - Holy Trinity Hospital in Graceville - Graceville - MN",
  "Essentia Health - Northern Pines - Aurora - MN",
  "Essentia Health - Saint Mary's Medical Center - Duluth - MN",
  "Essentia Health - Sandstone - Sandstone - MN",
  "Essentia Health - St. Joseph's Medical Center - Brainerd - MN",
  "Essentia Health - Virginia - Virginia - MN",
  "Essentia Health Saint Mary's Hospital - Superior - Superior - WI",
  "Essentia Health St. Mary's - Detroit Lakes - Detroit Lakes - MN",
  "Essentia Health-Moose Lake - Moose Lake - MN",
  "Essex County Hospital Center - Cedar Grove - NJ",
  "Estes Park Medical Center - Estes Park - CO",
  "Euclid Hospital - Euclid - OH",
  "Eureka Community Health Services Avera - Eureka - SD",
  "Eureka Springs Hospital - Eureka Springs - AR",
  "Evangelical Community Hospital - Lewisburg - PA",
  "Evans Army Community Hospital - Fort Carson - CO",
  "Evans Memorial Hospital - Claxton - GA",
  "Evanston Hospital - Evanston - IL",
  "Evanston Regional Hospital - Evanston - WY",
  "Evansville Psychiatric Children's Center - Evansville - IN",
  "Evansville State Hospital - Evansville - IN",
  "Everest Rehabilitation Hospital of El Paso - El Paso - TX",
  "Everest Rehabilitation Hospital of Rogers - Rogers - AR",
  "Evergreen Medical Center - Evergreen - AL",
  "EvergreenHealth Kirkland - Kirkland - WA",
  "EvergreenHealth Monroe - Monroe - WA",
  "Excela Health Frick Hospital - Mount Pleasant - PA",
  "Excela Health Westmoreland Hospital - Greensburg - PA",
  "Excela Latrobe Hospital - Latrobe - PA",
  "Excelsior Springs Hospital - Excelsior Springs - MO",
  "Exceptional Community Hospital - Maricopa - Maricopa - AZ",
  "Exceptional Community Hospital - Yuma - Yuma - AZ",
  "Exeter Hospital - Exeter - NH",
  "Extended Care Hospital - Memphis - TN",
  "F.F. Thompson Hospital - Canandaigua - NY",
  "F.W. Huston Medical Center - Winchester - KS",
  "Fairbanks Memorial Hospital - Fairbanks - AK",
  "Fairchild Medical Center - Yreka - CA",
  "Fairfax Behavioral Health - Kirkland - WA",
  "Fairfax Community Hospital - Fairfax - OK",
  "Fairfield Medical Center - Lancaster - OH",
  "Fairfield Memorial Hospital - Fairfield - IL",
  "Fairlawn Rehabilitation Hospital - Worcester - MA",
  "Fairmont Medical Center - Fairmont - WV",
  "Fairmont Rehabilitation and Wellness - San Leandro - CA",
  "Fairmount Behavioral Health System - Philadelphia - PA",
  "Fairview Hospital - Cleveland - OH",
  "Fairview Hospital - Great Barrington - MA",
  "Fairview Park Hospital - Dublin - GA",
  "Fairview Range Medical Center - Hibbing - MN",
  "Fairview Regional Medical Center - Fairview - OK",
  "Faith Community Hospital - Jacksboro - TX",
  "Faith Regional Health Services - Norfolk - NE",
  "Fall River Health Services - Hot Springs - SD",
  "Fallon Medical Complex - Baker - MT",
  "Falls Community Hospital and Clinic - Marlin - TX",
  "Falmouth Hospital - Falmouth - MA",
  "Falmouth Treatment Center - Falmouth - KY",
  "Family Health West - Fruita - CO",
  "Fannin Regional Hospital - Blue Ridge - GA",
  "Fargo VA Health Care System - Fargo - ND",
  "Faulkton Area Medical Center - Faulkton - SD",
  "Fauquier Hospital - Warrenton - VA",
  "Fayette Medical Center - Fayette - AL",
  "Fayetteville VA Medical Center - Fayetteville - NC",
  "Fayetteville VA Medical Center - Fayetteville - AR",
  "Federal Medical Center (FMC) Butner - Butner - NC",
  "Federal Medical Center Carswell - Fort Worth - TX",
  "Federal Medical Center Devens - Ayer - MA",
  "Federal Medical Center Lexington - Lexington - KY",
  "Federal Medical Center Rochester - Rochester - MN",
  "Fern Lodge - Castro Valley - CA",
  "Ferrell Hospital - Eldorado - IL",
  "Ferriday Behavioral Health - Ferriday - LA",
  "Ferry County Health - Republic - WA",
  "FHN Memorial Hospital - Freeport - IL",
  "Field Memorial Community Hospital - Centreville - MS",
  "Fillmore Community Hospital - Fillmore - UT",
  "Fillmore County Hospital - Geneva - NE",
  "Firelands Regional Medical Center Main Campus - Sandusky - OH",
  "Firelands Regional Medical Center South Campus - Sandusky - OH",
  "First Care Health Center - Park River - ND",
  "First Surgical Hospital - Bellaire - TX",
  "FirstHealth Montgomery Memorial Hospital - Troy - NC",
  "FirstHealth Moore Regional Hospital - Pinehurst - NC",
  "FirstHealth Moore Regional Hospital-Hoke Campus - Raeford - NC",
  "FirstHealth Moore Regional Hospital-Richmond - Rockingham - NC",
  "Fisher County Hospital - Rotan - TX",
  "Fisher-Titus Medical Center - Norwalk - OH",
  "Fishermen's Community Hospital - Marathon - FL",
  "Fitzgibbon Hospital - Marshall - MO",
  "Flaget Memorial Hospital - Bardstown - KY",
  "Flagstaff Medical Center - Flagstaff - AZ",
  "Fleming County Hospital - Flemingsburg - KY",
  "Flint River Hospital - Montezuma - GA",
  "Florence Hospital - Florence - AZ",
  "Florida Medical Center - Fort Lauderdale - FL",
  "Florida State Hospital - Chattahoochee - FL",
  "Flowers Hospital - Dothan - AL",
  "Floyd Behavioral Health - Rome - GA",
  "Floyd County Medical Center - Charles City - IA",
  "Floyd Valley Healthcare - Le Mars - IA",
  "Flushing Hospital Medical Center - Flushing - NY",
  "Fond du Lac County Acute Psychiatric Unit - Fond du Lac - WI",
  "Fontana Medical Center - Fontana - CA",
  "Foothill Regional Medical Center - Tustin - CA",
  "Foothills Hospital - Boulder - CO",
  "Forbes Hospital - Monroeville - PA",
  "Forest Health Medical Center Michigan - Ypsilanti - MI",
  "Forest View Psychiatric Hospital - Grand Rapids - MI",
  "Forks Community Hospital - Forks - WA",
  "Forrest City Medical Center - Forrest City - AR",
  "Forrest General Hospital - Hattiesburg - MS",
  "Forsyth Medical Center - Winston-Salem - NC",
  "Fort Behavioral Health - Fort Worth - TX",
  "Fort Belknap Critical Access Hospital - Harlem - MT",
  "Fort Belvoir Community Hospital - Fort Belvoir - VA",
  "Fort Duncan Regional Medical Center - Eagle Pass - TX",
  "Fort Harrison VA Medical Center - Fort Harrison - MT",
  "Fort Lauderdale Behavioral Health Center - Oakland Park - FL",
  "Fort Loudoun Medical Center - Lenoir City - TN",
  "Fort Meade VA Medical Center - Fort Meade - SD",
  "Fort Memorial Hospital - Fort Atkinson - WI",
  "Fort Sanders Regional Medical Center - Knoxville - TN",
  "Fort Smith ER & Hospital - Fort Smith - AR",
  "Fort Wayne VA Medical Center - Fort Wayne - IN",
  "Fort Yates Hospital - Fort Yates - ND",
  "Foundation Health Partners Denali Center - Fairbanks - AK",
  "Foundation Surgical Hospital of San Antonio - San Antonio - TX",
  "Foundations Behavioral Health - Doylestown - PA",
  "Fountain Valley Regional Hospital - Fountain Valley - CA",
  "Four Winds Saratoga - Saratoga Springs - NY",
  "Four Winds Westchester - Katonah - NY",
  "Fox Chase Cancer Center - Philadelphia - PA",
  "Fox Run Center - Saint Clairsville - OH",
  "Fox Valley Hospital-Children's Wisconsin - Neenah - WI",
  "Framingham Union Hospital - Framingham - MA",
  "Frances Mahon Deaconess Hospital - Glasgow - MT",
  "Franciscan Health Crawfordsville - Crawfordsville - IN",
  "Franciscan Health Indianapolis - Indianapolis - IN",
  "Franciscan Health Lafayette East - Lafayette - IN",
  "Franciscan Beacon Hospital - La Porte - IN",
  "Franciscan Health Michigan City - Michigan City - IN",
  "Franciscan Health Mooresville Campus - Mooresville - IN",
  "Franciscan Health Munster - Munster - IN",
  "Franciscan Health Carmel - Carmel - IN",
  "Franciscan Health Crown Point - Crown Point - IN",
  "Franciscan Health Dyer Campus - Dyer - IN",
  "Franciscan Health Olympia Fields - Olympia Fields - IL",
  "Franciscan Health Orthopedic Hospital Carmel - Carmel - IN",
  "Franciscan Health Rensselaer - Rensselaer - IN",
  "Franciscan Healthcare - West Point - NE",
  "Franciscan Hospital for Children - Brighton - MA",
  "Frankfort Regional Medical Center - Frankfort - KY",
  "Franklin County Medical Center - Preston - ID",
  "Franklin County Memorial Hospital - Meadville - MS",
  "Franklin County Memorial Hospital - Franklin - NE",
  "Franklin Delano Roosevelt Hospital - Montrose - NY",
  "Franklin General Hospital - Hampton - IA",
  "Franklin Hospital - Benton - IL",
  "Franklin Medical Center - Winnsboro - LA",
  "Franklin Memorial Hospital - Farmington - ME",
  "Franklin Woods Community Hospital - Johnson City - TN",
  "Fred Hutchinson Cancer Center - Seattle - WA",
  "Frederick Memorial Hospital - Frederick - MD",
  "Fredonia Regional Hospital - Fredonia - KS",
  "Freedom Behavioral Monroe - Monroe - LA",
  "Freeman Hospital East - Joplin - MO",
  "Freeman Hospital West - Joplin - MO",
  "Freeman Neosho Hospital - Neosho - MO",
  "Freeman Regional Health Services - Freeman - SD",
  "Freestone Medical Center - Fairfield - TX",
  "Fremont Hospital - Fremont - CA",
  "Fremont Medical Center - Fremont - CA",
  "French Hospital Medical Center - San Luis Obispo - CA",
  "Fresno Heart & Surgical Hospital - Fresno - CA",
  "Fresno Medical Center - Fresno - CA",
  "Fresno Surgical Hospital - Fresno - CA",
  "Fresno VA Medical Center - Fresno - CA",
  "Friends Hospital - Philadelphia - PA",
  "Frio Regional Hospital - Pearsall - TX",
  "Frisbie Memorial Hospital - Rochester - NH",
  "Froedtert Community Hospital - New Berlin - New Berlin - WI",
  "Froedtert Community Hospital - Oak Creek - Oak Creek - WI",
  "Froedtert Community Hospital - Pewaukee - Pewaukee - WI",
  "Froedtert Hospital - Milwaukee - WI",
  "Froedtert Menomonee Falls Hospital - Menomonee Falls - WI",
  "Froedtert Pleasant Prairie Hospital - Pleasant Prairie - WI",
  "Froedtert West Bend Hospital - West Bend - WI",
  "Frye Regional Medical Center - Hickory - NC",
  "Fuller Hospital - South Attleboro - MA",
  "Fulton County Health Center - Wauseon - OH",
  "Fulton County Hospital - Salem - AR",
  "Fulton County Medical Center - McConnellsburg - PA",
  "Fulton State Hospital - Fulton - MO",
  "G. Werber Bryan Psychiatric Hospital - Columbia - SC",
  "G.V. (Sonny) Montgomery Department of Veterans Affairs Medical Center - Jackson - MS",
  "Gadsden Regional Medical Center - Gadsden - AL",
  "Galion Community Hospital - Galion - OH",
  "Gallup Indian Medical Center - Gallup - NM",
  "Garden City Hospital - Garden City - MI",
  "Garden Grove Hospital and Medical Center - Garden Grove - CA",
  "Garfield County Health Center - Jordan - MT",
  "Garfield County Hospital District - Pomeroy - WA",
  "Garfield Medical Center - Monterey Park - CA",
  "Garfield Memorial Hospital - Panguitch - UT",
  "Garfield Park Behavioral Hospital - Chicago - IL",
  "Garnet Health Medical Center - Middletown - NY",
  "Garnet Health Medical Center - Catskills, Callicoon Campus - Callicoon - NY",
  "Garnet Health Medical Center - Catskills, Harris Campus - Harris - NY",
  "Garrett Regional Medical Center - Oakland - MD",
  "Gateway Regional Medical Center - Granite City - IL",
  "Gateway Rehabilitation Hospital - Florence - KY",
  "Gateways Hospital and Mental Health Center - Los Angeles - CA",
  "Gaylord Hospital - Wallingford - CT",
  "Geisinger Bloomsburg Hospital - Bloomsburg - PA",
  "Geisinger Community Medical Center - Scranton - PA",
  "Geisinger Encompass Health Rehabilitation Hospital - Danville - PA",
  "Geisinger Janet Weis Children's Hospital - Danville - PA",
  "Geisinger Jersey Shore Hospital - Jersey Shore - PA",
  "Geisinger Lewistown Hospital - Lewistown - PA",
  "Geisinger Marworth - Waverly - PA",
  "Geisinger Medical Center - Danville - PA",
  "Geisinger Medical Center Muncy - Muncy - PA",
  "Geisinger Shamokin Area Community Hospital - Coal Township - PA",
  "Geisinger South Wilkes-Barre - Wilkes-Barre - PA",
  "Geisinger South Wilkes-Barre Inpatient Rehabilitation - Wilkes-Barre - PA",
  "Geisinger St. Luke's Hospital - Orwigsburg - PA",
  "Geisinger Wyoming Valley Medical Center - Wilkes-Barre - PA",
  "General Leonard Wood Army Community Hospital - Fort Leonard Wood - MO",
  "Generations Behavioral Health - Geneva - Geneva - OH",
  "Generations Behavioral Health Hospital Youngstown - Youngstown - OH",
  "Genesis Behavioral Hospital - Breaux Bridge - LA",
  "Genesis Hospital - Zanesville - OH",
  "Genesis Medical Center Silvis - Silvis - IL",
  "Genesis Medical Center, Aledo - Aledo - IL",
  "Genesis Medical Center, Davenport, East Rusholme Street - Davenport - IA",
  "Genesis Medical Center, Davenport, West Central Park Avenue - Davenport - IA",
  "Genesis Medical Center, DeWitt - DeWitt - IA",
  "Geneva General Hospital - Geneva - NY",
  "Genoa Medical Facilities - Genoa - NE",
  "George C. Grape Community Hospital - Hamburg - IA",
  "George E. Wahlen Department of Veterans Affairs Medical Center - Salt Lake City - UT",
  "George E. Weems Memorial Hospital - Apalachicola - FL",
  "George H. O'Brien, Jr., Department of Veterans Affairs Medical Center - Big Spring - TX",
  "George Regional Hospital - Lucedale - MS",
  "Georgetown Behavioral Health Institute - Georgetown - TX",
  "Georgetown Behavioral Hospital - Georgetown - OH",
  "Georgetown Community Hospital - Georgetown - KY",
  "Georgia Regional Hospital - Atlanta - Decatur - GA",
  "Georgia Regional Hospital at Savannah - Savannah - GA",
  "Gerald Champion Regional Medical Center - Alamogordo - NM",
  "Gibson Area Hospital & Health Services - Gibson City - IL",
  "Gifford Medical Center - Randolph - VT",
  "Gila Regional Medical Center - Silver City - NM",
  "Gillette Children's Specialty Healthcare - Saint Paul Campus - Saint Paul - MN",
  "Girard Medical Center - Girard - KS",
  "Glacial Ridge Hospital - Glenwood - MN",
  "Glancy Inpatient Rehabilitation Center Duluth - Duluth - GA",
  "Glen Cove Hospital - Glen Cove - NY",
  "Glen Oaks Hospital - Greenville - TX",
  "Glen Rose Medical Center - Glen Rose - TX",
  "Glenbeigh Hospital of Rock Creek - Rock Creek - OH",
  "Glenbrook Hospital - Glenview - IL",
  "Glencoe Regional Health - Glencoe - MN",
  "Glendale Memorial Hospital & Health Center - Glendale - CA",
  "Glendive Medical Center - Glendive - MT",
  "Glendora Oaks Behavioral Health Hospital - Glendora - CA",
  "Glenmont - Hilliard - OH",
  "Glenn Medical Center - Willows - CA",
  "Glens Falls Hospital - Glens Falls - NY",
  "Glenwood Behavioral Health Hospital - Cincinnati - OH",
  "Glenwood Regional Medical Center - West Monroe - LA",
  "Golden Plains Community Hospital - Borger - TX",
  "Golden Valley Memorial Hospital - Clinton - MO",
  "Goleta Valley Cottage Hospital - Santa Barbara - CA",
  "Golisano Children's Hospital - Rochester - NY",
  "Golisano Children's Hospital of Southwest Florida - Fort Myers - FL",
  "Gonzales Memorial Hospital - Gonzales - TX",
  "Good Hope Hospital - Erwin - NC",
  "Good Samaritan Hospital - Vincennes - IN",
  "Good Samaritan Hospital - Suffern - NY",
  "Good Samaritan Hospital - Bakersfield - CA",
  "Good Samaritan Hospital - San Jose - CA",
  "Good Samaritan Hospital - Cincinnati - OH",
  "Good Samaritan Medical Center - West Palm Beach - FL",
  "Good Samaritan Medical Center - Brockton - MA",
  "Good Samaritan Medical Center - Lafayette - CO",
  "Good Samaritan Regional Medical Center - Corvallis - OR",
  "Good Samaritan University Hospital - West Islip - NY",
  "Good Shepherd Campus - Hermiston - OR",
  "Good Shepherd Rehabilitation Hospital - Center Valley - PA",
  "Good Shepherd Rehabilitation Hospital Pediatric Unit - Bethlehem - PA",
  "Good Shepherd Specialty Hospital - Bethlehem - PA",
  "Goodall Witcher Healthcare - Clifton - TX",
  "Goodland Regional Medical Center - Goodland - KS",
  "Gordon Memorial Hospital - Gordon - NE",
  "Goshen Hospital - Goshen - IN",
  "Gothenburg Health - Gothenburg - NE",
  "Gottlieb Memorial Hospital - Melrose Park - IL",
  "Gouverneur Hospital - Gouverneur - NY",
  "Gove County Medical Center - Quinter - KS",
  "Governor Juan F. Luis Hospital & Medical Center - Christiansted - VI",
  "Grace Cottage Hospital - Townshend - VT",
  "Grace Hospital - Cleveland - OH",
  "Grace Medical Center - Lubbock - TX",
  "Gracie Square Hospital - New York - NY",
  "Grady Memorial Hospital - Atlanta - GA",
  "Grady Memorial Hospital - Chickasha - OK",
  "Grafton City Hospital - Grafton - WV",
  "Graham County Hospital - Hill City - KS",
  "Graham Hospital - Canton - IL",
  "Graham Regional Medical Center - Graham - TX",
  "Grand Island Regional Medical Center - Grand Island - NE",
  "Grand Itasca Clinic & Hospital - Grand Rapids - MN",
  "Grand Junction VA Medical Center - Grand Junction - CO",
  "Grand River Hospital and Medical Center - Rifle - CO",
  "Grand Strand Regional Medical Center - Myrtle Beach - SC",
  "Grand View Hospital - Sellersville - PA",
  "Grande Ronde Hospital - La Grande - OR",
  "Grandview Medical Center - Birmingham - AL",
  "Granite County Medical Center - Philipsburg - MT",
  "Granite Hills Hospital - West Allis - WI",
  "Grant Memorial Hospital - Petersburg - WV",
  "Grant Regional Health Center - Lancaster - WI",
  "Granville Medical Center - Oxford - NC",
  "Great Falls Clinic Hospital - Great Falls - MT",
  "Great Plains Health - North Platte - NE",
  "Great Plains Regional Medical Center - Elk City - OK",
  "Great River Medical Center - Blytheville - AR",
  "Greater Baltimore Medical Center - Baltimore - MD",
  "Greater Binghamton Health Center - Binghamton - NY",
  "Greater Bridgeport Community Mental Health Center - Bridgeport - CT",
  "Greater El Monte Community Hospital - South El Monte - CA",
  "Greater Regional Medical Center - Creston - IA",
  "Greeley County Hospital - Tribune - KS",
  "Green Bay Rehabilitation Hospital - Green Bay - WI",
  "Greene County General Hospital - Linton - IN",
  "Greene County Health System - Eutaw - AL",
  "Greene County Hospital - Leakesville - MS",
  "Greene County Medical Center - Jefferson - IA",
  "Greeneville Community Hospital - Greeneville - TN",
  "Greenleaf Behavioral Health Hospital - Valdosta - GA",
  "Greenwich Hospital - Greenwich - CT",
  "Greenwood County Hospital - Eureka - KS",
  "Greenwood Leflore Hospital - Greenwood - MS",
  "Greenwood Regional Rehabilitation Hospital - Greenwood - SC",
  "Greystone Park Psychiatric Hospital - Morris Plains - NJ",
  "Griffin Hospital - Derby - CT",
  "Griffin Memorial Hospital - Norman - OK",
  "Grinnell Regional Medical Center - Grinnell - IA",
  "Grisell Memorial Hospital - Ransom - KS",
  "Gritman Medical Center - Moscow - ID",
  "Grove City Methodist Hospital - Grove City - OH",
  "Grove Creek Medical Center - Blackfoot - ID",
  "Grove Hill Memorial Hospital - Grove Hill - AL",
  "Grover C. Dils Medical Center - Caliente - NV",
  "Grundy County Memorial Hospital - Grundy Center - IA",
  "Guadalupe County Hospital - Santa Rosa - NM",
  "Guadalupe Regional Medical Center - Seguin - TX",
  "Guam Memorial Hospital Authority - Oka Tamuning - GU",
  "Guam Regional Medical City - Dededo - GU",
  "Gulf Breeze Hospital - Gulf Breeze - FL",
  "Gulf Coast Medical Center - Fort Myers - FL",
  "Gulf Coast Treatment Center - Fort Walton Beach - FL",
  "Gulf Coast Veterans Health Care System - Biloxi - MS",
  "Gulfport Behavioral Health System - Gulfport - MS",
  "Gundersen Boscobel Area Hospital - Boscobel - WI",
  "Gundersen Lutheran Medical Center - La Crosse - WI",
  "Gundersen Moundview Hospital & Clinics - Friendship - WI",
  "Gundersen Palmer Lutheran Hospital - West Union - IA",
  "Gundersen St. Elizabeth's Hospital - Wabasha - MN",
  "Gundersen St. Joseph's Hospital - Hillsboro - WI",
  "Gundersen Tri-County Hospital - Whitehall - WI",
  "Gunnison Valley Hospital - Gunnison - CO",
  "Gunnison Valley Hospital - Gunnison - UT",
  "Guthrie Corning Hospital - Corning - NY",
  "Guthrie Cortland Medical Center - Cortland - NY",
  "Guthrie County Hospital - Guthrie Center - IA",
  "Guthrie Robert Packer Hospital - Sayre - PA",
  "Guthrie Robert Packer Hospital, Towanda Campus - Towanda - PA",
  "Guthrie Troy Community Hospital - Troy - PA",
  "Guttenberg Municipal Hospital - Guttenberg - IA",
  "Gwen Neilsen Anderson Rehabilitation Center - Twin Falls - ID",
  "H. John Heinz III Department of Veterans Affairs Medical Center - Pittsburgh - PA",
  "Habersham Medical Center - Demorest - GA",
  "Hackensack Meridian Carrier Clinic - Belle Mead - NJ",
  "Hackensack Meridian Johnson Rehabilitation Institute at Ocean University Medical Center - Brick - NJ",
  "Hackensack Meridian Long Term Acute Care Hospital - Perth Amboy - NJ",
  "Hackensack Meridian Mountainside Medical Center - Montclair - NJ",
  "Hackensack Meridian Pascack Valley Medical Center - Westwood - NJ",
  "Hackensack Meridian Southern Ocean Medical Center - Manahawkin - NJ",
  "Hackensack University Medical Center - Hackensack - NJ",
  "Hackettstown Medical Center - Hackettstown - NJ",
  "Hale County Hospital - Greensboro - AL",
  "Hale Ho'ola Hamakua - Honoka'a - HI",
  "Halifax Health - Medical Center of Port Orange - Port Orange - FL",
  "Halifax Health Medical Center of Daytona Beach - Daytona Beach - FL",
  "Halifax Health UF Health - Medical Center of Deltona - Deltona - FL",
  "Hamilton Center, Inc. - Terre Haute - IN",
  "Hamilton County Hospital - Syracuse - KS",
  "Hamilton General Hospital - Hamilton - TX",
  "Hamilton Medical Center - Dalton - GA",
  "Hamilton Memorial Hospital District - McLeansboro - IL",
  "Hammond-Henry Hospital - Geneseo - IL",
  "Hampshire Memorial Hospital - Romney - WV",
  "Hampstead Hospital - Hampstead - NH",
  "Hampton Behavioral Health Center - Westampton Township - NJ",
  "Hampton Regional Medical Center - Varnville - SC",
  "Hampton VA Medical Center - Hampton - VA",
  "Hancock County Health System - Britt - IA",
  "Hancock County Hospital - Sneedville - TN",
  "Hancock Regional Hospital - Greenfield - IN",
  "Hannibal Regional Hospital - Hannibal - MO",
  "Hanover Hospital - Hanover - KS",
  "Hans P. Peterson Memorial Hospital - Philip - SD",
  "Hansen Family Hospital - Iowa Falls - IA",
  "Hansford County Hospital District - Spearman - TX",
  "Harbor Beach Community Hospital - Harbor Beach - MI",
  "Harbor Oaks Hospital - New Baltimore - MI",
  "Harbor Point Behavioral Health Center - Portsmouth - VA",
  "Harbor Regional Health - Aberdeen - WA",
  "Harbor-UCLA Medical Center - Torrance - CA",
  "Harborview Medical Center - Seattle - WA",
  "Hardeman County Memorial Hospital - Quanah - TX",
  "Hardin County General Hospital - Rosiclare - IL",
  "Hardin Medical Center - Savannah - TN",
  "Hardtner Medical Center - Olla - LA",
  "Harlan ARH Hospital - Harlan - KY",
  "Harlan County Health System - Alma - NE",
  "Harlingen Medical Center - Harlingen - TX",
  "Harmon Memorial Hospital - Hollis - OK",
  "Harney District Hospital - Burns - OR",
  "Harper County Community Hospital - Buffalo - OK",
  "Harris Regional Hospital - Sylva - NC",
  "Harrisburg Medical Center - Harrisburg - IL",
  "Harrison Community Hospital - Cadiz - OH",
  "Harrison County Community Hospital - Bethany - MO",
  "Harrison County Hospital - Corydon - IN",
  "Harrison Memorial Hospital - Cynthiana - KY",
  "Harry S. Truman Memorial Veterans' Hospital - Columbia - MO",
  "Harsha Behavioral Center - Terre Haute - IN",
  "Hartford Hospital - Hartford - CT",
  "Hartgrove Behavioral Health System - Chicago - IL",
  "Hasbro Children's Hospital - Providence - RI",
  "Haskell Memorial Hospital - Haskell - TX",
  "Hastings Regional Center - Hastings - NE",
  "Havasu Regional Medical Center - Lake Havasu City - AZ",
  "Haven Behavioral Hospital of Albuquerque - Albuquerque - NM",
  "Haven Behavioral Hospital of Dayton - Dayton - OH",
  "Haven Behavioral Hospital of Eastern Pennsylvania - Reading - PA",
  "Haven Behavioral Hospital of Frisco - Frisco - TX",
  "Haven Behavioral Hospital of Philadelphia - Philadelphia - PA",
  "Haven Behavioral Hospital of Phoenix - Phoenix - AZ",
  "Havenwood Behavioral Health - Travelers Rest - SC",
  "Havenwyck Hospital - Auburn Hills - MI",
  "Haverhill Pavilion Behavioral Health Hospital - Haverhill - MA",
  "Hawarden Community Hospital - Hawarden - IA",
  "Hawkins County Memorial Hospital - Rogersville - TN",
  "Hawthorn Children's Psychiatric Hospital - Saint Louis - MO",
  "Haxtun Hospital - Haxtun - CO",
  "Haymarket Medical Center - Haymarket - VA",
  "Hays Medical Center - Hays - KS",
  "Haywood Regional Medical Center - Clyde - NC",
  "Hazard ARH Regional Medical Center - Hazard - KY",
  "Hazel Hawkins Memorial Hospital - Hollister - CA",
  "HCA Florida Aventura Hospital - Aventura - FL",
  "HCA Florida Bayonet Point Hospital - Hudson - FL",
  "HCA Florida Blake Hospital - Bradenton - FL",
  "HCA Florida Brandon Hospital - Brandon - FL",
  "HCA Florida Capital Hospital - Tallahassee - FL",
  "HCA Florida Citrus Hospital - Inverness - FL",
  "HCA Florida Englewood Hospital - Englewood - FL",
  "HCA Florida Fawcett Hospital - Port Charlotte - FL",
  "HCA Florida Fort Walton-Destin Hospital - Fort Walton Beach - FL",
  "HCA Florida Gulf Coast Hospital - Panama City - FL",
  "HCA Florida Highlands Hospital - Sebring - FL",
  "HCA Florida JFK Hospital - Atlantis - FL",
  "HCA Florida JFK North Hospital - West Palm Beach - FL",
  "HCA Florida Kendall Hospital - Miami - FL",
  "HCA Florida Lake City Hospital - Lake City - FL",
  "HCA Florida Lake Monroe Hospital - Sanford - FL",
  "HCA Florida Largo Hospital - Largo - FL",
  "HCA Florida Largo West Hospital - Largo - FL",
  "HCA Florida Lawnwood Hospital - Fort Pierce - FL",
  "HCA Florida Memorial Hospital - Jacksonville - FL",
  "HCA Florida Mercy Hospital - Miami - FL",
  "HCA Florida North Florida Hospital - Gainesville - FL",
  "HCA Florida Northside Hospital - Saint Petersburg - FL",
  "HCA Florida Northwest Hospital - Margate - FL",
  "HCA Florida Oak Hill Hospital - Brooksville - FL",
  "HCA Florida Ocala Hospital - Ocala - FL",
  "HCA Florida Orange Park Hospital - Orange Park - FL",
  "HCA Florida Osceola Hospital - Kissimmee - FL",
  "HCA Florida Palms West Hospital - Loxahatchee - FL",
  "HCA Florida Pasadena Hospital - Saint Petersburg - FL",
  "HCA Florida Poinciana Hospital - Kissimmee - FL",
  "HCA Florida Putnam Hospital - Palatka - FL",
  "HCA Florida Raulerson Hospital - Okeechobee - FL",
  "HCA Florida Sarasota Doctors Hospital - Sarasota - FL",
  "HCA Florida South Shore Hospital - Sun City Center - FL",
  "HCA Florida South Tampa Hospital - Tampa - FL",
  "HCA Florida St. Lucie Hospital - Port Saint Lucie - FL",
  "HCA Florida St. Petersburg Hospital - Saint Petersburg - FL",
  "HCA Florida Trinity Hospital - Trinity - FL",
  "HCA Florida Twin Cities Hospital - Niceville - FL",
  "HCA Florida University Hospital - Davie - FL",
  "HCA Florida West Hospital - Pensacola - FL",
  "HCA Florida West Marion Hospital - Ocala - FL",
  "HCA Florida West Tampa Hospital - Tampa - FL",
  "HCA Florida Westside Hospital - Plantation - FL",
  "HCA Florida Woodmont Hospital - Tamarac - FL",
  "HCA Houston Healthcare Clear Lake - Webster - TX",
  "HCA Houston Healthcare Conroe - Conroe - TX",
  "HCA Houston Healthcare Kingwood - Kingwood - TX",
  "HCA Houston Healthcare Mainland - Texas City - TX",
  "HCA Houston Healthcare Medical Center - Houston - TX",
  "HCA Houston Healthcare North Cypress - Cypress - TX",
  "HCA Houston Healthcare Northwest - Houston - TX",
  "HCA Houston Healthcare Pearland - Pearland - TX",
  "HCA Houston Healthcare Southeast - Pasadena - TX",
  "HCA Houston Healthcare Tomball - Tomball - TX",
  "HCA Houston Healthcare West - Houston - TX",
  "Healdsburg District Hospital - Healdsburg - CA",
  "HealthAlliance Hospital - Kingston - NY",
  "Healthbridge Children's Hospital - Orange - CA",
  "HealthPark Medical Center - Fort Myers - FL",
  "Healthsource Saginaw - Saginaw - MI",
  "Heart Hospital at Saint Francis - Tulsa - OK",
  "Heart Hospital of Austin - Austin - TX",
  "Heart of America Medical Center - Rugby - ND",
  "Heart of Texas Memorial Hospital - Brady - TX",
  "Heart of the Rockies Regional Medical Center - Salida - CO",
  "Heartland (Massillon) - Massillon - OH",
  "Heartland Behavioral Health - Nevada - MO",
  "Heartland Regional Medical Center - Marion - IL",
  "Heber Valley Medical Center - Heber City - UT",
  "Hebrew Rehabilitation Center - Boston - MA",
  "Hedrick Medical Center - Chillicothe - MO",
  "Hegg Health Center - Rock Valley - IA",
  "Helen Hayes Hospital - West Haverstraw - NY",
  "Helen Keller Hospital - Sheffield - AL",
  "Helen M. Simpson Rehabilitation Hospital - Harrisburg - PA",
  "Helen Newberry Joy Hospital and Healthcare Center - Newberry - MI",
  "Helena Regional Medical Center - Helena - AR",
  "Hemet Global Medical Center - Hemet - CA",
  "Hemphill County Hospital - Canadian - TX",
  "Henderson County Community Hospital - Lexington - TN",
  "Henderson Health Care - Henderson - NE",
  "Henderson Hospital - Henderson - NV",
  "Hendrick Medical Center - Abilene - TX",
  "Hendrick Medical Center Brownwood - Brownwood - TX",
  "Hendrick Medical Center South - Abilene - TX",
  "Hendricks Behavioral Hospital - Plainfield - IN",
  "Hendricks Community Hospital - Hendricks - MN",
  "Hendricks Regional Health Brownsburg Hospital - Brownsburg - IN",
  "Hendry Regional Medical Center - Clewiston - FL",
  "Hennepin Healthcare - Minneapolis - MN",
  "Henrico Doctors' Hospital - Richmond - VA",
  "Henry Community Health - New Castle - IN",
  "Henry County Health Center - Mount Pleasant - IA",
  "Henry County Hospital - Napoleon - OH",
  "Henry County Medical Center - Paris - TN",
  "Henry Ford Hospital - Detroit - MI",
  "Henry Ford Jackson Hospital - Jackson - MI",
  "Henry Ford Kingswood Hospital - Ferndale - MI",
  "Henry Ford Macomb Hospital - Clinton Township - MI",
  "Henry Ford West Bloomfield Hospital - West Bloomfield - MI",
  "Henry Ford Wyandotte Hospital - Wyandotte - MI",
  "Henry Mayo Newhall Memorial Hospital - Valencia - CA",
  "Hereford Regional Medical Center - Hereford - TX",
  "Heritage Oaks Hospital - Sacramento - CA",
  "Heritage Psychiatric Health Center - Oakland - CA",
  "Heritage Valley Beaver - Beaver - PA",
  "Heritage Valley Kennedy - McKees Rocks - PA",
  "Heritage Valley Sewickley - Sewickley - PA",
  "Hermann Area District Hospital - Hermann - MO",
  "Hershel Woody Williams VA Medical Center - Huntington - WV",
  "Heywood Hospital - Gardner - MA",
  "HH Lincoln Health - Fayetteville - TN",
  "Hi-Desert Medical Center - Joshua Tree - CA",
  "Hialeah Hospital - Hialeah - FL",
  "Hickory Trail Hospital - DeSoto - TX",
  "Higgins General Hospital - Bremen - GA",
  "High Point Medical Center - High Point - NC",
  "Highland Clarksburg Hospital - Clarksburg - WV",
  "Highland Community Hospital - Picayune - MS",
  "Highland District Hospital - Hillsboro - OH",
  "Highland Hills Medical Center - Senatobia - MS",
  "Highland Hospital - Rochester - NY",
  "Highland Hospital - Charleston - WV",
  "Highland Park Hospital - Highland Park - IL",
  "Highland Ridge Hospital - Midvale - UT",
  "Highland Springs - Highland Hills - OH",
  "Highlands ARH Regional Medical Center - Prestonsburg - KY",
  "Highlands Behavioral Health System - Littleton - CO",
  "Highlands Medical Center - Scottsboro - AL",
  "Highlands-Cashiers Hospital - Highlands - NC",
  "Highsmith-Rainey Specialty Hospital - Fayetteville - NC",
  "Hill Crest Behavioral Health Services - Birmingham - AL",
  "Hill Hospital Of Sumter County - York - AL",
  "Hill Regional Hospital - Hillsboro - TX",
  "Hillcrest Hospital - Mayfield Heights - OH",
  "Hillcrest Hospital Claremore - Claremore - OK",
  "Hillcrest Hospital Cushing - Cushing - OK",
  "Hillcrest Hospital Henryetta - Henryetta - OK",
  "Hillcrest Hospital Pryor - Pryor - OK",
  "Hillcrest Hospital South - Tulsa - OK",
  "Hillcrest Medical Center - Tulsa - OK",
  "Hills & Dales Healthcare - Cass City - MI",
  "Hillsboro Area Hospital - Hillsboro - IL",
  "Hillsboro Community Hospital - Hillsboro - KS",
  "Hillsdale Hospital - Hillsdale - MI",
  "Hillside Atlanta - Atlanta - GA",
  "Hillside Rehabilitation Hospital - Warren - OH",
  "Hilo Medical Center - Hilo - HI",
  "Hilton Head Regional Medical Center - Hilton Head - SC",
  "HIMA San Pablo Cupey - San Juan - PR",
  "HIMA-San Pablo Hospital-Caguas - Caguas - PR",
  "HIMA-San Pablo Hospital-Fajardo - Fajardo - PR",
  "HIMA-San Pablo Hospital-Humacao - Humacao - PR",
  "Hiram W. Davis Medical Center - Petersburg - VA",
  "HMHI Hospital Inpatient Treatment - Salt Lake City - UT",
  "Hoag Hospital Irvine - Irvine - CA",
  "Hoag Hospital Newport Beach - Newport Beach - CA",
  "Hoag Orthopedic Institute - Irvine - CA",
  "Hoboken University Medical Center - Hoboken - NJ",
  "Hoboken University Medical Centers Transitional Care Unit - Hoboken - NJ",
  "Hocking Valley Community Hospital - Logan - OH",
  "Hodgeman County Health Center - Jetmore - KS",
  "Hoke Hospital - Raeford - NC",
  "Holdenville General Hospital - Holdenville - OK",
  "Holland Hospital - Holland - MI",
  "Holly Hill Hospital - Raleigh - NC",
  "Holly Hill Hospital Children's Campus - Raleigh - NC",
  "Holmes Regional Medical Center - Melbourne - FL",
  "Holston Valley Medical Center - Kingsport - TN",
  "Holton Community Hospital - Holton - KS",
  "Holtz Children's Hospital - Miami - FL",
  "Holy Cross Germantown Hospital - Germantown - MD",
  "Holy Cross Health - Fort Lauderdale - FL",
  "Holy Cross Hospital - Silver Spring - MD",
  "Holy Cross Hospital - Chicago - IL",
  "Holy Cross Hospital - Nogales - AZ",
  "Holy Cross Hospital-Davis - Layton - UT",
  "Holy Cross Hospital-Jordan Valley - West Jordan - UT",
  "Holy Cross Hospital-Jordan Valley West - West Valley City - UT",
  "Holy Cross Hospital-Mountain Point - Lehi - UT",
  "Holy Cross Hospital-Salt Lake - Salt Lake City - UT",
  "Holy Cross Medical Center - Taos - NM",
  "Holy Family Hospital - Methuen - Methuen - MA",
  "Holy Family Hospital -Haverhill - Haverhill - MA",
  "Holy Family Memorial Medical Center - Manitowoc - WI",
  "Holy Name Medical Center - Teaneck - NJ",
  "Holy Redeemer Hospital - Meadowbrook - PA",
  "Holy Rosary Healthcare - Miles City - MT",
  "Holyoke Medical Center - Holyoke - MA",
  "Holzer Gallipolis - Gallipolis - OH",
  "Holzer Medical Center - Jackson - Jackson - OH",
  "Homestead Hospital - Homestead - FL",
  "HonorHealth Deer Valley Medical Center - Phoenix - AZ",
  "HonorHealth John C. Lincoln Medical Center - Phoenix - AZ",
  "HonorHealth Rehabilitation Hospital - Scottsdale - AZ",
  "HonorHealth Scottsdale Osborn Medical Center - Scottsdale - AZ",
  "HonorHealth Scottsdale Shea Medical Center - Scottsdale - AZ",
  "HonorHealth Scottsdale Thompson Peak Medical Center - Scottsdale - AZ",
  "HonorHealth Sonoran Crossing Medical Center - Phoenix - AZ",
  "Hood Memorial Hospital - Amite City - LA",
  "Hoops Family Children's Hospital - Huntington - WV",
  "Hopedale Medical Complex - Hopedale - IL",
  "Hopi Health Care Center - Polacca - AZ",
  "Horizon Medical Center of Denton - Denton - TX",
  "Horizon Medical Center of McKinney - McKinney - TX",
  "Horizon Specialty Hospital of Henderson - Las Vegas - NV",
  "Horizon Specialty Hospital of Las Vegas - Las Vegas - NV",
  "Horn Memorial Hospital - Ida Grove - IA",
  "Horsham Clinic - Ambler - PA",
  "Hospital Damas - Ponce - PR",
  "Hospital Buen Samaritano - Aguadilla - PR",
  "Hospital Caribbean Medical Center - Fajardo - PR",
  "Hospital de la Concepcion - San German - PR",
  "Hospital Del Centro Comprensivo De Cancer - San Juan - PR",
  "Hospital El Maestro - Hato Rey - PR",
  "Hospital Episcopal San Lucas - Ponce - PR",
  "Hospital for Behavioral Medicine - Worcester - MA",
  "Hospital for Special Care - New Britain - CT",
  "Hospital for Special Surgery - New York - NY",
  "Hospital General Castaner - Castaner - PR",
  "Hospital HIMA - San Pablo Bayamon - Urb. Santa Cruz, Bayamon - PR",
  "Hospital Menonita Aibonito - Aibonito - PR",
  "Hospital Menonita Caguas - Caguas - PR",
  "Hospital Menonita CIMA - Aibonito - PR",
  "Hospital Menonita Guayama - Guayama - PR",
  "Hospital Menonita Humacao - Humacao - PR",
  "Hospital Menonita Ponce - Coto Laurel - PR",
  "Hospital Metropolitan Psiquiatrico Cabo Rojo - Cabo Rojo - PR",
  "Hospital Metropolitano De La Montana - Utuado - PR",
  "Hospital Metropolitano Dr. Pila - Ponce - PR",
  "Hospital Metropolitano Dr. Susoni - Arecibo - PR",
  "Hospital Metropolitano San German - San German - PR",
  "Hospital Metropolitano, Guaynabo - Rio Piedras - PR",
  "Hospital of Central Connecticut, New Britain General Campus - New Britain - CT",
  "Hospital of the University of Pennsylvania - Philadelphia - PA",
  "Hospital Oncologico Dr. Isaac Gonzalez Martinez - Rio Piedras - PR",
  "Hospital Pavia Arecibo - Arecibo - PR",
  "Hospital Pavia de Hato Rey - Hato Rey - PR",
  "Hospital Pavia Santurce - San Juan - PR",
  "Hospital Perea, Mayaguez - Mayaguez - PR",
  "Hospital San Antonio - Mayaguez - PR",
  "Hospital San Carlos Borromeo - Moca - PR",
  "Hospital San Francisco - San Juan - PR",
  "Hospital San Juan Capestrano - Camino Las Lomas - PR",
  "Hot Springs County Memorial Hospital - Thermopolis - WY",
  "Hot Springs VA Medical Center - Hot Springs - SD",
  "Houlton Regional Hospital - Houlton - ME",
  "Houston Behavioral Healthcare Hospital - Houston - TX",
  "Houston County Community Hospital - Erin - TN",
  "Houston Healthcare - Perry - Perry - GA",
  "Houston Medical Center - Warner Robins - GA",
  "Houston Methodist Baytown Hospital - Baytown - TX",
  "Houston Methodist Clear Lake Hospital - Nassau Bay - TX",
  "Houston Methodist Continuing Care Hospital - Katy - TX",
  "Houston Methodist Hospital - Houston - TX",
  "Houston Methodist Sugar Land Hospital - Sugar Land - TX",
  "Houston Methodist The Woodlands Hospital - The Woodlands - TX",
  "Houston Methodist West Hospital - Houston - TX",
  "Houston Methodist Willowbrook Hospital - Houston - TX",
  "Houston Physicians' Hospital - Webster - TX",
  "Howard County Medical Center - Saint Paul - NE",
  "Howard Memorial Hospital - Nashville - AR",
  "Howard University Hospital - Washington - DC",
  "Howard Young Medical Center - Woodruff - WI",
  "HRI Hospital - Brookline - MA",
  "HSHS Good Shepherd Hospital - Shelbyville - IL",
  "HSHS Holy Family Hospital - Greenville - IL",
  "HSHS Sacred Heart Hospital - Eau Claire - WI",
  "HSHS Saint Anthony's Memorial Hospital - Effingham - IL",
  "HSHS Saint Clare Memorial Hospital - Oconto Falls - WI",
  "HSHS Saint Elizabeth's Hospital - O'Fallon - IL",
  "HSHS Saint Francis Hospital - Litchfield - IL",
  "HSHS Saint John's Hospital - Springfield - IL",
  "HSHS Saint Joseph's Hospital - Chippewa Falls - WI",
  "HSHS Saint Joseph's Hospital Highland - Highland - IL",
  "HSHS Saint Mary's Hospital - Decatur - IL",
  "HSHS Saint Mary's Hospital Medical Center - Green Bay - WI",
  "HSHS Saint Nicholas Hospital - Sheboygan - WI",
  "HSHS Saint Vincent Hospital - Green Bay - WI",
  "HSHS St. John's Children's Hospital - Springfield - IL",
  "HSHS St. Joseph's Hospital Breese - Breese - IL",
  "Hu Hu Kam Memorial Hospital - Sacaton - AZ",
  "Hudson Hospital And Clinic - Hudson - WI",
  "Hudson Regional Hospital - Secaucus - NJ",
  "Huggins Hospital - Wolfeboro - NH",
  "Hugh Chatham Memorial Hospital - Elkin - NC",
  "Humboldt County Memorial Hospital - Humboldt - IA",
  "Humboldt General Hospital - Winnemucca - NV",
  "Humboldt Park Health - Chicago - IL",
  "Hunt Regional Medical Center - Greenville - TX",
  "Hunterdon Medical Center - Flemington - NJ",
  "Huntington Beach Hospital - Huntington Beach - CA",
  "Huntington Creek Recovery Center - Shickshinny - PA",
  "Huntington Health - Pasadena - CA",
  "Huntington Hospital - Huntington - NY",
  "Huntsville Hospital - Huntsville - AL",
  "Huntsville Hospital for Women and Children - Huntsville - AL",
  "Huntsville Memorial Hospital - Huntsville - TX",
  "Hurley Medical Center - Flint - MI",
  "Huron Regional Medical Center - Huron - SD",
  "Hutchings Psychiatric Center - Syracuse - NY",
  "Hutchinson Health Hospital - Hutchinson - MN",
  "Hutchinson Regional Medical Center - Hutchinson - KS",
  "Iberia Medical Center - New Iberia - LA",
  "Iberia Rehabilitation Hospital - New Iberia - LA",
  "Idaho Falls Community Hospital - Idaho Falls - ID",
  "Illini Community Hospital - Pittsfield - IL",
  "Impact Drug and Alcohol Treatment Center - Pasadena - CA",
  "Incline Village Community Hospital - Incline Village - NV",
  "Independence Mental Health Institute - Independence - IA",
  "Indian Path Community Hospital - Kingsport - TN",
  "Indiana Regional Medical Center - Indiana - PA",
  "Indianapolis Rehabilitation Hospital at Carmel - Carmel - IN",
  "Indianhead Medical Center - Shell Lake - WI",
  "Infirmary Long Term Acute Care Hospital - Mobile - AL",
  "Inland Northwest Behavioral Health - Spokane - WA",
  "Inova Alexandria Hospital - Alexandria - VA",
  "Inova Fair Oaks Hospital - Fairfax - VA",
  "Inova Fairfax Medical Campus - Falls Church - VA",
  "Inova Loudoun Hospital - Leesburg - VA",
  "Inova Mount Vernon Hospital - Alexandria - VA",
  "INSIGHT Hospital and Medical Center Chicago - Chicago - IL",
  "Insight Surgical Hospital - Warren - MI",
  "Inspira Medical Center Elmer - Elmer - NJ",
  "Inspira Medical Center Mannington - Salem - NJ",
  "Inspira Medical Center Mullica Hill - Mullica Hill - NJ",
  "Inspira Medical Center Vineland - Vineland - NJ",
  "Inspire Specialty Hospital - Midwest City - OK",
  "Institute for Orthopaedic Surgery - Lima - OH",
  "INTEGRIS Baptist Medical Center - Oklahoma City - OK",
  "INTEGRIS Baptist Medical Center Portland Avenue - Oklahoma City - OK",
  "INTEGRIS Bass Baptist Health Center - Enid - OK",
  "INTEGRIS Canadian Valley Hospital - Yukon - OK",
  "INTEGRIS Community Hospital at OKC West - Oklahoma City - OK",
  "INTEGRIS Community Hospital in Del City - Del City - OK",
  "INTEGRIS Community Hospital in Moore - Moore - OK",
  "INTEGRIS Health Community Hospital at Council Crossing - Oklahoma City - OK",
  "INTEGRIS Health Edmond Hospital - Edmond - OK",
  "INTEGRIS Health Grove Hospital - Grove - OK",
  "INTEGRIS Health Ponca City - Ponca City - OK",
  "INTEGRIS Health Woodward Hospital - Woodward - OK",
  "INTEGRIS Hospital in Miami - Miami - OK",
  "INTEGRIS Jim Thorpe Rehabilitation Hospital - Oklahoma City - OK",
  "INTEGRIS Southwest Medical Center - Oklahoma City - OK",
  "Intensive Specialty Hospital (North Campus) - Shreveport - LA",
  "Intensive Specialty Hospital (Pierremont Campus) - Shreveport - LA",
  "Intensive Specialty Hospital - Bossier City Campus - Bossier City - LA",
  "Intensive Specialty Hospital - Shreveport Campus - Shreveport - LA",
  "Interfaith Medical Center - Brooklyn - NY",
  "Intermountain Cassia Regional Hospital - Burley - ID",
  "Intermountain Hospital - Boise - ID",
  "Intermountain Layton Hospital - Layton - UT",
  "Intermountain Medical Center - Murray - UT",
  "Intermountain Riverton Hospital - Riverton - UT",
  "Intermountain Sanpete Valley Hospital - Mount Pleasant - UT",
  "Intermountain Sevier Valley Hospital - Richfield - UT",
  "Intermountain St. George Regional Hospital - Saint George - UT",
  "IntraCare North Hospital - Houston - TX",
  "Ioannis A. Lougaris Veterans' Administration Medical Center - Reno - NV",
  "Iowa City VA Health Care System - Iowa City - IA",
  "Iowa Specialty Hospital - Belmond - Belmond - IA",
  "Iowa Specialty Hospital-Clarion - Clarion - IA",
  "Ira Davenport Memorial Hospital - Bath - NY",
  "Iraan General Hospital - Iraan - TX",
  "Iredell Memorial Hospital - Statesville - NC",
  "Iron County Medical Center - Pilot Knob - MO",
  "Iroquois Memorial Hospital - Watseka - IL",
  "Irwin Army Community Hospital - Fort Riley - KS",
  "Irwin County Hospital - Ocilla - GA",
  "Island Hospital - Anacortes - WA",
  "IU Health Arnett Hospital - Lafayette - IN",
  "IU Health Ball Memorial Hospital - Muncie - IN",
  "IU Health Bedford Hospital - Bedford - IN",
  "IU Health Bloomington Hospital - Bloomington - IN",
  "IU Health Frankfort Hospital - Frankfort - IN",
  "IU Health Jay Hospital - Portland - IN",
  "IU Health Methodist University - Indianapolis - IN",
  "IU Health North Hospital - Carmel - IN",
  "IU Health Paoli Hospital - Paoli - IN",
  "IU Health Saxony Hospital - Fishers - IN",
  "IU Health Tipton Hospital - Tipton - IN",
  "IU Health University Hospital - Indianapolis - IN",
  "IU Health West Hospital - Avon - IN",
  "IU Health White Memorial Hospital - Monticello - IN",
  "Ivinson Memorial Hospital - Laramie - WY",
  "Izard Regional Hospital - Calico Rock - AR",
  "J. Paul Jones Hospital - Camden - AL",
  "J.D. McCarty Center - Norman - OK",
  "J.W. Ruby Memorial Hospital - Morgantown - WV",
  "Jack C. Montgomery VA Medical Center - Muskogee - OK",
  "Jack D. Weiler Hospital - Bronx - NY",
  "Jack Hughston Memorial Hospital - Phenix City - AL",
  "Jackson Behavioral Health Hospital - Miami - FL",
  "Jackson County Hospital District - Edna - TX",
  "Jackson County Memorial Hospital - Altus - OK",
  "Jackson County Regional Health Center - Maquoketa - IA",
  "Jackson General Hospital - Ripley - WV",
  "Jackson Hospital - Marianna - FL",
  "Jackson Hospital - Montgomery - AL",
  "Jackson Medical Center - Jackson - AL",
  "Jackson Memorial Hospital - Miami - FL",
  "Jackson North Medical Center - North Miami Beach - FL",
  "Jackson Parish Hospital - Jonesboro - LA",
  "Jackson Park Hospital - Chicago - IL",
  "Jackson Purchase Medical Center - Mayfield - KY",
  "Jackson South Medical Center - Miami - FL",
  "Jackson West Medical Center - Doral - FL",
  "Jacksonville Memorial Hospital - Jacksonville - IL",
  "Jacobs Medical Center at UC San Diego Health - La Jolla - CA",
  "Jacobson Memorial Hospital Care Center - Elgin - ND",
  "Jamaica Hospital Medical Center - Jamaica - NY",
  "James A. Haley Veterans' Hospital - Tampa - FL",
  "James E. Van Zandt VA Medical Center - Altoona, PA - Altoona - PA",
  "James H. Quillen VA Medical Center - Mountain Home - TN",
  "James J. Peters Department of Veterans Affairs Medical Center - Bronx - NY",
  "James K. Elrod WK Rehabilitation Institute - Shreveport - LA",
  "Jamestown Regional Medical Center - Jamestown - ND",
  "Jane Todd Crawford Hospital - Greensburg - KY",
  "Jasper General Hospital - Bay Springs - MS",
  "Jasper Memorial Hospital - Monticello - GA",
  "Javon Bea Hospital - Rockton - Rockford - IL",
  "Javon Bea Hospital-Riverside - Rockford - IL",
  "Jay Hospital - Jay - FL",
  "Jeff Davis Hospital - Hazlehurst - GA",
  "Jefferson Washington Township Hospital - Turnersville - NJ",
  "Jefferson Abington Hospital - Abington - PA",
  "Jefferson Bucks Hospital - Langhorne - PA",
  "Jefferson Center - Lakewood - CO",
  "Jefferson Cherry Hill Hospital - Cherry Hill - NJ",
  "Jefferson Community Health and Life Center - Fairbury - NE",
  "Jefferson County Health Center - Fairfield - IA",
  "Jefferson County Hospital - Waurika - OK",
  "Jefferson County Hospital and Behavioral Health Unit - Fayette - MS",
  "Jefferson Davis Community Hospital - Prentiss - MS",
  "Jefferson Einstein Hospital - Philadelphia - PA",
  "Jefferson Einstein Montgomery Hospital - East Norriton - PA",
  "Jefferson Frankford Hospital - Philadelphia - PA",
  "Jefferson Healthcare Medical Center - Port Townsend - WA",
  "Jefferson Hospital - Louisville - GA",
  "Jefferson Hospital - Jefferson Hills - PA",
  "Jefferson Hospital for Neuroscience - Philadelphia - PA",
  "Jefferson Lansdale Hospital - Lansdale - PA",
  "Jefferson Medical Center - Ranson - WV",
  "Jefferson Memorial Hospital - Jefferson City - TN",
  "Jefferson Methodist Hospital - Philadelphia - PA",
  "Jefferson Moss - Magee Rehabilitation Hospital - Doylestown - Doylestown - PA",
  "Jefferson Moss-Magee Rehabilitation Hospital - Elkins Park - Elkins Park - PA",
  "Jefferson Regional Medical Center - Pine Bluff - AR",
  "Jefferson Stratford Hospital - Stratford - NJ",
  "Jefferson Torresdale Hospital - Philadelphia - PA",
  "Jenkins County Medical Center - Millen - GA",
  "Jennie Stuart Medical Center - Hopkinsville - KY",
  "Jennings Senior Care Hospital - Jennings - LA",
  "Jerold Phelps Community Hospital - Garberville - CA",
  "Jerry L. Pettis Memorial Veterans' Hospital - Loma Linda - CA",
  "Jersey City Medical Center - Jersey City - NJ",
  "Jersey Community Hospital - Jerseyville - IL",
  "Jersey Shore University Medical Center - Neptune - NJ",
  "Jesse Brown VA Medical Center - Chicago - IL",
  "Jewell County Hospital - Mankato - KS",
  "JFK University Medical Center - Edison - NJ",
  "Jim Taliaferro Community Mental Health Center - Lawton - OK",
  "Joe DiMaggio Children's Hospital - Hollywood - FL",
  "John C. Fremont Healthcare District - Mariposa - CA",
  "John D. Dingell Department of Veterans Affairs Medical Center - Detroit - MI",
  "John F. Kennedy Memorial Hospital - Indio - CA",
  "John George Psychiatric Hospital - San Leandro - CA",
  "John H. Stroger, Jr. Hospital of Cook County - Chicago - IL",
  "John J. Cochran Veterans Hospital - Saint Louis - MO",
  "John J. Pershing VA Medical Center - Poplar Bluff - MO",
  "John L. Gildner Regional Institute for Children and Adolescents - Rockville - MD",
  "John L. McClellan Memorial Veterans Hospital - Little Rock - AR",
  "John Peter Smith Hospital - Fort Worth - TX",
  "John R. Oishei Children's Hospital - Buffalo - NY",
  "Johns Hopkins All Children's Hospital - Saint Petersburg - FL",
  "Johns Hopkins Bayview Medical Center - Baltimore - MD",
  "Johns Hopkins Howard County Medical Center - Columbia - MD",
  "Johns Hopkins Suburban Hospital - Bethesda - MD",
  "Johnson City Medical Center - Johnson City - TN",
  "Johnson County Community Hospital - Mountain City - TN",
  "Johnson County Healthcare Center - Buffalo - WY",
  "Johnson County Hospital - Tecumseh - NE",
  "Johnson County Rehabilitation Hospital - Overland Park - KS",
  "Johnson Memorial Health - Franklin - IN",
  "Johnson Memorial Health Services - Dawson - MN",
  "Johnson Memorial Hospital - Stafford Springs - CT",
  "Johnson Regional Medical Center - Clarksville - AR",
  "Johnston Memorial Hospital - Abingdon - VA",
  "Johnston-Willis Hospital - Richmond - VA",
  "Johnstown Heights Behavioral Health - Johnstown - CO",
  "Joint Township District Memorial Hospital - Saint Marys - OH",
  "Jonathan M. Wainwright Memorial VA Medical Center - Walla Walla - WA",
  "Jones Memorial Hospital - Wellsville - NY",
  "Jones Regional Medical Center - Anamosa - IA",
  "Joyce Eisenberg-Keefer Medical Center - Reseda - CA",
  "Julian F. Keith Alcohol and Drug Abuse Treatment Center - Black Mountain - NC",
  "Jupiter Medical Center - Jupiter - FL",
  "Ka'u Hospital - Pahala - HI",
  "Kadlec Regional Medical Center - Richland - WA",
  "Kahi Mohala - Ewa Beach - HI",
  "Kahuku Medical Center - Kahuku - HI",
  "Kaiser Permanente Behavioral Health Center in Santa Clara - Santa Clara - CA",
  "Kaiser Permanente Manteca Medical Center - Manteca - CA",
  "Kaiser Permanente Moanalua Medical Center - Honolulu - HI",
  "Kaiser Permanente Sacramento Medical Center - Sacramento - CA",
  "Kaiser Permanente San Diego Medical Center - San Diego - CA",
  "Kaiser Permanente San Francisco Medical Center - San Francisco - CA",
  "Kaiser Permanente South San Francisco Medical Center - South San Francisco - CA",
  "Kaiser Permanente Sunnyside Medical Center - Clackamas - OR",
  "Kaiser Permanente Westside Medical Center - Hillsboro - OR",
  "Kaiser Permanente Zion Medical Center - San Diego - CA",
  "Kalamazoo Psychiatric Hospital - Kalamazoo - MI",
  "Kalkaska Memorial Health Center - Kalkaska - MI",
  "Kanakanak Hospital - Dillingham - AK",
  "Kane County Hospital - Kanab - UT",
  "Kansas City Orthopaedic Institute - Leawood - KS",
  "Kansas City VA Medical Center - Kansas City - MO",
  "Kansas Heart Hospital - Wichita - KS",
  "Kansas Medical Center - Andover - KS",
  "Kansas Rehabilitation Hospital - Topeka - KS",
  "Kansas Spine & Specialty Hospital - Wichita - KS",
  "Kansas Surgery & Recovery Center - Wichita - KS",
  "Kapi'olani Medical Center for Women & Children - Honolulu - HI",
  "Karmanos Cancer Hospital - Detroit - MI",
  "Kate Dishman Rehabilitation Hospital Beamount - Beaumont - TX",
  "Katherine Shaw Bethea Hospital - Dixon - IL",
  "Kauai Veterans Memorial Hospital - Waimea - HI",
  "Kaweah Health Medical Center - Visalia - CA",
  "Kearney County Hospital - Minden - NE",
  "Kearny County Hospital - Lakin - KS",
  "Kedren Health - Los Angeles - CA",
  "Keefe Memorial Hospital - Cheyenne Wells - CO",
  "Kell West Regional Hospital - Wichita Falls - TX",
  "Keller Army Community Hospital - West Point - NY",
  "Kenmore Mercy Hospital - Kenmore - NY",
  "Kennedy Krieger Institute - Baltimore - MD",
  "Kensington Hospital - Philadelphia - PA",
  "Kent Hospital - Warwick - RI",
  "Kentfield Hospital - Kentfield - CA",
  "Kentfield Hospital San Francisco - San Francisco - CA",
  "Kentucky Children's Hospital - Lexington - KY",
  "Kentucky River Medical Center - Jackson - KY",
  "Keokuk County Hospitals and Clinics - Sigourney - IA",
  "Keralty Hospital - Miami - FL",
  "Kern Medical Center - Bakersfield - CA",
  "Kern Valley Hospital - Mountain Mesa - CA",
  "Kerrville State Hospital - Kerrville - TX",
  "Kerrville VA Hospital - Kerrville - TX",
  "Kessler Institute for Rehabilitation - Marlton - Marlton - NJ",
  "Kessler Institute for Rehabilitation - Saddle Brook - Saddle Brook - NJ",
  "Kessler Institute for Rehabilitation - West Orange - West Orange - NJ",
  "Kessler Institute for Rehabilitation Chester - Chester - NJ",
  "Kettering Health Behavioral Medical Center - Moraine - OH",
  "Kettering Health Dayton - Dayton - OH",
  "Kettering Health Greene Memorial - Xenia - OH",
  "Kettering Health Hamilton - Hamilton - OH",
  "Kettering Health Main Campus - Kettering - OH",
  "Kettering Health Miamisburg - Miamisburg - OH",
  "Kettering Health Troy - Troy - OH",
  "Kettering Health Washington Township - Washington Township - OH",
  "KeyStone Center - Chester - PA",
  "KidsPeace Children's Hospital - KidsPeace Orchard Hills Campus - Orefield - PA",
  "Kimball Health Services - Kimball - NE",
  "Kimble Hospital - Junction - TX",
  "Kindred Hospital Aurora - Aurora - CO",
  "Kindred Hospital Clear Lake - Webster - TX",
  "Kindred Hospital El Paso - El Paso - TX",
  "Kindred Hospital Ocala - Ocala - FL",
  "Kindred Hospital Sugar Land - Sugar Land - TX",
  "Kindred Hospital Albuquerque - Albuquerque - NM",
  "Kindred Hospital Baldwin Park - Baldwin Park - CA",
  "Kindred Hospital Bay Area - St. Petersburg and Acute Rehabilitation Unit - Saint Petersburg - FL",
  "Kindred Hospital Bay Area - Tampa - Tampa - FL",
  "Kindred Hospital Brea - Brea - CA",
  "Kindred Hospital Central Tampa - Tampa - FL",
  "Kindred Hospital Chattanooga - Chattanooga - TN",
  "Kindred Hospital Chicago - North - Chicago - IL",
  "Kindred Hospital Chicago - Northlake - Northlake - IL",
  "Kindred Hospital Chicago Lakeshore - Chicago - IL",
  "Kindred Hospital Dallas Central - Dallas - TX",
  "Kindred Hospital Dayton - Dayton - OH",
  "Kindred Hospital Denver - Denver - CO",
  "Kindred Hospital East New Jersey - Passaic - NJ",
  "Kindred Hospital Greensboro - Greensboro - NC",
  "Kindred Hospital Houston Medical Center and Acute Rehabilitation Unit - Houston - TX",
  "Kindred Hospital Houston Northwest and Acute Rehabilitation Unit - Houston - TX",
  "Kindred Hospital Indianapolis - Indianapolis - IN",
  "Kindred Hospital Indianapolis North - Indianapolis - IN",
  "Kindred Hospital La Mirada - La Mirada - CA",
  "Kindred Hospital Las Vegas - Flamingo - Las Vegas - NV",
  "Kindred Hospital Las Vegas - Sahara - Las Vegas - NV",
  "Kindred Hospital Lima - Lima - OH",
  "Kindred Hospital Los Angeles - Los Angeles - CA",
  "Kindred Hospital Louisville - Louisville - KY",
  "Kindred Hospital Louisville at Jewish Hospital - Louisville - KY",
  "Kindred Hospital Melbourne and Acute Rehabilitation Unit - Melbourne - FL",
  "Kindred Hospital New Jersey - Morris County - Dover - NJ",
  "Kindred Hospital New Jersey - Rahway - Rahway - NJ",
  "Kindred Hospital North Florida and Acute Rehabilitation Unit - Green Cove Springs - FL",
  "Kindred Hospital Northland - Kansas City - MO",
  "Kindred Hospital Ontario - Ontario - CA",
  "Kindred Hospital Paramount - Paramount - CA",
  "Kindred Hospital Philadelphia - Philadelphia - PA",
  "Kindred Hospital Philadelphia - Havertown - Havertown - PA",
  "Kindred Hospital Rancho - Rancho Cucamonga - CA",
  "Kindred Hospital Riverside - Perris - CA",
  "Kindred Hospital Saint Louis - Saint Louis - MO",
  "Kindred Hospital Saint Louis South - Saint Louis - MO",
  "Kindred Hospital San Antonio - San Antonio - TX",
  "Kindred Hospital San Antonio Central - San Antonio - TX",
  "Kindred Hospital San Diego - San Diego - CA",
  "Kindred Hospital San Francisco Bay Area - San Leandro - CA",
  "Kindred Hospital San Gabriel Valley - West Covina - CA",
  "Kindred Hospital Santa Ana - Santa Ana - CA",
  "Kindred Hospital Seattle -First Hill - Seattle - WA",
  "Kindred Hospital South Bay - Gardena - CA",
  "Kindred Hospital South Florida - Coral Gables - Coral Gables - FL",
  "Kindred Hospital South Florida - Fort Lauderdale - Fort Lauderdale - FL",
  "Kindred Hospital South Florida - Hollywood - Hollywood - FL",
  "Kindred Hospital Sycamore - Sycamore - IL",
  "Kindred Hospital Tarrant County - Arlington - TX",
  "Kindred Hospital Tarrant County - Fort Worth Southwest - Fort Worth - TX",
  "Kindred Hospital The Palm Beaches - Riviera Beach - FL",
  "Kindred Hospital Westminster - Westminster - CA",
  "King's Daughters Medical Center - Brookhaven - MS",
  "King's Daughters Medical Center - Ashland - KY",
  "King's Daughters Medical Center Ohio - Portsmouth - OH",
  "Kingman Healthcare Center - Kingman - KS",
  "Kingman Regional Medical Center - Kingman - AZ",
  "Kingsboro Psychiatric Center - Brooklyn - NY",
  "Kingwood Pines Hospital - Kingwood - TX",
  "Kiowa County Hospital District - Eads - CO",
  "Kiowa County Memorial Hospital - Greensburg - KS",
  "Kiowa District Hospital - Kiowa - KS",
  "Kirby Forensic Psychiatric Center - New York - NY",
  "Kirby Medical Center - Monticello - IL",
  "Kirkbride Center - Philadelphia - PA",
  "Kit Carson County Memorial Hospital - Burlington - CO",
  "Kittitas Valley Healthcare - Ellensburg - WA",
  "Kittson Healthcare - Hallock - MN",
  "Klickitat Valley Hospital - Goldendale - WA",
  "Knapp Medical Center - Weslaco - TX",
  "Knox Community Hospital - Mount Vernon - OH",
  "Knox County Hospital District - Knox City - TX",
  "Knoxville Center for Behavioral Medicine - Knoxville - TN",
  "Knoxville Hospital and Clinics - Knoxville - IA",
  "Knoxville Rehabilitation Hospital - Knoxville - TN",
  "Kohala Hospital - Kapaau - HI",
  "Kona Community Hospital - Kealakekua - HI",
  "Kootenai Health - Coeur d'Alene - ID",
  "Kossuth Regional Health Center - Algona - IA",
  "KPC Promise Healthcare Phoenix - Mesa - AZ",
  "KPC Promise Hospital of Amarillo - Amarillo - TX",
  "KPC Promise Hospital of Baton Rouge - Baton Rouge - LA",
  "KPC Promise Hospital of Dallas - Dallas - TX",
  "KPC Promise Hospital of Salt Lake - Murray - UT",
  "KPC Promise of Wichita Falls - Wichita Falls - TX",
  "KPC Promise Skilled Nursing Facility Hospital of Overland Park - Overland Park - KS",
  "Kuakini Medical Center - Honolulu - HI",
  "Kula Hospital - Kula - HI",
  "Kyle ER & Hospital - Kyle - TX",
  "LA Downtown Medical Center Downtown Campus - Los Angeles - CA",
  "LA Downtown Medical Center Ingleside Campus - Rosemead - CA",
  "La Hacienda Treatment Center - Hunt - TX",
  "La Palma Intercommunity Hospital - La Palma - CA",
  "La Paz Regional Hospital - Parker - AZ",
  "La Rabida Children's Hospital - Chicago - IL",
  "Labette Health - Parsons - KS",
  "Lackey Memorial Hospital - Forest - MS",
  "Lady of the Sea Hospital - Cut Off - LA",
  "Lafayette Physical Rehabilitation Hospital - Lafayette - LA",
  "Lafayette Regional Health Center - Lexington - MO",
  "Lafayette Regional Rehabilitation Hospital - Lafayette - IN",
  "Lafayette Surgical Specialty Hospital - Lafayette - LA",
  "LaFollette Medical Center - LaFollette - TN",
  "Laguna Honda Hospital and Rehabilitation Center - San Francisco - CA",
  "Lahey Hospital and Medical Center - Burlington - MA",
  "Lahey Medical Center, Peabody - Peabody - MA",
  "Lake Behavioral Hospital - Waukegan - IL",
  "Lake Butler Hospital - Lake Butler - FL",
  "Lake Charles Memorial Hospital - Lake Charles - LA",
  "Lake Charles Memorial Hospital for Women - Lake Charles - LA",
  "Lake Chelan Hearth Hospital - Chelan - WA",
  "Lake City VA Medical Center - Lake City - FL",
  "Lake Cumberland Regional Hospital - Somerset - KY",
  "Lake District Hospital - Lakeview - OR",
  "Lake Granbury Medical Center - Granbury - TX",
  "Lake Huron Medical Center - Port Huron - MI",
  "Lake Martin Community Hospital - Dadeville - AL",
  "Lake Norman Regional Medical Center - Mooresville - NC",
  "Lake Region Hospital - Fergus Falls - MN",
  "Lake Regional Hospital - Osage Beach - MO",
  "Lake Taylor Transitional Care Hospital - Norfolk - VA",
  "Lake View Hospital - Two Harbors - MN",
  "Lakeland Behavioral Health System - Springfield - MO",
  "Lakeland Community Hospital - Haleyville - AL",
  "Lakeland Regional Health Medical Center - Lakeland - FL",
  "Lakes Regional Hospital - Spirit Lake - IA",
  "Lakeside Behavioral Health System - Memphis - TN",
  "Lakeside Medical Center - Belle Glade - FL",
  "Lakeside Women's Hospital - Oklahoma City - OK",
  "Lakeview Behavioral Health - Norcross - GA",
  "Lakeview Hospital - Bountiful - UT",
  "Lakeview Hospital - Stillwater - MN",
  "Lakeview Regional Medical Center - Covington - LA",
  "Lakeview Specialty Hospital and Rehab - Waterford - WI",
  "Lakewood Health System Hospital - Staples - MN",
  "Lakewood Ranch Medical Center - Lakewood Ranch - FL",
  "Lakewood Regional Medical Center - Lakewood - CA",
  "Lamb Healthcare Center - Littlefield - TX",
  "Lanai Community Hospital - Lanai City - HI",
  "Lancaster Behavioral Health Hospital - Lancaster - PA",
  "Lancaster General Hospital - Lancaster - PA",
  "Lancaster Rehabilitation Hospital - Lancaster - PA",
  "Landmann-Jungman Memorial Hospital Avera - Scotland - SD",
  "Landmark Hospital of Athens - Athens - GA",
  "Landmark Hospital of Cape Girardeau - Cape Girardeau - MO",
  "Landmark Hospital of Joplin - Joplin - MO",
  "Landmark Hospital of Savannah - Savannah - GA",
  "Landmark Hospital of Southwest Florida - Lehigh Acres - FL",
  "Landmark Medical Center - Woonsocket - RI",
  "Lane County Hospital - Dighton - KS",
  "Lane Regional Medical Center - Zachary - LA",
  "Langdon Prairie Health - Langdon - ND",
  "Langley Porter Psychiatric Hospital and Clinics - San Francisco - CA",
  "Lankenau Medical Center - Wynnewood - PA",
  "Laredo Medical Center - Laredo - TX",
  "Laredo Rehabilitation Hospital - Laredo - TX",
  "Laredo Specialty Hospital - Laredo - TX",
  "Larkin Community Hospital Behavioral Health Services - Hollywood - FL",
  "Larkin Community Hospital Palm Springs Campus - Hialeah - FL",
  "Larkin Community Hospital South Miami - South Miami - FL",
  "Larned State Hospital - Larned - KS",
  "Las Encinas Hospital - Pasadena - CA",
  "Las Palmas Del Sol Rehabilitation Hospital East - El Paso - TX",
  "Las Palmas Medical Center - El Paso - TX",
  "Lasalle General Hospital - Jena - LA",
  "Lauderdale Community Hospital - Ripley - TN",
  "Laureate Psychiatric Clinic and Hospital - Tulsa - OK",
  "Laurel Heights Hospital - Atlanta - GA",
  "Laurel Oaks Behavioral Health Center - Dothan - AL",
  "Laurel Ridge Treatment Center - San Antonio - TX",
  "Lavaca Medical Center - Hallettsville - TX",
  "Lawrence & Memorial Hospital - New London - CT",
  "Lawrence County Hospital - Monticello - MS",
  "Lawrence County Memorial Hospital - Lawrenceville - IL",
  "Lawrence General Hospital - Lawrence - MA",
  "Lawrence Medical Center - Moulton - AL",
  "Lawrence Memorial Hospital - Walnut Ridge - AR",
  "Lawrence Memorial Hospital of Medford - Medford - MA",
  "Lawrence Rehabilitation Center - Lawrence Township - NJ",
  "Lawton Indian Hospital - Lawton - OK",
  "LBJ Tropical Medical Center - Pago Pago - AS",
  "LDS Hospital - Salt Lake City - UT",
  "Le Bonheur Children's Hospital - Memphis - TN",
  "Leahi Hospital - Honolulu - HI",
  "Lebanon VA Medical Center - Lebanon - PA",
  "LeConte Medical Center - Sevierville - TN",
  "Ledgewood Rehabilitation and Skilled Nursing Center - Beverly - MA",
  "Lee County Community Hospital - Pennington Gap - VA",
  "Lee Memorial Hospital - Fort Myers - FL",
  "Lee's Summit Medical Center - Lee's Summit - MO",
  "Legacy Emanuel Medical Center - Portland - OR",
  "Legacy Good Samaritan Medical Center - Portland - OR",
  "Legacy Meridian Park Medical Center - Tualatin - OR",
  "Legacy Mount Hood Medical Center - Gresham - OR",
  "Legacy Salmon Creek Medical Center - Vancouver - WA",
  "Legacy Silverton Medical Center - Silverton - OR",
  "Legent Orthopedic and Spine - San Antonio - TX",
  "Lehigh Regional Medical Center - Lehigh Acres - FL",
  "Lehigh Valley Health Network - Allentown - PA",
  "Lehigh Valley Health Network - Highland Avenue - Bethlehem - PA",
  "Lehigh Valley Hospital - Carbon - Lehighton - PA",
  "Lehigh Valley Hospital - Cedar Crest - Allentown - PA",
  "Lehigh Valley Hospital - Dickson City - Dickson City - PA",
  "Lehigh Valley Hospital - Hecktown Oaks - Easton - PA",
  "Lehigh Valley Hospital - Muhlenberg - Bethlehem - PA",
  "Lehigh Valley Hospital - Pocono - East Stroudsburg - PA",
  "Lehigh Valley Hospital - Schuylkill E. Norwegian Street - Pottsville - PA",
  "Lehigh Valley Hospital-Hazleton - Hazleton - PA",
  "Lehigh Valley Hospital-Schuylkill S. Jackson Street - Pottsville - PA",
  "Lehigh Valley Reilly Children's Hospital - Allentown - PA",
  "Lemuel Shattuck Hospital - Jamaica Plain - MA",
  "Lenoir UNC Health Care - Kinston - NC",
  "Lenox Hill Hospital - New York - NY",
  "Leonard J. Chabert Medical Center - Houma - LA",
  "Leonard Morse Hospital - Natick - MA",
  "Levi Hospital - Hot Springs National Park - AR",
  "Levindale - Baltimore - MD",
  "Lewis County Health System - Lowville - NY",
  "LewisGale Hospital Alleghany - Low Moor - VA",
  "LewisGale Hospital Montgomery - Blacksburg - VA",
  "LewisGale Hospital Pulaski - Pulaski - VA",
  "LewisGale Medical Center - Salem - VA",
  "Lexington Medical Center - West Columbia - SC",
  "Lexington Medical Center - Lexington - NC",
  "Lexington Regional Health Center - Lexington - NE",
  "Lexington VA Medical Center Troy Bowling Campus - Lexington - KY",
  "Liberty Dayton Regional Medical Center - Liberty - TX",
  "Liberty Hospital - Liberty - MO",
  "Liberty Regional Medical Center - Hinesville - GA",
  "Liberty Rehabilitation Hospital - Liberty Township - OH",
  "Licking Memorial Hospital - Newark - OH",
  "Lieutenant Colonel Charles S. Kettles VA Medical Center - Ann Arbor - MI",
  "LifeBrite Community Hospital of Early - Blakely - GA",
  "LifeBrite Community Hospital of Stokes - Danbury - NC",
  "LifeCare Hospitals of Dallas - Dallas - TX",
  "Lifecare Hospitals of Fort Worth - Fort Worth - TX",
  "LifeCare Hospitals of Plano - Plano - TX",
  "LifeCare Medical Center - Roseau - MN",
  "LifeScape Children's Services - Sioux Falls - SD",
  "LifeStream Hospital - Leesburg - FL",
  "Lifeways Hospital - Boise - ID",
  "Lighthouse Behavioral Health Hospital - Conway - SC",
  "Lighthouse Care Center of Augusta - Augusta - GA",
  "Lillian M. Hudspeth Memorial Hospital - Sonora - TX",
  "Lima Memorial Hospital - Lima - OH",
  "Limestone Medical Center - Groesbeck - TX",
  "Lincoln Community Hospital - Hugo - CO",
  "Lincoln County Hospital - Lincoln - KS",
  "Lincoln County Medical Center - Ruidoso - NM",
  "Lincoln Hospital - Davenport - WA",
  "Lincoln Memorial Hospital - Lincoln - IL",
  "Lincoln Prairie Behavioral Health Center - Springfield - IL",
  "Lincoln Regional Center - Lincoln - NE",
  "Lincoln Surgical Hospital - Lincoln - NE",
  "Lincoln Trail Behavioral Health System - Radcliff - KY",
  "LincolnHealth - Miles Campus & Hospital - Damariscotta - ME",
  "Linden Oaks Behavioral Health - Naperville - IL",
  "Lindner Center of HOPE - Mason - OH",
  "Lindsay Municipal Hospital - Lindsay - OK",
  "Lindsborg Community Hospital - Lindsborg - KS",
  "Linton Regional Medical Center - Linton - ND",
  "Little Colorado Medical Center - Winslow - AZ",
  "Little Falls Hospital - Little Falls - NY",
  "Little River Memorial Hospital - Ashdown - AR",
  "Littleton Regional Healthcare - Littleton - NH",
  "Livengrin Foundation - Bensalem - PA",
  "Livingston HealthCare - Livingston - MT",
  "Livingston Hospital - Salem - KY",
  "Livingston Regional Hospital - Livingston - TN",
  "LMH Health Main Campus - Lawrence - KS",
  "Logan County Health Services - Oakley - KS",
  "Logan Health - Cut Bank - Cut Bank - MT",
  "Logan Health - Whitefish - Whitefish - MT",
  "Logan Health Chester - Chester - MT",
  "Logan Health Conrad - Conrad - MT",
  "Logan Health Medical Center - Kalispell - MT",
  "Logan Health Shelby - Shelby - MT",
  "Logan Memorial Hospital - Russellville - KY",
  "Logan Regional Hospital - Logan - UT",
  "Logan Regional Medical Center - Logan - WV",
  "Logansport Memorial Hospital - Logansport - IN",
  "Loma Linda University Children's Hospital - Loma Linda - CA",
  "Loma Linda University Health Behavioral Health - Redlands - CA",
  "Loma Linda University Medical Center - Loma Linda - CA",
  "Loma Linda University Medical Center - Murrieta - Murrieta - CA",
  "Loma Linda University Medical Center East Campus - Loma Linda - CA",
  "Loma Linda University Surgical Hospital - Redlands - CA",
  "Lompoc Valley Medical Center - Lompoc - CA",
  "Lone Peak Hospital - Draper - UT",
  "Lone Star Behavioral Health - Cypress - TX",
  "Lonesome Pine Hospital - Big Stone Gap - VA",
  "Long Beach Medical Center - Long Beach - CA",
  "Long Island Jewish Forest Hills Hospital - Forest Hills - NY",
  "Long Island Jewish Medical Center - New Hyde Park - NY",
  "Long Island Jewish Valley Stream - Valley Stream - NY",
  "Long Term Acute Care Hospital Mosaic Life Care at Saint Joseph - Saint Joseph - MO",
  "Longleaf Hospital - Alexandria - LA",
  "Longview Regional Medical Center - Longview - TX",
  "Longview Rehabilitation Hospital - Longview - TX",
  "Loretto Hospital - Chicago - IL",
  "Loring Hospital - Sac City - IA",
  "Los Alamitos Medical Center - Los Alamitos - CA",
  "Los Alamos Medical Center - Los Alamos - NM",
  "Los Angeles Community Hospital - Los Angeles - CA",
  "Los Angeles Community Hospital at Bellflower - Bellflower - CA",
  "Los Angeles General Medical Center - Los Angeles - CA",
  "Los Angeles Medical Center - Los Angeles - CA",
  "Los Robles Regional Medical Center - Thousand Oaks - CA",
  "Lost Rivers Medical Center - Arco - ID",
  "Louis A. Johnson Veterans' Administration Medical Center - Clarksburg - WV",
  "Louis Stokes Cleveland Department of Veterans Affairs Medical Center - Cleveland - OH",
  "Louisiana Behavioral Health - Shreveport - LA",
  "Louisiana Extended Care Hospital of Lafayette - Lafayette - LA",
  "Louisiana Extended Care Hospital of Natchitoches - Natchitoches - LA",
  "Louisiana Extended Care of West Monroe - West Monroe - LA",
  "Louisville VA Medical Center - Louisville - KY",
  "Lourdes Counseling Center - Richland - WA",
  "Lourdes Hospital - Binghamton - NY",
  "Lourdes Medical Center - Pasco - WA",
  "Lovelace Medical Center - Albuquerque - NM",
  "Lovelace Regional Hospital - Roswell - NM",
  "Lovelace UNW Rehabilitation Hospital - Albuquerque - NM",
  "Lovelace Westside Hospital - Albuquerque - NM",
  "Lovelace Women's Hospital - Albuquerque - NM",
  "Lowell General - Saints Campus - Lowell - MA",
  "Lowell General Hospital - Lowell - MA",
  "Lower Bucks Hospital - Bristol - PA",
  "Lower Keys Medical Center - Key West - FL",
  "Lower Umpqua Hospital District - Reedsport - OR",
  "Loyola Medicine Children's Hospital - Maywood - IL",
  "Loyola University Medical Center - Maywood - IL",
  "LSU Health Lallie Kemp Regional Medical Center - Independence - LA",
  "Lt. Col. Luke Weathers, Jr. VA Medical Center - Memphis - TN",
  "LTACH - CareOne at Hackensack University Medical Center, Pascack Valley - Westwood - NJ",
  "LTACH CareOne at Saint Peter's University Hospital - New Brunswick - NJ",
  "LTACH CareOne at Trinitas Regional Medical Center - Elizabeth - NJ",
  "Lubbock Heart & Surgical Hospital - Lubbock - TX",
  "Lucas County Health Center - Chariton - IA",
  "Lucile Packard Children's Hospital Stanford - Palo Alto - CA",
  "Luminis Health Anne Arundel Medical Center - Annapolis - MD",
  "Luminis Health Doctors Community Medical Center - Lanham - MD",
  "Luminis Health J. Kent McNew Family Medical Center - Annapolis - MD",
  "Lutheran Downtown Hospital - Fort Wayne - IN",
  "Lutheran Health Network The Orthopedic Hospital - Fort Wayne - IN",
  "Lutheran Hospital - Fort Wayne - IN",
  "Lutheran Kosciusko Hospital - Warsaw - IN",
  "Lutheran Medical Center - Wheat Ridge - CO",
  "Lyndon B. Johnson Hospital - Houston - TX",
  "Lynn County Hospital - Tahoka - TX",
  "Lynn House of Potomac Valley - Alexandria - VA",
  "Lyons VA Medical Center - Lyons - NJ",
  "M Health Fairview Bethesda Hospital - Saint Paul - MN",
  "M Health Fairview Lakes Medical Center - Wyoming - Wyoming - MN",
  "M Health Fairview Masonic Children's Hospital - Minneapolis - MN",
  "M Health Fairview Northland Medical Center - Princeton - MN",
  "M Health Fairview Ridges Hospital - Burnsville - MN",
  "M Health Fairview Southdale Hospital - Edina - MN",
  "M Health Fairview St. John's Hospital - Maplewood - MN",
  "M Health Fairview University of Minnesota Medical Center - Minneapolis - MN",
  "M Health Fairview University of Minnesota Medical Center - West Bank East - Minneapolis - MN",
  "M Health Fairview Woodwinds Hospital - Woodbury - Woodbury - MN",
  "Mackinac Straits Hospital & Health Center - Saint Ignace - MI",
  "MacNeal Hospital - Berwyn - IL",
  "Macon Community Hospital - Lafayette - TN",
  "Mad River Community Hospital - Arcata - CA",
  "Madden Mental Health Center - Hines - IL",
  "Madelia Health - Madelia - MN",
  "Madigan Army Medical Center - Tacoma - WA",
  "Madison County Memorial Hospital - Winterset - IA",
  "Madison County Memorial Hospital - Madison - FL",
  "Madison Health - London - OH",
  "Madison Healthcare Services - Madison - MN",
  "Madison Hospital - Madison - AL",
  "Madison Medical Center - Fredericktown - MO",
  "Madison Memorial Hospital - Rexburg - ID",
  "Madison Parish Hospital - Tallulah - LA",
  "Madison Regional Health System - Madison - SD",
  "Madison State Hospital - Madison - IN",
  "Madison Valley Medical Center - Ennis - MT",
  "Madonna Rehabilitation Hospital - Lincoln - NE",
  "Madonna Rehabilitation Hospitals Lincoln Campus - Lincoln - NE",
  "Madonna Rehabilitation Hospitals Omaha Campus - Omaha - NE",
  "Madonna Rehabilitation Specialty Hospital - Bellevue - NE",
  "Magee General Hospital - Magee - MS",
  "Magee Rehabilitation Hospital - Philadelphia - PA",
  "Magnolia Regional Health Center - Corinth - MS",
  "Magnolia Regional Medical Center - Magnolia - AR",
  "Magruder Hospital - Port Clinton - OH",
  "Mahaska Hospital - Oskaloosa - IA",
  "Mahnomen Health - Mahnomen - MN",
  "Maimonides Medical Center - Brooklyn - NY",
  "Maimonides Midwood Community Hospital - Brooklyn - NY",
  "Maine Medical Center - Portland - ME",
  "Maine VA Medical Center - Augusta - ME",
  "MaineGeneral Health - Augusta - ME",
  "Malcom Randall Department of Veterans Affairs Medical Center - Gainesville - FL",
  "Malvern Behavioral Health - Philadelphia - PA",
  "Mammoth Hospital - Mammoth Lakes - CA",
  "Manatee Memorial Hospital - Bradenton - FL",
  "Manati Medical Center - Manati - PR",
  "Manchester Inpatient Rehabilitation Unit at Elliot Hospital - Manchester - NH",
  "Manchester Memorial Hospital - Manchester - CT",
  "Manchester VA Medical Center - Manchester - NH",
  "Mangum Regional Medical Center - Mangum - OK",
  "Manhattan Psychiatric Center - New York - NY",
  "Manhattan Surgical Center - Manhattan - KS",
  "Maniilaq Health Center - Kotzebue - AK",
  "Manning Regional Healthcare Center - Manning - IA",
  "Maple Grove Hospital - Maple Grove - MN",
  "Maple Heights Behavioral Health - Fort Wayne - IN",
  "Margaret Cochran Corbin VA Campus - New York - NY",
  "Margaret Mary Health - Main Campus - Batesville - IN",
  "Margaretville Hospital - Margaretville - NY",
  "Maria Fareri Children's Hospital - Valhalla - NY",
  "Maria Parham Medical Center - Henderson - NC",
  "Marian Regional Medical Center - Santa Maria - CA",
  "Marianjoy Rehabilitation Hospital - Wheaton - IL",
  "Marietta Memorial Hospital - Marietta - OH",
  "Mariners Hospital - Tavernier - FL",
  "Marion General Hospital - Columbia - MS",
  "Marion General Hospital - Marion - IN",
  "Marion VA Medical Center - Marion - IL",
  "Mark Twain Medical Center - San Andreas - CA",
  "Marlette Regional Hospital - Marlette - MI",
  "Marshall Browning Hospital - DuQuoin - IL",
  "Marshall County Healthcare Center Avera - Britton - SD",
  "Marshall County Hospital - Benton - KY",
  "Marshall Medical Center - Placerville - CA",
  "Marshall Medical Center - Lewisburg - TN",
  "Marshall Medical Center North - Guntersville - AL",
  "Marshall Medical Center South - Boaz - AL",
  "Marshfield Children's Hospital - Marshfield - WI",
  "Marshfield Medical Center - Beaver Dam - Beaver Dam - WI",
  "Marshfield Medical Center - Eau Claire - Eau Claire - WI",
  "Marshfield Medical Center - Ladysmith - Ladysmith - WI",
  "Marshfield Medical Center - Marshfield - Marshfield - WI",
  "Marshfield Medical Center - Minocqua - Minocqua - WI",
  "Marshfield Medical Center - Neillsville - Neillsville - WI",
  "Marshfield Medical Center - Park Falls - Park Falls - WI",
  "Marshfield Medical Center - Rice Lake - Rice Lake - WI",
  "Marshfield Medical Center - Weston - Weston - WI",
  "Marshfield Medical Center Dickinson - Iron Mountain - MI",
  "Marshfield Medical Center-River Region Stevens Point Campus - Stevens Point - WI",
  "Martha's Vineyard Hospital - Oak Bluffs - MA",
  "Martin Army Community Hospital - Fort Benning - GA",
  "Martin County Hospital - Stanton - TX",
  "Martin Luther King, Jr. Community Hospital - Los Angeles - CA",
  "Martinsburg VA Medical Center - Martinsburg - WV",
  "Mary Breckinridge ARH Hospital - Hyden - KY",
  "Mary Bridge Children's Hospital and Health Center - Tacoma - WA",
  "Mary Free Bed at Sparrow - Lansing - MI",
  "Mary Free Bed Rehabilitation Hospital - Grand Rapids - MI",
  "Mary Gandy Travis Residential Treatment Center - Erlanger - KY",
  "Mary Greeley Medical Center - Ames - IA",
  "Mary Lanning Memorial Hospital - Hastings - NE",
  "Mary Rutan Hospital - Bellefontaine - OH",
  "Mary Starke Harper Geriatric Psychiatry Center - Tuscaloosa - AL",
  "Mary Washington Healthcare Snowden at Fredericksburg - Fredericksburg - VA",
  "Mary Washington Hospital - Fredericksburg - VA",
  "Maryland Heights Center for Behavioral Health - Bridgeton - MO",
  "Mason District Hospital - Havana - IL",
  "Mason General Hospital - Shelton - WA",
  "Masonicare Main Campus - Wallingford - CT",
  "Massac Memorial Hospital - Metropolis - IL",
  "Massachusetts Eye and Ear Infirmary - Boston - MA",
  "Massachusetts General Hospital - Boston - MA",
  "Massena Hospital - Massena - NY",
  "Mat-Su Regional Medical Center - Palmer - AK",
  "Matagorda Regional Medical Center - Bay City - TX",
  "Matheny Hospital - Peapack - NJ",
  "Mather Hospital - Port Jefferson - NY",
  "Maui Memorial Medical Center - Wailuku - HI",
  "Maury Regional Medical Center - Columbia - TN",
  "Mayaguez Medical Center - Mayaguez - PR",
  "Mayers Memorial Hospital - Fall River Mills - CA",
  "Mayhill Hospital - Denton - TX",
  "Mayo Building and Hospital - Jacksonville - FL",
  "Mayo Clinic Health System - Chippewa Valley Bloomer - Bloomer - WI",
  "Mayo Clinic Health System - Franciscan Healthcare La Crosse - La Crosse - WI",
  "Mayo Clinic Health System - Franciscan Healthcare Sparta - Sparta - WI",
  "Mayo Clinic Health System - Oakridge in Osseo - Osseo - WI",
  "Mayo Clinic Health System - Red Cedar Menomonie - Menomonie - WI",
  "Mayo Clinic Health System Albert Lea - Albert Lea - MN",
  "Mayo Clinic Health System Cannon Falls - Cannon Falls - MN",
  "Mayo Clinic Health System in Austin - Austin - MN",
  "Mayo Clinic Health System in Eau Claire - Eau Claire - WI",
  "Mayo Clinic Health System in Fairmont - Fairmont - MN",
  "Mayo Clinic Health System in Lake City - Lake City - MN",
  "Mayo Clinic Health System in Mankato - Mankato - MN",
  "Mayo Clinic Health System in New Prague - New Prague - MN",
  "Mayo Clinic Health System in Red Wing - Red Wing - MN",
  "Mayo Clinic Health System in St. James - Saint James - MN",
  "Mayo Clinic Health System in Waseca - Waseca - MN",
  "Mayo Clinic Health System- Northland Barron - Barron - WI",
  "Mayo Clinic Hospital , Saint Mary's Campus - Rochester - MN",
  "Mayo Clinic Hospital, Methodist Campus - Rochester - MN",
  "Mayo Clinic Hospital, Phoenix Arizona - Phoenix - AZ",
  "Mayo Eugenio Litta Children's Hospital - Rochester - MN",
  "McAlester Regional Health Center - McAlester - OK",
  "McBride Orthopedic Hospital - Oklahoma City - OK",
  "McCamey County Hospital District - McCamey - TX",
  "McCone County Health Center - Circle - MT",
  "McCullough-Hyde Memorial Hospital - Oxford - OH",
  "McCurtain Memorial Hospital - Idabel - OK",
  "McDonald Army Health Center - Fort Eustis - VA",
  "McDonough District Hospital - Macomb - IL",
  "McDowell ARH Hospital - McDowell - KY",
  "McFarland Mental Health Center - Springfield - IL",
  "MCFP Springfield - Springfield - MO",
  "McGehee Hospital - McGehee - AR",
  "McKay-Dee Hospital - Ogden - UT",
  "McKee Medical Center - Loveland - CO",
  "McKenzie Health Hospital - Watford City - ND",
  "McKenzie Memorial Hospital - Sandusky - MI",
  "McKenzie-Willamette Medical Center - Springfield - OR",
  "McLaren Bay Region - Bay City - MI",
  "McLaren Bay Special Care Hospital - Bay City - MI",
  "McLaren Caro Region - Caro - MI",
  "McLaren Central Michigan - Mount Pleasant - MI",
  "McLaren Flint Hospital - Flint - MI",
  "McLaren Greater Lansing - Lansing - MI",
  "McLaren Lapeer Region Hospital - Lapeer - MI",
  "McLaren Macomb Hospital - Mount Clemens - MI",
  "McLaren Northern Michigan - Petoskey - MI",
  "McLaren Oakland - Pontiac - MI",
  "McLaren Port Huron Hospital - Port Huron - MI",
  "McLaren Thumb Region Hospital - Bad Axe - MI",
  "McLean Hospital - Belmont - MA",
  "McLeod Behavioral Health Center in Darlington - Darlington - SC",
  "McLeod Health Cheraw - Cheraw - SC",
  "McLeod Health Clarendon - Manning - SC",
  "McLeod Health Dillon - Dillon - SC",
  "McLeod Health Seacoast - Little River - SC",
  "McLeod Loris - Loris - SC",
  "McLeod Regional Medical Center - Florence - SC",
  "McPherson Center for Health - McPherson - KS",
  "Meade District Hospital - Meade - KS",
  "Meadowbrook Rehabilitation Hospital - Gardner - KS",
  "Meadowview Psychiatric Hospital - Secaucus - NJ",
  "Meadowview Regional Medical Center - Maysville - KY",
  "MeadowWood Behavioral Health Hospital - New Castle - DE",
  "Meadville Medical Center - Meadville - PA",
  "Mease Countryside Hospital - Safety Harbor - FL",
  "Mease Dunedin Hospital - Dunedin - FL",
  "Medical Arts Hospital - Lamesa - TX",
  "Medical Behavioral Hospital of Clear Lake - Houston - TX",
  "Medical Behavioral Hospital of Indianapolis - Greenwood - IN",
  "Medical Behavioral Hospital of Mishawaka - Mishawaka - IN",
  "Medical Behavioral Hospital of Northern Arizona - Prescott - AZ",
  "Medical Center Barbour - Eufaula - AL",
  "Medical Center Enterprise - Enterprise - AL",
  "Medical Center Hospital - Odessa - TX",
  "Medical City Alliance - Fort Worth - TX",
  "Medical City Argyle, a Campus of Medical City Denton - Argyle - TX",
  "Medical City Arlington - Arlington - TX",
  "Medical City Children's Hospital - Dallas - TX",
  "Medical City Dallas - Dallas - TX",
  "Medical City Decatur - Decatur - TX",
  "Medical City Denton - Denton - TX",
  "Medical City Fort Worth - Fort Worth - TX",
  "Medical City Frisco - Frisco - TX",
  "Medical City Green Oaks Hospital - Dallas - TX",
  "Medical City Las Colinas - Irving - TX",
  "Medical City Lewisville - Lewisville - TX",
  "Medical City McKinney - McKinney - TX",
  "Medical City North Hills - North Richland Hills - TX",
  "Medical City Plano - Plano - TX",
  "Medical City Surgical Hospital - Alliance, A Campus of Medical City Alliance - Fort Worth - TX",
  "Medical City Weatherford - Weatherford - TX",
  "Medical West Main Campus - Bessemer - AL",
  "Medicine Lodge Memorial Hospital - Medicine Lodge - KS",
  "Medina Regional Hospital - Hondo - TX",
  "MedStar Franklin Square Medical Center - Baltimore - MD",
  "MedStar Georgetown University Hospital - Washington - DC",
  "Medstar Good Samaritan Hospital - Baltimore - MD",
  "MedStar Harbor Hospital - Baltimore - MD",
  "MedStar Montgomery Medical Center - Olney - MD",
  "MedStar National Rehabilitation Hospital - Washington - DC",
  "MedStar Saint Mary's Hospital - Leonardtown - MD",
  "MedStar Southern Maryland Hospital - Clinton - MD",
  "MedStar Union Memorial Hospital - Baltimore - MD",
  "Medstar Washington Hospital Center - Washington - DC",
  "Mee Memorial Hospital - King City - CA",
  "Meeker Memorial Hospital - Litchfield - MN",
  "Melbourne Regional Medical Center - Melbourne - FL",
  "Melissa Memorial Hospital - Holyoke - CO",
  "MelroseWakefield Hospital - Melrose - MA",
  "Memorial Community Health - Aurora - NE",
  "Memorial Community Hospital - Blair - NE",
  "Memorial Epworth Center - South Bend - IN",
  "Memorial Health - Savannah - GA",
  "Memorial Health Dwaine and Cynthia Willett Children's Hospital of Savannah - Savannah - GA",
  "Memorial Health Meadows Hospital - Vidalia - GA",
  "Memorial Healthcare - Owosso - MI",
  "Memorial Hermann - Texas Medical Center - Houston - TX",
  "Memorial Hermann Cypress Hospital - Cypress - TX",
  "Memorial Hermann Greater Heights Hospital - Houston - TX",
  "Memorial Hermann Katy Hospital - Katy - TX",
  "Memorial Hermann Memorial City Medical Center - Houston - TX",
  "Memorial Hermann Northeast Hospital - Humble - TX",
  "Memorial Hermann Pearland Hospital - Pearland - TX",
  "Memorial Hermann Rehabilitation Hospital - Katy - Katy - TX",
  "Memorial Hermann Rockets Orthopedic Hospital - Bellaire - TX",
  "Memorial Hermann Southeast Hospital - Houston - TX",
  "Memorial Hermann Southwest Hospital - Houston - TX",
  "Memorial Hermann Sugar Land Hospital - Sugar Land - TX",
  "Memorial Hermann Surgical Hospital First Colony - Sugar Land - TX",
  "Memorial Hermann Surgical Hospital Kingwood - Kingwood - TX",
  "Memorial Hermann The Woodlands Medical Center - The Woodlands - TX",
  "Memorial Hospital - Marysville - OH",
  "Memorial Hospital - Seward - NE",
  "Memorial Hospital - Abilene - KS",
  "Memorial Hospital - South Bend - IN",
  "Memorial Hospital - Chester - IL",
  "Memorial Hospital and Health Care Center - Jasper - IN",
  "Memorial Hospital and Manor - Bainbridge - GA",
  "Memorial Hospital Belleville - Belleville - IL",
  "Memorial Hospital Gulfport - Gulfport - MS",
  "Memorial Hospital Los Banos - Los Banos - CA",
  "Memorial Hospital Miramar - Miramar - FL",
  "Memorial Hospital of Carbon County - Rawlins - WY",
  "Memorial Hospital of Carbondale - Carbondale - IL",
  "Memorial Hospital of Converse County - Douglas - WY",
  "Memorial Hospital of Gardena - Gardena - CA",
  "Memorial Hospital of Lafayette County - Darlington - WI",
  "Memorial Hospital of Sweetwater County - Rock Springs - WY",
  "Memorial Hospital of Texas County - Guymon - OK",
  "Memorial Hospital Pembroke - Pembroke Pines - FL",
  "Memorial Hospital Shiloh - Shiloh - IL",
  "Memorial Hospital Stone County - Wiggins - MS",
  "Memorial Hospital West - Pembroke Pines - FL",
  "Memorial Medical Center - Las Cruces - NM",
  "Memorial Medical Center - Modesto - CA",
  "Memorial Medical Center - Port Lavaca - TX",
  "Memorial Regional Health - Craig - CO",
  "Memorial Regional Hospital - Hollywood - FL",
  "Memorial Regional Hospital South - Hollywood - FL",
  "Memorial Regional Medical Center - Mechanicsville - VA",
  "Memorial Satilla Health - Waycross - GA",
  "Memorial Sloan Kettering Cancer Center - New York - NY",
  "Memphis Mental Health Institute - Memphis - TN",
  "Mena Regional Health System - Mena - AR",
  "Mendota Mental Health Institute - Madison - WI",
  "Menifee Global Medical Center - Menifee - CA",
  "Menorah Medical Center - Overland Park - KS",
  "Mental Health Services for Clark and Madison Counties - Springfield - OH",
  "Mentor Hospital - Mentor - OH",
  "Mercer County Community Hospital - Coldwater - Coldwater - OH",
  "Mercy Hospital Columbus - Columbus - KS",
  "Mercy Behavioral Hospital - Lecompte - LA",
  "Mercy Children's Hospital Saint Louis - Saint Louis - MO",
  "Mercy Children's Hospital Springfield - Springfield - MO",
  "Mercy Fitzgerald Hospital - Darby - PA",
  "Mercy General Hospital - Sacramento - CA",
  "Mercy Gilbert Medical Center - Gilbert - AZ",
  "Mercy Health - Allen Hospital - Oberlin - OH",
  "Mercy Health - Clermont Hospital - Batavia - OH",
  "Mercy Health - Defiance Hospital - Defiance - OH",
  "Mercy Health - Lourdes Hospital - Paducah - KY",
  "Mercy Health - Marcum and Wallace Hospital - Irvine - KY",
  "Mercy Health - Saint Charles Hospital - Oregon - OH",
  "Mercy Health - Saint Elizabeth Youngstown Hospital - Youngstown - OH",
  "Mercy Health - Saint Rita's Medical Center - Lima - OH",
  "Mercy Health - Springfield Regional Medical Center - Springfield - OH",
  "Mercy Health - St. Anne Hospital - Toledo - OH",
  "Mercy Health - St. Joseph Warren Hospital - Warren - OH",
  "Mercy Health - Urbana Hospital - Urbana - OH",
  "Mercy Health - West Hospital - Cincinnati - OH",
  "Mercy Health / Love County Hospital - Marietta - OK",
  "Mercy Health- Fairfield Hospital - Fairfield - OH",
  "Mercy Health- Saint Vincent Medical Center - Toledo - OH",
  "Mercy Health- Willard Hospital - Willard - OH",
  "Mercy Health-Lorain Hospital - Lorain - OH",
  "Mercy Health-Perrysburg Hospital - Perrysburg - OH",
  "Mercy Health-Saint Elizabeth Boardman Hospital - Boardman - OH",
  "Mercy Health-Tiffin Hospital - Tiffin - OH",
  "Mercy Heart and Vascular Hospital Saint Louis - Saint Louis - MO",
  "Mercy Hospital - Coon Rapids - MN",
  "Mercy Hospital - Moundridge - KS",
  "Mercy Hospital - Unity Campus - Fridley - MN",
  "Mercy Hospital Ada - Ada - OK",
  "Mercy Hospital Ardmore - Ardmore - OK",
  "Mercy Hospital Aurora - Aurora - MO",
  "Mercy Hospital Berryville - Berryville - AR",
  "Mercy Hospital Booneville - Booneville - AR",
  "Mercy Hospital Carthage - Carthage - MO",
  "Mercy Hospital Cassville - Cassville - MO",
  "Mercy Hospital Downtown Bakersfield - Bakersfield - CA",
  "Mercy Hospital Fort Smith - Fort Smith - AR",
  "Mercy Hospital Healdton - Healdton - OK",
  "Mercy Hospital Jefferson - Festus - MO",
  "Mercy Hospital Joplin - Joplin - MO",
  "Mercy Hospital Kingfisher - Kingfisher - OK",
  "Mercy Hospital Lebanon - Lebanon - MO",
  "Mercy Hospital Lincoln - Troy - MO",
  "Mercy Hospital Logan County - Guthrie - OK",
  "Mercy Hospital Northwest Arkansas - Rogers - AR",
  "Mercy Hospital of Buffalo - Buffalo - NY",
  "Mercy Hospital of Folsom - Folsom - CA",
  "Mercy Hospital Oklahoma City - Oklahoma City - OK",
  "Mercy Hospital Ozark - Ozark - AR",
  "Mercy Hospital Paris - Paris - AR",
  "Mercy Hospital Perry - Perryville - MO",
  "Mercy Hospital Saint Louis - Saint Louis - MO",
  "Mercy Hospital South - Saint Louis - MO",
  "Mercy Hospital Southwest - Bakersfield - CA",
  "Mercy Hospital Springfield - Springfield - MO",
  "Mercy Hospital Tishomingo - Tishomingo - OK",
  "Mercy Hospital Waldron - Waldron - AR",
  "Mercy Hospital Washington - Washington - MO",
  "Mercy Hospital Watonga - Watonga - OK",
  "Mercy Iowa City - Iowa City - IA",
  "Mercy Iowa City Rehabilitation Hospital - Coralville - IA",
  "Mercy Medical Center - Roseburg - OR",
  "Mercy Medical Center - Baltimore - MD",
  "Mercy Medical Center - Springfield - MA",
  "Mercy Medical Center - Cedar Rapids - IA",
  "Mercy Medical Center Merced - Merced - CA",
  "Mercy Medical Center Mt. Shasta - Mount Shasta - CA",
  "Mercy Medical Center Redding - Redding - CA",
  "Mercy Orthopedic Hospital Fort Smith - Fort Smith - AR",
  "Mercy Orthopedic Hospital Springfield - Ozark - MO",
  "Mercy Regional Medical Center - Ville Platte - LA",
  "Mercy Rehabilitation Hospital Fort Smith - Fort Smith - AR",
  "Mercy Rehabilitation Hospital Oklahoma City - Oklahoma City - OK",
  "Mercy Rehabilitation Hospital Oklahoma City South - Oklahoma City - OK",
  "Mercy Rehabilitation Hospital South - Saint Louis - MO",
  "Mercy Rehabilitation Hospital Springfield - Springfield - MO",
  "Mercy Rehabilitation Hospital St. Louis - Chesterfield - MO",
  "Mercy San Juan Medical Center - Carmichael - CA",
  "Mercy St. Francis Hospital - Mountain View - MO",
  "Mercyhealth Hospital and Medical Center- Walworth - Lake Geneva - WI",
  "Mercyhealth Hospital and Trauma Center-Janesville - Janesville - WI",
  "MercyOne Cedar Falls Medical Center - Cedar Falls - IA",
  "MercyOne Centerville Medical Center - Centerville - IA",
  "MercyOne Clinton Medical Center - Clinton - IA",
  "MercyOne Clive Rehabilitation Hospital - Clive - IA",
  "MercyOne Des Moines - Des Moines - IA",
  "MercyOne Dubuque Medical Center - Dubuque - IA",
  "MercyOne Dyersville Medical Center - Dyersville - IA",
  "MercyOne Elkader Medical Center - Elkader - IA",
  "MercyOne New Hampton Medical Center - New Hampton - IA",
  "MercyOne Newton Medical Center - Newton - IA",
  "MercyOne North Iowa - Mason City - IA",
  "MercyOne Oelwein Medical Center - Oelwein - IA",
  "MercyOne Primghar Medical Center - Primghar - IA",
  "MercyOne Siouxland Medical Center - Sioux City - IA",
  "MercyOne Waterloo Medical Center - Waterloo - IA",
  "MercyOne West Des Moines Medical Center - West Des Moines - IA",
  "Meridell Achievement Center - Liberty Hill - TX",
  "Merit Health Biloxi - Biloxi - MS",
  "Merit Health Central - Jackson - MS",
  "Merit Health Madison - Canton - MS",
  "Merit Health Natchez - Natchez - MS",
  "Merit Health Rankin - Brandon - MS",
  "Merit Health River Oaks - Flowood - MS",
  "Merit Health River Region - Vicksburg - MS",
  "Merit Health Wesley - Hattiesburg - MS",
  "Merit Health Woman's Hospital - Jackson - MS",
  "Meritus Medical Center - Hagerstown - MD",
  "Merrick Medical Center - Central City - NE",
  "Mesa Springs - Fort Worth - TX",
  "Mesa View Regional Hospital - Mesquite - NV",
  "Mesilla Valley Hospital - Las Cruces - NM",
  "Mesquite Rehabilitation Institute - Mesquite - TX",
  "Mesquite Specialty Hospital - Mesquite - TX",
  "Methodist Behavioral Hospital - Maumelle - AR",
  "Methodist Charlton Medical Center - Dallas - TX",
  "Methodist Children's Hospital - San Antonio - TX",
  "Methodist Dallas Medical Center - Dallas - TX",
  "Methodist Fremont Health - Fremont - NE",
  "Methodist Hospital - San Antonio - TX",
  "Methodist Hospital - Saint Louis Park - MN",
  "Methodist Hospital - Omaha - NE",
  "Methodist Hospital Atascosa - Jourdanton - TX",
  "Methodist Hospital for Surgery - Addison - TX",
  "Methodist Hospital Hill Country - Fredericksburg - TX",
  "Methodist Hospital Northeast - Live Oak - TX",
  "Methodist Hospital of Sacramento - Sacramento - CA",
  "Methodist Hospital Stone Oak Rehabilitation Center - San Antonio - TX",
  "Methodist Hospital Texan - San Antonio - TX",
  "Methodist Hospitals - Northlake Campus - Gary - IN",
  "Methodist Hospitals - Southlake Campus - Merrillville - IN",
  "Methodist Jennie Edmundson Hospital - Council Bluffs - IA",
  "Methodist Le Bonheur Germantown Hospital - Germantown - TN",
  "Methodist Mansfield Medical Center - Mansfield - TX",
  "Methodist McKinney Hospital - McKinney - TX",
  "Methodist Medical Center - Oak Ridge - TN",
  "Methodist Midlothian Medical Center - Midlothian - TX",
  "Methodist North Hospital - Memphis - TN",
  "Methodist Olive Branch Hospital - Olive Branch - MS",
  "Methodist Rehabilitation Center - Jackson - MS",
  "Methodist Rehabilitation Hospital - Dallas - TX",
  "Methodist Richardson Medical Center - Richardson - TX",
  "Methodist South Hospital - Memphis - TN",
  "Methodist Southlake Medical Center - Southlake - TX",
  "Methodist Specialty and Transplant Hospital - San Antonio - TX",
  "Methodist Stone Oak Hospital - San Antonio - TX",
  "Methodist University Hospital - Memphis - TN",
  "Methodist Women's Hospital - Omaha - NE",
  "MetroHealth Main Campus Medical Center - Cleveland - OH",
  "Metropolitan Methodist Hospital - San Antonio - TX",
  "Metropolitan Saint Louis Psychiatric Center - Saint Louis - MO",
  "Meyer Orthopedic and Rehabilitation Hospital - Springfield - MO",
  "MHP Medical Center - Shelbyville - IN",
  "Miami County Medical Center - Paola - KS",
  "Miami Jewish Health Systems - Miami - FL",
  "Miami Valley Hospital - Dayton - OH",
  "Miami Valley Hospital North - Englewood - OH",
  "Miami Valley Hospital South - Centerville - OH",
  "Michael E. DeBakey Department of Veterans Affairs Medical Center - Houston - TX",
  "Michiana Behavioral Health - Plymouth - IN",
  "Mid Coast Hospital - Brunswick - ME",
  "Mid-Hudson Forensic Psychiatric Center - New Hampton - NY",
  "Mid-Valley Hospital - Omak - WA",
  "MidAmerica Rehabilitation Hospital - Overland Park - KS",
  "MidCoast Medical Center - Central - Llano - TX",
  "MidCoast Medical Center Bellville - Bellville - TX",
  "Middle Park Health Granby - Granby - CO",
  "Middle Park Health Kremmling - Kremmling - CO",
  "Middle Tennessee Mental Health Institute - Nashville - TN",
  "Middlesboro ARH Hospital - Middlesboro - KY",
  "Middlesex Hospital - Middletown - CT",
  "Midhudson Regional Hospital - Poughkeepsie - NY",
  "Midland Memorial Hospital - Midland - TX",
  "Midlands Behavioral Health Hospital - Sumpter - SC",
  "Midlands Regional Center - Columbia - SC",
  "Midlands Regional Rehabilitation Hospital - Elgin - SC",
  "MidState Medical Center - Meriden - CT",
  "Midwest Medical Center - Galena - IL",
  "Midwest Orthopedic Specialty Hospital - Franklin - WI",
  "Midwest Surgical Hospital - Omaha - NE",
  "Milbank Area Health Care Campus - Milbank - SD",
  "Mildred Mitchell-Bateman Hospital - Huntington - WV",
  "Mile Bluff Medical Center - Mauston - WI",
  "Milford Regional Medical Center - Milford - MA",
  "Milford Valley Memorial Hospital - Milford - UT",
  "Millard Fillmore Suburban Hospital - Williamsville - NY",
  "Millcreek Community Hospital - Erie - PA",
  "Mille Lacs Hospital - Onamia - MN",
  "Miller Children's and Women's Hospital Long Beach - Long Beach - CA",
  "Miller County Hospital - Colquitt - GA",
  "Millinocket Regional Hospital - Millinocket - ME",
  "Mills Health Center - San Mateo - CA",
  "Mills-Peninsula Medical Center - Burlingame - CA",
  "Millwood Hospital - Arlington - TX",
  "Milton S. Hershey Medical Center - Hershey - PA",
  "Milwaukee County Mental Health - Milwaukee - WI",
  "Milwaukee Rehabilitation Hospital at Greenfield - Milwaukee - WI",
  "Milwaukee VA Medical Center - Milwaukee - WI",
  "Mimbres Memorial Hospital - Deming - NM",
  "Minden Medical Center - Minden - LA",
  "Mineral Community Hospital - Superior - MT",
  "Miners' Colfax Medical Center - Raton - NM",
  "Minidoka Memorial Hospital - Rupert - ID",
  "Minneapolis VA Medical Center - Minneapolis - MN",
  "Minneola District Hospital - Minneola - KS",
  "Minnesota Security Hospital - Saint Peter - MN",
  "Minnie Hamilton Health Systems - Grantsville - WV",
  "Miramont Behavioral Health - Middleton - WI",
  "MISH Hospital and Clinics - Lenexa - KS",
  "Mishawaka Medical Center - Mishawaka - IN",
  "Mission Children's Hospital - Asheville - NC",
  "Mission Community Hospital - Panorama City - CA",
  "Mission Hospital - Asheville - NC",
  "Mission Hospital McDowell - Marion - NC",
  "Mission Regional Medical Center - Mission - TX",
  "Mission Saint Joseph Campus - Asheville - NC",
  "Mission Trail Baptist Hospital - San Antonio - TX",
  "Mississippi Baptist Medical Center - Jackson - MS",
  "Mississippi State Hospital - Whitfield - MS",
  "Missouri Baptist Medical Center - Saint Louis - MO",
  "Missouri Baptist Sullivan Hospital - Sullivan - MO",
  "Missouri Delta Medical Center - Sikeston - MO",
  "Missouri Psychiatric Center - Columbia - MO",
  "Mitchell County Hospital - Camilla - GA",
  "Mitchell County Hospital - Colorado City - TX",
  "Mitchell County Hospital Health Systems - Beloit - KS",
  "Mitchell County Regional Health Center - Osage - IA",
  "Mitchell Hospital - Hyde Park - Chicago - IL",
  "Mizell Memorial Hospital - Opp - AL",
  "Moab Regional Hospital - Moab - UT",
  "Moberly Regional Medical Center - Moberly - MO",
  "Mobile Infirmary Medical Center - Mobile - AL",
  "Mobridge Regional Hospital - Mobridge - SD",
  "Moccasin Bend Mental Health Institute - Chattanooga - TN",
  "Moccasin Bend Ranch - Miami - OK",
  "Modesto Medical Center - Modesto - CA",
  "Modoc Medical Center - Alturas - CA",
  "Moffitt Cancer Center Magnolia Campus - Tampa - FL",
  "Mohawk Valley Psychiatric Center - Utica - NY",
  "Molokai General Hospital - Kaunakakai - HI",
  "Mon Health Marion Neighborhood Hospital - White Hall - WV",
  "Mon Health Medical Center - Morgantown - WV",
  "Mon Health Preston Memorial Hospital - Kingwood - WV",
  "Mon Health Stonewall Jackson Memorial Hospital - Weston - WV",
  "Monadnock Community Hospital - Peterborough - NH",
  "Monmouth Medical Center - Long Branch - NJ",
  "Monmouth Medical Center Southern Campus - Lakewood - NJ",
  "Monroe Carell Jr. Children's Hospital at Vanderbilt - Nashville - TN",
  "Monroe County Hospital - Forsyth - GA",
  "Monroe County Hospital - Monroeville - AL",
  "Monroe County Hospital - Albia - IA",
  "Monroe County Medical Center - Tompkinsville - KY",
  "Monroe Hospital - Bloomington - IN",
  "Monroe Regional Hospital - Aberdeen - MS",
  "Monroe Surgical Hospital - Monroe - LA",
  "Monrovia Memorial Hospital - Monrovia - CA",
  "Montana Children's - Kalispell - MT",
  "Montana State Hospital - Warm Springs - MT",
  "Montclair Hospital Medical Center - Montclair - CA",
  "Montefiore Hospital- Moses Campus - Bronx - NY",
  "Montefiore Mount Vernon Hospital - Mount Vernon - NY",
  "Montefiore New Rochelle Hospital - New Rochelle - NY",
  "Montefiore Nyack Hospital - Nyack - NY",
  "Montefiore St. Luke's Cornwall - Newburgh - NY",
  "Montefiore Wakefield Campus - Bronx - NY",
  "Montefiore Westchester Square Campus - Bronx - NY",
  "Monterey Park Hospital - Monterey Park - CA",
  "Montevideo Hospital and Clinic - Montevideo - MN",
  "Montgomery County Emergency Service, Inc. - Norristown - PA",
  "Montgomery County Memorial Hospital - Red Oak - IA",
  "Montgomery General Hospital - Montgomery - WV",
  "Montrose Behavioral Health Hospital - Chicago - IL",
  "Montrose Regional Health - Montrose - CO",
  "Monument Health Behavioral Health Center - Rapid City - SD",
  "Monument Health Custer Hospital - Custer - SD",
  "Monument Health Lead - Deadwood Hospital - Deadwood - SD",
  "Monument Health Orthopedic and Specialty Hospital - Rapid City - SD",
  "Monument Health Rapid City Hospital - Rapid City - SD",
  "Monument Health Spearfish Hospital - Spearfish - SD",
  "Monument Health Sturgis Hospital - Sturgis - SD",
  "Moore County Hospital - Dumas - TX",
  "Mora Hospital - Mora - MN",
  "Morehouse General Hospital - Bastrop - LA",
  "Moreno Valley Medical Center - Moreno Valley - CA",
  "Morgan County ARH Hospital - West Liberty - KY",
  "Morgan Medical Center - Madison - GA",
  "Morrill County Community Hospital - Bridgeport - NE",
  "Morris County Hospital - Council Grove - KS",
  "Morris Hospital - Morris - IL",
  "Morris Village Alcohol and Drug Treatment Center - Columbia - SC",
  "Morrison Community Hospital - Morrison - IL",
  "Morristown Medical Center - Morristown - NJ",
  "Morristown-Hamblen Hospital - Morristown - TN",
  "Morrow County Hospital - Mount Gilead - OH",
  "Morton County Hospital - Elkhart - KS",
  "Morton Hospital - Taunton - MA",
  "Morton Plant Hospital - Clearwater - FL",
  "Morton Plant North Bay Hospital - New Port Richey - FL",
  "Mosaic Life Care at St. Joseph - Medical Center - Saint Joseph - MO",
  "Mosaic Medical Center in Albany - Albany - MO",
  "Mosaic Medical Center in Maryville - Maryville - MO",
  "Moses Taylor Hospital - Scranton - PA",
  "MossRehab Einstein Philadelphia - Philadelphia - PA",
  "MossRehab Jefferson Bucks Hospital - Langhorne - PA",
  "MossRehab Jefferson Frankford Hospital - Philadelphia - PA",
  "Motion Picture & Television Hospital - Woodland Hills - CA",
  "Mount Ascutney Hospital and Health Center - Windsor - VT",
  "Mount Auburn Hospital - Cambridge - MA",
  "Mount Carmel Behavioral Health - Columbus - OH",
  "Mount Carmel East - Columbus - OH",
  "Mount Carmel Grove City - Grove City - OH",
  "Mount Carmel New Albany - New Albany - OH",
  "Mount Carmel Rehabilitation Hospital - Westerville - OH",
  "Mount Carmel Saint Ann's - Westerville - OH",
  "Mount Desert Island Hospital - Bar Harbor - ME",
  "Mount Graham Regional Medical Center - Safford - AZ",
  "Mount Grant General Hospital - Hawthorne - NV",
  "Mount Nittany Medical Center - State College - PA",
  "Mount Regis Center - Salem - VA",
  "Mount Saint Mary's Hospital - Lewiston - NY",
  "Mount San Rafael Hospital - Trinidad - CO",
  "Mount Sinai Brooklyn - Brooklyn - NY",
  "Mount Sinai Queens - Astoria - NY",
  "Mount Sinai Beth Israel - New York - NY",
  "Mount Sinai Hospital - Chicago - IL",
  "Mount Sinai Medical Center - Miami Beach - FL",
  "Mount Sinai Morningside - New York - NY",
  "Mount Sinai Rehabilitation Hospital - Hartford - CT",
  "Mount Sinai South Nassau - Oceanside - NY",
  "Mount Sinai West - New York - NY",
  "Mount Washington Pediatric Hospital- Main Campus - Baltimore - MD",
  "Mountain Communities Healthcare District Trinity Hospital - Weaverville - CA",
  "Mountain Lakes Medical Center - Clayton - GA",
  "Mountain Manor Treatment Center - Emmitsburg - Emmitsburg - MD",
  "Mountain Valley Regional Rehabilitation Hospital - Prescott Valley - AZ",
  "Mountain View Hospital - Gadsden - AL",
  "Mountain View Hospital - Idaho Falls - ID",
  "Mountain View Hospital - Payson - Payson - UT",
  "Mountain Vista Medical Center - Mesa - AZ",
  "Mountain West Medical Center - Tooele - UT",
  "Mountains Community Hospital - Lake Arrowhead - CA",
  "MountainView Hospital - Las Vegas - NV",
  "Mountainview Medical Center - White Sulphur Springs - MT",
  "MountainView Regional Medical Center - Las Cruces - NM",
  "Mountrail County Health Center - Stanley - ND",
  "Mt. Edgecumbe Hospital - Sitka - AK",
  "Muenster Memorial Hospital - Muenster - TX",
  "Muleshoe Area Medical Center - Muleshoe - TX",
  "Multicare Allenmore Hospital - Tacoma - WA",
  "Multicare Auburn Medical Center - Auburn - WA",
  "MultiCare Capital Medical Center - Olympia - WA",
  "MultiCare Covington Medical Center - Covington - WA",
  "MultiCare Deaconess Hospital - Spokane - WA",
  "MultiCare Good Samaritan Hospital - Puyallup - WA",
  "Multicare Tacoma General Hospital - Tacoma - WA",
  "MultiCare Valley Hospital - Spokane Valley - WA",
  "MultiCare Yakima Memorial Hospital - Yakima - WA",
  "Multy- Medical Rehabilitation Hospital - Hato Rey - PR",
  "Munising Memorial Hospital - Munising - MI",
  "Munson Healthcare Cadillac Hospital - Cadillac - MI",
  "Munson Healthcare Charlevoix Hospital - Charlevoix - MI",
  "Munson Healthcare Grayling Hospital - Grayling - MI",
  "Munson Medical Center - Traverse City - MI",
  "Murray County Medical Center - Slayton - MN",
  "Murray-Calloway County Hospital - Murray - KY",
  "MUSC Health - Lancaster Medical Center - Lancaster - SC",
  "MUSC Health - Orangeburg - Orangeburg - SC",
  "MUSC Health Ashley River Tower - Charleston - SC",
  "MUSC Health Black River Medical Center - Cades - SC",
  "MUSC Health Columbia Medical Center Downtown - Columbia - SC",
  "MUSC Health Columbia Medical Center Northeast - Columbia - SC",
  "MUSC Health Florence Medical Center - Florence - SC",
  "MUSC Health Kershaw Medical Center - Camden - SC",
  "MUSC Health Marion Medical Center - Mullins - SC",
  "MUSC Health Medical University of South Carolina Rehabilitation Hospital - Charleston - SC",
  "MUSC Health Shawn Jenkins Children's Hospital - Charleston - SC",
  "MUSC Health University Hospital - Charleston - SC",
  "MWPH at UM Capital Region Medical Center - Largo - MD",
  "MyMichigan Medical Center Alma - Alma - MI",
  "MyMichigan Medical Center Alpena - Alpena - MI",
  "MyMichigan Medical Center Clare - Clare - MI",
  "MyMichigan Medical Center Gladwin - Gladwin - MI",
  "MyMichigan Medical Center Midland - Midland - MI",
  "MyMichigan Medical Center Sault - Sault Saint Marie - MI",
  "MyMichigan Medical Center West Branch - West Branch - MI",
  "Myrtue Medical Center - Harlan - IA",
  "Nacogdoches Medical Center - Nacogdoches - TX",
  "Nacogdoches Memorial Hospital - Nacogdoches - TX",
  "Nantucket Cottage Hospital - Nantucket - MA",
  "Nash General Hospital - Rocky Mount - NC",
  "Nashoba Valley Medical Center - Ayer - MA",
  "Nashville General Hospital at Meharry - Nashville - TN",
  "Nashville VA Medical Center - Nashville - TN",
  "Nassau University Medical Center - East Meadow - NY",
  "Natchaug Hospital - Mansfield Center - CT",
  "Natchitoches Regional Medical Center - Natchitoches - LA",
  "Nathan Littauer Hospital - Gloversville - NY",
  "National Jewish Health Main Campus - Denver - CO",
  "National Park Medical Center - Hot Springs - AR",
  "Nationwide Children's Hospital - Columbus - OH",
  "Nationwide Children's Hospital-Toledo - Toledo - OH",
  "Natividad Medical Center - Salinas - CA",
  "Navajo Health Foundation/Sage Memorial Hospital - Ganado - AZ",
  "Naval Health Clinic Lemoore - Lemoore - CA",
  "Naval Hospital Beaufort - Beaufort - SC",
  "Naval Hospital Bremerton - Bremerton - WA",
  "Naval Hospital Camp Lejeune - Camp Lejeune - NC",
  "Naval Hospital Camp Pendleton - Camp Pendleton - CA",
  "Naval Hospital Guam - Agana Heights - GU",
  "Naval Hospital Jacksonville - Jacksonville - FL",
  "Naval Hospital Oak Harbor - Oak Harbor - WA",
  "Naval Hospital Pensacola - Pensacola - FL",
  "Naval Hospital Twentynine Palms - Twentynine Palms - CA",
  "Naval Medical Center Portsmouth - Portsmouth - VA",
  "Naval Medical Center San Diego - San Diego - CA",
  "Navarro Regional Hospital - Corsicana - TX",
  "Navos West Seattle Campus - Seattle - WA",
  "Nazareth Hospital - Philadelphia - PA",
  "NCH Baker Downtown - Naples - FL",
  "NCH North Naples Hospital - Naples - FL",
  "NEA Baptist Memorial Hospital - Jonesboro - AR",
  "Nebraska Medical Center - Omaha - NE",
  "Nebraska Spine Hospital - Omaha - NE",
  "Nell J. Redfield Memorial Hospital - Malad City - ID",
  "Nelson County Health System Hospital - McVille - ND",
  "Nemaha County Hospital - Auburn - NE",
  "Nemaha Valley Community Hospital - Seneca - KS",
  "Nemours Children's Hospital, Delaware - Wilmington - DE",
  "Nemours Children's Hospital, Florida - Orlando - FL",
  "Neosho Memorial Regional Medical Center - Chanute - KS",
  "Neshoba General - Philadelphia - MS",
  "Ness County Hospital - Ness City - KS",
  "NeuroBehavioral Hospital of Northwest Indiana / Chicago - Crown Point - IN",
  "NeuroBehavioral Hospital of the Palm Beaches - North - West Palm Beach - FL",
  "NeuroBehavioral Hospital of the Palm Beaches - South - Boynton Beach - FL",
  "NeuroDiagnostic Institute - Indianapolis - IN",
  "Neurological Rehabilitation Institute at Brookhaven Hospital - Tulsa - OK",
  "NeuroPsychiatric Hospital of Indianapolis - Indianapolis - IN",
  "Nevada Regional Medical Center - Nevada - MO",
  "New Braunfels ER & Hospital - New Braunfels - TX",
  "New Braunfels Regional Rehabilitation Hospital - New Braunfels - TX",
  "New England Baptist Hospital - Boston - MA",
  "New England Rehabilitation Hospital of Portland - Portland - ME",
  "New England Sinai Hospital - Stoughton - MA",
  "New Hampshire Hospital - Concord - NH",
  "New Horizons of Treasure Coast and Okeechobee - Fort Pierce - FL",
  "New London Hospital - New London - NH",
  "New Mexico Behavioral Health Institute - Las Vegas - NM",
  "New Mexico Rehabilitation Center - Roswell - NM",
  "New Milford Hospital - New Milford - CT",
  "New Orleans East Hospital - New Orleans - LA",
  "New Orleans VA Medical Center - New Orleans - LA",
  "New Ulm Medical Center - New Ulm - MN",
  "New York City Children's Center - Queens Campus - Bellerose - NY",
  "New York City Children's Center Bronx Campus - Bronx - NY",
  "New York Presbyterian/Columbia University Irving Medical Center - New York - NY",
  "New York Presbyterian/Weill Cornell Medical Center - New York - NY",
  "New York State Psychiatric Institute - New York - NY",
  "Newark Beth Israel Medical Center - Newark - NJ",
  "Newark-Wayne Community Hospital - Newark - NY",
  "Newberry County Memorial Hospital - Newberry - SC",
  "Newman Memorial Hospital - Shattuck - OK",
  "Newman Regional Health - Emporia - KS",
  "Newport Community Hospital - Newport - WA",
  "Newport Hospital - Newport - RI",
  "Newport Medical Center - Newport - TN",
  "Newton Medical Center - Newton - NJ",
  "Newton-Wellesley Hospital - Newton - MA",
  "NewYork - Presbyterian Lower Manhattan Hospital - New York - NY",
  "NewYork - Presbyterian Westchester - Bronxville - NY",
  "NewYork-Presbyterian Queens Hospital - Flushing - NY",
  "NewYork-Presbyterian Allen Hospital - New York - NY",
  "NewYork-Presbyterian Brooklyn Methodist Hospital - Brooklyn - NY",
  "NewYork-Presbyterian Hudson Valley Hospital - Cortlandt Manor - NY",
  "NewYork-Presbyterian Morgan Stanley Children's Hospital - New York - NY",
  "NewYork-Presbyterian Westchester Behavioral Health Center - White Plains - NY",
  "Nexus Children's Hospital Houston - Houston - TX",
  "Nexus Neurorecovery Center - Conroe - TX",
  "Nexus Specialty Hospital - Shenandoah Campus - Shenandoah - TX",
  "Nexus Specialty Hospital - The Woodlands Campus - The Woodlands - TX",
  "NGMC Barrow - Winder - GA",
  "NGMC Braselton - Braselton - GA",
  "NGMC Gainesville - Gainesville - GA",
  "NGMC Lumpkin - Dahlonega - GA",
  "NHS Sequoyah - Sallisaw - OK",
  "Niagara Falls Memorial Medical Center - Niagara Falls - NY",
  "Nicklaus Children's Hospital - Miami - FL",
  "Niobrara Community Hospital - Lusk - WY",
  "Niobrara Valley Hospital - Lynch - NE",
  "Niswonger Children's Hospital - Johnson City - TN",
  "NMC Health - Newton - KS",
  "NMMC Women's Hospital - Tupelo - MS",
  "Nocona General Hospital - Nocona - TX",
  "Noland Hospital Anniston - Anniston - AL",
  "Noland Hospital Birmingham Downtown - Birmingham - AL",
  "Noland Hospital Birmingham East - Birmingham - AL",
  "Noland Hospital Dothan - Dothan - AL",
  "Noland Hospital Montgomery - Montgomery - AL",
  "Noland Hospital Tuscaloosa - Tuscaloosa - AL",
  "Nor-Lea Hospital District - Lovington - NM",
  "Norfolk Regional Center - Norfolk - NE",
  "Norman Regional HealthPlex - Norman - OK",
  "Norman Regional Hospital - Norman - OK",
  "North Alabama Medical Center - Florence - AL",
  "North Alabama Shoals Hospital - Muscle Shoals - AL",
  "North Alabama Specialty Hospital - Athens - AL",
  "North Arkansas Regional Medical Center - Harrison - AR",
  "North Baldwin Infirmary - Bay Minette - AL",
  "North Big Horn Hospital District - Lovell - WY",
  "North Caddo Medical Center - Vivian - LA",
  "North Canyon Medical Center - Gooding - ID",
  "North Carolina Specialty Hospital - Durham - NC",
  "North Central Baptist Hospital - San Antonio - TX",
  "North Central Health Care - Wausau - WI",
  "North Central Kansas Medical Center - Concordia - KS",
  "North Central Surgical Center Hospital - Dallas - TX",
  "North Country Hospital - Newport - VT",
  "North Dakota State Hospital - Jamestown - ND",
  "North Kansas City Hospital - North Kansas City - MO",
  "North Knoxville Medical Center - Powell - TN",
  "North Las Vegas VA Medical Center - Las Vegas - NV",
  "North Memorial Health - Robbinsdale Hospital - Robbinsdale - MN",
  "North Mississippi Medical Center - Eupora - Eupora - MS",
  "North Mississippi Medical Center - Hamilton - Hamilton - AL",
  "North Mississippi Medical Center - Iuka - Iuka - MS",
  "North Mississippi Medical Center - Pontotoc - Pontotoc - MS",
  "North Mississippi Medical Center - Tupelo - Tupelo - MS",
  "North Mississippi Medical Center - West Point - West Point - MS",
  "North Mississippi Medical Center Gilmore - Amory - Amory - MS",
  "North Mississippi State Hospital - Tupelo - MS",
  "North Oaks Medical Center - Hammond - LA",
  "North Oaks Rehabilitation Hospital - Hammond - LA",
  "North Okaloosa Medical Center - Crestview - FL",
  "North Ottawa Community Hospital - Grand Haven - MI",
  "North Runnels Hospital District - Winters - TX",
  "North Shore Health - Grand Marais - MN",
  "North Shore Medical Center - Miami - FL",
  "North Shore University Hospital - Manhasset - NY",
  "North Spring Behavioral Healthcare - Leesburg - VA",
  "North Star Behavioral Health - Anchorage - AK",
  "North Suburban Medical Center - Thornton - CO",
  "North Sunflower Medical Center - Ruleville - MS",
  "North Tampa Behavioral Health - Wesley Chapel - FL",
  "North Texas Medical Center - Gainesville - TX",
  "North Texas State Hospital - Wichita Falls Campus - Wichita Falls - TX",
  "North Texas State Hospital Main Campus - Vernon - TX",
  "North Valley Health Center - Warren - MN",
  "North Valley Hospital - Tonasket - WA",
  "North Vista Hospital - North Las Vegas - NV",
  "NorthBay Medical Center - Fairfield - CA",
  "NorthBay VacaValley Hospital - Vacaville - CA",
  "Northbrook Behavioral Health Hospital - Blackwood - NJ",
  "Northcoast Behavioral Healthcare - Northfield - OH",
  "Northeast Baptist Hospital - San Antonio - TX",
  "Northeast Florida State Hospital - Macclenny - FL",
  "Northeast Regional Medical Center - Kirksville - MO",
  "Northeast Rehab Hospital at Southern NH Medical Center in Nashua - Nashua - NH",
  "Northeast Rehabilitation Hospital - Salem - NH",
  "Northeast Rehabilitation Hospital in Portsmouth - Portsmouth - NH",
  "Northeastern Center - Kendallville - IN",
  "Northeastern Health System - Tahlequah - OK",
  "Northeastern Nevada Regional Hospital - Elko - NV",
  "Northeastern Vermont Regional Hospital - Saint Johnsbury - VT",
  "Northern Arizona VA Health Care System - Prescott - AZ",
  "Northern Cochise Community Hospital - Willcox - AZ",
  "Northern Colorado Long Term Acute Hospital - Johnstown - CO",
  "Northern Colorado Rehabilitation Hospital - Johnstown - CO",
  "Northern Dutchess Hospital - Rhinebeck - NY",
  "Northern Idaho Advanced Care Hospital - Post Falls - ID",
  "Northern Inyo Hospital - Bishop - CA",
  "Northern Light Acadia Hospital - Bangor - ME",
  "Northern Light AR Gould Hospital - Presque Isle - ME",
  "Northern Light Blue Hill Hospital - Blue Hill - ME",
  "Northern Light CA Dean Hospital - Greenville - ME",
  "Northern Light Eastern Maine Medical Center - Bangor - ME",
  "Northern Light Inland Hospital - Waterville - ME",
  "Northern Light Maine Coast Hospital - Ellsworth - ME",
  "Northern Light Mayo Hospital - Dover-Foxcroft - ME",
  "Northern Light Mercy Hospital - Portland - ME",
  "Northern Light Sebasticook Valley Hospital - Pittsfield - ME",
  "Northern Louisiana Medical Center - Ruston - LA",
  "Northern Maine Medical Center - Fort Kent - ME",
  "Northern Montana Hospital - Havre - MT",
  "Northern Nevada Adult Mental Health Services - Sparks - NV",
  "Northern Nevada Medical Center - Sparks - NV",
  "Northern Nevada Sierra Medical Center - Reno - NV",
  "Northern Regional Hospital - Mount Airy - NC",
  "Northern Utah Rehabilitation Hospital - South Ogden - UT",
  "Northern Virginia Mental Health Institute - Annandale - VA",
  "Northern Westchester Hospital - Mount Kisco - NY",
  "Northfield Hospital - Northfield - MN",
  "Northlake Behavioral Health System - Mandeville - LA",
  "Northport Medical Center - Northport - AL",
  "Northport VA Medical Center - Northport - NY",
  "Northridge Hospital Medical Center - Northridge - CA",
  "Northshore Rehabiliation Hospital - Lacombe - LA",
  "Northside Hospital Atlanta - Atlanta - GA",
  "Northside Hospital Cherokee - Canton - GA",
  "Northside Hospital Duluth - Duluth - GA",
  "Northside Hospital Forsyth - Cumming - GA",
  "Northside Hospital Gwinnett - Lawrenceville - GA",
  "Northwest Center for Behavioral Health - Fort Supply - OK",
  "Northwest Community Hospital - Arlington Heights - IL",
  "Northwest Florida Community Hospital - Chipley - FL",
  "Northwest Health - Portage - Portage - IN",
  "Northwest Health - Porter - Valparaiso - IN",
  "Northwest Health - Starke - Knox - IN",
  "Northwest Health La Porte - La Porte - IN",
  "Northwest Health Physicians' Specialty Hospital - Fayetteville - AR",
  "Northwest Hills Surgical Hospital - Austin - TX",
  "Northwest Hospital - Randallstown - MD",
  "Northwest Medical Center - Tucson - AZ",
  "Northwest Medical Center - Bentonville - Bentonville - AR",
  "Northwest Medical Center - Springdale - Springdale - AR",
  "Northwest Medical Center Sahuarita - Sahuarita - AZ",
  "Northwest Missouri Psychiatric Rehabilitation Center - Saint Joseph - MO",
  "Northwest Ohio Psychiatric Hospital - Toledo - OH",
  "Northwest Regional - Clarksdale - MS",
  "Northwest Regional Health - Winfield - AL",
  "Northwest Specialty Hospital - Post Falls - ID",
  "Northwest Surgery Hospital - Oklahoma City - OK",
  "Northwest Surgical Hospital - Amarillo - TX",
  "Northwest Texas Healthcare System - Amarillo - TX",
  "Northwestern Medical Center - Saint Albans - VT",
  "Northwestern Medicine Central DuPage Hospital - Winfield - IL",
  "Northwestern Medicine Delnor Hospital - Geneva - IL",
  "Northwestern Medicine Huntley Hospital - Huntley - IL",
  "Northwestern Medicine Lake Forest Hospital - Lake Forest - IL",
  "Northwestern Medicine McHenry Hospital - McHenry - IL",
  "Northwestern Medicine Palos Hospital - Palos Heights - IL",
  "Northwestern Medicine Prentice Women's Hospital - Chicago - IL",
  "Northwestern Medicine Valley West Hospital - Sandwich - IL",
  "Northwestern Medicine Woodstock Hospital - Woodstock - IL",
  "Northwestern Memorial Hospital - Chicago - IL",
  "Northwood Deaconess Health Center - Northwood - ND",
  "Norton Audubon Hospital - Louisville - KY",
  "Norton Brownsboro Hospital - Louisville - KY",
  "Norton Children's Hospital - Louisville - KY",
  "Norton Clark Hospital - Jeffersonville - IN",
  "Norton Community Hospital - Norton - VA",
  "Norton County Hospital - Norton - KS",
  "Norton Hospital - Louisville - KY",
  "Norton King's Daughters' Hospital - Madison - IN",
  "Norton Scott Hospital - Scottsburg - IN",
  "Norton Sound Regional Hospital - Nome - AK",
  "Norton Women's & Children's Hospital - Louisville - KY",
  "Norwalk Community Hospital - Norwalk - CA",
  "Norwalk Hospital - Norwalk - CT",
  "Norwood Health Center - Marshfield - WI",
  "Novant Health Betty H. Cameron Women's and Children's Hospital - Wilmington - NC",
  "Novant Health Brunswick Medical Center - Bolivia - NC",
  "Novant Health Charlotte Orthopaedic Hospital - Charlotte - NC",
  "Novant Health Hemby Children's Hospital - Charlotte - NC",
  "Novant Health Huntersville Medical Center - Huntersville - NC",
  "Novant Health Kernersville Medical Center - Kernersville - NC",
  "Novant Health Matthews Medical Center - Matthews - NC",
  "Novant Health Medical Park Hospital - Winston-Salem - NC",
  "Novant Health Mint Hill Medical Center - Mint Hill - NC",
  "Novant Health New Hanover Behavioral Health Hospital - Wilmington - NC",
  "Novant Health New Hanover Orthopedic Hospital - Wilmington - NC",
  "Novant Health New Hanover Regional Medical Center - Wilmington - NC",
  "Novant Health New Hanover Rehabilitation Hospital - Wilmington - NC",
  "Novant Health Pender Medical Center - Burgaw - NC",
  "Novant Health Presbyterian Medical Center - Charlotte - NC",
  "Novant Health Rehabilitation Hospital - Winston-Salem - NC",
  "Novant Health Rowan Medical Center - Salisbury - NC",
  "Novant Health Thomasville Medical Center - Thomasville - NC",
  "Novato Community Hospital - Novato - CA",
  "Noxubee General Hospital - Macon - MS",
  "NW Indiana 24/7 ER & Hospital - Hammond - IN",
  "NYC Health + Hospitals Bellevue - New York - NY",
  "NYC Health + Hospitals Carter - New York - NY",
  "NYC Health + Hospitals Elmhurst - Elmhurst - NY",
  "NYC Health + Hospitals Harlem - New York - NY",
  "NYC Health + Hospitals Jacobi - Bronx - NY",
  "NYC Health + Hospitals Kings County - Brooklyn - NY",
  "NYC Health + Hospitals Lincoln - Bronx - NY",
  "NYC Health + Hospitals Metropolitan - New York - NY",
  "NYC Health + Hospitals North Central Bronx - Bronx - NY",
  "NYC Health + Hospitals Queens - Jamaica - NY",
  "NYC Health + Hospitals South Brooklyn Health - Brooklyn - NY",
  "NYC Health + Hospitals Woodhull - Brooklyn - NY",
  "NYC Heath + Hospitals Coler - New York - NY",
  "NYU Langone Hospital - Brooklyn - Brooklyn - NY",
  "NYU Langone Hospital - Long Island - Mineola - NY",
  "NYU Langone Orthopedic Hospital - New York - NY",
  "O'Connor Hospital - Delhi - NY",
  "O'Connor Hospital - San Jose - CA",
  "Oak Valley Hospital District - Oakdale - CA",
  "OakBend Medical Center - Richmond - TX",
  "Oakdale Community Hospital - Oakdale - LA",
  "Oakland Medical Center - Oakland - CA",
  "Oaklawn - Goshen - IN",
  "Oaklawn Hospital - Marshall - MI",
  "Oakleaf Surgical Hospital - Altoona - WI",
  "Oakwood Springs - Oklahoma City - OK",
  "Oasis Behavioral Health Hospital - Chandler - AZ",
  "OASIS Hospital - Phoenix - AZ",
  "Ocean Beach Hospital - Ilwaco - WA",
  "Ocean Springs Hospital - Ocean Springs - MS",
  "Ocean University Medical Center - Brick - NJ",
  "Ocean View Adult Psychiatric Hospital - Long Beach - CA",
  "Oceans Behavioral Hospital Abilene - Abilene - TX",
  "Oceans Behavioral Hospital Alexandria - Alexandria - LA",
  "Oceans Behavioral Hospital Amarillo - Amarillo - TX",
  "Oceans Behavioral Hospital Baton Rouge - Baton Rouge - LA",
  "Oceans Behavioral Hospital Biloxi - Biloxi - MS",
  "Oceans Behavioral Hospital Broussard - Broussard - LA",
  "Oceans Behavioral Hospital Corpus Christi - Corpus Christi - TX",
  "Oceans Behavioral Hospital DeRidder - DeRidder - LA",
  "Oceans Behavioral Hospital Greater New Orleans - Kenner - Kenner - LA",
  "Oceans Behavioral Hospital Greater New Orleans - Marrero - Marrero - LA",
  "Oceans Behavioral Hospital Katy - Katy - TX",
  "Oceans Behavioral Hospital Kentwood - Kentwood - LA",
  "Oceans Behavioral Hospital Lake Charles - Lake Charles - LA",
  "Oceans Behavioral Hospital Longview - Longview - TX",
  "Oceans Behavioral Hospital Lubbock - Lubbock - TX",
  "Oceans Behavioral Hospital Lufkin - Lufkin - TX",
  "Oceans Behavioral Hospital of Pasadena - Pasadena - TX",
  "Oceans Behavioral Hospital Opelousas - Opelousas - LA",
  "Oceans Behavioral Hospital Permian Basin - Midland - TX",
  "Oceans Behavioral Hospital Waco - Waco - TX",
  "Oceans Behavioral Hospital Westbank - Gretna - LA",
  "OCH Regional Medical Center - Starkville - MS",
  "Ochiltree General Hospital - Perryton - TX",
  "Ochsner Abrom Kaplan Memorial Hospital - Kaplan - LA",
  "Ochsner Acadia General Hospital - Crowley - LA",
  "Ochsner American Legion Hospital - Jennings - LA",
  "Ochsner Baptist - A Campus of Ochsner Medical Center - New Orleans - LA",
  "Ochsner Choctaw General - Butler - AL",
  "Ochsner Extended Care Hospital of Kenner - Kenner - LA",
  "Ochsner Hospital for Orthopedics and Sports Medicine - Jefferson - LA",
  "Ochsner Lafayette General Medical Center - Lafayette - LA",
  "Ochsner Lafayette General Orthopedic Hospital - Lafayette - LA",
  "Ochsner Lafayette General Surgical Hospital - Lafayette - LA",
  "Ochsner Laird Hospital - Union - MS",
  "Ochsner LSU Health - Monroe Medical Center - Monroe - LA",
  "Ochsner LSU Health - St. Mary Medical Center - Shreveport - LA",
  "Ochsner LSU Health Shreveport - Academic Medical Center - Shreveport - LA",
  "Ochsner Medical Center - New Orleans - LA",
  "Ochsner Medical Center - Baton Rouge - Baton Rouge - LA",
  "Ochsner Medical Center - Hancock - Bay Saint Louis - MS",
  "Ochsner Medical Center - Kenner - Kenner - LA",
  "Ochsner Medical Center - West Bank - Gretna - LA",
  "Ochsner Rehabilitation Hospital - Jefferson - LA",
  "Ochsner Rush Medical Center - Meridian - MS",
  "Ochsner Scott Regional - Morton - MS",
  "Ochsner Specialty Hospital - Meridian - MS",
  "Ochsner St. Anne Hospital - Raceland - LA",
  "Ochsner St. Martin Hospital - Breaux Bridge - LA",
  "Ochsner St. Mary - Morgan City - LA",
  "Ochsner Stennis Hospital - DeKalb - MS",
  "Ochsner University Hospital and Clinics - Lafayette - LA",
  "Ochsner Watkins Hospital - Quitman - MS",
  "Oconomowoc Main Campus - Oconomowoc - WI",
  "Odessa Memorial Healthcare Center - Odessa - WA",
  "Odessa Regional Medical Center - Odessa - TX",
  "Ogallala Community Hospital - Ogallala - NE",
  "Ogden Regional Medical Center - Ogden - UT",
  "Ohio County Hospital - Hartford - KY",
  "Ohio Hospital for Psychiatry - Columbus - OH",
  "Ohio State East Hospital - Columbus - OH",
  "Ohio State Harding Hospital - Columbus - OH",
  "Ohio State Richard M. Ross Heart Hospital - Columbus - OH",
  "Ohio State University Comprehensive Cancer Center - Arthur G. James Cancer Hospital - Columbus - OH",
  "Ohio State University Wexner Medical Center - Columbus - OH",
  "Ohio Valley Surgical Hospital - Springfield - OH",
  "OhioHealth Berger Hospital - Circleville - OH",
  "OhioHealth Doctors Hospital - Columbus - OH",
  "OhioHealth Dublin Methodist Hospital - Dublin - OH",
  "OhioHealth Grady Memorial Hospital - Delaware - OH",
  "OhioHealth Grant Medical Center - Columbus - OH",
  "OhioHealth Hardin Memorial Hospital - Kenton - OH",
  "OhioHealth Mansfield Hospital - Mansfield - OH",
  "OhioHealth Marion General Hospital - Marion - OH",
  "OhioHealth O'Bleness Hospital - Athens - OH",
  "OhioHealth Pickerington Medical Campus - Pickerington - OH",
  "OhioHealth Rehabilitation Hospital - Columbus - OH",
  "OhioHealth Rehabilitation Hospital Dublin - Dublin - OH",
  "OhioHealth Riverside Methodist Hospital - Columbus - OH",
  "OhioHealth Shelby Hospital - Shelby - OH",
  "OhioHealth Van Wert Hospital - Van Wert - OH",
  "OHSU Health Hillsboro Medical Center - Hillsboro - OR",
  "Okeene Municipal Hospital - Okeene - OK",
  "Okemah Community Hospital - Okemah - OK",
  "Oklahoma Children's Hospital - Oklahoma City - OK",
  "Oklahoma City Rehabilitation Hospital - Oklahoma City - OK",
  "Oklahoma City VA Medical Center - Oklahoma City - OK",
  "Oklahoma ER & Hospital - Edmond - OK",
  "Oklahoma Forensic Center - Vinita - OK",
  "Oklahoma Heart Hospital North - Oklahoma City - OK",
  "Oklahoma Heart Hospital South - Oklahoma City - OK",
  "Oklahoma Heart Institute at Hillcrest Medical Center - Tulsa - OK",
  "Oklahoma Spine Hospital - Oklahoma City - OK",
  "Oklahoma State University Medical Center - Tulsa - OK",
  "Oklahoma Surgical Hospital - Tulsa - OK",
  "Okmulgee Medical Center - Okmulgee - OK",
  "Olathe Medical Center - Olathe - KS",
  "Old Bridge Medical Center - Old Bridge - NJ",
  "Old Vineyard Behavioral Health Services - Winston-Salem - NC",
  "Olean General Hospital - Olean - NY",
  "Olive View-UCLA Medical Center - Sylmar - CA",
  "Olivia Hospital & Clinic - Olivia - MN",
  "Olmsted Medical Center - Rochester - MN",
  "Olney Hamilton Hospital - Olney - TX",
  "Olympic Memorial Hospital - Port Angeles - WA",
  "Omaha VA Medical Center - Omaha - NE",
  "Omega Hospital - Metairie - LA",
  "OneCore Health Orthopedics - Oklahoma City - OK",
  "Oneida Health - Oneida - NY",
  "Onslow Memorial Hospital - Jacksonville - NC",
  "Ontario Medical Center - Ontario - CA",
  "Opelousas General Main Campus - Opelousas - LA",
  "Opelousas General South Campus - Opelousas - LA",
  "Optim Medical Center - Screven - Sylvania - GA",
  "Optim Medical Center Tattnall - Reidsville - GA",
  "Options Behavioral Health System - Indianapolis - IN",
  "Orange City Hospital - Orange City - IA",
  "Orange Coast Memorial Medical Center - Fountain Valley - CA",
  "Orange County Global Medical Center - Santa Ana - CA",
  "Orange County-Irvine Medical Center - Irvine - CA",
  "Orchard Hospital - Gridley - CA",
  "Oregon Health & Science University Hospital - Portland - OR",
  "Oregon State Hospital - Junction City - Junction City - OR",
  "Oregon State Hospital - Salem - Salem - OR",
  "Orem Community Hospital - Orem - UT",
  "Orlando Health - Health Central Hospital - Ocoee - FL",
  "Orlando Health Arnold Palmer Hospital for Children - Orlando - FL",
  "Orlando Health Cancer Institute Downtown - Orlando - FL",
  "Orlando Health Dr. P. Phillips Hospital - Orlando - FL",
  "Orlando Health Horizon West Hospital - Winter Garden - FL",
  "Orlando Health Orlando Regional Medical Center - Orlando - FL",
  "Orlando Health South Lake Hospital - Clermont - FL",
  "Orlando Health South Seminole Hospital - Longwood - FL",
  "Orlando Health St. Cloud Hospital - Saint Cloud - FL",
  "Orlando Health Winnie Palmer Hospital for Women & Babies - Orlando - FL",
  "Orlando VA Medical Center - Orlando - FL",
  "Orleans Community Health Medina Memorial Hospital - Medina - NY",
  "Oro Valley Hospital - Tucson - AZ",
  "Oroville Hospital - Oroville - CA",
  "OrthoColorado Hospital - Lakewood - CO",
  "OrthoIndy Northwest Hospital - Indianapolis - IN",
  "OrthoNebraska - Omaha - NE",
  "Orthopaedic Hospital of Wisconsin - Glendale - WI",
  "Ortonville Area Health Services - Ortonville - MN",
  "Osawatomie State Hospital - Osawatomie - KS",
  "Osborne County Memorial Hospital - Osborne - KS",
  "Oscar G. Johnson VA Medical Center - Iron Mountain - MI",
  "Osceola Medical Center - Osceola - WI",
  "Osceola Regional Health Center - Sibley - IA",
  "OSF Children's Hospital of Illinois - Peoria - IL",
  "OSF HealthCare Transitional Care Hospital - Peoria - IL",
  "OSF Heart of Mary Medical Center - Urbana - IL",
  "OSF Holy Family Medical Center - Monmouth - IL",
  "OSF Little Company of Mary Medical Center - Evergreen Park - IL",
  "OSF Sacred Heart Medical Center - Danville - IL",
  "OSF Saint Anthony Medical Center - Rockford - IL",
  "OSF Saint Anthony's Health Center - Alton - IL",
  "OSF Saint Clare Medical Center - Princeton - IL",
  "OSF Saint Elizabeth Medical Center - Ottawa - IL",
  "OSF Saint Francis Hospital - Escanaba - MI",
  "OSF Saint Francis Medical Center - Peoria - IL",
  "OSF Saint James-John W. Albrecht Medical Center - Pontiac - IL",
  "OSF Saint Joseph Medical Center - Bloomington - IL",
  "OSF Saint Luke Medical Center - Kewanee - IL",
  "OSF Saint Mary Medical Center - Galesburg - IL",
  "OSF Saint Paul Medical Center - Mendota - IL",
  "Osmond General Hospital - Osmond - NE",
  "OSS Health Orthopaedic Hospital - York - PA",
  "Oswego Hospital - Oswego - NY",
  "Othello Community Hospital - Othello - WA",
  "Otsego Memorial Hospital - Gaylord - MI",
  "Ottawa County Health Center - Minneapolis - KS",
  "Otto Kaiser Memorial Hospital - Kenedy - TX",
  "Ottumwa Regional Health Center - Ottumwa - IA",
  "OU Health University of Oklahoma Medical Center - Oklahoma City - OK",
  "OU Health-Edmond Medical Center - Edmond - OK",
  "Ouachita County Medical Center - Camden - AR",
  "Our Lady of Fatima Hospital - North Providence - RI",
  "Our Lady of Lourdes Heart Hospital - Lafayette - LA",
  "Our Lady of Lourdes Regional Medical Center - Lafayette - LA",
  "Our Lady of Lourdes Women's and Children's Hospital - Lafayette - LA",
  "Our Lady of the Angels Hospital - Bogalusa - LA",
  "Our Lady of the Lake Ascension - Gonzales - LA",
  "Our Lady of the Lake Children's Hospital - Baton Rouge - LA",
  "Our Lady of the Lake Regional Medical Center - Baton Rouge - LA",
  "Overlake Medical Center - Bellevue - WA",
  "Overland Park Regional Medical Center - Overland Park - KS",
  "Overlook Medical Center - Summit - NJ",
  "Overton Brooks VA Medical Center - Shreveport - LA",
  "Oviedo Medical Center - Oviedo - FL",
  "Owatonna Hospital - Owatonna - MN",
  "Owensboro Health Muhlenberg Community Hospital - Greenville - KY",
  "Owensboro Health Regional Hospital - Owensboro - KY",
  "Ozark Health Medical Center - Clinton - AR",
  "Ozarks Community Hospital of Gravette - Gravette - AR",
  "Ozarks Medical Center - West Plains - MO",
  "Pacific Grove Hospital - Riverside - CA",
  "Pacifica Hospital of the Valley - Sun Valley - CA",
  "Page Hospital - Page - AZ",
  "Page Memorial Hospital - Luray - VA",
  "Pagosa Springs Medical Center - Pagosa Springs - CO",
  "Paintsville ARH Hospital - Paintsville - KY",
  "Palacios Community Medical Center - Palacios - TX",
  "Palestine Regional Medical Center - Palestine - TX",
  "Palestine Regional West Campus - Palestine - TX",
  "Pali Momi Medical Center - Aiea - HI",
  "Palm Bay Hospital - Palm Bay - FL",
  "Palm Beach Children's Hospital - West Palm Beach - FL",
  "Palm Beach Gardens Medical Center - Palm Beach Gardens - FL",
  "Palm Point Behavioral Health - Titusville - FL",
  "Palm Shores Behavioral Health Center - Bradenton - FL",
  "Palmdale Regional Medical Center - Palmdale - CA",
  "Palmetto General Hospital - Hialeah - FL",
  "Palmetto Lowcountry Behavioral Hospital - Charleston - SC",
  "Palmetto Summerville Behavioral Health - Summerville - SC",
  "Palms Behavioral Health - Harlingen - TX",
  "Palo Alto County Health System - Emmetsburg - IA",
  "Palo Alto VA Medical Center - Palo Alto - CA",
  "Palo Pinto General Hospital - Mineral Wells - TX",
  "Palo Verde Behavioral Health - Tucson - AZ",
  "Palo Verde Hospital - Blythe - CA",
  "Palomar Health Rehabilitation Institute - Escondido - CA",
  "Palomar Medical Center Escondido - Escondido - CA",
  "Palomar Medical Center Poway - Poway - CA",
  "PAM Health Rehabilitation Hospital of Allen - Allen - TX",
  "PAM Health Rehabilitation Hospital of Beaumont - Beaumont - TX",
  "PAM Health Rehabilitation Hospital of Centennial Hills - Las Vegas - NV",
  "PAM Health Rehabilitation Hospital of Clear Lake - Webster - TX",
  "PAM Health Rehabilitation Hospital of Dover - Dover - DE",
  "PAM Health Rehabilitation Hospital of El Paso - El Paso - TX",
  "PAM Health Rehabilitation Hospital of Fargo - Fargo - ND",
  "PAM Health Rehabilitation Hospital of Georgetown - Georgetown - DE",
  "PAM Health Rehabilitation Hospital of Greater Indiana - Clarksville - IN",
  "PAM Health Rehabilitation Hospital of Houston Heights - Houston - TX",
  "PAM Health Rehabilitation Hospital of Kyle - Kyle - TX",
  "PAM Health Rehabilitation Hospital of Round Rock - Round Rock - TX",
  "PAM Health Rehabilitation Hospital of Surprise - Surprise - AZ",
  "PAM Health Rehabilitation Hospital of Tavares - Tavares - FL",
  "PAM Health Rehabilitation Hospital of Westminster - Westminster - CO",
  "PAM Health Specialty and Rehabilitation Hospital of New Braunfels - New Braunfels - TX",
  "PAM Health Specialty and Rehabilitation Hospital of New Orleans - New Orleans - LA",
  "PAM Health Specialty Hospital Heritage Valley - Beaver - PA",
  "PAM Health Specialty Hospital Jacksonville - Jacksonville - FL",
  "PAM Health Specialty Hospital of Corpus Christi Bayfront - Corpus Christi - TX",
  "PAM Health Specialty Hospital of Corpus Christi North - Corpus Christi - TX",
  "PAM Health Specialty Hospital of Covington - Covington - LA",
  "PAM Health Specialty Hospital of Dayton - Miamisburg - OH",
  "PAM Health Specialty Hospital of Denver - Denver - CO",
  "PAM Health Specialty Hospital of Hammond - Hammond - LA",
  "PAM Health Specialty Hospital of Las Vegas - Las Vegas - NV",
  "PAM Health Specialty Hospital of Luling - Luling - TX",
  "PAM Health Specialty Hospital of Oklahoma City - Oklahoma City - OK",
  "PAM Health Specialty Hospital of Pittsburgh - Oakdale - PA",
  "PAM Health Specialty Hospital of Rocky Mount - Rocky Mount - NC",
  "PAM Health Specialty Hospital of San Antonio - San Antonio - TX",
  "PAM Health Specialty Hospital of San Antonio Medical Center - San Antonio - TX",
  "PAM Health Specialty Hospital of Sarasota - Sarasota - FL",
  "PAM Health Specialty Hospital of Shreveport - Shreveport - LA",
  "PAM Health Specialty Hospital of Stoughton - Stoughton - MA",
  "PAM Health Specialty Hospital of Texarkana - Texarkana - TX",
  "PAM Health Specialty Hospital of Tulsa - Tulsa - OK",
  "PAM Health Specialty Hospital of Victoria North - Victoria - TX",
  "PAM Health Specialty Hospital of Victoria South - Victoria - TX",
  "PAM Health Specialty Hospital of Wilkes-Barre - Wilkes Barre - PA",
  "PAM Health Warm Springs Rehabilitation Hospital Northeast San Antonio - San Antonio - TX",
  "PAM Health Warm Springs Rehabilitation Hospital of San Antonio - San Antonio - TX",
  "PAM Health Warm Springs Rehabilitation Hospital of Westover Hills - San Antonio - TX",
  "PAM Rehabilitation Hospital of Tulsa - Tulsa - OK",
  "PAM Rehabilitation Hospital of Victoria - Victoria - TX",
  "Pampa Regional Medical Center - Pampa - TX",
  "Pana Community Hospital - Pana - IL",
  "Panamericano - Cidra - PR",
  "Panhandle Surgical Hospital - Amarillo - TX",
  "Panola Medical Center - Batesville - MS",
  "Panola Medical Center Crossroads Behavioral Health - Batesville - MS",
  "Panorama City Medical Center - Panorama City - CA",
  "Paoli Hospital - Paoli - PA",
  "Paradise Valley Hospital - National City - CA",
  "Parham Doctors' Hospital - Richmond - VA",
  "Paris Community Hospital - Paris - IL",
  "Paris Regional Health - Paris - TX",
  "Park City Hospital - Park City - UT",
  "Park Place Surgical Hospital - Lafayette - LA",
  "Park Royal Hospital - Fort Myers - FL",
  "Parker Indian Health Center - Parker - AZ",
  "Parkland Health Center Bonne Terre - Bonne Terre - MO",
  "Parkland Health Center Farmington - Farmington - MO",
  "Parkland Hospital - Dallas - TX",
  "Parkland Medical Center - Derry - NH",
  "Parkridge East Hospital - Chattanooga - TN",
  "Parkridge Medical Center - Chattanooga - TN",
  "Parkridge Valley Child & Adolescent Campus - Chattanooga - TN",
  "Parkside Psychiatric Hospital and Clinic - Tulsa - OK",
  "Parkview Behavioral Health Institute - Park Center - Fort Wayne - IN",
  "Parkview Bryan Hospital - Bryan - OH",
  "Parkview Community Hospital Medical Center - Riverside - CA",
  "Parkview DeKalb Hospital - Auburn - IN",
  "Parkview Hospital - Wheeler - TX",
  "Parkview Hospital Randallia - Fort Wayne - IN",
  "Parkview Huntington Hospital - Huntington - IN",
  "Parkview LaGrange Hospital - LaGrange - IN",
  "Parkview Medical Center - Pueblo - CO",
  "Parkview Montpelier Hospital - Montpelier - OH",
  "Parkview Noble Hospital - Kendallville - IN",
  "Parkview Ortho Hospital - Fort Wayne - IN",
  "Parkview Regional Hospital - Mexia - TX",
  "Parkview Regional Medical Center - Fort Wayne - IN",
  "Parkview Wabash Hospital - Wabash - IN",
  "Parkview Whitley Hospital - Columbia City - IN",
  "Parkwest Medical Center - Knoxville - TN",
  "Parkwood Behavioral Health System - Olive Branch - MS",
  "Parmer Medical Center - Friona - TX",
  "Parrish Medical Center - Titusville - FL",
  "Pascagoula Hospital - Pascagoula - MS",
  "Pathway Rehabilitation Hospital - Bossier City - LA",
  "Pathways Behavioral Health Services - Jackson - TN",
  "Patients Emergency Room & Hospital - Baytown - TX",
  "Patients Hospital of Redding - Redding - CA",
  "Patricia Neal Rehabilitation Hospital - Knoxville - TN",
  "Patrick B. Harris Psychiatric Hospital - Anderson - SC",
  "Patterson Health Center - Anthony - KS",
  "Paul Oliver Memorial Hospital - Frankfort - MI",
  "Paulding County Hospital - Paulding - OH",
  "Pavia Yauco Hospital - Yauco - PR",
  "Pavilion for Women and Children Providence Regional Medical Center - Everett - WA",
  "Pawhuska Hospital - Pawhuska - OK",
  "Pawnee County Memorial Hospital - Pawnee City - NE",
  "Pawnee Valley Community Hospital - Larned - KS",
  "Peace Harbor Medical Center - Florence - OR",
  "Peace Haven Association - Saint Louis - MO",
  "PeaceHealth Cottage Grove Community Medical Center - Cottage Grove - OR",
  "PeaceHealth Ketchikan Medical Center - Ketchikan - AK",
  "PeaceHealth Peace Island Medical Center - Friday Harbor - WA",
  "PeaceHealth Sacred Heart Medical Center at RiverBend - Springfield - OR",
  "PeaceHealth Saint John Medical Center - Longview - WA",
  "PeaceHealth Saint Joseph Medical Center - Bellingham - WA",
  "PeaceHealth Southwest Medical Center - Vancouver - WA",
  "PeaceHealth United General Medical Center - Sedro-Woolley - WA",
  "Peachford Hospital - Atlanta - GA",
  "Peak Behavioral Health Services - Santa Teresa - NM",
  "Peak View Behavioral Health - Colorado Springs - CO",
  "Pearl River County Hospital - Poplarville - MS",
  "Peconic Bay Medical Center - Riverhead - NY",
  "Pecos County Memorial Hospital - Fort Stockton - TX",
  "Pelham Medical Center - Greer - SC",
  "Pella Regional Health Center - Pella - IA",
  "Pembina County Memorial Hospital - Cavalier - ND",
  "Pembroke Hospital - Pembroke - MA",
  "Pemiscot Memorial Main Hospital - Hayti - MO",
  "Pen Bay Medical Center - Rockport - ME",
  "Pender Community Hospital - Pender - NE",
  "Peninsula Hospital - Louisville - TN",
  "Penn State Health Children's Hospital - Hershey - PA",
  "Penn Highlands Brookville - Brookville - PA",
  "Penn Highlands Clearfield - Clearfield - PA",
  "Penn Highlands Connellsville - Connellsville - PA",
  "Penn Highlands DuBois - DuBois - PA",
  "Penn Highlands Elk - Saint Marys - PA",
  "Penn Highlands Huntingdon - Huntingdon - PA",
  "Penn Highlands Mon Valley - Monongahela - PA",
  "Penn Highlands Tyrone - Tyrone - PA",
  "Penn Medicine Rehabilitation - Philadelphia - PA",
  "Penn Presbyterian Medical Center - Philadelphia - PA",
  "Penn State Health Hampden Medical Center - Enola - PA",
  "Penn State Health Holy Spirit Medical Center - Camp Hill - PA",
  "Penn State Health Lancaster Medical Center - Lancaster - PA",
  "Penn State Health St. Joseph Medical Center - Reading - PA",
  "Penn State Hershey Rehabilitation Hospital - Hummelstown - PA",
  "Pennsylvania Hospital - Philadelphia - PA",
  "Pennsylvania Psychiatric Institute - Harrisburg - PA",
  "Penobscot Valley Hospital - Lincoln - ME",
  "Perham Health - Perham - MN",
  "Perimeter Behavioral Hospital of Arlington - Arlington - TX",
  "Perimeter Behavioral Hospital of Dallas - Garland - TX",
  "Perimeter Behavioral Hospital of Jackson - Jackson - TN",
  "Perimeter Behavioral Hospital of New Orleans - Kenner - LA",
  "Perimeter Behavioral Hospital of Springfield - Springfield - MO",
  "Perimeter Behavioral of West Memphis - West Memphis - AR",
  "Perkins County Health Services - Grant - NE",
  "Permian Regional Medical Center - Andrews - TX",
  "Perry County General Hospital - Richton - MS",
  "Perry County Memorial Hospital - Tell City - IN",
  "Perry Point VA Medical Center - Perry Point - MD",
  "Pershing General Hospital - Lovelock - NV",
  "Pershing Memorial Hospital - Brookfield - MO",
  "Person Memorial Hospital - Roxboro - NC",
  "Petaluma Valley Hospital - Petaluma - CA",
  "Petersburg Medical Center - Petersburg - AK",
  "Peterson Healthcare and Rehabilitation Hospital - Wheeling - WV",
  "Peterson Regional Medical Center - Kerrville - TX",
  "Peyton Manning Children's Hospital at Ascension St. Vincent in Indianapolis - Indianapolis - IN",
  "Phelps Health Hospital - Rolla - MO",
  "Phelps Hospital - Sleepy Hollow - NY",
  "Phelps Memorial Health Center - Holdrege - NE",
  "Phillips County Hospital - Malta - MT",
  "Phillips County Hospital - Phillipsburg - KS",
  "Phillips Eye Institute - Minneapolis - MN",
  "Phoebe North Campus - Albany - GA",
  "Phoebe Putney Memorial Hospital - Albany - GA",
  "Phoebe Sumter Medical Center - Americus - GA",
  "Phoebe Worth Medical Center - Sylvester - GA",
  "Phoenix Children's Hospital - Phoenix - AZ",
  "Phoenix ER & Medical Hospital - Chandler - AZ",
  "Phoenix Indian Medical Center - Phoenix - AZ",
  "Phoenix Medical Psychiatric Hospital - Phoenix - AZ",
  "Phoenixville Hospital - Phoenixville - PA",
  "Physicians Behavioral Hospital - Shreveport - LA",
  "Physicians Care Surgical Hospital - Royersford - PA",
  "Physicians Medical Center of Houma - Houma - LA",
  "Physicians Regional - Collier Boulevard - Naples - FL",
  "Physicians Regional Medical Center - Pine Ridge - Naples - FL",
  "Piedmont Athens Regional Medical Center - Athens - GA",
  "Piedmont Atlanta Hospital - Atlanta - GA",
  "Piedmont Augusta Hospital - Augusta - GA",
  "Piedmont Augusta Summerville Campus - Augusta - GA",
  "Piedmont Cartersville Medical Center - Cartersville - GA",
  "Piedmont Columbus Regional - Midtown Campus - Columbus - GA",
  "Piedmont Columbus Regional - Northside - Columbus - GA",
  "Piedmont Eastside Medical Center - Snellville - GA",
  "Piedmont Fayette Hospital - Fayetteville - GA",
  "Piedmont Henry Hospital - Stockbridge - GA",
  "Piedmont Macon Medical Center - Macon - GA",
  "Piedmont Macon North Hospital - Macon - GA",
  "Piedmont McDuffie - Thomson - GA",
  "Piedmont Medical Center - Rock Hill - SC",
  "Piedmont Medical Center - Fort Mill - Fort Mill - SC",
  "Piedmont Mountainside Hospital - Jasper - GA",
  "Piedmont Newnan Hospital - Newnan - GA",
  "Piedmont Newton Hospital - Covington - GA",
  "Piedmont Rockdale Hospital - Conyers - GA",
  "Piedmont Walton - Monroe - GA",
  "Piggott Community Hospital - Piggott - AR",
  "PIH Health Downey Hospital - Downey - CA",
  "PIH Health Good Samaritan Hospital - Los Angeles - CA",
  "PIH Health Whittier Hospital - Whittier - CA",
  "Pike County Memorial Hospital - Louisiana - MO",
  "Pikeville Medical Center - Pikeville - KY",
  "Pilgrim Psychiatric Center - West Brentwood - NY",
  "Pinckneyville Community Hospital - Pinckneyville - IL",
  "Pine Rest Christian Mental Health Services - Grand Rapids - MI",
  "Pine Ridge Hospital - Pine Ridge - SD",
  "Pinecrest Rehabilitation Hospital - Delray Beach - FL",
  "Pineville Community Health Center - Pineville - KY",
  "Pinewood Springs - Columbia - TN",
  "Pinnacle Hospital - Crown Point - IN",
  "Pinnacle Pointe Hospital - Little Rock - AR",
  "Pioneer Medical Center - Big Timber - MT",
  "Pioneer Memorial Hospital - Heppner - OR",
  "Pioneer Memorial Hospital & Health Services - Viborg - SD",
  "Pioneer Specialty Hospital - Garden City - Garden City - MI",
  "Pioneer Specialty Hospital - Pontiac - Pontiac - MI",
  "Pioneers Medical Center - Meeker - CO",
  "Pioneers Memorial Hospital - Brawley - CA",
  "Pipestone County Medical Center - Pipestone - MN",
  "Pittsburgh VA Medical Center-University Drive - Pittsburgh - PA",
  "Placentia-Linda Hospital - Placentia - CA",
  "Plains Memorial Hospital - Dimmitt - TX",
  "Plains Regional Medical Center - Clovis - NM",
  "Plainview Hospital - Plainview - NY",
  "Platte County Memorial Hospital - Wheatland - WY",
  "Platte Health Center Avera - Platte - SD",
  "Platte Valley Medical Center - Brighton - CO",
  "Plumas District Hospital - Quincy - CA",
  "Plymouth Medical Center - Plymouth - IN",
  "PMC Regional Hospital - New Albany - IN",
  "Pocahontas Community Hospital - Pocahontas - IA",
  "Pocahontas Memorial Hospital - Buckeye - WV",
  "Pocasset Mental Health Center - Pocasset - MA",
  "Pocono Mountain Recovery Center - Henryville - PA",
  "Pointe Coupee General Hospital - New Roads - LA",
  "Polara Health Crisis Stabilization Unit - Prescott Valley - AZ",
  "Pomerene Hospital - Millersburg - OH",
  "Pomona Valley Hospital Medical Center - Pomona - CA",
  "Pontiac General Hospital - Pontiac - MI",
  "Poplar Bluff Regional Medical Center - Poplar Bluff - MO",
  "Poplar Bluff Regional Medical Center-Westwood - Poplar Bluff - MO",
  "Poplar Community Hospital - Poplar - MT",
  "Poplar Springs Hospital - Petersburg - VA",
  "Port Saint Lucie Hospital - Port Saint Lucie - FL",
  "Porter Medical Center - Middlebury - VT",
  "Porter Starke Services - Inpatient Care Center - Valparaiso - IN",
  "Porterville Developmental Center - Porterville - CA",
  "Portland VA Medical Center - Portland - OR",
  "Portneuf Medical Center - Pocatello - ID",
  "Portneuf Medical Center Behavioral Health - Pocatello - ID",
  "Portsmouth Regional Hospital - Portsmouth - NH",
  "Potomac Valley Hospital - Keyser - WV",
  "Pottstown Hospital - Pottstown - PA",
  "Powell Valley Healthcare - Powell - WY",
  "Power County Hospital District - American Falls - ID",
  "Prague Regional Memorial Hospital - Prague - OK",
  "Prairie Community Hospital - Terry - MT",
  "Prairie Lakes Hospital - Watertown - SD",
  "Prairie Ridge Health - Columbus - WI",
  "Prairie Saint John's Hospital - Fargo - ND",
  "Prairie View - Newton - KS",
  "PrairieCare Maplewood - Maple Grove - MN",
  "Prairieville Family Hospital - Prairieville - LA",
  "Pratt Regional Medical Center - Pratt - KS",
  "Prattville Baptist Hospital - Prattville - AL",
  "Premier Specialty Hospital of El Paso - El Paso - TX",
  "Presbyterian Espanola Hospital - Espanola - NM",
  "Presbyterian Hospital - Albuquerque - NM",
  "Presbyterian Kaseman Hospital - Albuquerque - NM",
  "Presbyterian Rust Medical Center - Rio Rancho - NM",
  "Presbyterian Santa Fe Medical Center - Santa Fe - NM",
  "Presbyterian/St. Luke's Medical Center - Denver - CO",
  "Prevost Memorial Hospital - Donaldsonville - LA",
  "Primary Children's Hospital - Salt Lake City - UT",
  "Prince William Medical Center - Manassas - VA",
  "Princeton Baptist Medical Center - Birmingham - AL",
  "Princeton House Behavioral Health - Princeton - NJ",
  "Princeton Medical Center - Plainsboro - NJ",
  "Prisma Health Baptist Easley Hospital - Easley - SC",
  "Prisma Health Baptist Hospital - Columbia - SC",
  "Prisma Health Baptist Parkridge Hospital - Columbia - SC",
  "Prisma Health Children's Hospital - Midlands - Columbia - SC",
  "Prisma Health Greenville Memorial Hospital - Greenville - SC",
  "Prisma Health Greer Memorial Hospital - Greer - SC",
  "Prisma Health Heart Hospital - Columbia - SC",
  "Prisma Health Hillcrest Hospital - Simpsonville - SC",
  "Prisma Health Laurens County Hospital - Clinton - SC",
  "Prisma Health North Greenville Hospital - Travelers Rest - SC",
  "Prisma Health Oconee Memorial Hospital - Seneca - SC",
  "Prisma Health Patewood Hospital - Greenville - SC",
  "Prisma Health Richland Hospital - Columbia - SC",
  "Prisma Health Tuomey Hospital - Sumter - SC",
  "Professional Hospital Guaynabo - Guaynabo - PR",
  "Progress West Hospital - O'Fallon - MO",
  "ProHealth Oconomowoc Memorial Hospital - Oconomowoc - WI",
  "ProHealth Rehabilitation Hospital of Wisconsin - Waukesha - WI",
  "ProHealth Waukesha Memorial Hospital - Waukesha - WI",
  "ProMedica Bay Park Hospital - Oregon - OH",
  "ProMedica Charles and Virginia Hickman Hospital - Adrian Township - MI",
  "ProMedica Coldwater Regional Hospital - Coldwater - MI",
  "ProMedica Defiance Regional Hospital - Defiance - OH",
  "ProMedica Flower Hospital - Sylvania - OH",
  "ProMedica Fostoria Community Hospital - Fostoria - OH",
  "ProMedica Memorial Hospital - Fremont - OH",
  "ProMedica Monroe Regional Hospital - Monroe - MI",
  "ProMedica Russell J. Ebeid Children's Hospital - Toledo - OH",
  "ProMedica Toledo Hospital - Toledo - OH",
  "ProMedica Wildwood Orthopaedic and Spine Hospital - Toledo - OH",
  "Prosser Memorial Health Hospital - Prosser - WA",
  "Providence Alaska Children's Hospital - Anchorage - AK",
  "Providence Alaska Medical Center - Anchorage - AK",
  "Providence Cedars-Sinai Tarzana Medical Center - Tarzana - CA",
  "Providence Centralia Hospital - Centralia - WA",
  "Providence Holy Cross Medical Center - Mission Hills - CA",
  "Providence Hood River Memorial Hospital - Hood River - OR",
  "Providence Kodiak Island Medical Center - Kodiak Island - AK",
  "Providence Little Company of Mary Medical Center San Pedro - San Pedro - CA",
  "Providence Little Company of Mary Medical Center Torrance - Torrance - CA",
  "Providence Medford Medical Center - Medford - OR",
  "Providence Medical Center - Kansas City - KS",
  "Providence Medical Center - Wayne - NE",
  "Providence Milwaukie Hospital - Milwaukie - OR",
  "Providence Mission Hospital Laguna Beach - Laguna Beach - CA",
  "Providence Mission Hospital Mission Viejo - Mission Viejo - CA",
  "Providence Mount Carmel Hospital - Colville - WA",
  "Providence Newberg Medical Center - Newberg - OR",
  "Providence Portland Medical Center - Portland - OR",
  "Providence Queen of the Valley Medical Center - Napa - CA",
  "Providence Redwood Memorial Hospital - Fortuna - CA",
  "Providence Regional Medical Center - Everett - WA",
  "Providence Regional Medical Center Everett - Pacific Campus - Everett - WA",
  "Providence Sacred Heart Medical Center - Spokane - WA",
  "Providence Saint Elias Specialty Hospital - Anchorage - AK",
  "Providence Saint Joseph Hospital Orange - Orange - CA",
  "Providence Saint Joseph Medical Center - Burbank - CA",
  "Providence Saint Joseph's Hospital - Chewelah - WA",
  "Providence Saint Jude Medical Center - Fullerton - CA",
  "Providence Saint Mary Medical Center - Walla Walla - WA",
  "Providence Saint Mary Medical Center - Apple Valley - CA",
  "Providence Saint Patrick Hospital - Missoula - MT",
  "Providence Saint Peter Hospital - Olympia - WA",
  "Providence Saint Vincent Medical Center - Portland - OR",
  "Providence Santa Rosa Memorial Hospital - Santa Rosa - CA",
  "Providence Seaside Hospital - Seaside - OR",
  "Providence Seward Medical Center - Seward - AK",
  "Providence St. Joseph Hospital Eureka - Eureka - CA",
  "Providence St. Joseph Hospital Eureka Inpatient Rehabilitation - Eureka - CA",
  "Providence St. Luke's Rehabilitation Medical Center - Spokane - WA",
  "Providence VA Medical Center - Providence - RI",
  "Providence Valdez Medical Center - Valdez - AK",
  "Providence Willamette Falls Medical Center - Oregon City - OR",
  "Provident Hospital of Cook County - Chicago - IL",
  "Prowers Medical Center - Lamar - CO",
  "Puerto Rico Women and Children's Hospital - Bayamon - PR",
  "Pulaski Memorial Hospital - Winamac - IN",
  "Pullman Regional Hospital - Pullman - WA",
  "Punxsutawney Area Hospital - Punxsutawney - PA",
  "Purcell Municipal Hospital - Purcell - OK",
  "Pushmataha Hospital - Antlers - OK",
  "Putnam County Hospital - Greencastle - IN",
  "Putnam County Memorial Hospital - Unionville - MO",
  "Putnam General Hospital - Eatonton - GA",
  "Putnam Hospital - Carmel - NY",
  "Quail Creek Surgical Hospital - Amarillo - TX",
  "Quail Run Behavioral Health - Phoenix - AZ",
  "Queen's North Hawaii Community Hospital - Kamuela - HI",
  "Quentin N. Burdick Memorial Health Care Facility - Belcourt - ND",
  "Quillen Rehabilitation Hospital - Johnson City - TN",
  "Quincy Valley Medical Center - Quincy - WA",
  "Quitman Community Hospital - Marks - MS",
  "Radiant Health - Marion - IN",
  "Rady Children's Hospital - San Diego - San Diego - CA",
  "Rainier Springs Hospital - Vancouver - WA",
  "Rainy Lake Medical Center - International Falls - MN",
  "Raleigh General Hospital - Beckley - WV",
  "Raleigh Oaks Behavioral Health - Garner - NC",
  "Ralph H. Johnson VA Medical Center - Charleston - SC",
  "Rancho Los Amigos National Rehabilitation Center - Downey - CA",
  "Randall Children's Hospital at Legacy Emanuel - Portland - OR",
  "Randolph Health - Asheboro - NC",
  "Rangely District Hospital - Rangely - CO",
  "Ranken Jordan Pediatric Bridge Hospital - Maryland Heights - MO",
  "Rankin County Hospital District - Rankin - TX",
  "Rapides Regional Medical Center - Alexandria - LA",
  "Rappahannock General Hospital - Kilmarnock - VA",
  "Raritan Bay Medical Center - Perth Amboy - NJ",
  "Rawlins County Health Center - Atwood - KS",
  "Ray County Hospital and Healthcare - Richmond - MO",
  "Raymond G. Murphy VA Medical Center - Albuquerque - NM",
  "Reagan Memorial Hospital - Big Lake - TX",
  "Rebound Behavioral Health Hospital - Lancaster - SC",
  "Reception and Medical Center - Lake Butler - FL",
  "Red Bay Hospital - Red Bay - AL",
  "Red Bud Regional Hospital - Red Bud - IL",
  "Red Lake IHS Hospital - Redlake - MN",
  "Red River Behavioral Center - Bossier City - LA",
  "Red River Hospital - Wichita Falls - TX",
  "Redington-Fairview General Hospital - Skowhegan - ME",
  "Redlands Community Hospital - Redlands - CA",
  "Redwood City Medical Center - Redwood City - CA",
  "Reedsburg Area Medical Center - Reedsburg - WI",
  "Reeves Memorial Medical Center - Bernice - LA",
  "Reeves Regional Health - Pecos - TX",
  "Refugio County Memorial Hospital - Refugio - TX",
  "Regency Florence - Florence - SC",
  "Regency Hospital - Minneapolis - Golden Valley - MN",
  "Regency Hospital Macon - Macon - GA",
  "Regency Hospital Meridian - Meridian - MS",
  "Regency Hospital North Central Ohio - Cleveland West - Middleburg Heights - OH",
  "Regency Hospital Springdale - Springdale - AR",
  "Regency Hospital Toledo - Sylvania - OH",
  "Regency Hospital- Greenville - Greenville - SC",
  "Regency North Central Ohio - Cleveland East - Warrensville Heights - OH",
  "Regency Northwest Indiana - East Chicago - IN",
  "Regency Northwest Indiana - Porter County - Portage - IN",
  "Regional One Medical Center - Memphis - TN",
  "Regional Health Clinic Merrillville - Merrillville - IN",
  "Regional Health Services of Howard County - Cresco - IA",
  "Regional Hospital of Scranton - Scranton - PA",
  "Regional Medical Center - Alamosa - CO",
  "Regional Medical Center - Manchester - IA",
  "Regional Medical Center of Central Alabama - Greenville - AL",
  "Regional Medical Center of San Jose - San Jose - CA",
  "Regional One Rehabilitation Hospital - Memphis - TN",
  "Regional Rehabilitation Hospital - Phenix City - AL",
  "Regional West Garden County Hospital - Oshkosh - NE",
  "Regional West Medical Center - Scottsbluff - NE",
  "Regions Behavioral Hospital - Baton Rouge - LA",
  "Regions Hospital - Saint Paul - MN",
  "Rehabilitation Hospital at Lee Memorial Hospital - Fort Myers - FL",
  "Rehabilitation Hospital of Bowie - Bowie - MD",
  "Rehabilitation Hospital of Indiana - Indianapolis - IN",
  "Rehabilitation Hospital of Jennings - Jennings - LA",
  "Rehabilitation Hospital of Kingsport - Kingsport - TN",
  "Rehabilitation Hospital of Northern Arizona - Flagstaff - AZ",
  "Rehabilitation Hospital of Northern Indiana - Mishawaka - IN",
  "Rehabilitation Hospital of Northwest Ohio - Toledo - OH",
  "Rehabilitation Hospital of Overland Park - Overland Park - KS",
  "Rehabilitation Hospital of Rhode Island - North Smithfield - RI",
  "Rehabilitation Hospital of Southern California - Rancho Mirage - CA",
  "Rehabilitation Hospital of Southern New Mexico - Las Cruces - NM",
  "Rehabilitation Hospital of the Northwest - Post Falls - ID",
  "Rehabilitation Hospital of the Pacific - Honolulu - HI",
  "Rehabilitation Hospital of Western Wisconsin - Eau Claire - WI",
  "Rehoboth McKinley Christian Health Care Services Hospital - Gallup - NM",
  "Reid Hospital - Richmond - IN",
  "Reno Behavioral Healthcare Hospital - Reno - NV",
  "Renown Children's Hospital - Reno - NV",
  "Renown Regional Medical Center - Reno - NV",
  "Renown Rehabilitation Hospital - Reno - NV",
  "Renown South Meadows Medical Center - Reno - NV",
  "Republic County Hospital - Belleville - KS",
  "Research Medical Center - Kansas City - MO",
  "Research Psychiatric Center - Kansas City - MO",
  "Resolute Baptist Hospital - New Braunfels - TX",
  "Reston Hospital Center - Reston - VA",
  "Retreat Doctors Hospital - Richmond - VA",
  "Reunion Rehabilitation Hospital Arlington - Arlington - TX",
  "Reunion Rehabilitation Hospital Denver - Denver - CO",
  "Reunion Rehabilitation Hospital Inverness - Englewood - CO",
  "Reunion Rehabilitation Hospital Peoria - Peoria - AZ",
  "Reunion Rehabilitation Hospital Phoenix - Phoenix - AZ",
  "Reunion Rehabilitation Hospital Plano - Plano - TX",
  "Reynolds Memorial Hospital - Glen Dale - WV",
  "Rhea Medical Center - Dayton - TN",
  "Rhode Island Hospital - Providence - RI",
  "RICA-Baltimore - Baltimore - MD",
  "Rice County District Hospital - Lyons - KS",
  "Rice Medical Center - Eagle Lake - TX",
  "Riceland Medical Center - Winnie - TX",
  "Richard L. Roudebush VA Medical Center - Indianapolis - IN",
  "Richardson Medical Center - Rayville - LA",
  "Richmond Community Hospital - Richmond - VA",
  "Richmond Medical Center - Richmond - CA",
  "Richmond State Hospital - Richmond - IN",
  "Richmond University Medical Center - Staten Island - NY",
  "Richmond VA Medical Center - Richmond - VA",
  "Riddle Hospital - Media - PA",
  "Ridgecrest Regional Hospital - Ridgecrest - CA",
  "Ridgeview Behavioral Health Services - Oak Ridge - TN",
  "Ridgeview Behavioral Hospital - Middle Pointe - OH",
  "Ridgeview Institute - Smyrna - GA",
  "Ridgeview Institute Monroe - Monroe - GA",
  "Ridgeview Le Sueur Medical Center - Le Sueur - MN",
  "Ridgeview Medical Center - Waconia - MN",
  "Ridgeview Sibley Medical Center - Arlington - MN",
  "Riley Hospital for Children - Indianapolis - IN",
  "Ringgold County Hospital - Mount Ayr - IA",
  "Rio Grande Hospital - Del Norte - CO",
  "Rio Grande Regional Hospital - McAllen - TX",
  "Rio Grande State Center - Harlingen - TX",
  "Rio Vista Behavioral Health Hospital - El Paso - TX",
  "Rivendell Behavioral Health Services of Arkansas - Benton - AR",
  "Rivendell Behavioral Health Services of Kentucky - Bowling Green - KY",
  "River Bend Hospital - West Lafayette - IN",
  "River Crest Hospital - San Angelo - TX",
  "River Falls Area Hospital - River Falls - WI",
  "River Hospital - Alexandria Bay - NY",
  "River Oaks Hospital - New Orleans - LA",
  "River Oaks Hospital - Houston - TX",
  "River Park Hospital - Huntington - WV",
  "River Place Behavioral Health - LaPlace - LA",
  "River Point Behavioral Health - Jacksonville - FL",
  "River Vista Behavioral Hospital - Columbus - OH",
  "River's Edge Hospital - Saint Peter - MN",
  "Riverbend Rehabilitation Hospital - Monroe - LA",
  "RiverBridge Specialty Hospital - Vidalia - LA",
  "Riveredge Hospital - Forest Park - IL",
  "Rivers Health - Point Pleasant - WV",
  "Riverside Behavioral Health Center - Hampton - VA",
  "Riverside Community Hospital - Riverside - CA",
  "Riverside Doctors Hospital Williamsburg - Williamsburg - VA",
  "Riverside Hospital - Alexandria - LA",
  "Riverside Medical Center - Riverside - CA",
  "Riverside Medical Center - Kankakee - IL",
  "Riverside Medical Center - Franklinton - LA",
  "Riverside Regional Medical Center - Newport News - VA",
  "Riverside Rehabilitation Hospital - Newport News - VA",
  "Riverside Shore Memorial Hospital - Onancock - VA",
  "Riverside University Medical Center - Moreno Valley - CA",
  "Riverside Walter Reed Hospital - Gloucester - VA",
  "RiverValley Behavioral Health Hospital - Owensboro - KY",
  "Riverview Behavioral Health - Texarkana - AR",
  "RiverView Health - Crookston - MN",
  "Riverview Health Noblesville Hospital - Noblesville - IN",
  "Riverview Health Westfield Hospital - Westfield - IN",
  "Riverview Medical Center - Red Bank - NJ",
  "Riverview Psychiatric Center - Augusta - ME",
  "Riverview Regional Medical Center - Gadsden - AL",
  "Riverview Regional Medical Center - Carthage - TN",
  "Riverwood HealthCare Center - Aitkin - MN",
  "RiverWoods Behavioral Health System - Riverdale - GA",
  "RMC Anniston - Anniston - AL",
  "RML Specialty Hospital Chicago - Chicago - IL",
  "RML Specialty Hospital Hinsdale - Hinsdale - IL",
  "Roane General Hospital - Spencer - WV",
  "Roane Medical Center - Harriman - TN",
  "Robert J. Dole VA Medical Center - Wichita - KS",
  "Robert Wood Johnson University Hospital at Rahway - Rahway - NJ",
  "Robert Wood Johnson University Hospital New Brunswick - New Brunswick - NJ",
  "Robert Wood Johnson University Hospital Somerset - Somerville - NJ",
  "Rochelle Community Hospital - Rochelle - IL",
  "Rochester General Hospital - Rochester - NY",
  "Rochester Psychiatric Center - Rochester - NY",
  "Rock County Hospital - Bassett - NE",
  "Rock Regional Hospital - Derby - KS",
  "Rock Springs - Georgetown - TX",
  "Rockcastle Regional Hospital - Mount Vernon - KY",
  "Rockford Center - Newark - DE",
  "Rockland Children's Psychiatric Center - Orangeburg - NY",
  "Rockland Psychiatric Center - Orangeburg - NY",
  "Rockledge Regional Medical Center - Rockledge - FL",
  "Rockville General Hospital - Vernon - CT",
  "Rocky Mountain Hospital for Children - Denver - CO",
  "Roger Mills Memorial Hospital - Cheyenne - OK",
  "Roger Williams Medical Center - Providence - RI",
  "Rogers Behavioral Health in Brown Deer - Brown Deer - WI",
  "Rogers Behavioral Health in West Allis - West Allis - WI",
  "Rolling Hills Hospital - Ada - OK",
  "Rolling Hills Hospital - Franklin - TN",
  "Rolling Plains Memorial Hospital - Sweetwater - TX",
  "Rome Memorial Hospital - Rome - NY",
  "Ronald Reagan UCLA Medical Center - Los Angeles - CA",
  "Rooks County Health Center - Plainville - KS",
  "Roosevelt General Hospital - Portales - NM",
  "Roosevelt Long Term Acute Care Hospital - Warm Springs - GA",
  "Roosevelt Medical Center - Culbertson - MT",
  "Roosevelt Rehabilitation and Specialty Hospital - Warm Springs - GA",
  "Roper Hospital - Charleston - SC",
  "Roper Rehabilitation Hospital - Charleston - SC",
  "Roper St. Francis Berkeley Hospital - Summerville - SC",
  "Roper St. Francis Mount Pleasant Hospital - Mount Pleasant - SC",
  "Rose Medical Center - Denver - CO",
  "Rosebud Health Care Center - Forsyth - MT",
  "Rosebud Hospital - Rosebud - SD",
  "Roseburg VA Health Care System - Roseburg - OR",
  "Roseville Medical Center - Roseville - CA",
  "Roswell Park Cancer Institute - Buffalo - NY",
  "Rothman Orthopaedic Specialty Hospital - Bensalem - PA",
  "Roundup Memorial Hospital - Roundup - MT",
  "Roxborough Memorial Hospital - Philadelphia - PA",
  "Roxbury Treatment Center - Shippensburg - PA",
  "Royal C. Johnson Veterans' Memorial Hospital - Sioux Falls - SD",
  "Royal Oaks Hospital - Windsor - MO",
  "Ruby Valley Medical Center - Sheridan - MT",
  "Rumford Hospital - Rumford - ME",
  "Runnells Center for Rehab and Healthcare - Berkeley Heights - NJ",
  "Rural Wellness Anadarko - Anadarko - OK",
  "Rural Wellness Stroud - Stroud - OK",
  "RUSH Copley Medical Center - Aurora - IL",
  "Rush County Memorial Hospital - La Crosse - KS",
  "Rush Memorial Hospital - Rushville - IN",
  "Rush Oak Park Hospital - Oak Park - IL",
  "Rush University Children's Hospital - Chicago - Chicago - IL",
  "Rush University Medical Center - Chicago - IL",
  "Rusk Rehabilitation at Tisch Hospital - New York - NY",
  "Rusk Rehabilitation Hospital - Columbia - MO",
  "Rusk State Hospital - Rusk - TX",
  "Russell County Hospital - Russell Springs - KY",
  "Russell County Hospital - Lebanon - VA",
  "Russell Medical Center - Alexander City - AL",
  "Russell Regional Hospital - Russell - KS",
  "Russellville Hospital - Russellville - AL",
  "Ruston Regional Specialty Hospital - Ruston - LA",
  "Rutgers University Behavioral Healthcare - Piscataway - NJ",
  "Rutherford Regional Health System - Rutherfordton - NC",
  "Rutland Regional Medical Center - Rutland - VT",
  "RWJ University Hospital Hamilton - Hamilton - NJ",
  "RWJBarnabas Health Behavioral Health Center - Toms River - NJ",
  "Ryder Memorial Hospital - Humacao - PR",
  "Sabetha Community Hospital - Sabetha - KS",
  "Sabine County Hospital - Hemphill - TX",
  "Sabine Medical Center - Many - LA",
  "Sacramento Behavioral Healthcare Hospital - Sacramento - CA",
  "Sacramento Rehabilitation Hospital - Sacramento - CA",
  "Sacramento VA Medical Center - Mather - CA",
  "Sacred Heart Medical Center University District - Eugene - OR",
  "Saddleback Medical Center - Laguna Hills - CA",
  "Sagamore Children's Psychiatric Center - Dix Hills - NY",
  "SAGE Rehabilitation Hospital - Baton Rouge - LA",
  "SAGE Specialty Hospital - Denham Springs - Denham Springs - LA",
  "SAGE Specialty Hospital - LTAC - Lafayette - LA",
  "SageWest Lander - Lander - WY",
  "SageWest Riverton - Riverton - WY",
  "Saint Catherine Memorial Hospital - New Orleans - LA",
  "Saint Agnes Medical Center - Fresno - CA",
  "Saint Aloisius Medical Center - Harvey - ND",
  "Saint Alphonsus Medical Center - Nampa - Nampa - ID",
  "Saint Alphonsus Medical Center - Ontario - Ontario - OR",
  "Saint Alphonsus Medical Center in Baker City - Baker City - OR",
  "Saint Alphonsus Regional Medical Center - Boise - ID",
  "Saint Alphonsus Regional Rehabilitation Hospital - Boise - ID",
  "Saint Anne's Hospital - Fall River - MA",
  "Saint Anthony Community Hospital - Warwick - NY",
  "Saint Anthony Hospital - Chicago - IL",
  "Saint Anthony Regional Hospital - Carroll - IA",
  "Saint Anthony's Hospital - Saint Petersburg - FL",
  "Saint Anthony's Rehabilitation Hospital - Lauderdale Lakes - FL",
  "Saint Bernard Hospital and Health Care Center - Chicago - IL",
  "Saint Bernardine Medical Center - San Bernardino - CA",
  "Saint Bernards Behavioral Health - Jonesboro - AR",
  "Saint Catherine Hospital - East Chicago - IN",
  "Saint Catherine's Rehabilitation Hospital - North Miami - FL",
  "Saint Catherine's West Rehabilitation Hospital - Hialeah Gardens - FL",
  "Saint Charles Bend - Bend - OR",
  "Saint Charles Madras - Madras - OR",
  "Saint Charles Parish Hospital - Luling - LA",
  "Saint Charles Surgical Hospital - New Orleans - LA",
  "Saint Christopher's Hospital for Children - Philadelphia - PA",
  "Saint Clair Hospital - Pittsburgh - PA",
  "Saint Claire Regional Medical Center - Morehead - KY",
  "Saint Clare's Behavioral Health - Boonton - Boonton Township - NJ",
  "Saint Clare's Denville Hospital - Denville - NJ",
  "Saint Clare's Dover Hospital - Dover - NJ",
  "Saint Cloud Hospital - Saint Cloud - MN",
  "Saint Cloud VA Medical Center - Saint Cloud - MN",
  "Saint Croix Regional Medical Center - Saint Croix Falls - WI",
  "Saint David's Children's Hospital - Austin - TX",
  "Saint David's Georgetown Hospital - Georgetown - TX",
  "Saint David's North Austin Medical Center - Austin - TX",
  "Saint David's Rehabilitation Hospital - Austin - TX",
  "Saint David's Round Rock Medical Center - Round Rock - TX",
  "Saint David's South Austin Medical Center - Austin - TX",
  "Saint Dominic Hospital - Jackson - MS",
  "Saint Elizabeth Covington - Covington - KY",
  "Saint Elizabeth Fort Thomas - Fort Thomas - KY",
  "Saint Elizabeth Grant Hospital - Williamstown - KY",
  "Saint Elizabeth's Medical Center - Brighton - MA",
  "Saint Elizabeths Hospital - Washington - DC",
  "Saint Francis -Emory Healthcare - Columbus - GA",
  "Saint Francis Downtown - Greenville - SC",
  "Saint Francis Eastside - Greenville - SC",
  "Saint Francis Healthcare - Wilmington - DE",
  "Saint Francis Hospital - Charleston - WV",
  "Saint Francis Hospital - Tulsa - OK",
  "Saint Francis Hospital - Hartford - CT",
  "Saint Francis Hospital - Bartlett - Bartlett - TN",
  "Saint Francis Hospital Muskogee - Muskogee - OK",
  "Saint Francis Hospital Muskogee East - Muskogee - OK",
  "Saint Francis Hospital South - Tulsa - OK",
  "Saint Francis Hospital Vinita - Vinita - OK",
  "Saint Francis Hospital-Memphis - Memphis - TN",
  "Saint Francis Medical Center - Cape Girardeau - MO",
  "Saint Francis Medical Center - Midlothian - VA",
  "Saint Francis Medical Center - Monroe - LA",
  "Saint Francis Memorial Hospital - San Francisco - CA",
  "Saint Francis Regional Medical Center - Shakopee - MN",
  "Saint Genevieve County Memorial Hospital - Ste. Genevieve - MO",
  "Saint Helena Parish Hospital - Greensburg - LA",
  "Saint James Behavioral Health Hospital - Gonzales - LA",
  "Saint James Hospital - Hornell - NY",
  "Saint John Hospital - Leavenworth - KS",
  "Saint John Medical Center - Tulsa - OK",
  "Saint John Rehabilitation Hospital - Broken Arrow - OK",
  "Saint John Vianney Center - Downingtown - PA",
  "Saint John's Episcopal Hospital - Far Rockaway - NY",
  "Saint John's Health - Jackson - WY",
  "Saint John's Nursing Center - Lauderdale Lakes - FL",
  "Saint John's Regional Medical Center - Oxnard - CA",
  "Saint John's Riverside Hospital - Andrus Pavilion - Yonkers - NY",
  "Saint Joseph Berea - Berea - KY",
  "Saint Joseph Hospital - Denver - CO",
  "Saint Joseph Hospital - Nashua - NH",
  "Saint Joseph London - London - KY",
  "Saint Joseph Medical Center - Houston - TX",
  "Saint Joseph Medical Center - Kansas City - MO",
  "Saint Joseph Mount Sterling - Mount Sterling - KY",
  "Saint Joseph Regional Medical Center - Lewiston - ID",
  "Saint Joseph Villa - Salt Lake City - UT",
  "Saint Joseph's Children's Hospital - Tampa - FL",
  "Saint Joseph's Hospital - Elmira - NY",
  "Saint Joseph's Hospital - Tucson - AZ",
  "Saint Joseph's Hospital - Buckhannon - WV",
  "Saint Joseph's Hospital - Tampa - FL",
  "Saint Joseph's Hospital - Savannah - GA",
  "Saint Joseph's Hospital - North - Lutz - FL",
  "Saint Joseph's Hospital - South - Riverview - FL",
  "Saint Joseph's Medical Center - Yonkers - NY",
  "Saint Joseph's University Medical Center - Paterson - NJ",
  "Saint Joseph's Wayne Medical Center - Wayne - NJ",
  "Saint Joseph's Westgate Medical Center - Glendale - AZ",
  "Saint Joseph's Women's Hospital - Tampa - FL",
  "Saint Jude Children's Research Hospital - Memphis - TN",
  "Saint Landry Extended Care Hospital - Opelousas - LA",
  "Saint Lawrence Psychiatric Center - Ogdensburg - NY",
  "Saint Louis Children's Hospital - Saint Louis - MO",
  "Saint Louise Regional Hospital - Gilroy - CA",
  "Saint Luke Community Hospital - Ronan - MT",
  "Saint Luke Institute - Silver Spring - MD",
  "Saint Luke's Anderson Campus - Easton - PA",
  "Saint Luke's Allentown Campus - Allentown - PA",
  "Saint Luke's Des Peres Hospital - Saint Louis - MO",
  "Saint Luke's East Hospital - Lee's Summit - MO",
  "Saint Luke's Hospital - Cedar Rapids - IA",
  "Saint Luke's Hospital - Columbus - NC",
  "Saint Luke's Hospital - Chesterfield - MO",
  "Saint Luke's Hospital Crittenton Children's Center - Kansas City - MO",
  "Saint Luke's Hospital of Kansas City - Kansas City - MO",
  "Saint Luke's Medical Center - Crosby - ND",
  "Saint Luke's Miners Campus - Coaldale - PA",
  "Saint Luke's Monroe Campus - Stroudsburg - PA",
  "Saint Luke's North Hospital - Barry Road - Kansas City - MO",
  "Saint Luke's North Hospital - Smithville - Smithville - MO",
  "Saint Luke's Rehabilitation Hospital - Chesterfield - MO",
  "Saint Luke's Sacred Heart Campus - Allentown - PA",
  "Saint Luke's South Hospital - Overland Park - KS",
  "Saint Mark's Hospital - Salt Lake City - UT",
  "Saint Mary Medical Center - Langhorne - PA",
  "Saint Mary Medical Center - Hobart - IN",
  "Saint Mary Rehabilitation Hospital - Langhorne - PA",
  "Saint Mary's General Hospital - Passaic - NJ",
  "Saint Mary's Good Samaritan Hospital - Greensboro - GA",
  "Saint Mary's Healthcare Amsterdam - Amsterdam - NY",
  "Saint Mary's Home for Disabled Children - Norfolk - VA",
  "Saint Mary's Hospital - Tucson - AZ",
  "Saint Mary's Hospital - Richmond - VA",
  "Saint Mary's Hospital - Waterbury - CT",
  "Saint Mary's Hospital and Clinics - Cottonwood - ID",
  "Saint Mary's Hospital for Children - Bayside - NY",
  "Saint Mary's Medical Center - Grand Junction - CO",
  "Saint Mary's Medical Center - Blue Springs - MO",
  "Saint Mary's Medical Center - Huntington - WV",
  "Saint Mary's Medical Center - San Francisco - CA",
  "Saint Mary's Medical Center - West Palm Beach - FL",
  "Saint Mary's Regional Health System - Russellville - AR",
  "Saint Mary's Regional Medical Center - Lewiston - ME",
  "Saint Mary's Regional Medical Center - Reno - NV",
  "Saint Mary's Regional Medical Center - Enid - OK",
  "Saint Mary's Sacred Heart Hospital - Lavonia - GA",
  "Saint Michael's Elite Hospital - Sugar Land - TX",
  "Saint Michael's Hospital Avera - Tyndall - SD",
  "Saint Michael's Medical Center - Newark - NJ",
  "Saint Peter's Hospital - Albany - NY",
  "Saint Peter's University Hospital - New Brunswick - NJ",
  "Saint Simons By-The-Sea - Saint Simons Island - GA",
  "Saint Tammany Parish Hospital - Covington - LA",
  "Saint Thomas Hospital for Specialty Surgery - Nashville - TN",
  "Saint Vincent Health - Leadville - CO",
  "Saint Vincent Healthcare - Billings - MT",
  "Saint Vincent Hospital - Erie - PA",
  "Saint Vincent Hospital - Worcester - MA",
  "Saint Vincent's Hospital Westchester - Harrison - NY",
  "Saint Vincent's Medical Center - Bridgeport - CT",
  "Sakakawea Medical Center - Hazen - ND",
  "Salah Foundation Children's Hospital at Broward Health - Fort Lauderdale - FL",
  "Salem Hospital - Salem - MA",
  "Salem Hospital - Salem - OR",
  "Salem Memorial District Hospital - Salem - MO",
  "Salem Regional Medical Center - Salem - OH",
  "Salem Township Hospital - Salem - IL",
  "Salem VA Medical Center - Salem - VA",
  "Salina Regional Health Center - Salina - KS",
  "Salina Surgical Hospital - Salina - KS",
  "Salinas Valley Health - Salinas - CA",
  "Saline Memorial Hospital - Benton - AR",
  "Salt Lake Behavioral Health - Salt Lake City - UT",
  "Samaritan Albany General Hospital - Albany - OR",
  "Samaritan Hospital - Macon - MO",
  "Samaritan Hospital - Moses Lake - WA",
  "Samaritan Hospital - Troy - NY",
  "Samaritan Hospital-Albany Memorial Campus - Albany - NY",
  "Samaritan Lebanon Community Hospital - Lebanon - OR",
  "Samaritan Medical Center - Watertown - NY",
  "Samaritan North Lincoln Hospital - Lincoln City - OR",
  "Samaritan Pacific Communities Hospital - Newport - OR",
  "Same Day Surgery Center - Rapid City - SD",
  "Sampson Regional Medical Center - Clinton - NC",
  "Samuel Mahelona Memorial Hospital - Kapaa - HI",
  "Samuel Simmonds Memorial Hospital - Barrow - AK",
  "San Antonio Behavioral Healthcare Hospital - San Antonio - TX",
  "San Antonio Regional Hospital - Upland - CA",
  "San Antonio State Hospital - San Antonio - TX",
  "San Carlos Apache Healthcare - Peridot - AZ",
  "San Diego County Psychiatric Hospital - San Diego - CA",
  "San Diego VA Medical Center - San Diego - CA",
  "San Dimas Community Hospital - San Dimas - CA",
  "San Francisco Campus for Jewish Living - San Francisco - CA",
  "San Francisco VA Medical Center - San Francisco - CA",
  "San Gabriel Valley Medical Center - San Gabriel - CA",
  "San Gorgonio Memorial Hospital - Banning - CA",
  "San Joaquin General Hospital - French Camp - CA",
  "San Joaquin Valley Rehabilitation Hospital - Fresno - CA",
  "San Jorge Children's and Women's Hospital - San Juan - PR",
  "San Jose Behavioral Health - San Jose - CA",
  "San Jose Main Campus - San Jose - CA",
  "San Juan City Hospital - San Juan - PR",
  "San Juan Hospital - Monticello - UT",
  "San Juan Regional Medical Center - Farmington - NM",
  "San Juan Regional Rehabilitation Hospital - Farmington - NM",
  "San Leandro Hospital - San Leandro - CA",
  "San Leandro Medical Center - San Leandro - CA",
  "San Mateo Medical Center - San Mateo - CA",
  "San Rafael Medical Center - San Rafael - CA",
  "San Ramon Regional Medical Center - San Ramon - CA",
  "Sanford Aberdeen Medical Center - Aberdeen - SD",
  "Sanford Bagley Medical Center - Bagley - MN",
  "Sanford Bemidji Medical Center - Bemidji - MN",
  "Sanford Canby Medical Center - Canby - MN",
  "Sanford Canton-Inwood Medical Center - Canton - SD",
  "Sanford Chamberlain Medical Center - Chamberlain - SD",
  "Sanford Children's Hospital Fargo - Fargo - ND",
  "Sanford Children's Hospital Sioux Falls - Sioux Falls - SD",
  "Sanford Hillsboro Medical Center - Hillsboro - ND",
  "Sanford Jackson Medical Center - Jackson - MN",
  "Sanford Luverne Medical Center - Luverne - MN",
  "Sanford Mayville Medical Center - Mayville - ND",
  "Sanford Medical Center - Bismarck - Bismarck - ND",
  "Sanford Medical Center Fargo - Fargo - ND",
  "Sanford Sheldon Medical Center - Sheldon - IA",
  "Sanford South University Medical Center - Fargo - ND",
  "Sanford Thief River Falls Behavioral Health Hospital - Thief River Falls - MN",
  "Sanford Thief River Falls Medical Center - Thief River Falls - MN",
  "Sanford Tracy Medical Center - Tracy - MN",
  "Sanford USD Medical Center - Sioux Falls - SD",
  "Sanford Vermillion Medical Center - Vermillion - SD",
  "Sanford Webster Medical Center - Webster - SD",
  "Sanford Westbrook Medical Center - Westbrook - MN",
  "Sanford Wheaton Medical Center - Wheaton - MN",
  "Sanford Worthington Medical Center - Worthington - MN",
  "Santa Barbara Cottage Hospital - Santa Barbara - CA",
  "Santa Barbara County Department of Behavioral Wellness - Santa Barbara - CA",
  "Santa Clara Medical Center - Santa Clara - CA",
  "Santa Clara Valley Medical Center - San Jose - CA",
  "Santa Cruz County Psychiatric Health Facility - Santa Cruz - CA",
  "Santa Paula Hospital - Santa Paula - CA",
  "Santa Rosa Behavioral Healthcare Hospital - Santa Rosa - CA",
  "Santa Rosa Hospital - Santa Rosa - CA",
  "Santa Rosa Medical Center - Milton - FL",
  "Santa Ynez Valley Cottage Hospital - Solvang - CA",
  "Santiam Hospital - Stayton - OR",
  "Sarah Bush Lincoln - Mattoon - IL",
  "Sarah Bush Lincoln Fayette County Hospital and Long Term Care - Vandalia - IL",
  "Sarah D. Culbertson Memorial Hospital - Rushville - IL",
  "Sarasota Memorial Hospital - Sarasota Campus - Sarasota - FL",
  "Sarasota Memorial Hospital - Venice Campus - North Venice - FL",
  "Saratoga Hospital Campus - Saratoga Springs - NY",
  "Satanta District Hospital - Satanta - KS",
  "Sauk Prairie Memorial Hospital - Prairie du Sac - WI",
  "Saunders Medical Center - Wahoo - NE",
  "Savoy Medical Center - Mamou - LA",
  "Scenic Mountain Medical Center - Big Spring - TX",
  "Scheurer Hospital - Pigeon - MI",
  "Schleicher County Medical Center - Eldorado - TX",
  "Schneck Medical Center - Seymour - IN",
  "Schneider Regional Medical Center - Saint Thomas - VI",
  "Schoolcraft Memorial Hospital - Manistique - MI",
  "Schuyler Hospital - Montour Falls - NY",
  "Schwab Rehabilitation Hospital - Chicago - IL",
  "Scotland County Memorial Hospital - Memphis - MO",
  "Scotland Memorial Hospital - Laurinburg - NC",
  "Scott County Hospital - Scott City - KS",
  "Scripps Green Hospital - La Jolla - CA",
  "Scripps Memorial Hospital Encinitas - Encinitas - CA",
  "Scripps Memorial Hospital La Jolla - La Jolla - CA",
  "Scripps Mercy Hospital Chula Vista - Chula Vista - CA",
  "Scripps Mercy Hospital San Diego - San Diego - CA",
  "SE Texas ER and Hospital Humble - Humble - TX",
  "Sea Pines Rehabilitation Hospital - Melbourne - FL",
  "Seaside Behavioral Center - New Orleans - New Orleans - LA",
  "Seaside Behavioral Center-Metairie - Metairie - LA",
  "Seaside Health System-Baton Rouge - Baton Rouge - LA",
  "Seattle Children's Hospital & Regional Medical Center - Seattle - WA",
  "Seattle VA Medical Center - Seattle - WA",
  "Sebastian River Medical Center - Sebastian - FL",
  "Sedan City Hospital - Sedan - KS",
  "Sedgwick County Health Center - Julesburg - CO",
  "Seiling Community Hospital - Seiling - OK",
  "Selby General Hospital - Marietta - OH",
  "Select Medical Rehabilitation Hospital at Lutheran Hospital - Fort Wayne - IN",
  "Select Rehabilitation Hospital of Denton - Denton - TX",
  "Select Specialty Hospital - Akron - Akron - OH",
  "Select Specialty Hospital - Alle Kiski - Natrona Heights - PA",
  "Select Specialty Hospital - Ann Arbor - Ypsilanti - MI",
  "Select Specialty Hospital - Atlantic City - Atlantic City - NJ",
  "Select Specialty Hospital - Augusta - Augusta - GA",
  "Select Specialty Hospital - Battle Creek - Battle Creek - MI",
  "Select Specialty Hospital - Belhaven - Jackson - MS",
  "Select Specialty Hospital - Birmingham - Birmingham - AL",
  "Select Specialty Hospital - Camp Hill - Camp Hill - PA",
  "Select Specialty Hospital - Canton - Canton - OH",
  "Select Specialty Hospital - Central Kentucky - Danville - KY",
  "Select Specialty Hospital - Charleston - Charleston - WV",
  "Select Specialty Hospital - Cincinnati - Cincinnati - OH",
  "Select Specialty Hospital - Cincinnati North - Cincinnati - OH",
  "Select Specialty Hospital - Cleveland Fairhill - Cleveland - OH",
  "Select Specialty Hospital - Columbus - Columbus - OH",
  "Select Specialty Hospital - Columbus South - Columbus - OH",
  "Select Specialty Hospital - Dallas Downtown - DeSoto - TX",
  "Select Specialty Hospital - Dallas Plano - Plano - TX",
  "Select Specialty Hospital - Daytona Beach - Daytona Beach - FL",
  "Select Specialty Hospital - Des Moines - Des Moines - IA",
  "Select Specialty Hospital - Downriver - Wyandotte - MI",
  "Select Specialty Hospital - Durham - Durham - NC",
  "Select Specialty Hospital - Erie - Erie - PA",
  "Select Specialty Hospital - Evansville - Evansville - IN",
  "Select Specialty Hospital - Flint - Flint - MI",
  "Select Specialty Hospital - Fort Myers - Fort Myers - FL",
  "Select Specialty Hospital - Fort Smith - Fort Smith - AR",
  "Select Specialty Hospital - Gainesville - Gainesville - FL",
  "Select Specialty Hospital - Greensboro - Greensboro - NC",
  "Select Specialty Hospital - Grosse Pointe - Detroit - MI",
  "Select Specialty Hospital - Gulf Coast - Gulfport - MS",
  "Select Specialty Hospital - Harrisburg - Harrisburg - PA",
  "Select Specialty Hospital - Jackson - Jackson - MS",
  "Select Specialty Hospital - Johnstown - Johnstown - PA",
  "Select Specialty Hospital - Kansas City - Kansas City - KS",
  "Select Specialty Hospital - Knoxville - Knoxville - TN",
  "Select Specialty Hospital - Laurel Highlands - Latrobe - PA",
  "Select Specialty Hospital - Longview - Longview - TX",
  "Select Specialty Hospital - Macomb - Mount Clemens - MI",
  "Select Specialty Hospital - Madison - Madison - WI",
  "Select Specialty Hospital - McKeesport - McKeesport - PA",
  "Select Specialty Hospital - Memphis - Memphis - TN",
  "Select Specialty Hospital - Miami - Miami - FL",
  "Select Specialty Hospital - Midtown Atlanta - Atlanta - GA",
  "Select Specialty Hospital - Milwaukee - St. Francis - Milwaukee - WI",
  "Select Specialty Hospital - Morgantown - Morgantown - WV",
  "Select Specialty Hospital - Nashville - Nashville - TN",
  "Select Specialty Hospital - North Knoxville - Powell - TN",
  "Select Specialty Hospital - Northeast New Jersey - Rochelle Park - NJ",
  "Select Specialty Hospital - Northern Kentucky - Fort Thomas - KY",
  "Select Specialty Hospital - Northwest Detroit - Detroit - MI",
  "Select Specialty Hospital - Oklahoma City - Oklahoma City - OK",
  "Select Specialty Hospital - Omaha - Omaha - NE",
  "Select Specialty Hospital - Orlando South - Edgewood - FL",
  "Select Specialty Hospital - Palm Beach - Lake Worth - FL",
  "Select Specialty Hospital - Panama City - Panama City - FL",
  "Select Specialty Hospital - Pensacola - Pensacola - FL",
  "Select Specialty Hospital - Phoenix - Phoenix - AZ",
  "Select Specialty Hospital - Phoenix Downtown - Phoenix - AZ",
  "Select Specialty Hospital - Richmond - Richmond - VA",
  "Select Specialty Hospital - Saint Louis - Saint Charles - MO",
  "Select Specialty Hospital - South Dakota - Sioux Falls - SD",
  "Select Specialty Hospital - Southeast Ohio - Newark - OH",
  "Select Specialty Hospital - Spectrum Health - Grand Rapids - MI",
  "Select Specialty Hospital - Springfield - Springfield - MO",
  "Select Specialty Hospital - Tallahassee - Tallahassee - FL",
  "Select Specialty Hospital - Tri Cities - Bristol - TN",
  "Select Specialty Hospital - Trumbull - Warren - OH",
  "Select Specialty Hospital - Tucson Northwest - Tucson - AZ",
  "Select Specialty Hospital - Tulsa - Tulsa - OK",
  "Select Specialty Hospital - Weirton - Weirton - WV",
  "Select Specialty Hospital - Wheeling - Wheeling - WV",
  "Select Specialty Hospital - Willingboro - Willingboro - NJ",
  "Select Specialty Hospital - Wilmington - Wilmington - DE",
  "Select Specialty Hospital - York - York - PA",
  "Select Specialty Hospital - Youngstown - Youngstown - OH",
  "Select Specialty Hospital Hampton Roads - Newport News - VA",
  "Select Specialty Hospital Miami Lakes - Miami Lakes - FL",
  "Select Specialty Hospital Milwaukee -West Allis - West Allis - WI",
  "Select Specialty Hospital Orlando North - Orlando - FL",
  "Select Specialty Hospital Pittsburgh UPMC - Pittsburgh - PA",
  "Select Specialty Hospital Pontiac - Pontiac - MI",
  "Select Specialty Hospital Quad Cities - Davenport - IA",
  "Select Specialty Hospital Saginaw - Saginaw - MI",
  "Select Specialty Hospital Savannah - Savannah - GA",
  "Select Specialty Hospital The Villages - Oxford - FL",
  "Select Specialty Hospital West Tennessee - Jackson - TN",
  "Select Specialty Hospital Wichita - Wichita - KS",
  "Select Specialty Hospital-San Diego - San Diego - CA",
  "Self Regional Healthcare - Greenwood - SC",
  "Sells Indian Hospital - Sells - AZ",
  "Seminole Hospital District - Seminole - TX",
  "Seneca Healthcare District - Chester - CA",
  "Sentara Albemarle Medical Center - Elizabeth City - NC",
  "Sentara CarePlex Hospital - Hampton - VA",
  "Sentara Halifax Regional Hospital - South Boston - VA",
  "Sentara Heart Hospital - Norfolk - VA",
  "Sentara Leigh Hospital - Norfolk - VA",
  "Sentara Martha Jefferson Hospital - Charlottesville - VA",
  "Sentara Norfolk General Hospital - Norfolk - VA",
  "Sentara Northern Virginia Medical Center - Woodbridge - VA",
  "Sentara Obici Hospital - Suffolk - VA",
  "Sentara Princess Anne Hospital - Virginia Beach - VA",
  "Sentara RMH Medical Center - Harrisonburg - VA",
  "Sentara Virginia Beach General Hospital - Virginia Beach - VA",
  "Sentara Williamsburg Regional Medical Center - Williamsburg - VA",
  "Sequoia Hospital - Redwood City - CA",
  "Sequoyah Adolescent Treatment Center - Albuquerque - NM",
  "Serenity Lane Inpatient Hospital - Coburg - OR",
  "Seton Medical Center Harker Heights - Harker Heights - TX",
  "Seven Hills Hospital - Henderson - NV",
  "Sevier County Medical Center - De Queen - AR",
  "Seymour Hospital - Seymour - TX",
  "SGMC Berrien Campus - Nashville - GA",
  "SGMC Health Main - Valdosta - GA",
  "SGMC Lanier Campus - Lakeland - GA",
  "SGMC Smith Northview Hospital - Valdosta - GA",
  "Shamrock General Hospital - Shamrock - TX",
  "Shannon Medical Center - San Angelo - TX",
  "Shannon Rehabilitation Hospital - San Angelo - TX",
  "Shannon South - San Angelo - TX",
  "Share Medical Center - Alva - OK",
  "Sharkey Issaquena Community Hospital - Rolling Fork - MS",
  "Sharon Hospital - Sharon - CT",
  "Sharon Regional Medical Center - Sharon - PA",
  "Sharp Chula Vista Medical Center - Chula Vista - CA",
  "Sharp Coronado Hospital - Coronado - CA",
  "Sharp Grossmont Hospital - La Mesa - CA",
  "Sharp Mary Birch Hospital for Women and Newborns - San Diego - CA",
  "Sharp Memorial Hospital - San Diego - CA",
  "Sharp Mesa Vista Hospital - San Diego - CA",
  "Shasta Regional Medical Center - Redding - CA",
  "Shelby Baptist Medical Center - Alabaster - AL",
  "Sheltering Arms Institute - Richmond - VA",
  "Shenandoah Medical Center - Shenandoah - IA",
  "Shenandoah Memorial Hospital - Woodstock - VA",
  "Shepherd Center - Atlanta - GA",
  "Sheppard Pratt - Baltimore/Washington Campus - Elkridge - MD",
  "Sheppard Pratt - Towson Campus - Baltimore - MD",
  "Sheridan Community Hospital - Sheridan - MI",
  "Sheridan County Health Complex - Hoxie - KS",
  "Sheridan Memorial - Plentywood - MT",
  "Sheridan Memorial Hospital - Sheridan - WY",
  "Sheridan VA Medical Center - Sheridan - WY",
  "Sherman Oaks Hospital - Sherman Oaks - CA",
  "Shirley Ryan AbilityLab - Chicago - IL",
  "Shodair Children's Hospital - Helena - MT",
  "Shore Medical Center - Somers Point - NJ",
  "ShorePoint Health Port Charlotte - Port Charlotte - FL",
  "ShorePoint Health Punta Gorda - Punta Gorda - FL",
  "Shoshone Medical Center - Kellogg - ID",
  "Shreveport Rehabilitation Hospital - Shreveport - LA",
  "Shriner's Children's Hawaii - Honolulu - HI",
  "Shriners Children Twin Cities - Woodbury - MN",
  "Shriners Children's Boston - Boston - MA",
  "Shriners Children's Chicago - Chicago - IL",
  "Shriners Children's Greenville - Greenville - SC",
  "Shriners Children's New England - Springfield - MA",
  "Shriners Children's Northern California - Sacramento - CA",
  "Shriners Children's Ohio - Dayton - OH",
  "Shriners Children's Philadelphia - Philadelphia - PA",
  "Shriners Children's Portland - Portland - OR",
  "Shriners Children's Salt Lake City - Salt Lake City - UT",
  "Shriners Children's Shreveport - Shreveport - LA",
  "Shriners Children's Spokane - Spokane - WA",
  "Shriners Children's St. Louis - Saint Louis - MO",
  "Shriners Children's Texas - Galveston - TX",
  "Sibley Memorial Hospital - Washington - DC",
  "Sidney and Lois Eskenazi Hospital - Indianapolis - IN",
  "Sidney Health Center - Sidney - MT",
  "Sidney Regional Medical Center - Sidney - NE",
  "Sierra Nevada Memorial Hospital - Grass Valley - CA",
  "Sierra Tucson - Tucson - AZ",
  "Sierra View Medical Center - Porterville - CA",
  "Sierra Vista Hospital - Sacramento - CA",
  "Sierra Vista Hospital - Truth or Consequences - NM",
  "Sierra Vista Regional Medical Center - San Luis Obispo - CA",
  "Signature Psychiatric Hospital - North Kansas City - MO",
  "SIH Herrin Hospital - Herrin - IL",
  "SIH Saint Joseph Memorial Hospital - Murphysboro - IL",
  "Siloam Springs Regional Hospital - Siloam Springs - AR",
  "Silver Cross Hospital - New Lenox - IL",
  "Silver Hill Hospital - New Canaan - CT",
  "Silver Lake Hospital - Newark - NJ",
  "Silver Oaks Behavioral Hospital - New Lenox - IL",
  "Simpson General Hospital - Mendenhall - MS",
  "Sinai Children's Hospital - Chicago - IL",
  "Sinai Hospital - Baltimore - MD",
  "Singing River Gulfport - Gulfport - MS",
  "Sioux Center Health Center - Sioux Center - IA",
  "Sioux Falls Specialty Hospital - Sioux Falls - SD",
  "Siskin Hospital for Physical Rehabilitation - Chattanooga - TN",
  "Sisters of Charity Hospital - Buffalo - NY",
  "Sisters of Charity Hospital, Saint Joseph Campus - Buffalo - NY",
  "Sistersville General Hospital - Sistersville - WV",
  "Skagit Valley Hospital - Mount Vernon - WA",
  "Skokie Hospital - Skokie - IL",
  "Sky Lakes Medical Center - Klamath Falls - OR",
  "Sky Ridge Medical Center - Lone Tree - CO",
  "Skyline Health - White Salmon - WA",
  "Sleepy Eye Medical Center - Sleepy Eye - MN",
  "Slidell Memorial Hospital - Slidell - LA",
  "Slidell Memorial Hospital East - Slidell - LA",
  "Smilow Cancer Hospital at Yale New Haven - New Haven - CT",
  "Smith County Memorial Hospital - Smith Center - KS",
  "Smokey Point Behavioral Hospital - Marysville - WA",
  "SMP Health - St. Andrews - Bottineau - ND",
  "SMP Health - St. Kateri - Rolla - ND",
  "Smyth County Community Hospital - Marion - VA",
  "Snoqualmie Valley Hospital - Snoqualmie - WA",
  "Socorro General Hospital - Socorro - NM",
  "Soin Medical Center - Kettering Health - Beavercreek - OH",
  "Sojourn at Seneca Senior Behavioral Health Hospital - Tiffiin - OH",
  "Solara Specialty Hospitals Brownsville - Brownsville - TX",
  "Solara Specialty Hospitals Harlingen - Harlingen - TX",
  "Solara Specialty Hospitals McAllen - McAllen - TX",
  "Soldiers & Sailors Memorial Hospital - Penn Yan - NY",
  "Solomon Carter Fuller Mental Health Center - Boston - MA",
  "Sonoma Specialty Hospital - Sebastopol - CA",
  "Sonoma Valley Hospital - Sonoma - CA",
  "Sonora Behavioral Health Hospital - Tucson - AZ",
  "South Arkansas Regional Hospital - El Dorado - AR",
  "South Baldwin Regional Medical Center - Foley - AL",
  "South Bay Medical Center - Harbor City - CA",
  "South Beach Psychiatric Center - Staten Island - NY",
  "South Central Health - Wishek - ND",
  "South Central Kansas Regional Medical Center - Arkansas City - KS",
  "South Central Regional Medical Center - Laurel - MS",
  "South Coast Global Medical Center - Santa Ana - CA",
  "South County Health - Wakefield - RI",
  "South Dakota Human Services Center - Yankton - SD",
  "South Davis Community Hospital - Bountiful - UT",
  "South Florida Baptist Hospital - Plant City - FL",
  "South Florida State Hospital - Pembroke Pines - FL",
  "South Lincoln Medical Center - Kemmerer - WY",
  "South Lyon Medical Center - Yerington - NV",
  "South Miami Hospital - South Miami - FL",
  "South Mississippi County Regional Medical Center - Osceola - AR",
  "South Mississippi State Hospital - Purvis - MS",
  "South Oaks Hospital - Amityville - NY",
  "South Peninsula Hospital - Homer - AK",
  "South Plains Rehabilitation Hospital - Lubbock - TX",
  "South Pointe Hospital - Warrensville Heights - OH",
  "South Sacramento Medical Center - Sacramento - CA",
  "South Shore Hospital - Chicago - IL",
  "South Shore Hospital - South Weymouth - MA",
  "South Shore University Hospital - Bay Shore - NY",
  "South Sound Behavioral Hospital - Lacey - WA",
  "South Sunflower County Hospital - Indianola - MS",
  "South Texas Behavioral Health Center - Edinburg - TX",
  "South Texas Health System Children's - Edinburg - TX",
  "South Texas Health System Edinburg - Edinburg - TX",
  "South Texas Health System McAllen - McAllen - TX",
  "South Texas Rehabilitation Hospital - Brownsville - TX",
  "South Texas Spine & Surgical Hospital - San Antonio - TX",
  "Southcoast Behavioral Health - Dartmouth - MA",
  "Southeast Behavioral Hospital - Cape Girardeau - MO",
  "Southeast Colorado Hospital District - Springfield - CO",
  "Southeast Georgia Health System - Brunswick Campus - Brunswick - GA",
  "Southeast Georgia Health System - Camden Campus - Saint Marys - GA",
  "Southeast Health Center of Stoddard County - Dexter - MO",
  "Southeast Health Medical Center - Dothan - AL",
  "Southeast Hospital - Cape Girardeau - MO",
  "Southeast Iowa Regional Medical Center, Fort Madison Campus - Fort Madison - IA",
  "Southeast Iowa Regional Medical Center, West Burlington Campus - West Burlington - IA",
  "Southeast Kansas Specialty Hospital - Galena - KS",
  "Southeast Missouri Mental Health Center - Farmington - MO",
  "Southeast Rehabilitation Hospital - Lake Village - AR",
  "Southeastern Medical Center - Cambridge - OH",
  "Southern Arizona VA Health Care System - Tucson - AZ",
  "Southern California Hospital at Culver City - Culver City - CA",
  "Southern California Hospital at Hollywood - Hollywood - CA",
  "Southern Coos Hospital & Health Center - Bandon - OR",
  "Southern Hills Hospital & Medical Center - Las Vegas - NV",
  "Southern Indiana Rehabilitation Hospital - New Albany - IN",
  "Southern Inyo Hospital - Lone Pine - CA",
  "Southern Kentucky Rehabilitation Hospital - Bowling Green - KY",
  "Southern Maine Health Care - Biddeford - ME",
  "Southern Nevada Adult Mental Health Services - Las Vegas - NV",
  "Southern New Hampshire Medical Center - Nashua - NH",
  "Southern Ohio Medical Center - Portsmouth - OH",
  "Southern Regional Medical Center - Riverdale - GA",
  "Southern Tennessee - Lawrenceburg - Lawrenceburg - TN",
  "Southern Tennessee Regional Health Care Pulaski - Pulaski - TN",
  "Southern Tennessee Regional Health System Sewanee - Sewanee - TN",
  "Southern Virginia Mental Health Institute - Danville - VA",
  "Southern Winds Hospital - Hialeah - FL",
  "Southwell Medical Hospital and Surgical Center - Adel - GA",
  "Southwest General Health Center - Middleburg Heights - OH",
  "Southwest Health - Platteville - WI",
  "Southwest Healthcare Inland Valley Hospital - Wildomar - CA",
  "Southwest Healthcare Rancho Springs Medical Center - Murrieta - CA",
  "Southwest Healthcare Services - Bowman - ND",
  "Southwest Medical Center - Liberal - KS",
  "Southwest Memorial Hospital - Cortez - CO",
  "Southwest Mississippi Regional Medical Center - McComb - MS",
  "Southwest Orthopaedic and Reconstructive Specialists - Oklahoma City - OK",
  "Southwestern Medical Center - Lawton - OK",
  "Southwestern Vermont Medical Center - Bennington - VT",
  "Southwestern Virginia Mental Health Institute - Marion - VA",
  "Southwood Psychiatric Hospital - Pittsburgh - PA",
  "Sovah Health - Danville - Danville - VA",
  "Sovah Health - Martinsville - Martinsville - VA",
  "Spalding Rehabilitation Hospital - Aurora - CO",
  "Spanish Fork Hospital - Spanish Fork - UT",
  "Spanish Peaks Regional Health Center - Walsenburg - CO",
  "Sparrow Carson Hospital - Carson City - MI",
  "Sparrow Clinton Hospital - Saint Johns - MI",
  "Sparrow Eaton Hospital - Charlotte - MI",
  "Sparrow Hospital - Lansing - MI",
  "Sparrow Ionia Hospital - Ionia - MI",
  "Sparrow Specialty Hospital - Lansing - MI",
  "Sparta Community Hospital - Sparta - IL",
  "Spartanburg Hospital for Restorative Care - Spartanburg - SC",
  "Spartanburg Medical Center - Spartanburg - SC",
  "Spartanburg Medical Center - Mary Black Campus - Spartanburg - SC",
  "Spartanburg Rehabilitation Institute - Spartanburg - SC",
  "Spaulding Hospital for Continuing Medical Care Cambridge - Cambridge - MA",
  "Spaulding Rehabilitation Hospital Boston - Boston - MA",
  "Spaulding Rehabilitation Hospital Cape Cod - East Sandwich - MA",
  "Speare Memorial Hospital - Plymouth - NH",
  "Specialists Hospital Shreveport - Shreveport - LA",
  "Specialty Hospital Monroe - Monroe - LA",
  "Specialty Hospital of Central Jersey - Lakewood - NJ",
  "Specialty Hospital of Lorain - Amherst - OH",
  "Specialty Rehabilitation Hospital - Coushatta - LA",
  "Spectrum Health Big Rapids Hospital - Big Rapids - MI",
  "Spectrum Health Butterworth Hospital - Grand Rapids - MI",
  "Spectrum Health Gerber Memorial - Fremont - MI",
  "Spectrum Health Helen DeVos Children's Hospital - Grand Rapids - MI",
  "Spectrum Health Hospitals Blodgett Hospital - Grand Rapids - MI",
  "Spectrum Health Lakeland Medical Center - Saint Joseph - MI",
  "Spectrum Health Lakeland Niles Hospital - Niles - MI",
  "Spectrum Health Ludington Hospital - Ludington - MI",
  "Spectrum Health Pennock - Hastings - MI",
  "Spectrum Health Reed City Hospital - Reed City - MI",
  "Spectrum Health Zeeland Community Hospital - Zeeland - MI",
  "Spencer Hospital - Spencer - IA",
  "Spokane VA Medical Center - Spokane - WA",
  "Spooner Health - Spooner - WI",
  "Spotsylvania Regional Medical Center - Fredericksburg - VA",
  "Spring Grove Hospital Center - Catonsville - MD",
  "Spring Harbor Hospital - Westbrook - ME",
  "Spring Hospital - Spring - TX",
  "Spring Mountain Sahara - Las Vegas - NV",
  "Spring Mountain Treatment Center - Las Vegas - NV",
  "Spring Valley Hospital Medical Center - Las Vegas - NV",
  "Spring View Hospital - Lebanon - KY",
  "Springbrook Behavioral Hospital - Brooksville - FL",
  "Springfield Hospital - Springfield - VT",
  "Springfield Hospital Center - Sykesville - MD",
  "Springfield Memorial Hospital - Springfield - IL",
  "Springhill Medical Center - Mobile - AL",
  "Springhill Medical Center - Springhill - LA",
  "Springwoods Behavioral Health - Fayetteville - AR",
  "SSM Health Cardinal Glennon Children's Hospital - Saint Louis - MO",
  "SSM Health Saint Joseph Hospital-Saint Charles - Saint Charles - MO",
  "SSM Health Bone & Joint Hospital at St. Anthony - Oklahoma City - OK",
  "SSM Health DePaul Hospital - St. Louis - Bridgeton - MO",
  "SSM Health Good Samaritan Hospital - Mount Vernon - Mount Vernon - IL",
  "SSM Health Rehab Lake Saint Louis - Lake Saint Louis - MO",
  "SSM Health Rehabilitation Hospital at Bridgeton - Bridgeton - MO",
  "SSM Health Rehabilitation Hospital at Richmond Heights - St. Louis - MO",
  "SSM Health Ripon Community Hospital - Ripon - WI",
  "SSM Health Saint Anthony Hospital - Oklahoma City - Oklahoma City - OK",
  "SSM Health Saint Anthony South - Oklahoma City - OK",
  "SSM Health Saint Clare Hospital -Baraboo - Baraboo - WI",
  "SSM Health Saint Joseph Hospital - Lake Saint Louis - Lake Saint Louis - MO",
  "SSM Health Saint Joseph Hospital - Wentzville - Wentzville - MO",
  "SSM Health Saint Louis University Hospital - Saint Louis - MO",
  "SSM Health Saint Mary's Hospital - Janesville - Janesville - WI",
  "SSM Health Saint Mary's Hospital - Jefferson City - Jefferson City - MO",
  "SSM Health Saint Mary's Hospital - Madison - Madison - WI",
  "SSM Health Saint Mary's Hospital - Saint Louis - Saint Louis - MO",
  "SSM Health Saint Mary's Hospital-Centralia - Centralia - IL",
  "SSM Health St. Agnes Hospital - Fond du Lac - Fond du Lac - WI",
  "SSM Health St. Anthony Hospital - Midwest - Midwest City - OK",
  "SSM Health St. Anthony Hospital - Shawnee, Seminole Campus - Seminole - OK",
  "SSM Health St. Anthony Hospital-Shawnee - Shawnee - OK",
  "SSM Health St. Clare Hospital - Fenton - Fenton - MO",
  "SSM Health Waupun Memorial Hospital - Waupun - WI",
  "St Joseph's Medical Center Stockton - Stockton - CA",
  "St. Anne Hospital - Burien - WA",
  "St. Anthony Hospital - Gig Harbor - WA",
  "St. Anthony's Behavioral Health Hospital - Olathe - KS",
  "St. Barnabas Hospital - Bronx - NY",
  "St. Bernard Parish Hospital - Chalmette - LA",
  "St. Bernards CrossRidge Community Hospital - Wynne - AR",
  "St. Bernards Five Rivers Medical Center - Pocahontas - AR",
  "St. Bernards Medical Center - Jonesboro - AR",
  "St. Charles Prineville - Prineville - OR",
  "St. Charles Redmond - Redmond - OR",
  "St. Clare Hospital - Lakewood - WA",
  "St. David's Medical Center - Austin - TX",
  "St. Elizabeth Community Hospital - Red Bluff - CA",
  "St. Elizabeth Dearborn Hospital - Lawrenceburg - IN",
  "St. Elizabeth Edgewood Hospital - Edgewood - KY",
  "St. Elizabeth Florence Hospital - Florence - KY",
  "St. Elizabeth Hospital - Enumclaw - WA",
  "St. Francis Hospital - Federal Way - WA",
  "St. Francis Medical Center - Lynwood - CA",
  "St. Francis P&S Surgery & Heart Center - Monroe - LA",
  "St. Helena Center for Behavioral Health - Vallejo - CA",
  "St. James Healthcare - Butte - MT",
  "St. James Parish Hospital - Lutcher - LA",
  "St. John's Hospital Camarillo - Camarillo - CA",
  "St. John's Riverside Hospital - Dobbs Ferry Pavilion - Dobbs Ferry - NY",
  "St. John's Riverside Hospital ParkCare Pavilion - Yonkers - NY",
  "St. Joseph Health Burleson Hospital - Caldwell - TX",
  "St. Joseph Health Madison Hospital - Madisonville - TX",
  "St. Joseph Hospital - Bangor - ME",
  "St. Joseph Medical Center - Tacoma - WA",
  "St. Joseph's Behavioral Health Center - Stockton - CA",
  "St. Joseph's Health Hospital - Syracuse - NY",
  "St. Joseph's Hospital and Medical Center - Phoenix - AZ",
  "St. Louis Forensic Treatment Center - South - Saint Louis - MO",
  "St. Luke Hospital - Marion - KS",
  "St. Luke's Baptist Hospital - San Antonio - TX",
  "St. Luke's Behavioral Health Center - Phoenix - AZ",
  "St. Luke's Boise Medical Center - Boise - ID",
  "St. Luke's Children's Hospital - Boise - ID",
  "St. Luke's Easton Campus - Easton - PA",
  "St. Luke's Elmore Medical Center - Mountain Home - ID",
  "St. Luke's Health - Baylor St. Luke's Medical Center - Houston - TX",
  "St. Luke's Health - Brazosport Hospital - Lake Jackson, TX - Lake Jackson - TX",
  "St. Luke's Health - Memorial Hospital - Livingston, TX - Livingston - TX",
  "St. Luke's Health - Memorial Hospital - Lufkin Texas - Lufkin - TX",
  "St. Luke's Health - Memorial Hospital - San Augustine - San Augustine - TX",
  "St. Luke's Health -The Woodlands Hospital - The Woodlands - TX",
  "St. Luke's Hospital - Duluth - MN",
  "St. Luke's Hospital - New Bedford - MA",
  "St. Luke's Hospital - Carbon Campus - Lehighton - PA",
  "St. Luke's Jerome Medical Center - Jerome - ID",
  "St. Luke's Magic Valley Medical Center - Twin Falls - ID",
  "St. Luke's McCall Medical Center - McCall - ID",
  "St. Luke's Meridian Medical Center - Meridian - ID",
  "St. Luke's Nampa Medical Center - Nampa - ID",
  "St. Luke's Rehabilitation Hospital - Boise - ID",
  "St. Luke's University Hospital - Bethlehem - Bethlehem - PA",
  "St. Luke's Upper Bucks Campus - Quakertown - PA",
  "St. Luke's Warren Campus - Phillipsburg - NJ",
  "St. Luke's Wood River Medical Center - Ketchum - ID",
  "St. Mary Medical Center - Long Beach - CA",
  "St. Mary's Hospital - Athens - GA",
  "St. Michael Medical Center - Silverdale - WA",
  "St. Peter's Health Regional Medical Center - Helena - MT",
  "St. Rose Hospital - Hayward - CA",
  "St. Vincent's Behavioral Health Services, Westport - Westport - CT",
  "Stafford County Hospital - Stafford - KS",
  "Stafford Hospital - Stafford - VA",
  "Stamford Hospital - Stamford - CT",
  "Stanford Health Care - ValleyCare - Livermore - CA",
  "Stanford Hospital - Stanford - CA",
  "Stanford Hospital Medicine Tri-Valley Section - Pleasanton - CA",
  "Stanislaus Surgical Hospital - Modesto - CA",
  "Stanton County Hospital - Johnson - KS",
  "Star Valley Medical Center - Afton - WY",
  "Starr County Memorial Hospital - Rio Grande City - TX",
  "Starr Regional - Athens - Athens - TN",
  "State Hospital South - Blackfoot - ID",
  "Staten Island University Hospital - Staten Island - NY",
  "Steele Memorial Medical Center - Salmon - ID",
  "Stephens County Hospital - Toccoa - GA",
  "Stephens Memorial Hospital - Norway - ME",
  "Stephens Memorial Hospital - Breckenridge - TX",
  "Sterling Regional MedCenter - Sterling - CO",
  "Sterling Surgical Hospital - Slidell - LA",
  "Sterlington Rehabilitation Hospital - Bastrop - LA",
  "Stevens Community Medical Center - Morris - MN",
  "Stevens County Hospital - Hugoton - KS",
  "Steward Mesa Hospital - Mesa - AZ",
  "Stewart Memorial Community Hospital - Lake City - IA",
  "Stillwater Billings Clinic - Columbus - MT",
  "Stillwater Medical - Blackwell - Blackwell - OK",
  "Stillwater Medical Center - Stillwater - OK",
  "Stillwater Medical Perry - Perry - OK",
  "Stilwell Memorial Hospital - Stilwell - OK",
  "Stockton Regional Rehabilitation Hospital - Stockton - CA",
  "Stone County Medical Center - Mountain View - AR",
  "Stonecrest Center - Detroit - MI",
  "StoneSprings Hospital Center - Dulles - VA",
  "Stonewall Memorial Hospital - Aspermont - TX",
  "Stony Brook Children's Hospital - Stony Brook - NY",
  "Stony Brook Eastern Long Island Hospital - Greenport - NY",
  "Stony Brook Southampton Hospital - Southampton - NY",
  "Stony Brook University Hospital - Stony Brook - NY",
  "Stormont Vail Behavioral Health Center - Topeka - KS",
  "Stormont Vail Health-Flint Hills Campus - Junction City - KS",
  "Stormont Vail Hospital - Topeka - KS",
  "Story County Medical Center - Nevada - IA",
  "Stoughton Hospital - Stoughton - WI",
  "Straith Hospital - Southfield - MI",
  "Straub Medical Center - Honolulu - HI",
  "Streamwood Behavioral Health Center - Streamwood - IL",
  "STRHS - Winchester - Winchester - TN",
  "Stringfellow Campus of Northeast Alabama Regional Medical Center - Anniston - AL",
  "Strong Memorial Hospital - Rochester - NY",
  "Studer Family Children's Hospital at Ascension Sacred Heart - Pensacola - FL",
  "Sturdy Health - Attleboro - MA",
  "Sturgis Hospital - Sturgis - MI",
  "Suburban Community Hospital - East Norriton - PA",
  "Sugar Land Rehab Hospital - Sugarland - TX",
  "Sullivan County Community Hospital - Sullivan - IN",
  "Sullivan County Memorial Hospital - Milan - MO",
  "Summa Health System - Akron Campus - Akron - OH",
  "Summa Health System-Barberton Campus - Barberton - OH",
  "Summa Health System-St. Thomas Campus - Akron - OH",
  "Summa Rehab Hospital - Akron - OH",
  "Summerlin Hospital Medical Center - Las Vegas - NV",
  "Summers County ARH Hospital - Hinton - WV",
  "Summersville Regional Medical Center - Summersville - WV",
  "Summerville Medical Center - Summerville - SC",
  "Summit Behavioral Healthcare Hospital - Cincinnati - OH",
  "Summit Healthcare Regional Medical Center - Show Low - AZ",
  "Summit Medical Center - Edmond - OK",
  "Summit Medical Center Casper - Casper - WY",
  "Summit Oaks Hospital - Summit - NJ",
  "Summit Pacific Medical Center - Elma - WA",
  "Summit Surgical - Hutchinson - KS",
  "SummitRidge Hospital - Lawrenceville - GA",
  "Sumner Regional Medical Center - Gallatin - TN",
  "SUN Behavioral Delaware - Georgetown - DE",
  "SUN Behavioral Health - Houston - TX",
  "SUN Behavioral Health - Columbus - Columbus - OH",
  "SUN Behavioral Kentucky - Erlanger - KY",
  "Suncoast Behavioral Health Center - Bradenton - FL",
  "Sunland Home Foundation - Encinitas - CA",
  "Sunnyview Rehabilitation Hospital - Schenectady - NY",
  "Sunrise Canyon Hospital - Lubbock - TX",
  "Sunrise Children's Hospital - Las Vegas - NV",
  "Sunrise Hospital & Medical Center - Las Vegas - NV",
  "Sunrise Vista Behavioral Health Hospital - Canton - OH",
  "Sunshine Children's Home and Rehab Center - Ossining - NY",
  "Surgeons Choice Medical Center - Southfield - MI",
  "Surgery Specialty Hospitals of America - Pasadena - TX",
  "Surgical Hospital Of Oklahoma - Oklahoma City - OK",
  "Surgical Institute of Reading - Wyomissing - PA",
  "Surgical Specialty Center of Baton Rouge - Baton Rouge - LA",
  "Surprise Valley Hospital - Cedarville - CA",
  "Susan B. Allen Memorial Hospital - El Dorado - KS",
  "Sutter Amador Hospital - Jackson - CA",
  "Sutter Auburn Faith Hospital - Auburn - CA",
  "Sutter Center for Psychiatry - Sacramento - CA",
  "Sutter Coast Hospital - Crescent City - CA",
  "Sutter Davis Hospital - Davis - CA",
  "Sutter Delta Medical Center - Antioch - CA",
  "Sutter Lakeside Hospital - Lakeport - CA",
  "Sutter Maternity and Surgery Center of Santa Cruz - Santa Cruz - CA",
  "Sutter Medical Center - Sacramento - CA",
  "Sutter Roseville Medical Center - Roseville - CA",
  "Sutter Santa Rosa Regional Hospital - Santa Rosa - CA",
  "Sutter Solano Medical Center - Vallejo - CA",
  "Sutter Surgical Hospital North Valley - Yuba City - CA",
  "Sutter Tracy Community Hospital - Tracy - CA",
  "Swain Community Hospital - Bryson City - NC",
  "Swedish Ballard Campus - Seattle - WA",
  "Swedish Cherry Hill Campus - Seattle - WA",
  "Swedish Edmonds Campus - Edmonds - WA",
  "Swedish First Hill Campus - Seattle - WA",
  "Swedish Hospital - Chicago - IL",
  "Swedish Issaquah Campus - Issaquah - WA",
  "Swedish Medical Center - Englewood - CO",
  "Sweeny Community Hospital - Sweeny - TX",
  "Sweetwater Hospital Association - Sweetwater - TN",
  "Swisher Memorial Hospital - Tulia - TX",
  "Sycamore Shoals Hospital - Elizabethton - TN",
  "Sycamore Springs - Lafayette - IN",
  "Sylvester Comprehensive Cancer Center - Miami - FL",
  "Syosset Hospital - Syosset - NY",
  "Syracuse Area Health - Syracuse - NE",
  "Syracuse VA Medical Center - Syracuse - NY",
  "Syringa General Hospital - Grangeville - ID",
  "T. J. Samson Community Hospital - Glasgow - KY",
  "T.J. Health Columbia - Columbia - KY",
  "Tahoe Forest Hospital - Truckee - CA",
  "Talas Harbor Behavioral Health Hospital - Buckeye - Phoenix - AZ",
  "Talas Harbor Behavioral Health Hospital - Bullhead City - Bullhead City - AZ",
  "Talihina Health Care Center - Talihina - OK",
  "Tallahassee Memorial Healthcare - Tallahassee - FL",
  "Tallahatchie General Hospital - Charleston - MS",
  "Tamarack Health Ashland Medical Center - Ashland - WI",
  "Tamarack Health Hayward Medical Center - Hayward - WI",
  "Tampa General Hospital - Tampa - FL",
  "Tampa General Hospital Brooksville - Brooksville - FL",
  "Tampa General Hospital Crystal River - Crystal River - FL",
  "Tampa General Hospital Spring Hill - Spring Hill - FL",
  "Tanner Medical Center Carrollton - Carrollton - GA",
  "Tanner Medical Center East Alabama - Wedowee - AL",
  "Tanner Medical Center/Villa Rica - Villa Rica - GA",
  "TaraVista Behavioral Health Center - Devens - MA",
  "Tarzana Treatment Center - Tarzana - CA",
  "Taunton State Hospital - Taunton - MA",
  "Taylor Hardin Secure Medical Facility - Tuscaloosa - AL",
  "Taylor Hospital - Ridley Park - PA",
  "Taylor Regional Hospital - Campbellsville - KY",
  "Taylor Regional Hospital - Hawkinsville - GA",
  "Taylorville Memorial Hospital - Taylorville - IL",
  "Telluride Regional Medical Center - Telluride - CO",
  "Temecula Valley Hospital - Temecula - CA",
  "Tempe Saint Luke's Hospital - Tempe - AZ",
  "Temple Health-Chestnut Hill Hospital - Philadelphia - PA",
  "Temple Rehabilitation Hospital - Temple - TX",
  "Temple University Hospital - Episcopal Campus - Philadelphia - PA",
  "Temple University Hospital - Jeanes Campus - Philadelphia - PA",
  "Temple University Hospital - Main Campus - Philadelphia - PA",
  "Tennova Healthcare - Cleveland - Cleveland - TN",
  "Tennova Healthcare Clarksville - Clarksville - TN",
  "Terre Haute Regional Hospital - Terre Haute - IN",
  "Terrebonne General Health System - Houma - LA",
  "Terrell State Hospital - Terrell - TX",
  "Teton Valley Hospital - Driggs - ID",
  "Tewksbury Hospital - Tewksbury - MA",
  "Texarkana Emergency Center & Hospital - Texarkana - TX",
  "Texas Center for Infectious Disease - San Antonio - TX",
  "Texas Children's Hospital - Houston - TX",
  "Texas Children's Hospital The Woodlands - The Woodlands - TX",
  "Texas Children's Hospital West Campus - Houston - TX",
  "Texas County Memorial Hospital - Houston - MO",
  "Texas Emergency Hospital - Cleveland - TX",
  "Texas Health Alliance - Fort Worth - TX",
  "Texas Health Arlington Memorial Hospital - Arlington - TX",
  "Texas Health Azle - Azle - TX",
  "Texas Health Center for Diagnostics & Surgery - Plano - TX",
  "Texas Health Clearfork - Fort Worth - TX",
  "Texas Health Cleburne - Cleburne - TX",
  "Texas Health Dallas - Dallas - TX",
  "Texas Health Denton - Denton - TX",
  "Texas Health Flower Mound - Flower Mound - TX",
  "Texas Health Fort Worth - Fort Worth - TX",
  "Texas Health Frisco - Frisco - TX",
  "Texas Health Harris Methodist Hospital Southlake - Southlake - TX",
  "Texas Health Heart & Vascular Hospital Arlington - Arlington - TX",
  "Texas Health HEB - Bedford - TX",
  "Texas Health Huguley Hospital Fort Worth South - Burleson - TX",
  "Texas Health Kaufman - Kaufman - TX",
  "Texas Health Mansfield - Mansfield - TX",
  "Texas Health Plano - Plano - TX",
  "Texas Health Presbyterian Hospital Allen - Allen - TX",
  "Texas Health Rockwall - Rockwall - TX",
  "Texas Health Southwest Fort Worth - Fort Worth - TX",
  "Texas Health Specialty Hospital - Fort Worth - TX",
  "Texas Health Stephenville - Stephenville - TX",
  "Texas Institute for Surgery - Dallas - TX",
  "Texas NeuroRehab Center - Austin - TX",
  "Texas Orthopedic Hospital - Houston - TX",
  "Texas Rehabilitation Hospital of Arlington - Arlington - TX",
  "Texas Rehabilitation Hospital of Fort Worth - Fort Worth - TX",
  "Texas Rehabilitation Hospital of Keller - Keller - TX",
  "Texas Scottish Rite Hospital for Children - Dallas - TX",
  "Texas Surgical Hospital - Plano - TX",
  "Texoma Medical Center - Denison - TX",
  "TGH Rehabilitation Hospital - Tampa - FL",
  "Thayer County Health Services - Hebron - NE",
  "The Barbara Bush Children's Hospital at Maine Medical Center - Portland - ME",
  "The Behavioral Wellness Center at Girard - Philadelphia - PA",
  "The Bellevue Hospital - Bellevue - OH",
  "The Blackberry Center - St. Cloud - FL",
  "The Bradley Center - Columbus - GA",
  "The BridgeWay Hospital - North Little Rock - AR",
  "The Brook Hospital - Dupont - Louisville - KY",
  "The Brook Hospital - KMI - Louisville - KY",
  "The Brooklyn Hospital Center - Brooklyn - NY",
  "The Brown County Community Treatment Center - Green Bay - WI",
  "The Carolina Center for Behavioral Health - Greer - SC",
  "The Centers - Ocala - FL",
  "The Children's Home of Pittsburgh and Lemieux Family Center - Pittsburgh - PA",
  "The Children's Hospital at Montefiore - Bronx - NY",
  "The Children's Hospital at Saint Francis - Tulsa - OK",
  "The Children's Hospital at TriStar Centennial - Nashville - TN",
  "The Christ Hospital - Cincinnati - OH",
  "The Cleveland Clinic Main Campus - Cleveland - OH",
  "The Colony ER Hospital - The Colony - TX",
  "The Connecticut Hospice - Branford - CT",
  "The Connecticut Mental Health Center - New Haven - CT",
  "The CORE Institute Specialty Hospital - Phoenix - AZ",
  "The Foley Center at Chestnut Ridge - Blowing Rock - NC",
  "The George Washington University Hospital - Washington - DC",
  "The Guidance Center - Flagstaff - AZ",
  "The Heart Hospital - Newburgh - IN",
  "The Heart Hospital of New Mexico at Lovelace Medical Center - Albuquerque - NM",
  "The Herman and Walter Samuelson Children's Hospital at Sinai - Baltimore - MD",
  "The Hospital at Westlake Medical Center - West Lake Hills - TX",
  "The Hospital for Extended Recovery - Norfolk - VA",
  "The Hospitals of Providence - East Campus - El Paso - TX",
  "The Hospitals of Providence - Horizon City Campus - Horizon City - TX",
  "The Hospitals of Providence - Memorial Campus - El Paso - TX",
  "The Hospitals of Providence - Sierra Campus - El Paso - TX",
  "The Hospitals of Providence - Transmountain Campus - El Paso - TX",
  "The HSC Pediatric Center - Washington - DC",
  "The Jewish Hospital - Mercy Health - Cincinnati - OH",
  "The Johns Hopkins Hospital - Baltimore - MD",
  "The Keck Hospital of USC - Los Angeles - CA",
  "The Leaves, Inc. - Richardson - TX",
  "The Meadows Psychiatric Center - Centre Hall - PA",
  "The Medical Center at Albany - Albany - KY",
  "The Medical Center at Bowling Green - Bowling Green - KY",
  "The Medical Center at Caverna - Horse Cave - KY",
  "The Medical Center at Franklin - Franklin - KY",
  "The Medical Center at Scottsville - Scottsville - KY",
  "The Medical Center of Aurora - Aurora - CO",
  "The Medical Center of Southeast Texas - Port Arthur - TX",
  "The Melham Medical Center - Broken Bow - NE",
  "The Memorial Hospital - North Conway - NH",
  "The Mental Health Emergency Center - Milwaukee - WI",
  "The Miriam Hospital - Providence - RI",
  "The Monroe Clinic Hospital - Monroe - WI",
  "The Mount Sinai Hospital - New York - NY",
  "The Muscogee Creek Nation Physical Rehabilitation Center - Okmulgee - OK",
  "The National Institutes of Health (NIH) Clinical Center - Bethesda - MD",
  "The NeuroMedical Center Rehabilitation Hospital - Baton Rouge - LA",
  "The New Roseland Community Hospital - Chicago - IL",
  "The New York Eye and Ear Infirmary - New York - NY",
  "The Northern Navajo Medical Center - Shiprock - NM",
  "The Orthopedic Specialty Clinic at TOSH - Murray - UT",
  "The Outer Banks Hospital - Nags Head - NC",
  "The Pavilion at Williamsburg Place - Williamsburg - VA",
  "The Pavilion Behavioral Health System - Champaign - IL",
  "The Physicians Centre Hospital - Bryan - TX",
  "The Psychiatric Institute of Washington - Washington - DC",
  "The Puerto Rico Medical Services Administration - San Juan - PR",
  "The Quad Cities Rehabilitation Institute - Moline - IL",
  "The Queen's Medical Center - Honolulu - HI",
  "The Queen's Medical Center West O'Ahu - Ewa Beach - HI",
  "The Rehabilitation Hospital of Montana - Billings - MT",
  "The Rehabilitation Institute of Saint Louis - Saint Louis - MO",
  "The Rehabilitation Institute of Southern Illinois - Shiloh - IL",
  "The Rehabilitation Institute of St. Louis - St. Peters - St. Peters - MO",
  "The Richland Hospital - Richland Center - WI",
  "The Ridge Behavioral Health System - Lexington - KY",
  "The Rockefeller University Hospital - New York - NY",
  "The Samaritan Center - Detroit - MI",
  "The Sanctuary at the Woodlands - Cullman - AL",
  "The Spine Hospital of Louisiana - Baton Rouge - LA",
  "The Surgical Hospital at Southwoods - Boardman - OH",
  "The University Hospital - Newark - NJ",
  "The University of Kansas Hospital Main Campus, Bell Tower Hospital - Kansas City - KS",
  "The University of Texas M. D. Anderson Cancer Center - Houston - TX",
  "The University of Toledo Medical Center - Toledo - OH",
  "The University of Vermont Health Network Champlain Valley Physicians Hospital - Plattsburgh - NY",
  "The University of Vermont Health Network Elizabethtown Community Hospital - Elizabethtown - NY",
  "The University of Vermont Medical Center - Burlington - VT",
  "The Unterberg Children's Hospital at Monmouth Medical Center - Long Branch - NJ",
  "The Valley Hospital - Ridgewood - NJ",
  "The Vermont Psychiatric Care Hospital - Berlin - VT",
  "The Vines Hospital - Ocala - FL",
  "The Walter B. Jones Center - Greenville - NC",
  "The Westerly Hospital - Westerly - RI",
  "The Willough at Naples - Naples - FL",
  "The Woman's Hospital of Texas - Houston - TX",
  "The Women's Hospital - Newburgh - IN",
  "The Woodlands Specialty Hospital - The Woodlands - TX",
  "The Woods at Parkside - Gahanna - OH",
  "ThedaCare Medical Center- New London - New London - WI",
  "ThedaCare Medical Center- Shawano - Shawano - WI",
  "ThedaCare Medical Center-Berlin - Berlin - WI",
  "ThedaCare Medical Center-Waupaca - Waupaca - WI",
  "ThedaCare Medical Center-Wild Rose - Wild Rose - WI",
  "ThedaCare Regional Medical Center-Appleton - Appleton - WI",
  "ThedaCare Regional Medical Center-Neenah - Neenah - WI",
  "Thibodaux Regional Health System - Thibodaux - LA",
  "Thomas B. Finan Center - Cumberland - MD",
  "Thomas E. Creek VA Medical Center - Amarillo - TX",
  "Thomas H. Boyd Memorial Hospital - Carrollton - IL",
  "Thomas Hospital - Fairhope - AL",
  "Thomas Jefferson University Hospital - Philadelphia - PA",
  "Thomas Memorial Hospital - South Charleston - WV",
  "Thorek Memorial Hospital - Chicago - IL",
  "Thorek Memorial Hospital Andersonville - Chicago - IL",
  "Thousand Oaks Surgical Hospital - Thousand Oaks - CA",
  "Three Crosses Regional Hospital - Las Cruces - NM",
  "Three Rivers Behavioral Health - West Columbia - SC",
  "Three Rivers Health - Basin - WY",
  "Three Rivers Health Medical Center - Three Rivers - MI",
  "Three Rivers Hospital - Brewster - WA",
  "Three Rivers Medical Center - Louisa - KY",
  "Throckmorton County Memorial Hospital - Throckmorton - TX",
  "TidalHealth Nanticoke - Seaford - DE",
  "TidalHealth Peninsula Regional - Salisbury - MD",
  "Tidelands Georgetown Memorial Hospital - Georgetown - SC",
  "Tidelands Health Rehabilitation Hospital - Murrells Inlet - SC",
  "Tidelands Health Rehabilitation Hospital at Little River - Little River - SC",
  "Tidelands Waccamaw Community Hospital - Murrells Inlet - SC",
  "Tift Regional Medical Center - Tifton - GA",
  "Timpanogos Regional Hospital - Orem - UT",
  "Tioga Medical Center - Tioga - ND",
  "Tippah County Hospital - Ripley - MS",
  "TIRR Memorial Hermanm - Greater Heights - Houston - TX",
  "TIRR Memorial Hermann - Houston - TX",
  "TIRR Memorial Hermann - The Woodlands - The Woodlands - TX",
  "Tisch Hospital - New York - NY",
  "Titus Regional Medical Center - Mount Pleasant - TX",
  "Titusville Area Hospital - Titusville - PA",
  "TMC Behavioral Health Center - Sherman - TX",
  "TMC Bonham Hospital - Bonham - TX",
  "Tobey Hospital - Wareham - MA",
  "Tomah Health - Tomah - WI",
  "Tomah VA Medical Center - Tomah - WI",
  "Topeka ER & Hospital - Topeka - KS",
  "TOPS Surgical Specialty Hospital - Houston - TX",
  "Torrance Memorial Medical Center - Torrance - CA",
  "Torrance State Hospital - Torrance - PA",
  "Totally Kids Rehabilitation Hospital - Loma Linda - CA",
  "Touchette Regional Hospital - Centreville - IL",
  "Touro LCMC Health - New Orleans - LA",
  "Touro Rehabilitation Center - New Orleans - LA",
  "Tower Behavioral Health - Reading - PA",
  "Towner County Medical Center - Cando - ND",
  "Townsen Memorial Hospital - Humble - TX",
  "Trace Regional Hospital - Houston - MS",
  "Transylvania Regional Hospital - Brevard - NC",
  "Treasure Valley Hospital - Boise - ID",
  "Trego County Lemke Memorial Hospital - WaKeeney - KS",
  "Trenton Psychiatric Hospital - West Trenton - NJ",
  "Tri Valley Health System - Cambridge - NE",
  "Tri-City Medical Center - Oceanside - CA",
  "Triangle Springs - Raleigh - NC",
  "TriCities Hospital - Hopewell - VA",
  "Trident Medical Center - Charleston - SC",
  "Trigg County Hospital - Cadiz - KY",
  "TriHealth Rehabilitation Hospital - Cincinnati - OH",
  "Trinitas Regional Medical Center - Elizabeth - NJ",
  "Trinity Bettendorf - Bettendorf - IA",
  "Trinity Health Ann Arbor Hospital - Ypsilanti - MI",
  "Trinity Health Grand Rapids Hospital - Grand Rapids - MI",
  "Trinity Health Kenmare Hospital - Kenmare - ND",
  "Trinity Health Livingston Hospital - Howell - MI",
  "Trinity Health Livonia Hospital - Livonia - MI",
  "Trinity Health Muskegon Hospital - Muskegon - MI",
  "Trinity Health Oakland Hospital - Pontiac - MI",
  "Trinity Health Shelby Hospital - Shelby - MI",
  "Trinity Health St. Joseph's Hospital - Minot - ND",
  "Trinity Health System Twin City Medical Center - Dennison - OH",
  "Trinity Hospital - Wolf Point - MT",
  "Trinity Hospital - Minot - ND",
  "Trinity Medical - Ferriday - LA",
  "Trinity Medical Center East - Steubenville - OH",
  "Trinity Medical Center West - Steubenville - OH",
  "Trinity Reginal Hospital Sachse - Sachse - TX",
  "Trinity Springs Pavilion - Fort Worth - TX",
  "Trios Southridge Hospital - Kennewick - WA",
  "Tripler Army Medical Center - Honolulu - HI",
  "TriStar Ashland City - Ashland City - TN",
  "TriStar Centennial Medical Center - Nashville - TN",
  "TriStar Centennial Parthenon Pavilion - Nashville - TN",
  "TriStar Greenview Regional Hospital - Bowling Green - KY",
  "TriStar Hendersonville Medical Center - Hendersonville - TN",
  "TriStar Horizon Medical Center - Dickson - TN",
  "Tristar NorthCrest Medical Center - Springfield - TN",
  "TriStar Skyline Madison Campus - Madison - TN",
  "TriStar Skyline Medical Center - Nashville - TN",
  "TriStar Southern Hills Medical Center - Nashville - TN",
  "TriStar StoneCrest Medical Center - Smyrna - TN",
  "TriStar Summit - Hermitage - TN",
  "TriState Health - Clarkston - WA",
  "TRMC Alabama - Thomasville - AL",
  "Trousdale Medical Center - Hartsville - TN",
  "Troy Regional Medical Center - Troy - AL",
  "Trumbull Regional Medical Center - Warren - OH",
  "TrustPoint Hospital - Murfreesboro - TN",
  "TrustPoint Rehabilitation Hospital of Lubbock - Lubbock - TX",
  "Tsehootsooi Medical Center - Fort Defiance - AZ",
  "Tuba City Indian Medical Center - Tuba City - AZ",
  "Tucson ER & Hospital - Tucson - AZ",
  "Tucson Medical Center - Tucson - AZ",
  "Tufts Medical Center - Boston - MA",
  "Tug Valley ARH Regional Medical Center - South Williamson - KY",
  "Tulane Lakeside Hospital - Metairie - LA",
  "Tulane Medical Center - New Orleans - LA",
  "Tulsa Center for Behavioral Health - Tulsa - OK",
  "Tulsa ER & Hospital - Tulsa - OK",
  "Tulsa Rehabilitation Hospital - Tulsa - OK",
  "Tulsa Spine And Specialty Hospital - Tulsa - OK",
  "Turkey Creek Medical Center - Knoxville - TN",
  "Turning Point Care Center - Moultrie - GA",
  "Turning Point Mature Adult Care Unit - Louisville - MS",
  "Turquoise Lodge Hospital - Albuquerque - NM",
  "Tuscaloosa VA Medical Center - Tuscaloosa - AL",
  "Twin Cities Community Hospital - Templeton - CA",
  "Twin County Regional Hospital - Galax - VA",
  "Twin Lakes Regional Medical Center - Leitchfield - KY",
  "Twin Rivers Treatment Center - Melbourne - FL",
  "Twin Valley Behavioral Healthcare Hospital (Columbus) - Columbus - OH",
  "Tyler ContinueCARE Hospital at Mother Frances Hospital - Tyler - TX",
  "Tyler County Hospital - Woodville - TX",
  "Tyler Holmes Memorial Hospital - Winona - MS",
  "UAB Callahan Eye Hospital - Birmingham - AL",
  "UAB Hospital - Birmingham - AL",
  "UAB Hospital - Highlands - Birmingham - AL",
  "UC Davis Medical Center - Sacramento - CA",
  "UC Davis Rehabilitation Hospital - Sacramento - CA",
  "UC Medical Center - Cincinnati - OH",
  "UC San Diego Health East Campus Medical Center - San Diego - CA",
  "UC San Diego Medical Center - San Diego - CA",
  "UCF Lake Nona Hospital - Orlando - FL",
  "UCHealth Broomfield Hospital - Broomfield - CO",
  "UCHealth Grandview Hospital - Colorado Springs - CO",
  "UCHealth Greeley Hospital - Greeley - CO",
  "UCHealth Highlands Ranch Hospital - Highlands Ranch - CO",
  "UCHealth Longs Peak Hospital - Longmont - CO",
  "UCHealth Medical Center of the Rockies - Loveland - CO",
  "UCHealth Memorial Hospital Central - Colorado Springs - CO",
  "UCHealth Memorial Hospital North - Colorado Springs - CO",
  "UCHealth Mountain Crest Behavioral Health Center - Fort Collins - Fort Collins - CO",
  "UCHealth Pikes Peak Regional Hospital - Woodland Park - CO",
  "UCHealth Poudre Valley Hospital - Fort Collins - CO",
  "UCHealth University of Colorado Hospital - Aurora - CO",
  "UCHealth Yampa Valley Medical Center - Steamboat Springs - CO",
  "UChicago Medicine - Chicago - IL",
  "UChicago Medicine AdventHealth Bolingbrook - Bolingbrook - IL",
  "UChicago Medicine AdventHealth GlenOaks - Glendale Heights - IL",
  "UChicago Medicine AdventHealth Hinsdale - Hinsdale - IL",
  "UChicago Medicine AdventHealth La Grange - La Grange - IL",
  "UChicago Medicine Center for Care and Discovery - Hyde Park - Chicago - IL",
  "UChicago Medicine Ingalls Memorial - Harvey - IL",
  "UCI Health - Orange - CA",
  "UCLA Mattel Children's Hospital - Los Angeles - CA",
  "UCLA Resnick Neuropsychiatric Hospital - Los Angeles - CA",
  "UCLA Santa Monica Medical Center - Santa Monica - CA",
  "UConn John Dempsey Hospital - Farmington - CT",
  "UCSF Benioff Children's Hospital Oakland - Oakland - CA",
  "UCSF Benioff Children's Hospital San Francisco - San Francisco - CA",
  "UCSF Betty Irene Moore Women's Hospital - San Francisco - CA",
  "UCSF Helen Diller Medical Center at Parnassus Heights - San Francisco - CA",
  "UCSF Medical Center at Mission Bay - San Francisco - CA",
  "UF Health Jacksonville - Jacksonville - FL",
  "UF Health Leesburg Hospital - Leesburg - FL",
  "UF Health Psychiatric Hospital - Gainesville - FL",
  "UF Health Rehab Hospital - Gainesville - FL",
  "UF Health Shands Children's Hospital - Gainesville - FL",
  "UF Health Shands Florida - Gainesville - FL",
  "UF Health St. Johns - Saint Augustine - FL",
  "UF Health The Villages Hospital - The Villages - FL",
  "UH Ahuja Medical Center - Beachwood - OH",
  "UH Avon Rehabilitation Hospital - Avon - OH",
  "UH Beachwood Medical Center - Beachwood - OH",
  "UH Cleveland Medical Center - Cleveland - OH",
  "UH Conneaut Medical Center - Conneaut - OH",
  "UH Elyria Medical Center - Elyria - OH",
  "UH Geauga Medical Center - Chardon - OH",
  "UH Geneva Medical Center - Geneva - OH",
  "UH MacDonald Women's Hospital - Cleveland - OH",
  "UH Parma Medical Center - Parma - OH",
  "UH Portage Medical Center - Ravenna - OH",
  "UH Rainbow Babies & Children's Hospital - Cleveland - OH",
  "UH Rehabilitation Hospital - Beachwood - OH",
  "UH Saint John Medical Center - Westlake - OH",
  "UH Samaritan Medical Center - Ashland - OH",
  "UHealth Tower - Miami - FL",
  "UHS Binghamton General Hospital - Binghamton - NY",
  "UHS Chenango Memorial Hospital - Norwich - NY",
  "UHS Delaware Valley Hospital - Walton - NY",
  "UHS Wilson Medical Center - Johnson City - NY",
  "Uintah Basin Medical Center - Roosevelt - UT",
  "UK Good Samaritan Hospital - Lexington - KY",
  "UM Capital Region Medical Center - Largo - MD",
  "UM Harford Memorial Hospital - Havre de Grace - MD",
  "UM Health - West Hospital - Wyoming - MI",
  "UM Upper Chesapeake Medical Center - Bel Air - MD",
  "UMass Memorial Health Alliance - Clinton Hospital - Clinton - MA",
  "UMass Memorial Health Harrington - Southbridge - MA",
  "UMass Memorial HealthAlliance - Clinton Hospital, Leominster Campus - Leominster - MA",
  "UMass Memorial Marlborough Hospital - Marlborough - MA",
  "UMass Memorial Medical Center - Memorial Campus - Worcester - MA",
  "UMass Memorial Medical Center - University Campus - Worcester - MA",
  "UMC Children’s Hospital - Lubbock - TX",
  "UMC Children's Hospital - Las Vegas - NV",
  "UMC Health & Wellness Hospital - Lubbock - TX",
  "UMMC Grenada - Grenada - MS",
  "UMMC Holmes County - Lexington - MS",
  "UNC Health Blue Ridge - Morganton - NC",
  "UNC Health Johnston - Smithfield - NC",
  "UNC Health Johnston Health Clayton - Clayton - NC",
  "UNC Health Pardee - Hendersonville - NC",
  "UNC Health Southeastern - Lumberton - NC",
  "UNC Health Wayne - Goldsboro - NC",
  "UNC Hospitals Hillsborough Campus - Hillsborough - NC",
  "UNC Medical Center - Chapel Hill - NC",
  "UNC Rex Healthcare - Raleigh - NC",
  "UNC Rockingham Health Care - Eden - NC",
  "Unicoi County Hospital - Erwin - TN",
  "Union County General Hospital - Clayton - NM",
  "Union County Hospital - Anna - IL",
  "Union General Hospital - Farmerville - LA",
  "Union General Hospital - Blairsville - GA",
  "Union Hospital - Terre Haute - IN",
  "Union Hospital Clinton - Clinton - IN",
  "Union Medical Center - Union - SC",
  "United Hospital - Saint Paul - MN",
  "United Hospital Center - Bridgeport - WV",
  "United Hospital District - Blue Earth - MN",
  "United Medical Center - Washington - DC",
  "United Medical Physicians Rehabilitation Hospital of Ascension - Gonzales - LA",
  "United Medical Rehabilitation Hospital-Hammond - Hammond - LA",
  "United Medical Rehabilitation Hospitals New Orleans - Gretna - LA",
  "United Memorial Medical Center - Batavia - NY",
  "United Memorial Medical Center - Houston - TX",
  "United Regional - Wichita Falls - TX",
  "Unity Health - Jacksonville - Jacksonville - AR",
  "Unity Health - Newport - Newport - AR",
  "Unity Health - White County Medical Center - Searcy - AR",
  "Unity Hospital - Rochester - NY",
  "Unity Medical Center - Manchester - TN",
  "Unity Medical Center - Grafton - ND",
  "Unity Physicians Hospital - Mishawaka - IN",
  "Unity Psychiatric Care Clarksville - Clarksville - TN",
  "Unity Psychiatric Care Columbia - Columbia - TN",
  "Unity Psychiatric Care in Huntsville - Huntsville - AL",
  "Unity Psychiatric Care Martin - Martin - TN",
  "Unity Psychiatric Care Memphis - Memphis - TN",
  "Unity Specialty Hospital - Rochester - NY",
  "UnityPoint Health - Allen Hospital - Waterloo - IA",
  "UnityPoint Health - Finley Hospital - Dubuque - IA",
  "UnityPoint Health - Iowa Lutheran Hospital - Des Moines - IA",
  "UnityPoint Health - Iowa Methodist Medical Center - Des Moines - IA",
  "UnityPoint Health - Methodist West Hospital - West Des Moines - IA",
  "UnityPoint Health - St. Lukes - Sioux City - IA",
  "UnityPoint Health - Trinity Muscatine - Muscatine - IA",
  "UnityPoint Health - Trinity Regional Medical Center - Fort Dodge - IA",
  "UnityPoint Health -Trinity Rock Island - Rock Island - IL",
  "UnityPoint Health Marshalltown Hospital - Marshalltown - IA",
  "UnityPoint Health Memorial Hospital - Carthage - IL",
  "UnityPoint Health Meriter - Madison - WI",
  "UnityPoint Health Trinity - Moline - Moline - IL",
  "Universal Behavioral Health Hospital - Hammond - LA",
  "University Behavioral Center - Orlando - FL",
  "University Behavioral Health of Denton - Denton - TX",
  "University District Hospital - San Juan - PR",
  "University Health Lakewood Medical Center - Kansas City - MO",
  "University Health Truman Medical Center - Kansas City - MO",
  "University Hospital - San Antonio - TX",
  "University Hospital - Madison - WI",
  "University Hospital - Columbia - MO",
  "University Hospital Central Brooklyn - Brooklyn - NY",
  "University Hospitals Lake West Medical Center - Willoughby - OH",
  "University Hospitals TriPoint Medical Center - Concord - OH",
  "University Medical Center - Las Vegas - NV",
  "University Medical Center - Lubbock - TX",
  "University Medical Center New Orleans - New Orleans - LA",
  "University Medical Center of El Paso - El Paso - TX",
  "University of Arkansas for Medical Sciences (UAMS) Medical Center - Little Rock - AR",
  "University of Illinois Medical Center - Chicago - IL",
  "University of Iowa Health Network Rehabilitation Hospital - Coralville - IA",
  "University of Iowa Hospitals & Clinics - Iowa City - IA",
  "University of Kansas Health System Great Bend Campus - Great Bend - KS",
  "University of Kentucky Albert B. Chandler Hospital - Lexington - KY",
  "University of Louisville Hospital - Louisville - KY",
  "University of Maryland Baltimore Washington Medical Center - Glen Burnie - MD",
  "University of Maryland Charles Regional Medical Center - La Plata - MD",
  "University of Maryland Medical Center - Baltimore - MD",
  "University of Maryland Medical Center Midtown Campus - Baltimore - MD",
  "University of Maryland Rehabilitation and Orthopaedic Institute - Baltimore - MD",
  "University of Maryland Saint Joseph Medical Center - Towson - MD",
  "University of Maryland Shore Medical Center at Chestertown - Chestertown - MD",
  "University of Maryland Shore Medical Center at Easton - Easton - MD",
  "University of Michigan Medical Center - Ann Arbor - MI",
  "University of Mississippi Medical Center - Jackson - MS",
  "University of Puerto Rico Hospital, Dr. Federico Trilla - Carolina - PR",
  "University of Tennessee Medical Center - Knoxville - TN",
  "University of Utah Hospital - Salt Lake City - UT",
  "University of Virginia Children's Hospital - Charlottesville - VA",
  "University Pediatric Hospital - San Juan - PR",
  "UNM Children's Hospital - Albuquerque - NM",
  "UNM Hospital - Albuquerque - NM",
  "UNM Psychiatric Center - Albuquerque - NM",
  "UNM Sandoval Regional Medical Center - Rio Rancho - NM",
  "UofL Health - Frazier Rehabilitation Institute - Louisville - KY",
  "UofL Health - Jewish Hospital - Louisville - KY",
  "UofL Health - Mary & Elizabeth Hospital - Louisville - KY",
  "UofL Health- Shelbyville Hospital - Shelbyville - KY",
  "UofL Health-Peace Hospital - Louisville - KY",
  "UP Health System - Bell - Ishpeming - MI",
  "UP Health System - Marquette - Marquette - MI",
  "UP Health System - Portage - Hancock - MI",
  "Upland Hills Health - Dodgeville - WI",
  "UPMC Altoona - Altoona - PA",
  "UPMC Bedford - Everett - PA",
  "UPMC Carlisle - Carlisle - PA",
  "UPMC Chautauqua - Jamestown - NY",
  "UPMC Childrens Hospital of Pittsburgh - Pittsburgh - PA",
  "UPMC Community Osteopathic - Harrisburg - PA",
  "UPMC East - Monroeville - PA",
  "UPMC Hanover - Hanover - PA",
  "UPMC Harrisburg - Harrisburg - PA",
  "UPMC Horizon - Greenville - Greenville - PA",
  "UPMC Horizon - Shenango Valley - Farrell - PA",
  "UPMC Jameson - New Castle - PA",
  "UPMC Kane - Kane - PA",
  "UPMC Lititz - Lititz - PA",
  "UPMC McKeesport - McKeesport - PA",
  "UPMC Memorial - York - PA",
  "UPMC Mercy - Pittsburgh - PA",
  "UPMC Montefiore - Pittsburgh - PA",
  "UPMC Muncy - Muncy - PA",
  "UPMC Northwest - Seneca - PA",
  "UPMC Passavant - Cranberry - Cranberry Township - PA",
  "UPMC Passavant - McCandless - Pittsburgh - PA",
  "UPMC Presbyterian - Pittsburgh - PA",
  "UPMC Saint Margaret - Pittsburgh - PA",
  "UPMC Shadyside - Pittsburgh - PA",
  "UPMC Somerset - Somerset - PA",
  "UPMC Wellsboro - Wellsboro - PA",
  "UPMC West Shore - Mechanicsburg - PA",
  "UPMC Western Maryland - Cumberland - MD",
  "UPMC Western Psychiatric Hospital - Pittsburgh - PA",
  "UPMC Williamsport - Williamsport - PA",
  "UPMC Williamsport Divine Providence Campus - Williamsport - PA",
  "Upper Connecticut Valley Hospital - Colebrook - NH",
  "Upper Valley Medical Center - Troy - OH",
  "Upson Regional Medical Center - Thomaston - GA",
  "Upstate Golisano Children's Hospital - Syracuse - NY",
  "Upstate University Hospital - Syracuse - NY",
  "Upstate University Hospital - Community Campus - Syracuse - NY",
  "UR Medicine Noyes Health - Dansville - NY",
  "USA Children's and Women's Hospital - Mobile - AL",
  "USA Health Providence Hospital - Mobile - AL",
  "USA Health University Hospital - Mobile - AL",
  "USC Arcadia Hospital - Arcadia - CA",
  "USC Norris Comprehensive Cancer Center - Los Angeles - CA",
  "USC Verdugo Hills Hospital - Glendale - CA",
  "USMD Hospital at Arlington - Arlington - TX",
  "UT Health Athens - Athens - TX",
  "UT Health Carthage - Carthage - TX",
  "UT Health East Texas Long-Term Acute Care - Tyler - TX",
  "UT Health Henderson - Henderson - TX",
  "UT Health Jacksonville - Jacksonville - TX",
  "UT Health North Campus Tyler - Tyler - TX",
  "UT Health Pittsburg - Pittsburg - TX",
  "UT Health Quitman - Quitman - TX",
  "UT Health Tyler - Tyler - TX",
  "Utah State Hospital - Provo - UT",
  "Utah Valley Hospital - Provo - UT",
  "Utah Valley Specialty Hospital - Provo - UT",
  "UTHealth Harris County Psychiatric Center - Houston - TX",
  "UTMB Health - Galveston Campus - Galveston - TX",
  "UTMB Health Clear Lake Campus Hospital - Webster - TX",
  "UTMB Health League City Campus - League City - TX",
  "UVA Encompass Health Rehabilitation Hospital - Charlottesville - VA",
  "UVA University Hospital - Charlottesville - VA",
  "Uvalde Memorial Hospital - Uvalde - TX",
  "UW Health East Madison Hospital - Madison - WI",
  "UW Health Rehabilitation Hospital - Madison - WI",
  "UW Health SwedishAmerican Hospital - Rockford - IL",
  "UW Health Women and Children's Hospital - Rockford - IL",
  "UW Medical Center - Montlake - Seattle - WA",
  "UW Medical Center - Northwest - Seattle - WA",
  "VA Atlanta Health Care - Decatur - GA",
  "VA Boston Healthcare System - Jamaica Plain Division - Boston - MA",
  "VA Butler Healthcare - Butler - PA",
  "VA Caribbean Healthcare System - San Juan - PR",
  "VA Central Iowa Health Care System - Des Moines - IA",
  "VA Illiana Health Care System - Danville - IL",
  "VA Long Beach Healthcare System - Long Beach - CA",
  "Vacaville Medical Center - Vacaville - CA",
  "Vail Health Hospital - Vail - CO",
  "Val Verde Regional Medical Center - Del Rio - TX",
  "Valir Rehabilitation Hospital - Oklahoma City - OK",
  "Valle Vista Health System - Greenwood - IN",
  "Vallejo Hospital & Medical Offices - Vallejo - CA",
  "Valley Baptist Micro Hospital Weslaco - Weslaco - TX",
  "Valley Behavioral Health System - Barling - AR",
  "Valley Children's Healthcare - Madera - CA",
  "Valley Community Hospital - Pauls Valley - OK",
  "Valley County Hospital - Ord - NE",
  "Valley Forge Medical Center and Hospital - Norristown - PA",
  "Valley Hope of Norton - Norton - KS",
  "Valley Hospital Medical Center - Las Vegas - NV",
  "Valley Hospital Phoenix - Phoenix - AZ",
  "Valley Medical Center - Renton - WA",
  "Valley Presbyterian Hospital - Van Nuys - CA",
  "Valley Regional Hospital - Claremont - NH",
  "Valley Regional Medical Center - Brownsville - TX",
  "Valley Springs Behavioral Health Hospital - Holyoke - MA",
  "Valley View Hospital - Glenwood Springs - CO",
  "Valley View Medical Center - Fort Mohave - AZ",
  "Valley-Mount Sinai Comprehensive Cancer Care - Paramus - NJ",
  "Valleywise Behavioral Health Center - Mesa - Mesa - AZ",
  "Valleywise Behavioral Health Center-Maryvale - Phoenix - AZ",
  "Valleywise Health Medical Center - Phoenix - AZ",
  "Valor Health - Emmett - ID",
  "Van Buren County Hospital - Keosauqua - IA",
  "Van Diest Medical Center - Webster City - IA",
  "Van Matre Encompass Health Rehabilitation Hospital - Rockford - IL",
  "Van Nuys Behavioral Health Hospital - Van Nuys - CA",
  "Vanderbilt Bedford Hospital - Shelbyville - TN",
  "Vanderbilt Behavioral Health - Nashville - TN",
  "Vanderbilt Stallworth Rehabilitation Hospital - Nashville - TN",
  "Vanderbilt Tullahoma-Harton Hospital - Tullahoma - TN",
  "Vanderbilt University Medical Center - Nashville - TN",
  "Vanderbilt Wilson County Hospital - Lebanon - TN",
  "Vantage Point of Northwest Arkansas - Fayetteville - AR",
  "Vassar Brothers Medical Center - Poughkeepsie - NY",
  "Vaughan Regional Medical Center - Selma - AL",
  "VBMC - Brownsville - Brownsville - TX",
  "VBMC - Harlingen - Harlingen - TX",
  "VCU Community Memorial Hospital - South Hill - VA",
  "VCU Health Tappahannock Hospital - Tappahannock - VA",
  "VCU Medical Center - Richmond - VA",
  "Ventura County Medical Center - Ventura - CA",
  "Verde Valley Medical Center - Cottonwood - AZ",
  "Verde Valley Medical Center - Sedona Campus - Sedona - AZ",
  "Vermilion Behavioral Health Systems - Lafayette - LA",
  "Verne E. Gibbs Health Center - Poplar - MT",
  "Vernon Memorial Hospital - Viroqua - WI",
  "Veterans Memorial Hospital - Waukon - IA",
  "VHC Health - Arlington - VA",
  "Via Linda Behavioral Hospital - Scottsdale - AZ",
  "Vibra Hospital of Boise - Boise - ID",
  "Vibra Hospital of Central Dakotas - Mandan - ND",
  "Vibra Hospital of Charleston - Charleston - SC",
  "Vibra Hospital of Clear Lake - Webster - TX",
  "Vibra Hospital of Denver - Thornton - CO",
  "Vibra Hospital of Fargo - Fargo - ND",
  "Vibra Hospital of Houston - Houston - TX",
  "Vibra Hospital of Northern California - Redding - CA",
  "Vibra Hospital of Northwestern Indiana - Crown Point - IN",
  "Vibra Hospital of Richardson - Richardson - TX",
  "Vibra Hospital of Sacramento - Folsom - CA",
  "Vibra Hospital of Southeastern Massachusetts - New Bedford - MA",
  "Vibra Hospital of Southeastern Michigan - DMC Campus - Detroit - MI",
  "Vibra Hospital of Southeastern Michigan - Taylor Campus - Taylor - MI",
  "Vibra Hospital of Western Massachusetts Central Campus - Rochdale - MA",
  "Vibra Rehabilitation Hospital of Amarillo - Amarillo - TX",
  "Vibra Rehabilitation Hospital of Denver - Thornton - CO",
  "Vibra Specialty Hospital Portland - Portland - OR",
  "Victor Valley Global Medical Center - Victorville - CA",
  "Viera Hospital - Melbourne - FL",
  "Villa Feliciana Medical Complex - Jackson - LA",
  "Village Behavioral Health - Louisville - TN",
  "Virginia Beach Psychiatric Center - Virginia Beach - VA",
  "Virginia Gay Hospital - Vinton - IA",
  "Virginia Mason Franciscan Health Rehabilitation Hospital - Tacoma - WA",
  "Virginia Mason Hospital and Seattle Medical Center - Seattle - WA",
  "Virtua Marlton Hospital - Marlton - NJ",
  "Virtua Mount Holly Hospital - Mount Holly - NJ",
  "Virtua Our Lady of Lourdes Hospital - Camden - NJ",
  "Virtua Voorhees Hospital - Voorhees - NJ",
  "Virtua Willingboro Hospital - Willingboro - NJ",
  "Vista Del Mar Hospital - Ventura - CA",
  "Vista Medical Center East - Waukegan - IL",
  "Volunteer Behavioral Health Care System - Cookeville Campus - Cookeville - TN",
  "Voyages Behavioral Health of Sugar Land - Sugar Land - TX",
  "W. W. Hastings Indian Hospital - Tahlequah - OK",
  "W.G. (Bill) Hefner Salisbury Department of Veterans Affairs Medical Center - Salisbury - NC",
  "W.J. Mangold Memorial Hospital - Lockney - TX",
  "Wabash General Hospital - Mount Carmel - IL",
  "Waco Center for Youth - Waco - TX",
  "Wadley Regional Medical Center - Texarkana - TX",
  "Wadley Regional Medical Center at Hope - Hope - AR",
  "Wagner Community Memorial Hospital Avera - Wagner - SD",
  "Wagoner Community Hospital - Wagoner - OK",
  "Wahiawa General Hospital - Wahiawa - HI",
  "Wake Forest Baptist Health Davie Medical Center - Bermuda Run - NC",
  "WakeMed Cary Hospital - Cary - NC",
  "WakeMed North Hospital - Raleigh - NC",
  "WakeMed Raleigh Campus - Raleigh - NC",
  "Walden Behavioral Care - Waltham - MA",
  "Waldo County General Hospital - Belfast - ME",
  "Walker Baptist Medical Center - Jasper - AL",
  "Wallowa Memorial Hospital - Enterprise - OR",
  "Walnut Creek Medical Center - Walnut Creek - CA",
  "Walter P. Reuther Psychiatric Hospital - Westland - MI",
  "Walter Reed National Military Medical Center - Bethesda - MD",
  "Walthall County General Hospital - Tylertown - MS",
  "Walton Rehabilitation Hospital - Augusta - GA",
  "Wamego Health Center - Wamego - KS",
  "War Memorial Hospital - Berkeley Springs - WV",
  "Ward Memorial Hospital - Monahans - TX",
  "Warm Springs Medical Center - Warm Springs - GA",
  "Warner Hospital and Healthcare Services - Clinton - IL",
  "Warren General Hospital - Warren - PA",
  "Warren Memorial Hospital - Front Royal - VA",
  "Warren Memorial Hospital - Friend - NE",
  "Warren State Hospital - North Warren - PA",
  "Washakie Medical Center - Worland - WY",
  "Washington County Hospital - Chatom - AL",
  "Washington County Hospital - Nashville - IL",
  "Washington County Hospital - Washington - KS",
  "Washington County Hospital - Washington - IA",
  "Washington County Memorial Hospital - Potosi - MO",
  "Washington County Regional Medical Center - Sandersville - GA",
  "Washington DC VA Medical Center - Washington - DC",
  "Washington Health System Greene - Waynesburg - PA",
  "Washington Hospital - Washington - PA",
  "Washington Hospital Healthcare System - Fremont - CA",
  "Washington Regional Medical Center - Plymouth - NC",
  "Washington Regional Medical Center - Fayetteville - AR",
  "Washington State Penitentiary Hospital - Walla Walla - WA",
  "Watauga Medical Center - Boone - NC",
  "Waterbury Hospital - Waterbury - CT",
  "Watertown Regional Medical Center - Watertown - WI",
  "Watsonville Community Hospital - Watsonville - CA",
  "Waukesha County Mental Health Center - Waukesha - WI",
  "Waverly Health Center - Waverly - IA",
  "Wayne County Hospital - Corydon - IA",
  "Wayne County Hospital - Monticello - KY",
  "Wayne General Hospital - Waynesboro - MS",
  "Wayne Hospital - Greenville - OH",
  "Wayne Medical Center - Waynesboro - TN",
  "Wayne Memorial Hospital - Jesup - GA",
  "Wayne Memorial Hospital - Honesdale - PA",
  "Weatherford Regional Hospital - Weatherford - OK",
  "Webster County Community Hospital - Red Cloud - NE",
  "Webster County Memorial Hospital - Webster Springs - WV",
  "Weeks Medical Center - Lancaster - NH",
  "Weirton Medical Center - Weirton - WV",
  "Weiser Memorial Hospital - Weiser - ID",
  "Weisman Children's - Marlton - NJ",
  "Weiss Memorial Hospital - Chicago - IL",
  "Wekiva Springs Center - Jacksonville - FL",
  "Welch Community Hospital - Welch - WV",
  "WellBridge Fort Worth - Fort Worth - TX",
  "WellBridge Greater Dallas - Plano - TX",
  "Wellfound Behavioral Health Hospital - Tacoma - WA",
  "Wellington Regional Medical Center - Wellington - FL",
  "WellSpan Chambersburg Hospital - Chambersburg - PA",
  "WellSpan Ephrata Community Hospital - Ephrata - PA",
  "Wellspan Gettysburg Hospital - Gettysburg - PA",
  "WellSpan Good Samaritan Hospital - Lebanon - PA",
  "Wellspan Philhaven - Mount Gretna - PA",
  "Wellspan Surgery and Rehabilitation Hospital - York - PA",
  "Wellspan Waynesboro Hospital - Waynesboro - PA",
  "WellSpan York Hospital - York - PA",
  "Wellspring - Bethlehem - CT",
  "WellStar Cobb Hospital - Austell - GA",
  "WellStar Douglas Hospital - Douglasville - GA",
  "Wellstar Kennestone Regional Medical Center - Marietta - GA",
  "WellStar North Fulton Medical Center - Roswell - GA",
  "WellStar Paulding Hospital - Hiram - GA",
  "WellStar Spalding Regional Hospital - Griffin - GA",
  "WellStar Sylvan Grove Hospital - Jackson - GA",
  "WellStar West Georgia Medical Center - LaGrange - GA",
  "WellStar Windy Hill Hospital - Marietta - GA",
  "Wellstone Regional Hospital - Jeffersonville - IN",
  "Wentworth-Douglass Hospital - Dover - NH",
  "Wernersville State Hospital - Wernersville - PA",
  "Weslaco Regional Rehabilitation Hospital - Weslaco - TX",
  "Wesley Medical Center - Wichita - KS",
  "Wesley Woodlawn Hospital & ER - Wichita - KS",
  "West Anaheim Medical Center - Anaheim - CA",
  "West Boca Medical Center - West Boca Raton - FL",
  "West Calcasieu Cameron Hospital - Sulphur - LA",
  "West Carroll Memorial Hospital - Oak Grove - LA",
  "West Central Georgia Regional Hospital - Columbus - GA",
  "West Chester Medical Center - West Chester - OH",
  "West Coast Surgery - Palm Desert - CA",
  "West Covina Medical Center - West Covina - CA",
  "West Feliciana Parish Hospital - Saint Francisville - LA",
  "West Gables Rehabilitation Hospital - Miami - FL",
  "West Haven VA Medical Center - West Haven - CT",
  "West Hills Hospital & Medical Center - West Hills - CA",
  "West Holt Memorial Hospital - Atkinson - NE",
  "West Jefferson Medical Center - Marrero - LA",
  "West Kendall Baptist Hospital - Miami - FL",
  "West Los Angeles Medical Center - Los Angeles - CA",
  "West Los Angeles VA Medical Center - Los Angeles - CA",
  "West Oaks Hospital - Houston - TX",
  "West Palm Beach VA Medical Center - West Palm Beach - FL",
  "West Penn Hospital - Pittsburgh - PA",
  "West Plano Emergency Room - Plano - TX",
  "West River Health Services - Hettinger - ND",
  "West Roxbury VA Medical Center - West Roxbury - MA",
  "West Springs Hospital - Grand Junction - CO",
  "West Suburban Medical Center - Oak Park - IL",
  "West Tennessee Healthcare Bolivar Hospital - Bolivar - TN",
  "West Tennessee Healthcare Camden Hospital - Camden - TN",
  "West Tennessee Healthcare Dyersburg Hospital - Dyersburg - TN",
  "West Tennessee Healthcare Jackson - Madison County General Hospital - Jackson - TN",
  "West Tennessee Healthcare Milan Hospital - Milan - TN",
  "West Tennessee Healthcare North Hospital - Jackson - TN",
  "West Tennessee Healthcare Rehabilitation Hospital Cane Creek - Martin - TN",
  "West Tennessee Healthcare Volunteer Hospital - Martin - TN",
  "West Valley Hospital - Dallas - OR",
  "West Valley Medical Center - Caldwell - ID",
  "Westborough Behavioral Healthcare Hospital - Westborough - MA",
  "Westchester Medical Center - Valhalla - NY",
  "Western Arizona Regional Medical Center - Bullhead City - AZ",
  "Western Maryland Hospital Center - Hagerstown - MD",
  "Western Massachusetts Hospital - Westfield - MA",
  "Western Mental Health Institute - Bolivar - TN",
  "Western Missouri Medical Center - Warrensburg - MO",
  "Western New York Children's Psychiatric Center - West Seneca - NY",
  "Western Reserve Hospital - Cuyahoga Falls - OH",
  "Western State Hospital - Tacoma - WA",
  "Western State Hospital - Staunton - VA",
  "Western State Hospital - Hopkinsville - KY",
  "Western Wisconsin Health - Baldwin - WI",
  "Westfield Memorial Hospital - Westfield - NY",
  "Westfields Hospital and Clinic - New Richmond - WI",
  "Weston County Health Services - Newcastle - WY",
  "Westpark Springs - Richmond - TX",
  "Wetzel County Hospital - New Martinsville - WV",
  "Wheatland Memorial Healthcare - Harlowton - MT",
  "WhidbeyHealth Medical Center - Coupeville - WA",
  "White Mountain Regional Medical Center - Springerville - AZ",
  "White Plains Hospital - White Plains - NY",
  "White River Junction VA Medical Center - White River Junction - VT",
  "White River Medical Center - Batesville - AR",
  "White Rock Medical Center - Dallas - TX",
  "Whiteriver Indian Hospital - Whiteriver - AZ",
  "Whitesburg ARH Hospital - Whitesburg - KY",
  "Whitfield Medical Surgical Hospital - Whitfield - MS",
  "Whitfield Regional Hospital - Demopolis - AL",
  "Whiting Forensic Hospital - Middletown - CT",
  "Whitman Hospital and Medical Center - Colfax - WA",
  "Whittier Hospital Medical Center - Whittier - CA",
  "Whittier Rehabilitation Hospital Bradford - Bradford - MA",
  "Whittier Rehabilitation Hospital Westborough - Westborough - MA",
  "Wichita County Health Center - Leoti - KS",
  "Wickenburg Community Hospital - Wickenburg - AZ",
  "Wide Horizon - Wheat Ridge - CO",
  "Wilbarger General Hospital - Vernon - TX",
  "Wilcox Memorial Hospital - Lihue - HI",
  "Wilkes-Barre General Hospital - Wilkes-Barre - PA",
  "Wilkes-Barre VA Medical Center - Wilkes-Barre - PA",
  "Willamette Valley Medical Center - McMinnville - OR",
  "Willapa Harbor Hospital - South Bend - WA",
  "William Beaumont Army Medical Center - Fort Bliss - Fort Bliss - TX",
  "William Bee Ririe Hospital - Ely - NV",
  "William J. McCord Adolescent Treatment Facility - Orangeburg - SC",
  "William Newton Hospital - Winfield - KS",
  "William P. Clements Jr. University Hospital - Dallas - TX",
  "William R. Sharpe, Jr. Hospital - Weston - WV",
  "William S. Hall Psychiatric Institute - Columbia - SC",
  "William S. Middleton Memorial Veterans Hospital - Madison - WI",
  "Williamson Medical Center - Franklin - TN",
  "Willis-Knighton Bossier Health Center - Bossier City - LA",
  "Willis-Knighton Medical Center - Shreveport - LA",
  "Willis-Knighton South & The Center for Women's Health - Shreveport - LA",
  "Willow Creek Behavioral Health - Green Bay - WI",
  "Willow Creek Women's Hospital - Johnson - AR",
  "Willow Crest Hospital - Miami - OK",
  "Willow Rock Center - San Leandro - CA",
  "Willow Springs Center - Reno - NV",
  "Willowbrooke at Tanner - Villa Rica - Villa Rica - GA",
  "Wills Eye Hospital - Philadelphia - PA",
  "Wills Memorial Hospital - Washington - GA",
  "Wilma Chan Highland Hospital - Oakland - CA",
  "Wilma N. Vazquez Medical Center - Vega Baja - PR",
  "Wilmington Hospital - Wilmington - DE",
  "Wilmington Treatment Center - Wilmington - NC",
  "Wilmington VA Medical Center - Wilmington - DE",
  "Wilson Health - Sidney - OH",
  "Wilson Medical Center - Neodesha - KS",
  "Wilson Medical Center - Wilson - NC",
  "Wilson N. Jones Regional Medical Center - Sherman - TX",
  "Winchester Hospital - Winchester - MA",
  "Winchester Medical Center - Winchester - VA",
  "Windham Hospital - Willimantic - CT",
  "Windmoor Healthcare of Clearwater - Clearwater - FL",
  "Windom Area Health - Windom - MN",
  "Windsor-Laurelwood Center - Willoughby - OH",
  "Winkler County Memorial Hospital - Kermit - TX",
  "Winn Army Community Hospital - Fort Stewart - GA",
  "Winn Parish Medical Center - Winnfield - LA",
  "Winnebago Mental Health Institute - Winnebago - WI",
  "Winner Regional Health - Winner - SD",
  "Winneshiek Medical Center - Decorah - IA",
  "Winona Community Memorial Hospital - Winona - MN",
  "Winston Medical Center - Louisville - MS",
  "Winter Haven Hospital - Winter Haven - FL",
  "Winter Haven Women's Hospital - Winter Haven - FL",
  "Wiregrass Medical Center - Geneva - AL",
  "Wiser Hospital for Women and Infants - UMMC - Jackson - MS",
  "Witham Memorial Hospital - Lebanon - IN",
  "WK Pierremont Health Center - Shreveport - LA",
  "WMC Health Behavioral Health Center - Valhalla - NY",
  "Wolfson Children's Hospital - Jacksonville - FL",
  "Womack Army Medical Center - Fort Bragg - NC",
  "Woman's Hospital - Baton Rouge - LA",
  "Women & Infants Hospital - Providence - RI",
  "Women's and Children's Hospital - Columbia - MO",
  "Women's Hospital at Saint Joseph East - Lexington - KY",
  "Women's Memorial Hermann at Memorial Hermann Memorial City Medical Center - Houston - TX",
  "Wood County Hospital - Bowling Green - OH",
  "Woodland Memorial Hospital - Woodland - CA",
  "Woodland Heights Medical Center - Lufkin - TX",
  "Woodland Springs - Conroe - TX",
  "Woodlawn Hospital - Rochester - IN",
  "Woodridge Hospital - Johnson City - TN",
  "Wooster Community Hospital - Wooster - OH",
  "Worcester Recovery Center and Hospital - Worcester - MA",
  "Wrangell Medical Center - Wrangell - AK",
  "Wray Community District Hospital - Wray - CO",
  "Wright Memorial Hospital - Trenton - MO",
  "WVU Medicine Barnesville Hospital - Barnesville - OH",
  "WVU Medicine Children's Hospital - Morgantown - WV",
  "WVU Medicine Princeton Community Hospital - Princeton - WV",
  "WVU Medicine Uniontown Hospital - Uniontown - PA",
  "WVU Medicine Wheeling Hospital - Wheeling - WV",
  "Wyandot Memorial Hospital - Upper Sandusky - OH",
  "Wyckoff Heights Medical Center - Brooklyn - NY",
  "Wylie ER 24/7 Emergency Room - Wylie - TX",
  "Wynn Hospital - Utica - NY",
  "Wyoming Behavioral Institute - Casper - WY",
  "Wyoming County Community Health System - Warsaw - NY",
  "Wyoming Medical Center - Casper - WY",
  "Wyoming State Hospital - Evanston - WY",
  "Wythe County Community Hospital - Wytheville - VA",
  "Yale New Haven Hospital - New Haven - CT",
  "Yale New Haven Hospital, Saint Raphael Campus - New Haven - CT",
  "Yale New Haven Psychiatric Hospital - New Haven - CT",
  "Yale-New Haven Children's Hospital - New Haven - CT",
  "Yalobusha General Hospital - Water Valley - MS",
  "Yavapai Regional Medical Center - East - Prescott Valley - AZ",
  "Yavapai Regional Medical Center - West - Prescott - AZ",
  "Yoakum Community Hospital - Yoakum - TX",
  "Yoakum County Hospital - Denver City - TX",
  "York General Hospital - York - NE",
  "York Hospital - York - ME",
  "Yukon-Kuskokwim Delta Regional Hospital - Bethel - AK",
  "Yuma District Hospital - Yuma - CO",
  "Yuma Regional Medical Center - Yuma - AZ",
  "Yuma Rehabilitation Hospital, an affiliation of Encompass Health and Yuma Regional Medical Center - Yuma - AZ",
  "Zale Lipshy Pavilion-William P. Clements Jr. University Hospital - Dallas - TX",
  "Zuckerberg San Francisco General Hospital and Trauma Center - San Francisco - CA",
  "Zuni Comprehensive Health Center - Zuni - NM",
]
  .sort((a, b) => a.localeCompare(b))
  .map((i) => ({ title: i, value: i }))
